export default  {
    data() {
        return {
            jsonAddress: [
                {
                    "province":"กรุงเทพมหานคร",
                    "listAmphur":[
                        {
                            "amphur":"พระนคร",
                            "listTumbon":[
                            {
                                "tumbon":"พระบรมมหาราชวัง",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"วังบูรพาภิรมย์",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"วัดราชบพิธ",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"สำราญราษฎร์",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"ศาลเจ้าพ่อเสือ",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"เสาชิงช้า",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"บวรนิเวศ",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"ตลาดยอด",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"ชนะสงคราม",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"บ้านพานถม",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"บางขุนพรหม",
                                "postcode":"10200"
                            },
                            {
                                "tumbon":"วัดสามพระยา",
                                "postcode":"10200"
                            }
                            ]
                        },
                        {
                            "amphur":"ป้อมปราบศัตรูพ่าย",
                            "listTumbon":[
                            {
                                "tumbon":"ป้อมปราบ",
                                "postcode":"10100"
                            },
                            {
                                "tumbon":"วัดเทพศิรินทร์",
                                "postcode":"10100"
                            },
                            {
                                "tumbon":"คลองมหานาค",
                                "postcode":"10100"
                            },
                            {
                                "tumbon":"บ้านบาตร",
                                "postcode":"10100"
                            },
                            {
                                "tumbon":"วัดโสมนัส",
                                "postcode":"10100"
                            }
                            ]
                        },
                        {
                            "amphur":"สัมพันธวงศ์",
                            "listTumbon":[
                            {
                                "tumbon":"จักรวรรดิ์",
                                "postcode":"10100"
                            },
                            {
                                "tumbon":"สัมพันธวงศ์",
                                "postcode":"10100"
                            },
                            {
                                "tumbon":"ตลาดน้อย",
                                "postcode":"10100"
                            }
                            ]
                        },
                        {
                            "amphur":"บางรัก",
                            "listTumbon":[
                            {
                                "tumbon":"มหาพฤฒาราม",
                                "postcode":"10500"
                            },
                            {
                                "tumbon":"สีลม",
                                "postcode":"10500"
                            },
                            {
                                "tumbon":"สุริยวงศ์",
                                "postcode":"10500"
                            },
                            {
                                "tumbon":"บางรัก",
                                "postcode":"10500"
                            },
                            {
                                "tumbon":"สี่พระยา",
                                "postcode":"10500"
                            }
                            ]
                        },
                        {
                            "amphur":"ปทุมวัน",
                            "listTumbon":[
                            {
                                "tumbon":"รองเมือง",
                                "postcode":"10330"
                            },
                            {
                                "tumbon":"วังใหม่",
                                "postcode":"10330"
                            },
                            {
                                "tumbon":"ปทุมวัน",
                                "postcode":"10330"
                            },
                            {
                                "tumbon":"ลุมพินี",
                                "postcode":"10330"
                            }
                            ]
                        },
                        {
                            "amphur":"ยานนาวา",
                            "listTumbon":[
                            {
                                "tumbon":"ช่องนนทรี",
                                "postcode":"10120"
                            },
                            {
                                "tumbon":"บางโพงพาง",
                                "postcode":"10120"
                            }
                            ]
                        },
                        {
                            "amphur":"ดุสิต",
                            "listTumbon":[
                            {
                                "tumbon":"ดุสิต",
                                "postcode":"10300"
                            },
                            {
                                "tumbon":"วชิรพยาบาล",
                                "postcode":"10300"
                            },
                            {
                                "tumbon":"สวนจิตรลดา",
                                "postcode":"10300"
                            },
                            {
                                "tumbon":"สี่แยกมหานาค",
                                "postcode":"10300"
                            },
                            {
                                "tumbon":"ถนนนครไชยศรี",
                                "postcode":"10300"
                            }
                            ]
                        },
                        {
                            "amphur":"พญาไท",
                            "listTumbon":[
                            {
                                "tumbon":"สามเสนใน",
                                "postcode":"10400"
                            }
                            ]
                        },
                        {
                            "amphur":"ห้วยขวาง",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยขวาง",
                                "postcode":"10310"
                            },
                            {
                                "tumbon":"บางกะปิ",
                                "postcode":"10310"
                            },
                            {
                                "tumbon":"สามเสนนอก",
                                "postcode":"10310"
                            }
                            ]
                        },
                        {
                            "amphur":"พระโขนง",
                            "listTumbon":[
                            {
                                "tumbon":"บางจาก",
                                "postcode":"10260"
                            }
                            ]
                        },
                        {
                            "amphur":"บางกะปิ",
                            "listTumbon":[
                            {
                                "tumbon":"หัวหมาก",
                                "postcode":"10240"
                            },
                            {
                                "tumbon":"คลองจั่น",
                                "postcode":"10240"
                            }
                            ]
                        },
                        {
                            "amphur":"บางเขน",
                            "listTumbon":[
                            {
                                "tumbon":"อนุสาวรีย์",
                                "postcode":"10220"
                            },
                            {
                                "tumbon":"ท่าแร้ง",
                                "postcode":"10220"
                            }
                            ]
                        },
                        {
                            "amphur":"มีนบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"มีนบุรี",
                                "postcode":"10510"
                            },
                            {
                                "tumbon":"แสนแสบ",
                                "postcode":"10510"
                            }
                            ]
                        },
                        {
                            "amphur":"ลาดกระบัง",
                            "listTumbon":[
                            {
                                "tumbon":"ลาดกระบัง",
                                "postcode":"10520"
                            },
                            {
                                "tumbon":"คลองสองต้นนุ่น",
                                "postcode":"10520"
                            },
                            {
                                "tumbon":"คลองสามประเวศ",
                                "postcode":"10520"
                            },
                            {
                                "tumbon":"ลำปลาทิว",
                                "postcode":"10520"
                            },
                            {
                                "tumbon":"ทับยาว",
                                "postcode":"10520"
                            },
                            {
                                "tumbon":"ขุมทอง",
                                "postcode":"10520"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองจอก",
                            "listTumbon":[
                            {
                                "tumbon":"กระทุ่มราย",
                                "postcode":"10530"
                            },
                            {
                                "tumbon":"หนองจอก",
                                "postcode":"10530"
                            },
                            {
                                "tumbon":"คลองสิบ",
                                "postcode":"10530"
                            },
                            {
                                "tumbon":"คลองสิบสอง",
                                "postcode":"10530"
                            },
                            {
                                "tumbon":"โคกแฝด",
                                "postcode":"10530"
                            },
                            {
                                "tumbon":"คู้ฝั่งเหนือ",
                                "postcode":"10530"
                            },
                            {
                                "tumbon":"ลำผักชี",
                                "postcode":"10530"
                            },
                            {
                                "tumbon":"ลำต้อยติ่ง",
                                "postcode":"10530"
                            }
                            ]
                        },
                        {
                            "amphur":"ธนบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"วัดกัลยาณ์",
                                "postcode":"10600"
                            },
                            {
                                "tumbon":"หิรัญรูจี",
                                "postcode":"10600"
                            },
                            {
                                "tumbon":"บางยี่เรือ",
                                "postcode":"10600"
                            },
                            {
                                "tumbon":"บุคคโล",
                                "postcode":"10600"
                            },
                            {
                                "tumbon":"ตลาดพลู",
                                "postcode":"10600"
                            },
                            {
                                "tumbon":"ดาวคะนอง",
                                "postcode":"10600"
                            },
                            {
                                "tumbon":"สำเหร่",
                                "postcode":"10600"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองสาน",
                            "listTumbon":[
                            {
                                "tumbon":"สมเด็จเจ้าพระยา",
                                "postcode":"10600"
                            },
                            {
                                "tumbon":"คลองสาน",
                                "postcode":"10600"
                            },
                            {
                                "tumbon":"คลองต้นไทร",
                                "postcode":"10600"
                            },
                            {
                                "tumbon":"บางลำภูล่าง",
                                "postcode":"10600"
                            }
                            ]
                        },
                        {
                            "amphur":"บางกอกใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"วัดอรุณ",
                                "postcode":"10600"
                            },
                            {
                                "tumbon":"วัดท่าพระ",
                                "postcode":"10600"
                            }
                            ]
                        },
                        {
                            "amphur":"บางกอกน้อย",
                            "listTumbon":[
                            {
                                "tumbon":"ศิริราช",
                                "postcode":"10700"
                            },
                            {
                                "tumbon":"บ้านช่างหล่อ",
                                "postcode":"10700"
                            },
                            {
                                "tumbon":"บางขุนนนท์",
                                "postcode":"10700"
                            },
                            {
                                "tumbon":"บางขุนศรี",
                                "postcode":"10700"
                            },
                            {
                                "tumbon":"อรุณอัมรินทร์",
                                "postcode":"10700"
                            }
                            ]
                        },
                        {
                            "amphur":"ตลิ่งชัน",
                            "listTumbon":[
                            {
                                "tumbon":"คลองชักพระ",
                                "postcode":"10170"
                            },
                            {
                                "tumbon":"ตลิ่งชัน",
                                "postcode":"10170"
                            },
                            {
                                "tumbon":"ฉิมพลี",
                                "postcode":"10170"
                            },
                            {
                                "tumbon":"บางระมาด",
                                "postcode":"10170"
                            },
                            {
                                "tumbon":"บางเชือกหนัง",
                                "postcode":"10170"
                            },
                            {
                                "tumbon":"บางพรม",
                                "postcode":"10170"
                            }
                            ]
                        },
                        {
                            "amphur":"ภาษีเจริญ",
                            "listTumbon":[
                            {
                                "tumbon":"บางหว้า",
                                "postcode":"10160"
                            },
                            {
                                "tumbon":"บางด้วน",
                                "postcode":"10160"
                            },
                            {
                                "tumbon":"บางจาก",
                                "postcode":"10160"
                            },
                            {
                                "tumbon":"บางแวก",
                                "postcode":"10160"
                            },
                            {
                                "tumbon":"คลองขวาง",
                                "postcode":"10160"
                            },
                            {
                                "tumbon":"ปากคลองภาษีเจริญ",
                                "postcode":"10160"
                            },
                            {
                                "tumbon":"คูหาสวรรค์",
                                "postcode":"10160"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองแขม",
                            "listTumbon":[
                            {
                                "tumbon":"หนองแขม",
                                "postcode":"10160"
                            },
                            {
                                "tumbon":"หนองค้างพลู",
                                "postcode":"10160"
                            }
                            ]
                        },
                        {
                            "amphur":"บางขุนเทียน",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"10150"
                            },
                            {
                                "tumbon":"แสมดำ",
                                "postcode":"10150"
                            }
                            ]
                        },
                        {
                            "amphur":"ราษฎร์บูรณะ",
                            "listTumbon":[
                            {
                                "tumbon":"ราษฎร์บูรณะ",
                                "postcode":"10140"
                            },
                            {
                                "tumbon":"บางปะกอก",
                                "postcode":"10140"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอนเมือง",
                            "listTumbon":[
                            {
                                "tumbon":"สีกัน",
                                "postcode":"10210"
                            },
                            {
                                "tumbon":"ดอนเมือง",
                                "postcode":"10210"
                            },
                            {
                                "tumbon":"สนามบิน",
                                "postcode":"10210"
                            }
                            ]
                        },
                        {
                            "amphur":"จตุจักร",
                            "listTumbon":[
                            {
                                "tumbon":"ลาดยาว",
                                "postcode":"10900"
                            },
                            {
                                "tumbon":"จตุจักร",
                                "postcode":"10900"
                            },
                            {
                                "tumbon":"จอมพล",
                                "postcode":"10900"
                            },
                            {
                                "tumbon":"จันทรเกษม",
                                "postcode":"10900"
                            },
                            {
                                "tumbon":"เสนานิคม",
                                "postcode":"10900"
                            }
                            ]
                        },
                        {
                            "amphur":"ลาดพร้าว",
                            "listTumbon":[
                            {
                                "tumbon":"ลาดพร้าว",
                                "postcode":"10230"
                            },
                            {
                                "tumbon":"จรเข้บัว",
                                "postcode":"10230"
                            }
                            ]
                        },
                        {
                            "amphur":"บึงกุ่ม",
                            "listTumbon":[
                            {
                                "tumbon":"คลองกุ่ม",
                                "postcode":"10230"
                            },
                            {
                                "tumbon":"นวมินทร์",
                                "postcode":"10230"
                            },
                            {
                                "tumbon":"นวลจันทร์",
                                "postcode":"10230"
                            }
                            ]
                        },
                        {
                            "amphur":"สาทร",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งวัดดอน",
                                "postcode":"10120"
                            },
                            {
                                "tumbon":"ยานนาวา",
                                "postcode":"10120"
                            },
                            {
                                "tumbon":"ทุ่งมหาเมฆ",
                                "postcode":"10120"
                            }
                            ]
                        },
                        {
                            "amphur":"บางคอแหลม",
                            "listTumbon":[
                            {
                                "tumbon":"บางคอแหลม",
                                "postcode":"10120"
                            },
                            {
                                "tumbon":"วัดพระยาไกร",
                                "postcode":"10120"
                            },
                            {
                                "tumbon":"บางโคล่",
                                "postcode":"10120"
                            }
                            ]
                        },
                        {
                            "amphur":"บางซื่อ",
                            "listTumbon":[
                            {
                                "tumbon":"บางซื่อ",
                                "postcode":"10800"
                            },
                            {
                                "tumbon":"วงศ์สว่าง",
                                "postcode":"10800"
                            }
                            ]
                        },
                        {
                            "amphur":"ราชเทวี",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งพญาไท",
                                "postcode":"10400"
                            },
                            {
                                "tumbon":"ถนนพญาไท",
                                "postcode":"10400"
                            },
                            {
                                "tumbon":"ถนนเพชรบุรี",
                                "postcode":"10400"
                            },
                            {
                                "tumbon":"มักกะสัน",
                                "postcode":"10400"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองเตย",
                            "listTumbon":[
                            {
                                "tumbon":"คลองเตย",
                                "postcode":"10110"
                            },
                            {
                                "tumbon":"คลองตัน",
                                "postcode":"10110"
                            },
                            {
                                "tumbon":"พระโขนง",
                                "postcode":"10110"
                            }
                            ]
                        },
                        {
                            "amphur":"ประเวศ",
                            "listTumbon":[
                            {
                                "tumbon":"ประเวศ",
                                "postcode":"10250"
                            },
                            {
                                "tumbon":"หนองบอน",
                                "postcode":"10250"
                            },
                            {
                                "tumbon":"ดอกไม้",
                                "postcode":"10250"
                            }
                            ]
                        },
                        {
                            "amphur":"บางพลัด",
                            "listTumbon":[
                            {
                                "tumbon":"บางพลัด",
                                "postcode":"10700"
                            },
                            {
                                "tumbon":"บางอ้อ",
                                "postcode":"10700"
                            },
                            {
                                "tumbon":"บางบำหรุ",
                                "postcode":"10700"
                            },
                            {
                                "tumbon":"บางยี่ขัน",
                                "postcode":"10700"
                            }
                            ]
                        },
                        {
                            "amphur":"จอมทอง",
                            "listTumbon":[
                            {
                                "tumbon":"บางขุนเทียน",
                                "postcode":"10150"
                            },
                            {
                                "tumbon":"บางค้อ",
                                "postcode":"10150"
                            },
                            {
                                "tumbon":"บางมด",
                                "postcode":"10150"
                            },
                            {
                                "tumbon":"จอมทอง",
                                "postcode":"10150"
                            }
                            ]
                        },
                        {
                            "amphur":"ดินแดง",
                            "listTumbon":[
                            {
                                "tumbon":"ดินแดง",
                                "postcode":"10400"
                            }
                            ]
                        },
                        {
                            "amphur":"สวนหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"สวนหลวง",
                                "postcode":"10250"
                            }
                            ]
                        },
                        {
                            "amphur":"วัฒนา",
                            "listTumbon":[
                            {
                                "tumbon":"คลองเตยเหนือ",
                                "postcode":"10110"
                            },
                            {
                                "tumbon":"คลองตันเหนือ",
                                "postcode":"10110"
                            },
                            {
                                "tumbon":"พระโขนงเหนือ",
                                "postcode":"10110"
                            }
                            ]
                        },
                        {
                            "amphur":"บางแค",
                            "listTumbon":[
                            {
                                "tumbon":"บางแค",
                                "postcode":"10160"
                            },
                            {
                                "tumbon":"บางแคเหนือ",
                                "postcode":"10160"
                            },
                            {
                                "tumbon":"บางไผ่",
                                "postcode":"10160"
                            },
                            {
                                "tumbon":"หลักสอง",
                                "postcode":"10160"
                            }
                            ]
                        },
                        {
                            "amphur":"หลักสี่",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งสองห้อง",
                                "postcode":"10210"
                            },
                            {
                                "tumbon":"ตลาดบางเขน",
                                "postcode":"10210"
                            }
                            ]
                        },
                        {
                            "amphur":"สายไหม",
                            "listTumbon":[
                            {
                                "tumbon":"สายไหม",
                                "postcode":"10220"
                            },
                            {
                                "tumbon":"ออเงิน",
                                "postcode":"10220"
                            },
                            {
                                "tumbon":"คลองถนน",
                                "postcode":"10220"
                            }
                            ]
                        },
                        {
                            "amphur":"คันนายาว",
                            "listTumbon":[
                            {
                                "tumbon":"คันนายาว",
                                "postcode":"10230"
                            },
                            {
                                "tumbon":"รามอินทรา",
                                "postcode":"10230"
                            }
                            ]
                        },
                        {
                            "amphur":"สะพานสูง",
                            "listTumbon":[
                            {
                                "tumbon":"สะพานสูง",
                                "postcode":"10240"
                            }
                            ]
                        },
                        {
                            "amphur":"วังทองหลาง",
                            "listTumbon":[
                            {
                                "tumbon":"วังทองหลาง",
                                "postcode":"10310"
                            },
                            {
                                "tumbon":"คลองเจ้าคุณสิงห์",
                                "postcode":"10310"
                            },
                            {
                                "tumbon":"พลับพลา",
                                "postcode":"10310"
                            },
                            {
                                "tumbon":"สะพานสอง",
                                "postcode":"10310"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองสามวา",
                            "listTumbon":[
                            {
                                "tumbon":"สามวาตะวันตก",
                                "postcode":"10510"
                            },
                            {
                                "tumbon":"สามวาตะวันออก",
                                "postcode":"10510"
                            },
                            {
                                "tumbon":"บางชัน",
                                "postcode":"10510"
                            },
                            {
                                "tumbon":"ทรายกองดิน",
                                "postcode":"10510"
                            },
                            {
                                "tumbon":"ทรายกองดินใต้",
                                "postcode":"10510"
                            }
                            ]
                        },
                        {
                            "amphur":"บางนา",
                            "listTumbon":[
                            {
                                "tumbon":"บางนา",
                                "postcode":"10260"
                            }
                            ]
                        },
                        {
                            "amphur":"ทวีวัฒนา",
                            "listTumbon":[
                            {
                                "tumbon":"ทวีวัฒนา",
                                "postcode":"10170"
                            },
                            {
                                "tumbon":"ศาลาธรรมสพน์",
                                "postcode":"10170"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งครุ",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งครุ",
                                "postcode":"10140"
                            },
                            {
                                "tumbon":"บางมด",
                                "postcode":"10140"
                            }
                            ]
                        },
                        {
                            "amphur":"บางบอน",
                            "listTumbon":[
                            {
                                "tumbon":"บางบอน",
                                "postcode":"10150"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"นนทบุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองนนทบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"สวนใหญ่",
                                "postcode":"11000"
                            },
                            {
                                "tumbon":"ตลาดขวัญ",
                                "postcode":"11000"
                            },
                            {
                                "tumbon":"บางเขน",
                                "postcode":"11000"
                            },
                            {
                                "tumbon":"บางกระสอ",
                                "postcode":"11000"
                            },
                            {
                                "tumbon":"ท่าทราย",
                                "postcode":"11000"
                            },
                            {
                                "tumbon":"บางไผ่",
                                "postcode":"11000"
                            },
                            {
                                "tumbon":"บางศรีเมือง",
                                "postcode":"11000"
                            },
                            {
                                "tumbon":"บางกร่าง",
                                "postcode":"11000"
                            },
                            {
                                "tumbon":"ไทรม้า",
                                "postcode":"11000"
                            },
                            {
                                "tumbon":"บางรักน้อย",
                                "postcode":"11000"
                            }
                            ]
                        },
                        {
                            "amphur":"บางกรวย",
                            "listTumbon":[
                            {
                                "tumbon":"วัดชลอ",
                                "postcode":"11130"
                            },
                            {
                                "tumbon":"บางกรวย",
                                "postcode":"11130"
                            },
                            {
                                "tumbon":"บางสีทอง",
                                "postcode":"11130"
                            },
                            {
                                "tumbon":"บางขนุน",
                                "postcode":"11130"
                            },
                            {
                                "tumbon":"บางขุนกอง",
                                "postcode":"11130"
                            },
                            {
                                "tumbon":"บางคูเวียง",
                                "postcode":"11130"
                            },
                            {
                                "tumbon":"มหาสวัสดิ์",
                                "postcode":"11130"
                            },
                            {
                                "tumbon":"ปลายบาง",
                                "postcode":"11130"
                            },
                            {
                                "tumbon":"ศาลากลาง",
                                "postcode":"11130"
                            }
                            ]
                        },
                        {
                            "amphur":"บางใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"บางม่วง",
                                "postcode":"11140"
                            },
                            {
                                "tumbon":"บางแม่นาง",
                                "postcode":"11140"
                            },
                            {
                                "tumbon":"บางเลน",
                                "postcode":"11140"
                            },
                            {
                                "tumbon":"เสาธงหิน",
                                "postcode":"11140"
                            },
                            {
                                "tumbon":"บางใหญ่",
                                "postcode":"11140"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"11140"
                            }
                            ]
                        },
                        {
                            "amphur":"บางบัวทอง",
                            "listTumbon":[
                            {
                                "tumbon":"โสนลอย",
                                "postcode":"11110"
                            },
                            {
                                "tumbon":"บางบัวทอง",
                                "postcode":"11110"
                            },
                            {
                                "tumbon":"บางรักใหญ่",
                                "postcode":"11110"
                            },
                            {
                                "tumbon":"บางคูรัด",
                                "postcode":"11110"
                            },
                            {
                                "tumbon":"ละหาร",
                                "postcode":"11110"
                            },
                            {
                                "tumbon":"ลำโพ",
                                "postcode":"11110"
                            },
                            {
                                "tumbon":"พิมลราช",
                                "postcode":"11110"
                            },
                            {
                                "tumbon":"บางรักพัฒนา",
                                "postcode":"11110"
                            }
                            ]
                        },
                        {
                            "amphur":"ไทรน้อย",
                            "listTumbon":[
                            {
                                "tumbon":"ไทรน้อย",
                                "postcode":"11150"
                            },
                            {
                                "tumbon":"ราษฎร์นิยม",
                                "postcode":"11150"
                            },
                            {
                                "tumbon":"หนองเพรางาย",
                                "postcode":"11150"
                            },
                            {
                                "tumbon":"ไทรใหญ่",
                                "postcode":"11150"
                            },
                            {
                                "tumbon":"ขุนศรี",
                                "postcode":"11150"
                            },
                            {
                                "tumbon":"คลองขวาง",
                                "postcode":"11150"
                            },
                            {
                                "tumbon":"ทวีวัฒนา",
                                "postcode":"11150"
                            }
                            ]
                        },
                        {
                            "amphur":"ปากเกร็ด",
                            "listTumbon":[
                            {
                                "tumbon":"ปากเกร็ด",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"บางตลาด",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"บางพูด",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"บางตะไนย์",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"คลองพระอุดม",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"ท่าอิฐ",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"เกาะเกร็ด",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"อ้อมเกร็ด",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"บางพลับ",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"คลองเกลือ",
                                "postcode":"11120"
                            },
                            {
                                "tumbon":"คลองข่อย",
                                "postcode":"11120"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ปทุมธานี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองปทุมธานี",
                            "listTumbon":[
                            {
                                "tumbon":"บางปรอก",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บ้านกลาง",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บ้านฉาง",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บ้านกระแชง",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บางขะแยง",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บางคูวัด",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บางหลวง",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บางเดื่อ",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บางพูด",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บางพูน",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"บางกะดี",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"สวนพริกไทย",
                                "postcode":"12000"
                            },
                            {
                                "tumbon":"หลักหก",
                                "postcode":"12000"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"คลองหนึ่ง",
                                "postcode":"12120"
                            },
                            {
                                "tumbon":"คลองสอง",
                                "postcode":"12120"
                            },
                            {
                                "tumbon":"คลองสาม",
                                "postcode":"12120"
                            },
                            {
                                "tumbon":"คลองสี่",
                                "postcode":"12120"
                            },
                            {
                                "tumbon":"คลองห้า",
                                "postcode":"12120"
                            },
                            {
                                "tumbon":"คลองหก",
                                "postcode":"12120"
                            },
                            {
                                "tumbon":"คลองเจ็ด",
                                "postcode":"12120"
                            }
                            ]
                        },
                        {
                            "amphur":"ธัญบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ประชาธิปัตย์",
                                "postcode":"12130"
                            },
                            {
                                "tumbon":"บึงยี่โถ",
                                "postcode":"12130"
                            },
                            {
                                "tumbon":"รังสิต",
                                "postcode":"12110"
                            },
                            {
                                "tumbon":"ลำผักกูด",
                                "postcode":"12110"
                            },
                            {
                                "tumbon":"บึงสนั่น",
                                "postcode":"12110"
                            },
                            {
                                "tumbon":"บึงน้ำรักษ์",
                                "postcode":"12110"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองเสือ",
                            "listTumbon":[
                            {
                                "tumbon":"บึงบา",
                                "postcode":"12170"
                            },
                            {
                                "tumbon":"บึงบอน",
                                "postcode":"12170"
                            },
                            {
                                "tumbon":"บึงกาสาม",
                                "postcode":"12170"
                            },
                            {
                                "tumbon":"บึงชำอ้อ",
                                "postcode":"12170"
                            },
                            {
                                "tumbon":"หนองสามวัง",
                                "postcode":"12170"
                            },
                            {
                                "tumbon":"ศาลาครุ",
                                "postcode":"12170"
                            },
                            {
                                "tumbon":"นพรัตน์",
                                "postcode":"12170"
                            }
                            ]
                        },
                        {
                            "amphur":"ลาดหลุมแก้ว",
                            "listTumbon":[
                            {
                                "tumbon":"ระแหง",
                                "postcode":"12140"
                            },
                            {
                                "tumbon":"ลาดหลุมแก้ว",
                                "postcode":"12140"
                            },
                            {
                                "tumbon":"คูบางหลวง",
                                "postcode":"12140"
                            },
                            {
                                "tumbon":"คูขวาง",
                                "postcode":"12140"
                            },
                            {
                                "tumbon":"คลองพระอุดม",
                                "postcode":"12140"
                            },
                            {
                                "tumbon":"บ่อเงิน",
                                "postcode":"12140"
                            },
                            {
                                "tumbon":"หน้าไม้",
                                "postcode":"12140"
                            }
                            ]
                        },
                        {
                            "amphur":"ลำลูกกา",
                            "listTumbon":[
                            {
                                "tumbon":"คูคต",
                                "postcode":"12130"
                            },
                            {
                                "tumbon":"ลาดสวาย",
                                "postcode":"12150"
                            },
                            {
                                "tumbon":"บึงคำพร้อย",
                                "postcode":"12150"
                            },
                            {
                                "tumbon":"ลำลูกกา",
                                "postcode":"12150"
                            },
                            {
                                "tumbon":"บึงทองหลาง",
                                "postcode":"12150"
                            },
                            {
                                "tumbon":"ลำไทร",
                                "postcode":"12150"
                            },
                            {
                                "tumbon":"บึงคอไห",
                                "postcode":"12150"
                            },
                            {
                                "tumbon":"พืชอุดม",
                                "postcode":"12150"
                            }
                            ]
                        },
                        {
                            "amphur":"สามโคก",
                            "listTumbon":[
                            {
                                "tumbon":"บางเตย",
                                "postcode":"12160"
                            },
                            {
                                "tumbon":"คลองควาย",
                                "postcode":"12160"
                            },
                            {
                                "tumbon":"สามโคก",
                                "postcode":"12160"
                            },
                            {
                                "tumbon":"กระแชง",
                                "postcode":"12160"
                            },
                            {
                                "tumbon":"บางโพธิ์เหนือ",
                                "postcode":"12160"
                            },
                            {
                                "tumbon":"เชียงรากใหญ่",
                                "postcode":"12160"
                            },
                            {
                                "tumbon":"บ้านปทุม",
                                "postcode":"12160"
                            },
                            {
                                "tumbon":"บ้านงิ้ว",
                                "postcode":"12160"
                            },
                            {
                                "tumbon":"เชียงรากน้อย",
                                "postcode":"12160"
                            },
                            {
                                "tumbon":"บางกระบือ",
                                "postcode":"12160"
                            },
                            {
                                "tumbon":"ท้ายเกาะ",
                                "postcode":"12160"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"พระนครศรีอยุธยา",
                    "listAmphur":[
                        {
                            "amphur":"พระนครศรีอยุธยา",
                            "listTumbon":[
                            {
                                "tumbon":"ไผ่ลิง",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"ปากกราน",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"ภูเขาทอง",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"สำเภาล่ม",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"สวนพริก",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"คลองตะเคียน",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"วัดตูม",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"หันตรา",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"ลุมพลี",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"บ้านเกาะ",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"คลองสวนพลู",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"คลองสระบัว",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"เกาะเรียน",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"บ้านป้อม",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"บ้านรุน",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"กะมัง",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"ท่าวาสุกรี",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"ประตูชัย",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"หอรัตนไชย",
                                "postcode":"13000"
                            },
                            {
                                "tumbon":"หัวรอ",
                                "postcode":"13000"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าเรือ",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าเรือ",
                                "postcode":"13130"
                            },
                            {
                                "tumbon":"จำปา",
                                "postcode":"13130"
                            },
                            {
                                "tumbon":"ท่าหลวง",
                                "postcode":"18270"
                            },
                            {
                                "tumbon":"บ้านร่อม",
                                "postcode":"13130"
                            },
                            {
                                "tumbon":"ศาลาลอย",
                                "postcode":"13130"
                            },
                            {
                                "tumbon":"วังแดง",
                                "postcode":"13130"
                            },
                            {
                                "tumbon":"โพธิ์เอน",
                                "postcode":"13130"
                            },
                            {
                                "tumbon":"ปากท่า",
                                "postcode":"13130"
                            },
                            {
                                "tumbon":"หนองขนาก",
                                "postcode":"13130"
                            },
                            {
                                "tumbon":"ท่าเจ้าสนุก",
                                "postcode":"13130"
                            }
                            ]
                        },
                        {
                            "amphur":"นครหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"นครหลวง",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"ท่าช้าง",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"บ่อโพง",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"บ้านชุ้ง",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"ปากจั่น",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"บางระกำ",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"บางพระครู",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"แม่ลา",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"หนองปลิง",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"คลองสะแก",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"สามไถ",
                                "postcode":"13260"
                            },
                            {
                                "tumbon":"พระนอน",
                                "postcode":"13260"
                            }
                            ]
                        },
                        {
                            "amphur":"บางไทร",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านเกาะ",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"บางไทร",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"บางพลี",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"สนามชัย",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"หน้าไม้",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"บางยี่โท",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"แคออก",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"แคตก",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"ช่างเหล็ก",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"กระแชง",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"บ้านกลึง",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"ช้างน้อย",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"ห่อหมก",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"ไผ่พระ",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"กกแก้วบูรพา",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"ไม้ตรา",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"บ้านม้า",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"ราชคราม",
                                "postcode":"13290"
                            },
                            {
                                "tumbon":"ช้างใหญ่",
                                "postcode":"13290"
                            },
                            {
                                "tumbon":"โพแตง",
                                "postcode":"13290"
                            },
                            {
                                "tumbon":"เชียงรากน้อย",
                                "postcode":"13290"
                            },
                            {
                                "tumbon":"บ้านแป้ง",
                                "postcode":"13190"
                            },
                            {
                                "tumbon":"โคกช้าง",
                                "postcode":"13190"
                            }
                            ]
                        },
                        {
                            "amphur":"บางบาล",
                            "listTumbon":[
                            {
                                "tumbon":"บางบาล",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"วัดยม",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"ไทรน้อย",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"สะพานไทย",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"มหาพราหมณ์",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"กบเจา",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"บ้านคลัง",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"พระขาว",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"ทางช้าง",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"วัดตะกู",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"บางหลวง",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"บางหลวงโดด",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"บางหัก",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"บางชะนี",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"บ้านกุ่ม",
                                "postcode":"13250"
                            },
                            {
                                "tumbon":"น้ำเต้า",
                                "postcode":"13250"
                            }
                            ]
                        },
                        {
                            "amphur":"บางปะอิน",
                            "listTumbon":[
                            {
                                "tumbon":"วัดยม",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"บ้านเลน",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"เชียงรากน้อย",
                                "postcode":"13180"
                            },
                            {
                                "tumbon":"บ้านโพ",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"บ้านกรด",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"บางกระสั้น",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"คลองจิก",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"บ้านหว้า",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"บางประแดง",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"สามเรือน",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"เกาะเกิด",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"บ้านพลับ",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"บ้านแป้ง",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"คุ้งลาน",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"ตลิ่งชัน",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"บ้านสร้าง",
                                "postcode":"13170"
                            },
                            {
                                "tumbon":"ตลาดเกรียบ",
                                "postcode":"13160"
                            },
                            {
                                "tumbon":"ขนอนหลวง",
                                "postcode":"13160"
                            }
                            ]
                        },
                        {
                            "amphur":"บางปะหัน",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านม้า",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"บางปะหัน",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"ขยาย",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"บางเดื่อ",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"เสาธง",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"ทางกลาง",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"บางเพลิง",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"หันสัง",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"บางนางร้า",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"ตานิม",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"ทับน้ำ",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"ขวัญเมือง",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"บ้านลี่",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"โพธิ์สามต้น",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"พุทเลา",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"ตาลเอน",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"บ้านขล้อ",
                                "postcode":"13220"
                            },
                            {
                                "tumbon":"พุทเลา",
                                "postcode":"13220"
                            }
                            ]
                        },
                        {
                            "amphur":"ผักไห่",
                            "listTumbon":[
                            {
                                "tumbon":"ผักไห่",
                                "postcode":"13120"
                            },
                            {
                                "tumbon":"อมฤต",
                                "postcode":"13120"
                            },
                            {
                                "tumbon":"บ้านแค",
                                "postcode":"13120"
                            },
                            {
                                "tumbon":"ลาดน้ำเค็ม",
                                "postcode":"13120"
                            },
                            {
                                "tumbon":"ตาลาน",
                                "postcode":"13120"
                            },
                            {
                                "tumbon":"ท่าดินแดง",
                                "postcode":"13120"
                            },
                            {
                                "tumbon":"ดอนลาน",
                                "postcode":"13280"
                            },
                            {
                                "tumbon":"นาคู",
                                "postcode":"13280"
                            },
                            {
                                "tumbon":"กุฎี",
                                "postcode":"13120"
                            },
                            {
                                "tumbon":"ลำตะเคียน",
                                "postcode":"13280"
                            },
                            {
                                "tumbon":"โคกช้าง",
                                "postcode":"13120"
                            },
                            {
                                "tumbon":"จักราช",
                                "postcode":"13280"
                            },
                            {
                                "tumbon":"หนองน้ำใหญ่",
                                "postcode":"13280"
                            },
                            {
                                "tumbon":"ลาดชิด",
                                "postcode":"13120"
                            },
                            {
                                "tumbon":"หน้าโคก",
                                "postcode":"13120"
                            },
                            {
                                "tumbon":"บ้านใหญ่",
                                "postcode":"13120"
                            }
                            ]
                        },
                        {
                            "amphur":"ภาชี",
                            "listTumbon":[
                            {
                                "tumbon":"ภาชี",
                                "postcode":"13140"
                            },
                            {
                                "tumbon":"โคกม่วง",
                                "postcode":"13140"
                            },
                            {
                                "tumbon":"ระโสม",
                                "postcode":"13140"
                            },
                            {
                                "tumbon":"หนองน้ำใส",
                                "postcode":"13140"
                            },
                            {
                                "tumbon":"ดอนหญ้านาง",
                                "postcode":"13140"
                            },
                            {
                                "tumbon":"ไผ่ล้อม",
                                "postcode":"13140"
                            },
                            {
                                "tumbon":"กระจิว",
                                "postcode":"13140"
                            },
                            {
                                "tumbon":"พระแก้ว",
                                "postcode":"13140"
                            }
                            ]
                        },
                        {
                            "amphur":"ลาดบัวหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"ลาดบัวหลวง",
                                "postcode":"13230"
                            },
                            {
                                "tumbon":"หลักชัย",
                                "postcode":"13230"
                            },
                            {
                                "tumbon":"สามเมือง",
                                "postcode":"13230"
                            },
                            {
                                "tumbon":"พระยาบันลือ",
                                "postcode":"13230"
                            },
                            {
                                "tumbon":"สิงหนาท",
                                "postcode":"13230"
                            },
                            {
                                "tumbon":"คู้สลอด",
                                "postcode":"13230"
                            },
                            {
                                "tumbon":"คลองพระยาบันลือ",
                                "postcode":"13230"
                            }
                            ]
                        },
                        {
                            "amphur":"วังน้อย",
                            "listTumbon":[
                            {
                                "tumbon":"ลำตาเสา",
                                "postcode":"13170"
                            },
                            {
                                "tumbon":"บ่อตาโล่",
                                "postcode":"13170"
                            },
                            {
                                "tumbon":"วังน้อย",
                                "postcode":"13170"
                            },
                            {
                                "tumbon":"ลำไทร",
                                "postcode":"13170"
                            },
                            {
                                "tumbon":"สนับทึบ",
                                "postcode":"13170"
                            },
                            {
                                "tumbon":"พยอม",
                                "postcode":"13170"
                            },
                            {
                                "tumbon":"หันตะเภา",
                                "postcode":"13170"
                            },
                            {
                                "tumbon":"วังจุฬา",
                                "postcode":"13170"
                            },
                            {
                                "tumbon":"ข้าวงาม",
                                "postcode":"13170"
                            },
                            {
                                "tumbon":"ชะแมบ",
                                "postcode":"13170"
                            }
                            ]
                        },
                        {
                            "amphur":"เสนา",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านแพน",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"เจ้าเจ็ด",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"สามกอ",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"บางนมโค",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"หัวเวียง",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"มารวิชัย",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"บ้านโพธิ์",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"รางจรเข้",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"บ้านกระทุ่ม",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"บ้านแถว",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"ชายนา",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"สามตุ่ม",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"ลาดงา",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"ดอนทอง",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"บ้านหลวง",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"เจ้าเสด็จ",
                                "postcode":"13110"
                            },
                            {
                                "tumbon":"เสนา",
                                "postcode":"13110"
                            }
                            ]
                        },
                        {
                            "amphur":"บางซ้าย",
                            "listTumbon":[
                            {
                                "tumbon":"บางซ้าย",
                                "postcode":"13270"
                            },
                            {
                                "tumbon":"แก้วฟ้า",
                                "postcode":"13270"
                            },
                            {
                                "tumbon":"เต่าเล่า",
                                "postcode":"13270"
                            },
                            {
                                "tumbon":"ปลายกลัด",
                                "postcode":"13270"
                            },
                            {
                                "tumbon":"เทพมงคล",
                                "postcode":"13270"
                            },
                            {
                                "tumbon":"วังพัฒนา",
                                "postcode":"13270"
                            }
                            ]
                        },
                        {
                            "amphur":"อุทัย",
                            "listTumbon":[
                            {
                                "tumbon":"คานหาม",
                                "postcode":"13210"
                            },
                            {
                                "tumbon":"บ้านช้าง",
                                "postcode":"13210"
                            },
                            {
                                "tumbon":"สามบัณฑิต",
                                "postcode":"13210"
                            },
                            {
                                "tumbon":"บ้านหีบ",
                                "postcode":"13210"
                            },
                            {
                                "tumbon":"หนองไม้ซุง",
                                "postcode":"13210"
                            },
                            {
                                "tumbon":"อุทัย",
                                "postcode":"13210"
                            },
                            {
                                "tumbon":"เสนา",
                                "postcode":"13210"
                            },
                            {
                                "tumbon":"หนองน้ำส้ม",
                                "postcode":"13210"
                            },
                            {
                                "tumbon":"โพสาวหาญ",
                                "postcode":"13210"
                            },
                            {
                                "tumbon":"ธนู",
                                "postcode":"13210"
                            },
                            {
                                "tumbon":"ข้าวเม่า",
                                "postcode":"13210"
                            }
                            ]
                        },
                        {
                            "amphur":"มหาราช",
                            "listTumbon":[
                            {
                                "tumbon":"หัวไผ่",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"กะทุ่ม",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"มหาราช",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"น้ำเต้า",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"บางนา",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"โรงช้าง",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"เจ้าปลุก",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"พิตเพียน",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"บ้านขวาง",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"ท่าตอ",
                                "postcode":"13150"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"13150"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านแพรก",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านแพรก",
                                "postcode":"13240"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"13240"
                            },
                            {
                                "tumbon":"สำพะเนียง",
                                "postcode":"13240"
                            },
                            {
                                "tumbon":"คลองน้อย",
                                "postcode":"13240"
                            },
                            {
                                "tumbon":"สองห้อง",
                                "postcode":"13240"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"อ่างทอง",
                    "listAmphur":[
                        {
                            "amphur":"เมืองอ่างทอง",
                            "listTumbon":[
                            {
                                "tumbon":"ตลาดหลวง",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"ศาลาแดง",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"ป่างิ้ว",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"บ้านแห",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"ตลาดกรวด",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"มหาดไทย",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"บ้านอิฐ",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"หัวไผ่",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"จำปาหล่อ",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"โพสะ",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"บ้านรี",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"คลองวัว",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"ย่านซื่อ",
                                "postcode":"14000"
                            },
                            {
                                "tumbon":"บางแก้ว",
                                "postcode":"14000"
                            }
                            ]
                        },
                        {
                            "amphur":"ไชโย",
                            "listTumbon":[
                            {
                                "tumbon":"จรเข้ร้อง",
                                "postcode":"14140"
                            },
                            {
                                "tumbon":"ไชยภูมิ",
                                "postcode":"14140"
                            },
                            {
                                "tumbon":"ชัยฤทธิ์",
                                "postcode":"14140"
                            },
                            {
                                "tumbon":"เทวราช",
                                "postcode":"14140"
                            },
                            {
                                "tumbon":"ราชสถิตย์",
                                "postcode":"14140"
                            },
                            {
                                "tumbon":"ไชโย",
                                "postcode":"14140"
                            },
                            {
                                "tumbon":"หลักฟ้า",
                                "postcode":"14140"
                            },
                            {
                                "tumbon":"ชะไว",
                                "postcode":"14140"
                            },
                            {
                                "tumbon":"ตรีณรงค์",
                                "postcode":"14140"
                            }
                            ]
                        },
                        {
                            "amphur":"ป่าโมก",
                            "listTumbon":[
                            {
                                "tumbon":"บางปลากด",
                                "postcode":"14130"
                            },
                            {
                                "tumbon":"สายทอง",
                                "postcode":"14130"
                            },
                            {
                                "tumbon":"โรงช้าง",
                                "postcode":"14130"
                            },
                            {
                                "tumbon":"บางเสด็จ",
                                "postcode":"14130"
                            },
                            {
                                "tumbon":"นรสิงห์",
                                "postcode":"14130"
                            },
                            {
                                "tumbon":"เอกราช",
                                "postcode":"14130"
                            },
                            {
                                "tumbon":"โผงเผง",
                                "postcode":"14130"
                            },
                            {
                                "tumbon":"ป่าโมก",
                                "postcode":"14130"
                            }
                            ]
                        },
                        {
                            "amphur":"โพธิ์ทอง",
                            "listTumbon":[
                            {
                                "tumbon":"อ่างแก้ว",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"อินทประมูล",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"บางพลับ",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"หนองแม่ไก่",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"รำมะสัก",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"บางระกำ",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"โพธิ์รังนก",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"องครักษ์",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"โคกพุทรา",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"ยางช้าย",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"บ่อแร่",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"ทางพระ",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"สามง่าม",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"บางเจ้าฉ่า",
                                "postcode":"14120"
                            },
                            {
                                "tumbon":"คำหยาด",
                                "postcode":"14120"
                            }
                            ]
                        },
                        {
                            "amphur":"แสวงหา",
                            "listTumbon":[
                            {
                                "tumbon":"แสวงหา",
                                "postcode":"14150"
                            },
                            {
                                "tumbon":"ศรีพราน",
                                "postcode":"14150"
                            },
                            {
                                "tumbon":"บ้านพราน",
                                "postcode":"14150"
                            },
                            {
                                "tumbon":"วังน้ำเย็น",
                                "postcode":"14150"
                            },
                            {
                                "tumbon":"สีบัวทอง",
                                "postcode":"14150"
                            },
                            {
                                "tumbon":"ห้วยไผ่",
                                "postcode":"14150"
                            },
                            {
                                "tumbon":"จำลอง",
                                "postcode":"14150"
                            }
                            ]
                        },
                        {
                            "amphur":"วิเศษชัยชาญ",
                            "listTumbon":[
                            {
                                "tumbon":"ไผ่จำศีล",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"ศาลเจ้าโรงทอง",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"ไผ่ดำพัฒนา",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"สาวร้องไห้",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"ท่าช้าง",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"ยี่ล้น",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"บางจัก",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"ห้วยคันแหลน",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"คลองขนาก",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"ไผ่วง",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"สี่ร้อย",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"ม่วงเตี้ย",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"หัวตะพาน",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"หลักแก้ว",
                                "postcode":"14110"
                            },
                            {
                                "tumbon":"ตลาดใหม่",
                                "postcode":"14110"
                            }
                            ]
                        },
                        {
                            "amphur":"สามโก้",
                            "listTumbon":[
                            {
                                "tumbon":"สามโก้",
                                "postcode":"14160"
                            },
                            {
                                "tumbon":"ราษฎรพัฒนา",
                                "postcode":"14160"
                            },
                            {
                                "tumbon":"อบทม",
                                "postcode":"14160"
                            },
                            {
                                "tumbon":"โพธิ์ม่วงพันธ์",
                                "postcode":"14160"
                            },
                            {
                                "tumbon":"มงคลธรรมนิมิต",
                                "postcode":"14160"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สมุทรปราการ",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสมุทรปราการ",
                            "listTumbon":[
                            {
                                "tumbon":"ปากน้ำ",
                                "postcode":"10270"
                            },
                            {
                                "tumbon":"สำโรงเหนือ",
                                "postcode":"10270"
                            },
                            {
                                "tumbon":"บางเมือง",
                                "postcode":"10270"
                            },
                            {
                                "tumbon":"ท้ายบ้าน",
                                "postcode":"10280"
                            },
                            {
                                "tumbon":"บางปูใหม่",
                                "postcode":"10280"
                            },
                            {
                                "tumbon":"แพรกษา",
                                "postcode":"10280"
                            },
                            {
                                "tumbon":"บางโปรง",
                                "postcode":"10270"
                            },
                            {
                                "tumbon":"บางปู",
                                "postcode":"10280"
                            },
                            {
                                "tumbon":"บางด้วน",
                                "postcode":"10270"
                            },
                            {
                                "tumbon":"บางเมืองใหม่",
                                "postcode":"10270"
                            },
                            {
                                "tumbon":"เทพารักษ์",
                                "postcode":"10270"
                            },
                            {
                                "tumbon":"ท้ายบ้านใหม่",
                                "postcode":"10280"
                            },
                            {
                                "tumbon":"แพรกษาใหม่",
                                "postcode":"10280"
                            }
                            ]
                        },
                        {
                            "amphur":"บางบ่อ",
                            "listTumbon":[
                            {
                                "tumbon":"บางบ่อ",
                                "postcode":"10560"
                            },
                            {
                                "tumbon":"บ้านระกาศ",
                                "postcode":"10560"
                            },
                            {
                                "tumbon":"บางพลีน้อย",
                                "postcode":"10560"
                            },
                            {
                                "tumbon":"บางเพรียง",
                                "postcode":"10560"
                            },
                            {
                                "tumbon":"คลองด่าน",
                                "postcode":"10550"
                            },
                            {
                                "tumbon":"คลองสวน",
                                "postcode":"10560"
                            },
                            {
                                "tumbon":"เปร็ง",
                                "postcode":"10560"
                            },
                            {
                                "tumbon":"คลองนิยมยาตรา",
                                "postcode":"10560"
                            }
                            ]
                        },
                        {
                            "amphur":"บางพลี",
                            "listTumbon":[
                            {
                                "tumbon":"บางพลีใหญ่",
                                "postcode":"10540"
                            },
                            {
                                "tumbon":"บางแก้ว",
                                "postcode":"10540"
                            },
                            {
                                "tumbon":"บางปลา",
                                "postcode":"10540"
                            },
                            {
                                "tumbon":"บางโฉลง",
                                "postcode":"10540"
                            },
                            {
                                "tumbon":"ราชาเทวะ",
                                "postcode":"10540"
                            },
                            {
                                "tumbon":"หนองปรือ",
                                "postcode":"10540"
                            }
                            ]
                        },
                        {
                            "amphur":"พระประแดง",
                            "listTumbon":[
                            {
                                "tumbon":"ตลาด",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"บางพึ่ง",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"บางจาก",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"บางครุ",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"บางหญ้าแพรก",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"บางหัวเสือ",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"สำโรงใต้",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"บางยอ",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"บางกะเจ้า",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"บางน้ำผึ้ง",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"บางกระสอบ",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"บางกอบัว",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"ทรงคนอง",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"10130"
                            },
                            {
                                "tumbon":"สำโรงกลาง",
                                "postcode":"10130"
                            }
                            ]
                        },
                        {
                            "amphur":"พระสมุทรเจดีย์",
                            "listTumbon":[
                            {
                                "tumbon":"นาเกลือ",
                                "postcode":"10290"
                            },
                            {
                                "tumbon":"บ้านคลองสวน",
                                "postcode":"10290"
                            },
                            {
                                "tumbon":"แหลมฟ้าผ่า",
                                "postcode":"10290"
                            },
                            {
                                "tumbon":"ปากคลองบางปลากด",
                                "postcode":"10290"
                            },
                            {
                                "tumbon":"ในคลองบางปลากด",
                                "postcode":"10290"
                            }
                            ]
                        },
                        {
                            "amphur":"บางเสาธง",
                            "listTumbon":[
                            {
                                "tumbon":"บางเสาธง",
                                "postcode":"10540"
                            },
                            {
                                "tumbon":"ศีรษะจรเข้น้อย",
                                "postcode":"10540"
                            },
                            {
                                "tumbon":"ศีรษะจรเข้ใหญ่",
                                "postcode":"10540"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สระบุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสระบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ปากเพรียว",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"ดาวเรือง",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"นาโฉง",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"โคกสว่าง",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"หนองโน",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"หนองยาว",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"ปากข้าวสาร",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"หนองปลาไหล",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"กุดนกเปล้า",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"ตลิ่งชัน",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"ตะกุด",
                                "postcode":"18000"
                            }
                            ]
                        },
                        {
                            "amphur":"แก่งคอย",
                            "listTumbon":[
                            {
                                "tumbon":"แก่งคอย",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"ทับกวาง",
                                "postcode":"18260"
                            },
                            {
                                "tumbon":"ตาลเดี่ยว",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"ห้วยแห้ง",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"ท่าคล้อ",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"หินซ้อน",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"บ้านป่า",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"ท่าตูม",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"ชะอม",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"สองคอน",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"เตาปูน",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"ชำผักแพว",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"ท่ามะปราง",
                                "postcode":"18110"
                            },
                            {
                                "tumbon":"บ้านธาตุ",
                                "postcode":"18110"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองแค",
                            "listTumbon":[
                            {
                                "tumbon":"หนองแค",
                                "postcode":"18140"
                            },
                            {
                                "tumbon":"กุ่มหัก",
                                "postcode":"18140"
                            },
                            {
                                "tumbon":"คชสิทธิ์",
                                "postcode":"18250"
                            },
                            {
                                "tumbon":"โคกตูม",
                                "postcode":"18250"
                            },
                            {
                                "tumbon":"โคกแย้",
                                "postcode":"18230"
                            },
                            {
                                "tumbon":"บัวลอย",
                                "postcode":"18230"
                            },
                            {
                                "tumbon":"ไผ่ต่ำ",
                                "postcode":"18140"
                            },
                            {
                                "tumbon":"โพนทอง",
                                "postcode":"18250"
                            },
                            {
                                "tumbon":"ห้วยขมิ้น",
                                "postcode":"18230"
                            },
                            {
                                "tumbon":"ห้วยทราย",
                                "postcode":"18230"
                            },
                            {
                                "tumbon":"หนองไข่น้ำ",
                                "postcode":"18140"
                            },
                            {
                                "tumbon":"หนองแขม",
                                "postcode":"18140"
                            },
                            {
                                "tumbon":"หนองจิก",
                                "postcode":"18230"
                            },
                            {
                                "tumbon":"หนองจรเข้",
                                "postcode":"18140"
                            },
                            {
                                "tumbon":"หนองนาก",
                                "postcode":"18230"
                            },
                            {
                                "tumbon":"หนองปลาหมอ",
                                "postcode":"18140"
                            },
                            {
                                "tumbon":"หนองปลิง",
                                "postcode":"18140"
                            },
                            {
                                "tumbon":"หนองโรง",
                                "postcode":"18140"
                            }
                            ]
                        },
                        {
                            "amphur":"วิหารแดง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองหมู",
                                "postcode":"18150"
                            },
                            {
                                "tumbon":"บ้านลำ",
                                "postcode":"18150"
                            },
                            {
                                "tumbon":"คลองเรือ",
                                "postcode":"18150"
                            },
                            {
                                "tumbon":"วิหารแดง",
                                "postcode":"18150"
                            },
                            {
                                "tumbon":"หนองสรวง",
                                "postcode":"18150"
                            },
                            {
                                "tumbon":"เจริญธรรม",
                                "postcode":"18150"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองแซง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองแซง",
                                "postcode":"18170"
                            },
                            {
                                "tumbon":"หนองควายโซ",
                                "postcode":"18170"
                            },
                            {
                                "tumbon":"หนองหัวโพ",
                                "postcode":"18170"
                            },
                            {
                                "tumbon":"หนองสีดา",
                                "postcode":"18170"
                            },
                            {
                                "tumbon":"หนองกบ",
                                "postcode":"18170"
                            },
                            {
                                "tumbon":"ไก่เส่า",
                                "postcode":"18170"
                            },
                            {
                                "tumbon":"โคกสะอาด",
                                "postcode":"18170"
                            },
                            {
                                "tumbon":"ม่วงหวาน",
                                "postcode":"18170"
                            },
                            {
                                "tumbon":"เขาดิน",
                                "postcode":"18170"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านหมอ",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านหมอ",
                                "postcode":"18130"
                            },
                            {
                                "tumbon":"บางโขมด",
                                "postcode":"18130"
                            },
                            {
                                "tumbon":"สร่างโศก",
                                "postcode":"18130"
                            },
                            {
                                "tumbon":"ตลาดน้อย",
                                "postcode":"18130"
                            },
                            {
                                "tumbon":"หรเทพ",
                                "postcode":"18130"
                            },
                            {
                                "tumbon":"โคกใหญ่",
                                "postcode":"18130"
                            },
                            {
                                "tumbon":"ไผ่ขวาง",
                                "postcode":"18130"
                            },
                            {
                                "tumbon":"บ้านครัว",
                                "postcode":"18270"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"18130"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอนพุด",
                            "listTumbon":[
                            {
                                "tumbon":"ดอนพุด",
                                "postcode":"18210"
                            },
                            {
                                "tumbon":"ไผ่หลิ่ว",
                                "postcode":"18210"
                            },
                            {
                                "tumbon":"บ้านหลวง",
                                "postcode":"18210"
                            },
                            {
                                "tumbon":"ดงตะงาว",
                                "postcode":"18210"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองโดน",
                            "listTumbon":[
                            {
                                "tumbon":"หนองโดน",
                                "postcode":"18190"
                            },
                            {
                                "tumbon":"บ้านกลับ",
                                "postcode":"18190"
                            },
                            {
                                "tumbon":"ดอนทอง",
                                "postcode":"18190"
                            },
                            {
                                "tumbon":"บ้านโปร่ง",
                                "postcode":"18190"
                            }
                            ]
                        },
                        {
                            "amphur":"พระพุทธบาท",
                            "listTumbon":[
                            {
                                "tumbon":"พระพุทธบาท",
                                "postcode":"18120"
                            },
                            {
                                "tumbon":"ขุนโขลน",
                                "postcode":"18120"
                            },
                            {
                                "tumbon":"ธารเกษม",
                                "postcode":"18120"
                            },
                            {
                                "tumbon":"นายาว",
                                "postcode":"18120"
                            },
                            {
                                "tumbon":"พุคำจาน",
                                "postcode":"18120"
                            },
                            {
                                "tumbon":"เขาวง",
                                "postcode":"18120"
                            },
                            {
                                "tumbon":"ห้วยป่าหวาย",
                                "postcode":"18120"
                            },
                            {
                                "tumbon":"พุกร่าง",
                                "postcode":"18120"
                            },
                            {
                                "tumbon":"หนองแก",
                                "postcode":"18120"
                            }
                            ]
                        },
                        {
                            "amphur":"เสาไห้",
                            "listTumbon":[
                            {
                                "tumbon":"เสาไห้",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"บ้านยาง",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"หัวปลวก",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"งิ้วงาม",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"ศาลารีไทย",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"ต้นตาล",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"ท่าช้าง",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"พระยาทด",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"ม่วงงาม",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"เริงราง",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"เมืองเก่า",
                                "postcode":"18160"
                            },
                            {
                                "tumbon":"สวนดอกไม้",
                                "postcode":"18160"
                            }
                            ]
                        },
                        {
                            "amphur":"มวกเหล็ก",
                            "listTumbon":[
                            {
                                "tumbon":"มิตรภาพ",
                                "postcode":"18180"
                            },
                            {
                                "tumbon":"หนองย่างเสือ",
                                "postcode":"18180"
                            },
                            {
                                "tumbon":"ลำสมพุง",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"ลำพญากลาง",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"ซับสนุ่น",
                                "postcode":"18220"
                            },
                            {
                                "tumbon":"มวกเหล็ก",
                                "postcode":"18180"
                            }
                            ]
                        },
                        {
                            "amphur":"วังม่วง",
                            "listTumbon":[
                            {
                                "tumbon":"แสลงพัน",
                                "postcode":"18220"
                            },
                            {
                                "tumbon":"คำพราน",
                                "postcode":"18220"
                            },
                            {
                                "tumbon":"วังม่วง",
                                "postcode":"18220"
                            }
                            ]
                        },
                        {
                            "amphur":"เฉลิมพระเกียรติ",
                            "listTumbon":[
                            {
                                "tumbon":"เขาดินพัฒนา",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"บ้านแก้ง",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"ผึ้งรวง",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"พุแค",
                                "postcode":"18240"
                            },
                            {
                                "tumbon":"ห้วยบง",
                                "postcode":"18000"
                            },
                            {
                                "tumbon":"หน้าพระลาน",
                                "postcode":"18240"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ลพบุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองลพบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ทะเลชุบศร",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"กกโก",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"โก่งธนู",
                                "postcode":"13240"
                            },
                            {
                                "tumbon":"เขาพระงาม",
                                "postcode":"15160"
                            },
                            {
                                "tumbon":"เขาสามยอด",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"โคกกะเทียม",
                                "postcode":"15160"
                            },
                            {
                                "tumbon":"โคกลำพาน",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"โคกตูม",
                                "postcode":"15210"
                            },
                            {
                                "tumbon":"งิ้วราย",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"ตะลุง",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"ท่าแค",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"ท่าศาลา",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"นิคมสร้างตนเอง",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"บางขันหมาก",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"บ้านข่อย",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"ท้ายตลาด",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"ป่าตาล",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"พรหมมาสตร์",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"โพธิ์เก้าต้น",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"โพธิ์ตรุ",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"สี่คลอง",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"ถนนใหญ่",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"ดอนโพธิ์",
                                "postcode":"15000"
                            },
                            {
                                "tumbon":"ท่าหิน",
                                "postcode":"15000"
                            }
                            ]
                        },
                        {
                            "amphur":"พัฒนานิคม",
                            "listTumbon":[
                            {
                                "tumbon":"พัฒนานิคม",
                                "postcode":"15140"
                            },
                            {
                                "tumbon":"ช่องสาริกา",
                                "postcode":"15220"
                            },
                            {
                                "tumbon":"มะนาวหวาน",
                                "postcode":"15140"
                            },
                            {
                                "tumbon":"ดีลัง",
                                "postcode":"15220"
                            },
                            {
                                "tumbon":"โคกสลุง",
                                "postcode":"15140"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"15140"
                            },
                            {
                                "tumbon":"ห้วยขุนราม",
                                "postcode":"18220"
                            },
                            {
                                "tumbon":"น้ำสุด",
                                "postcode":"15140"
                            },
                            {
                                "tumbon":"ชอนน้อย",
                                "postcode":"15140"
                            }
                            ]
                        },
                        {
                            "amphur":"โคกสำโรง",
                            "listTumbon":[
                            {
                                "tumbon":"โคกสำโรง",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"เกาะแก้ว",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"ถลุงเหล็ก",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"หลุมข้าว",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"ห้วยโป่ง",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"คลองเกตุ",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"สะแกราบ",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"เพนียด",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"วังเพลิง",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"ดงมะรุม",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"วังขอนขว้าง",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"วังจั่น",
                                "postcode":"15120"
                            },
                            {
                                "tumbon":"หนองแขม",
                                "postcode":"15120"
                            }
                            ]
                        },
                        {
                            "amphur":"ชัยบาดาล",
                            "listTumbon":[
                            {
                                "tumbon":"ลำนารายณ์",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"ชัยนารายณ์",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"ศิลาทิพย์",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"ห้วยหิน",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"ม่วงค่อม",
                                "postcode":"15230"
                            },
                            {
                                "tumbon":"บัวชุม",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"ท่าดินดำ",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"มะกอกหวาน",
                                "postcode":"15230"
                            },
                            {
                                "tumbon":"ซับตะเคียน",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"นาโสม",
                                "postcode":"15190"
                            },
                            {
                                "tumbon":"หนองยายโต๊ะ",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"เกาะรัง",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"ท่ามะนาว",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"นิคมลำนารายณ์",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"ชัยบาดาล",
                                "postcode":"15230"
                            },
                            {
                                "tumbon":"บ้านใหม่สามัคคี",
                                "postcode":"15130"
                            },
                            {
                                "tumbon":"เขาแหลม",
                                "postcode":"15130"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าวุ้ง",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าวุ้ง",
                                "postcode":"15150"
                            },
                            {
                                "tumbon":"บางคู้",
                                "postcode":"15150"
                            },
                            {
                                "tumbon":"โพตลาดแก้ว",
                                "postcode":"15150"
                            },
                            {
                                "tumbon":"บางลี่",
                                "postcode":"15150"
                            },
                            {
                                "tumbon":"บางงา",
                                "postcode":"15150"
                            },
                            {
                                "tumbon":"โคกสลุด",
                                "postcode":"15150"
                            },
                            {
                                "tumbon":"เขาสมอคอน",
                                "postcode":"15180"
                            },
                            {
                                "tumbon":"หัวสำโรง",
                                "postcode":"15150"
                            },
                            {
                                "tumbon":"ลาดสาลี่",
                                "postcode":"15150"
                            },
                            {
                                "tumbon":"บ้านเบิก",
                                "postcode":"15150"
                            },
                            {
                                "tumbon":"มุจลินท์",
                                "postcode":"15150"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านหมี่",
                            "listTumbon":[
                            {
                                "tumbon":"ไผ่ใหญ่",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"บ้านทราย",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"บ้านกล้วย",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"ดงพลับ",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"บ้านชี",
                                "postcode":"15180"
                            },
                            {
                                "tumbon":"พุคา",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"หินปัก",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"บางพึ่ง",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"หนองทรายขาว",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"บางกะพี้",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"หนองเต่า",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"โพนทอง",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"บางขาม",
                                "postcode":"15180"
                            },
                            {
                                "tumbon":"ดอนดึง",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"ชอนม่วง",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"หนองกระเบียน",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"สายห้วยแก้ว",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"มหาสอน",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"เชียงงา",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"หนองเมือง",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"สนามแจง",
                                "postcode":"15110"
                            },
                            {
                                "tumbon":"บ้านหมี่",
                                "postcode":"15110"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าหลวง",
                                "postcode":"15230"
                            },
                            {
                                "tumbon":"แก่งผักกูด",
                                "postcode":"15230"
                            },
                            {
                                "tumbon":"ซับจำปา",
                                "postcode":"15230"
                            },
                            {
                                "tumbon":"หนองผักแว่น",
                                "postcode":"15230"
                            },
                            {
                                "tumbon":"ทะเลวังวัด",
                                "postcode":"15230"
                            },
                            {
                                "tumbon":"หัวลำ",
                                "postcode":"15230"
                            }
                            ]
                        },
                        {
                            "amphur":"สระโบสถ์",
                            "listTumbon":[
                            {
                                "tumbon":"สระโบสถ์",
                                "postcode":"15240"
                            },
                            {
                                "tumbon":"มหาโพธิ",
                                "postcode":"15240"
                            },
                            {
                                "tumbon":"ทุ่งท่าช้าง",
                                "postcode":"15240"
                            },
                            {
                                "tumbon":"ห้วยใหญ่",
                                "postcode":"15240"
                            },
                            {
                                "tumbon":"นิยมชัย",
                                "postcode":"15240"
                            }
                            ]
                        },
                        {
                            "amphur":"โคกเจริญ",
                            "listTumbon":[
                            {
                                "tumbon":"โคกเจริญ",
                                "postcode":"15250"
                            },
                            {
                                "tumbon":"ยางราก",
                                "postcode":"15250"
                            },
                            {
                                "tumbon":"หนองมะค่า",
                                "postcode":"15250"
                            },
                            {
                                "tumbon":"วังทอง",
                                "postcode":"15250"
                            },
                            {
                                "tumbon":"โคกแสมสาร",
                                "postcode":"15250"
                            }
                            ]
                        },
                        {
                            "amphur":"ลำสนธิ",
                            "listTumbon":[
                            {
                                "tumbon":"ลำสนธิ",
                                "postcode":"15190"
                            },
                            {
                                "tumbon":"ซับสมบูรณ์",
                                "postcode":"15190"
                            },
                            {
                                "tumbon":"หนองรี",
                                "postcode":"15190"
                            },
                            {
                                "tumbon":"กุดตาเพชร",
                                "postcode":"15190"
                            },
                            {
                                "tumbon":"เขารวก",
                                "postcode":"15190"
                            },
                            {
                                "tumbon":"เขาน้อย",
                                "postcode":"15130"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองม่วง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองม่วง",
                                "postcode":"15170"
                            },
                            {
                                "tumbon":"บ่อทอง",
                                "postcode":"15170"
                            },
                            {
                                "tumbon":"ดงดินแดง",
                                "postcode":"15170"
                            },
                            {
                                "tumbon":"ชอนสมบูรณ์",
                                "postcode":"15170"
                            },
                            {
                                "tumbon":"ยางโทน",
                                "postcode":"15170"
                            },
                            {
                                "tumbon":"ชอนสารเดช",
                                "postcode":"15170"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สิงห์บุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสิงห์บุรี",
                            "listTumbon":[
                            {
                                "tumbon":"บางพุทรา",
                                "postcode":"16000"
                            },
                            {
                                "tumbon":"โพกรวม",
                                "postcode":"16000"
                            },
                            {
                                "tumbon":"ม่วงหมู่",
                                "postcode":"16000"
                            },
                            {
                                "tumbon":"หัวไผ่",
                                "postcode":"16000"
                            },
                            {
                                "tumbon":"ต้นโพธิ์",
                                "postcode":"16000"
                            },
                            {
                                "tumbon":"จักรสีห์",
                                "postcode":"16000"
                            },
                            {
                                "tumbon":"บางกระบือ",
                                "postcode":"16000"
                            },
                            {
                                "tumbon":"บางมัญ",
                                "postcode":"16000"
                            }
                            ]
                        },
                        {
                            "amphur":"บางระจัน",
                            "listTumbon":[
                            {
                                "tumbon":"สิงห์",
                                "postcode":"16130"
                            },
                            {
                                "tumbon":"ไม้ดัด",
                                "postcode":"16130"
                            },
                            {
                                "tumbon":"เชิงกลัด",
                                "postcode":"16130"
                            },
                            {
                                "tumbon":"โพชนไก่",
                                "postcode":"16130"
                            },
                            {
                                "tumbon":"แม่ลา",
                                "postcode":"16130"
                            },
                            {
                                "tumbon":"บ้านจ่า",
                                "postcode":"16130"
                            },
                            {
                                "tumbon":"พักทัน",
                                "postcode":"16130"
                            },
                            {
                                "tumbon":"สระแจง",
                                "postcode":"16130"
                            }
                            ]
                        },
                        {
                            "amphur":"ค่ายบางระจัน",
                            "listTumbon":[
                            {
                                "tumbon":"โพทะเล",
                                "postcode":"16150"
                            },
                            {
                                "tumbon":"โพสังโฆ",
                                "postcode":"16150"
                            },
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"16150"
                            },
                            {
                                "tumbon":"คอทราย",
                                "postcode":"16150"
                            },
                            {
                                "tumbon":"หนองกระทุ่ม",
                                "postcode":"16150"
                            },
                            {
                                "tumbon":"บางระจัน",
                                "postcode":"16150"
                            }
                            ]
                        },
                        {
                            "amphur":"พรหมบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"พระงาม",
                                "postcode":"16120"
                            },
                            {
                                "tumbon":"พรหมบุรี",
                                "postcode":"16160"
                            },
                            {
                                "tumbon":"บางน้ำเชี่ยว",
                                "postcode":"16120"
                            },
                            {
                                "tumbon":"บ้านหม้อ",
                                "postcode":"16120"
                            },
                            {
                                "tumbon":"บ้านแป้ง",
                                "postcode":"16120"
                            },
                            {
                                "tumbon":"หัวป่า",
                                "postcode":"16120"
                            },
                            {
                                "tumbon":"โรงช้าง",
                                "postcode":"16120"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าช้าง",
                            "listTumbon":[
                            {
                                "tumbon":"ถอนสมอ",
                                "postcode":"16140"
                            },
                            {
                                "tumbon":"โพประจักษ์",
                                "postcode":"16140"
                            },
                            {
                                "tumbon":"วิหารขาว",
                                "postcode":"16140"
                            },
                            {
                                "tumbon":"พิกุลทอง",
                                "postcode":"16140"
                            }
                            ]
                        },
                        {
                            "amphur":"อินทร์บุรี",
                            "listTumbon":[
                            {
                                "tumbon":"อินทร์บุรี",
                                "postcode":"16110"
                            },
                            {
                                "tumbon":"ประศุก",
                                "postcode":"16110"
                            },
                            {
                                "tumbon":"ทับยา",
                                "postcode":"16110"
                            },
                            {
                                "tumbon":"งิ้วราย",
                                "postcode":"16110"
                            },
                            {
                                "tumbon":"ชีน้ำร้าย",
                                "postcode":"16110"
                            },
                            {
                                "tumbon":"ท่างาม",
                                "postcode":"16110"
                            },
                            {
                                "tumbon":"น้ำตาล",
                                "postcode":"16110"
                            },
                            {
                                "tumbon":"ทองเอน",
                                "postcode":"16110"
                            },
                            {
                                "tumbon":"ห้วยชัน",
                                "postcode":"16110"
                            },
                            {
                                "tumbon":"โพธิ์ชัย",
                                "postcode":"16110"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ชัยนาท",
                    "listAmphur":[
                        {
                            "amphur":"เมืองชัยนาท",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"17000"
                            },
                            {
                                "tumbon":"บ้านกล้วย",
                                "postcode":"17000"
                            },
                            {
                                "tumbon":"ท่าชัย",
                                "postcode":"17000"
                            },
                            {
                                "tumbon":"ชัยนาท",
                                "postcode":"17000"
                            },
                            {
                                "tumbon":"เขาท่าพระ",
                                "postcode":"17000"
                            },
                            {
                                "tumbon":"หาดท่าเสา",
                                "postcode":"17120"
                            },
                            {
                                "tumbon":"ธรรมามูล",
                                "postcode":"17000"
                            },
                            {
                                "tumbon":"เสือโฮก",
                                "postcode":"17000"
                            },
                            {
                                "tumbon":"นางลือ",
                                "postcode":"17000"
                            }
                            ]
                        },
                        {
                            "amphur":"มโนรมย์",
                            "listTumbon":[
                            {
                                "tumbon":"คุ้งสำเภา",
                                "postcode":"17110"
                            },
                            {
                                "tumbon":"วัดโคก",
                                "postcode":"17110"
                            },
                            {
                                "tumbon":"ศิลาดาน",
                                "postcode":"17110"
                            },
                            {
                                "tumbon":"ท่าฉนวน",
                                "postcode":"17110"
                            },
                            {
                                "tumbon":"หางน้ำสาคร",
                                "postcode":"17170"
                            },
                            {
                                "tumbon":"ไร่พัฒนา",
                                "postcode":"17170"
                            },
                            {
                                "tumbon":"อู่ตะเภา",
                                "postcode":"17170"
                            }
                            ]
                        },
                        {
                            "amphur":"วัดสิงห์",
                            "listTumbon":[
                            {
                                "tumbon":"วัดสิงห์",
                                "postcode":"17120"
                            },
                            {
                                "tumbon":"มะขามเฒ่า",
                                "postcode":"17120"
                            },
                            {
                                "tumbon":"หนองน้อย",
                                "postcode":"17120"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"17120"
                            },
                            {
                                "tumbon":"หนองขุ่น",
                                "postcode":"17120"
                            },
                            {
                                "tumbon":"บ่อแร่",
                                "postcode":"17120"
                            },
                            {
                                "tumbon":"วังหมัน",
                                "postcode":"17120"
                            }
                            ]
                        },
                        {
                            "amphur":"สรรพยา",
                            "listTumbon":[
                            {
                                "tumbon":"สรรพยา",
                                "postcode":"17150"
                            },
                            {
                                "tumbon":"ตลุก",
                                "postcode":"17150"
                            },
                            {
                                "tumbon":"เขาแก้ว",
                                "postcode":"17150"
                            },
                            {
                                "tumbon":"โพนางดำตก",
                                "postcode":"17150"
                            },
                            {
                                "tumbon":"โพนางดำออก",
                                "postcode":"17150"
                            },
                            {
                                "tumbon":"บางหลวง",
                                "postcode":"17150"
                            },
                            {
                                "tumbon":"หาดอาษา",
                                "postcode":"17150"
                            }
                            ]
                        },
                        {
                            "amphur":"สรรคบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"แพรกศรีราชา",
                                "postcode":"17140"
                            },
                            {
                                "tumbon":"เที่ยงแท้",
                                "postcode":"17140"
                            },
                            {
                                "tumbon":"ห้วยกรด",
                                "postcode":"17140"
                            },
                            {
                                "tumbon":"โพงาม",
                                "postcode":"17140"
                            },
                            {
                                "tumbon":"บางขุด",
                                "postcode":"17140"
                            },
                            {
                                "tumbon":"ดงคอน",
                                "postcode":"17140"
                            },
                            {
                                "tumbon":"ดอนกำ",
                                "postcode":"17140"
                            },
                            {
                                "tumbon":"ห้วยกรดพัฒนา",
                                "postcode":"17140"
                            }
                            ]
                        },
                        {
                            "amphur":"หันคา",
                            "listTumbon":[
                            {
                                "tumbon":"หันคา",
                                "postcode":"17130"
                            },
                            {
                                "tumbon":"บ้านเชี่ยน",
                                "postcode":"17130"
                            },
                            {
                                "tumbon":"ไพรนกยูง",
                                "postcode":"17130"
                            },
                            {
                                "tumbon":"หนองแซง",
                                "postcode":"17160"
                            },
                            {
                                "tumbon":"ห้วยงู",
                                "postcode":"17160"
                            },
                            {
                                "tumbon":"วังไก่เถื่อน",
                                "postcode":"17130"
                            },
                            {
                                "tumbon":"เด่นใหญ่",
                                "postcode":"17130"
                            },
                            {
                                "tumbon":"สามง่ามท่าโบสถ์",
                                "postcode":"17160"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองมะโมง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองมะโมง",
                                "postcode":"17120"
                            },
                            {
                                "tumbon":"วังตะเคียน",
                                "postcode":"17120"
                            },
                            {
                                "tumbon":"สะพานหิน",
                                "postcode":"17120"
                            },
                            {
                                "tumbon":"กุดจอก",
                                "postcode":"17120"
                            }
                            ]
                        },
                        {
                            "amphur":"เนินขาม",
                            "listTumbon":[
                            {
                                "tumbon":"เนินขาม",
                                "postcode":"17130"
                            },
                            {
                                "tumbon":"กะบกเตี้ย",
                                "postcode":"17130"
                            },
                            {
                                "tumbon":"สุขเดือนห้า",
                                "postcode":"17130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"นครนายก",
                    "listAmphur":[
                        {
                            "amphur":"เมืองนครนายก",
                            "listTumbon":[
                            {
                                "tumbon":"นครนายก",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"ท่าช้าง",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"บ้านใหญ่",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"วังกระโจม",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"ท่าทราย",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"ดอนยอ",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"ศรีจุฬา",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"ดงละคร",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"ศรีนาวา",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"สาริกา",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"หินตั้ง",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"เขาพระ",
                                "postcode":"26000"
                            },
                            {
                                "tumbon":"พรหมณี",
                                "postcode":"26000"
                            }
                            ]
                        },
                        {
                            "amphur":"ปากพลี",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะหวาย",
                                "postcode":"26130"
                            },
                            {
                                "tumbon":"เกาะโพธิ์",
                                "postcode":"26130"
                            },
                            {
                                "tumbon":"ปากพลี",
                                "postcode":"26130"
                            },
                            {
                                "tumbon":"โคกกรวด",
                                "postcode":"26130"
                            },
                            {
                                "tumbon":"ท่าเรือ",
                                "postcode":"26130"
                            },
                            {
                                "tumbon":"หนองแสง",
                                "postcode":"26130"
                            },
                            {
                                "tumbon":"นาหินลาด",
                                "postcode":"26130"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านนา",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"26110"
                            },
                            {
                                "tumbon":"บ้านพร้าว",
                                "postcode":"26110"
                            },
                            {
                                "tumbon":"บ้านพริก",
                                "postcode":"26110"
                            },
                            {
                                "tumbon":"อาษา",
                                "postcode":"26110"
                            },
                            {
                                "tumbon":"ทองหลาง",
                                "postcode":"26110"
                            },
                            {
                                "tumbon":"บางอ้อ",
                                "postcode":"26110"
                            },
                            {
                                "tumbon":"พิกุลออก",
                                "postcode":"26110"
                            },
                            {
                                "tumbon":"ป่าขะ",
                                "postcode":"26110"
                            },
                            {
                                "tumbon":"เขาเพิ่ม",
                                "postcode":"26110"
                            },
                            {
                                "tumbon":"ศรีกะอาง",
                                "postcode":"26110"
                            }
                            ]
                        },
                        {
                            "amphur":"องครักษ์",
                            "listTumbon":[
                            {
                                "tumbon":"พระอาจารย์",
                                "postcode":"26120"
                            },
                            {
                                "tumbon":"บึงศาล",
                                "postcode":"26120"
                            },
                            {
                                "tumbon":"ศีรษะกระบือ",
                                "postcode":"26120"
                            },
                            {
                                "tumbon":"โพธิ์แทน",
                                "postcode":"26120"
                            },
                            {
                                "tumbon":"บางสมบูรณ์",
                                "postcode":"26120"
                            },
                            {
                                "tumbon":"ทรายมูล",
                                "postcode":"26120"
                            },
                            {
                                "tumbon":"บางปลากด",
                                "postcode":"26120"
                            },
                            {
                                "tumbon":"บางลูกเสือ",
                                "postcode":"26120"
                            },
                            {
                                "tumbon":"องครักษ์",
                                "postcode":"26120"
                            },
                            {
                                "tumbon":"ชุมพล",
                                "postcode":"26120"
                            },
                            {
                                "tumbon":"คลองใหญ่",
                                "postcode":"26120"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สุพรรณบุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสุพรรณบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าพี่เลี้ยง",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"รั้วใหญ่",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"ทับตีเหล็ก",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"ท่าระหัด",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"ไผ่ขวาง",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"โคกโคเฒ่า",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"ดอนตาล",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"ดอนมะสังข์",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"พิหารแดง",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"ดอนกำยาน",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"ดอนโพธิ์ทอง",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"บ้านโพธิ์",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"สระแก้ว",
                                "postcode":"72230"
                            },
                            {
                                "tumbon":"ตลิ่งชัน",
                                "postcode":"72230"
                            },
                            {
                                "tumbon":"บางกุ้ง",
                                "postcode":"72210"
                            },
                            {
                                "tumbon":"ศาลาขาว",
                                "postcode":"72210"
                            },
                            {
                                "tumbon":"สวนแตง",
                                "postcode":"72210"
                            },
                            {
                                "tumbon":"โพธิ์พระยา",
                                "postcode":"72000"
                            },
                            {
                                "tumbon":"สนามคลี",
                                "postcode":"72230"
                            },
                            {
                                "tumbon":"สนามชัย",
                                "postcode":"72000"
                            }
                            ]
                        },
                        {
                            "amphur":"เดิมบางนางบวช",
                            "listTumbon":[
                            {
                                "tumbon":"เขาพระ",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"นางบวช",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"เขาดิน",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"ปากน้ำ",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"ทุ่งคลี",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"โคกช้าง",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"หัวเขา",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"หัวนา",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"บ่อกรุ",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"วังศรีราช",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"ป่าสะแก",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"ยางนอน",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"หนองกระทุ่ม",
                                "postcode":"72120"
                            },
                            {
                                "tumbon":"เดิมบาง",
                                "postcode":"72120"
                            }
                            ]
                        },
                        {
                            "amphur":"ด่านช้าง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองมะค่าโมง",
                                "postcode":"72180"
                            },
                            {
                                "tumbon":"ด่านช้าง",
                                "postcode":"72180"
                            },
                            {
                                "tumbon":"ห้วยขมิ้น",
                                "postcode":"72180"
                            },
                            {
                                "tumbon":"องค์พระ",
                                "postcode":"72180"
                            },
                            {
                                "tumbon":"วังคัน",
                                "postcode":"72180"
                            },
                            {
                                "tumbon":"นิคมกระเสียว",
                                "postcode":"72180"
                            },
                            {
                                "tumbon":"วังยาว",
                                "postcode":"72180"
                            }
                            ]
                        },
                        {
                            "amphur":"บางปลาม้า",
                            "listTumbon":[
                            {
                                "tumbon":"โคกคราม",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"บางปลาม้า",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"ตะค่า",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"บางใหญ่",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"กฤษณา",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"สาลี",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"ไผ่กองดิน",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"องครักษ์",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"จรเข้ใหญ่",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"บ้านแหลม",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"มะขามล้ม",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"วังน้ำเย็น",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"วัดโบสถ์",
                                "postcode":"72150"
                            },
                            {
                                "tumbon":"วัดดาว",
                                "postcode":"72150"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีประจันต์",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีประจันต์",
                                "postcode":"72140"
                            },
                            {
                                "tumbon":"บ้านกร่าง",
                                "postcode":"72140"
                            },
                            {
                                "tumbon":"มดแดง",
                                "postcode":"72140"
                            },
                            {
                                "tumbon":"บางงาม",
                                "postcode":"72140"
                            },
                            {
                                "tumbon":"ดอนปรู",
                                "postcode":"72140"
                            },
                            {
                                "tumbon":"ปลายนา",
                                "postcode":"72140"
                            },
                            {
                                "tumbon":"วังหว้า",
                                "postcode":"72140"
                            },
                            {
                                "tumbon":"วังน้ำซับ",
                                "postcode":"72140"
                            },
                            {
                                "tumbon":"วังยาง",
                                "postcode":"72140"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอนเจดีย์",
                            "listTumbon":[
                            {
                                "tumbon":"ดอนเจดีย์",
                                "postcode":"72170"
                            },
                            {
                                "tumbon":"หนองสาหร่าย",
                                "postcode":"72170"
                            },
                            {
                                "tumbon":"ไร่รถ",
                                "postcode":"72170"
                            },
                            {
                                "tumbon":"สระกระโจม",
                                "postcode":"72250"
                            },
                            {
                                "tumbon":"ทะเลบก",
                                "postcode":"72250"
                            }
                            ]
                        },
                        {
                            "amphur":"สองพี่น้อง",
                            "listTumbon":[
                            {
                                "tumbon":"สองพี่น้อง",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"บางเลน",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"บางตาเถร",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"บางตะเคียน",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"บ้านกุ่ม",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"หัวโพธิ์",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"บางพลับ",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"เนินพระปรางค์",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"บ้านช้าง",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"ต้นตาล",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"ศรีสำราญ",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"ทุ่งคอก",
                                "postcode":"72110"
                            },
                            {
                                "tumbon":"หนองบ่อ",
                                "postcode":"72190"
                            },
                            {
                                "tumbon":"บ่อสุพรรณ",
                                "postcode":"72190"
                            },
                            {
                                "tumbon":"ดอนมะนาว",
                                "postcode":"72110"
                            }
                            ]
                        },
                        {
                            "amphur":"สามชุก",
                            "listTumbon":[
                            {
                                "tumbon":"ย่านยาว",
                                "postcode":"72130"
                            },
                            {
                                "tumbon":"วังลึก",
                                "postcode":"72130"
                            },
                            {
                                "tumbon":"สามชุก",
                                "postcode":"72130"
                            },
                            {
                                "tumbon":"หนองผักนาก",
                                "postcode":"72130"
                            },
                            {
                                "tumbon":"บ้านสระ",
                                "postcode":"72130"
                            },
                            {
                                "tumbon":"หนองสะเดา",
                                "postcode":"72130"
                            },
                            {
                                "tumbon":"กระเสียว",
                                "postcode":"72130"
                            }
                            ]
                        },
                        {
                            "amphur":"อู่ทอง",
                            "listTumbon":[
                            {
                                "tumbon":"อู่ทอง",
                                "postcode":"72160"
                            },
                            {
                                "tumbon":"สระยายโสม",
                                "postcode":"72220"
                            },
                            {
                                "tumbon":"จรเข้สามพัน",
                                "postcode":"71170"
                            },
                            {
                                "tumbon":"บ้านดอน",
                                "postcode":"72160"
                            },
                            {
                                "tumbon":"ยุ้งทะลาย",
                                "postcode":"72160"
                            },
                            {
                                "tumbon":"ดอนมะเกลือ",
                                "postcode":"72220"
                            },
                            {
                                "tumbon":"หนองโอ่ง",
                                "postcode":"72160"
                            },
                            {
                                "tumbon":"ดอนคา",
                                "postcode":"72160"
                            },
                            {
                                "tumbon":"พลับพลาไชย",
                                "postcode":"72160"
                            },
                            {
                                "tumbon":"บ้านโข้ง",
                                "postcode":"72160"
                            },
                            {
                                "tumbon":"เจดีย์",
                                "postcode":"72160"
                            },
                            {
                                "tumbon":"สระพังลาน",
                                "postcode":"72220"
                            },
                            {
                                "tumbon":"กระจัน",
                                "postcode":"72160"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองหญ้าไซ",
                            "listTumbon":[
                            {
                                "tumbon":"หนองหญ้าไซ",
                                "postcode":"72240"
                            },
                            {
                                "tumbon":"หนองราชวัตร",
                                "postcode":"72240"
                            },
                            {
                                "tumbon":"หนองโพธิ์",
                                "postcode":"72240"
                            },
                            {
                                "tumbon":"แจงงาม",
                                "postcode":"72240"
                            },
                            {
                                "tumbon":"ทัพหลวง",
                                "postcode":"72240"
                            },
                            {
                                "tumbon":"หนองขาม",
                                "postcode":"72240"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ชลบุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองชลบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"บางปลาสร้อย",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"แสนสุข",
                                "postcode":"20130"
                            },
                            {
                                "tumbon":"บ้านสวน",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"หนองรี",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"นาป่า",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"หนองข้างคอก",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"ดอนหัวฬ่อ",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"หนองไม้แดง",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"คลองตำหรุ",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"เหมือง",
                                "postcode":"20130"
                            },
                            {
                                "tumbon":"บ้านปึก",
                                "postcode":"20130"
                            },
                            {
                                "tumbon":"ห้วยกะปิ",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"เสม็ด",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"อ่างศิลา",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"สำนักบก",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"บางทราย",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"บ้านโขด",
                                "postcode":"20000"
                            },
                            {
                                "tumbon":"มะขามหย่ง",
                                "postcode":"20000"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านบึง",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านบึง",
                                "postcode":"20170"
                            },
                            {
                                "tumbon":"คลองกิ่ว",
                                "postcode":"20220"
                            },
                            {
                                "tumbon":"มาบไผ่",
                                "postcode":"20170"
                            },
                            {
                                "tumbon":"หนองซ้ำซาก",
                                "postcode":"20170"
                            },
                            {
                                "tumbon":"หนองบอนแดง",
                                "postcode":"20170"
                            },
                            {
                                "tumbon":"หนองอิรุณ",
                                "postcode":"20220"
                            },
                            {
                                "tumbon":"หนองไผ่แก้ว",
                                "postcode":"20220"
                            },
                            {
                                "tumbon":"หนองชาก",
                                "postcode":"20170"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"หนองใหญ่",
                                "postcode":"20190"
                            },
                            {
                                "tumbon":"คลองพลู",
                                "postcode":"20190"
                            },
                            {
                                "tumbon":"หนองเสือช้าง",
                                "postcode":"20190"
                            },
                            {
                                "tumbon":"ห้างสูง",
                                "postcode":"20190"
                            },
                            {
                                "tumbon":"เขาซก",
                                "postcode":"20190"
                            }
                            ]
                        },
                        {
                            "amphur":"บางละมุง",
                            "listTumbon":[
                            {
                                "tumbon":"บางละมุง",
                                "postcode":"20150"
                            },
                            {
                                "tumbon":"หนองปรือ",
                                "postcode":"20150"
                            },
                            {
                                "tumbon":"หนองปลาไหล",
                                "postcode":"20150"
                            },
                            {
                                "tumbon":"โป่ง",
                                "postcode":"20150"
                            },
                            {
                                "tumbon":"เขาไม้แก้ว",
                                "postcode":"20150"
                            },
                            {
                                "tumbon":"ห้วยใหญ่",
                                "postcode":"20150"
                            },
                            {
                                "tumbon":"ตะเคียนเตี้ย",
                                "postcode":"20150"
                            },
                            {
                                "tumbon":"นาเกลือ",
                                "postcode":"20150"
                            },
                            {
                                "tumbon":"หนองปรือ",
                                "postcode":"20150"
                            }
                            ]
                        },
                        {
                            "amphur":"พานทอง",
                            "listTumbon":[
                            {
                                "tumbon":"พานทอง",
                                "postcode":"20160"
                            },
                            {
                                "tumbon":"หนองตำลึง",
                                "postcode":"20160"
                            },
                            {
                                "tumbon":"มาบโป่ง",
                                "postcode":"20160"
                            },
                            {
                                "tumbon":"หนองกะขะ",
                                "postcode":"20160"
                            },
                            {
                                "tumbon":"หนองหงษ์",
                                "postcode":"20160"
                            },
                            {
                                "tumbon":"โคกขี้หนอน",
                                "postcode":"20160"
                            },
                            {
                                "tumbon":"บ้านเก่า",
                                "postcode":"20160"
                            },
                            {
                                "tumbon":"หน้าประดู่",
                                "postcode":"20160"
                            },
                            {
                                "tumbon":"บางนาง",
                                "postcode":"20160"
                            },
                            {
                                "tumbon":"เกาะลอย",
                                "postcode":"20160"
                            },
                            {
                                "tumbon":"บางหัก",
                                "postcode":"20160"
                            }
                            ]
                        },
                        {
                            "amphur":"พนัสนิคม",
                            "listTumbon":[
                            {
                                "tumbon":"พนัสนิคม",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"หน้าพระธาตุ",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"วัดหลวง",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"บ้านเซิด",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"นาเริก",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"หมอนนาง",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"สระสี่เหลี่ยม",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"วัดโบสถ์",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"กุฎโง้ง",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"หัวถนน",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"หนองปรือ",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"หนองขยาด",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"ทุ่งขวาง",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"หนองเหียง",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"นาวังหิน",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"บ้านช้าง",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"โคกเพลาะ",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"ไร่หลักทอง",
                                "postcode":"20140"
                            },
                            {
                                "tumbon":"นามะตูม",
                                "postcode":"20140"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีราชา",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีราชา",
                                "postcode":"20110"
                            },
                            {
                                "tumbon":"สุรศักดิ์",
                                "postcode":"20110"
                            },
                            {
                                "tumbon":"ทุ่งสุขลา",
                                "postcode":"20230"
                            },
                            {
                                "tumbon":"บึง",
                                "postcode":"20230"
                            },
                            {
                                "tumbon":"หนองขาม",
                                "postcode":"20230"
                            },
                            {
                                "tumbon":"เขาคันทรง",
                                "postcode":"20110"
                            },
                            {
                                "tumbon":"บางพระ",
                                "postcode":"20110"
                            },
                            {
                                "tumbon":"บ่อวิน",
                                "postcode":"20230"
                            }
                            ]
                        },
                        {
                            "amphur":"เกาะสีชัง",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าเทววงษ์",
                                "postcode":"20120"
                            }
                            ]
                        },
                        {
                            "amphur":"สัตหีบ",
                            "listTumbon":[
                            {
                                "tumbon":"สัตหีบ",
                                "postcode":"20180"
                            },
                            {
                                "tumbon":"นาจอมเทียน",
                                "postcode":"20250"
                            },
                            {
                                "tumbon":"พลูตาหลวง",
                                "postcode":"20180"
                            },
                            {
                                "tumbon":"บางเสร่",
                                "postcode":"20250"
                            },
                            {
                                "tumbon":"แสมสาร",
                                "postcode":"20180"
                            }
                            ]
                        },
                        {
                            "amphur":"บ่อทอง",
                            "listTumbon":[
                            {
                                "tumbon":"บ่อทอง",
                                "postcode":"20270"
                            },
                            {
                                "tumbon":"วัดสุวรรณ",
                                "postcode":"20270"
                            },
                            {
                                "tumbon":"บ่อกวางทอง",
                                "postcode":"20270"
                            },
                            {
                                "tumbon":"ธาตุทอง",
                                "postcode":"20270"
                            },
                            {
                                "tumbon":"เกษตรสุวรรณ",
                                "postcode":"20270"
                            },
                            {
                                "tumbon":"พลวงทอง",
                                "postcode":"20270"
                            }
                            ]
                        },
                        {
                            "amphur":"เกาะจันทร์",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะจันทร์",
                                "postcode":"20240"
                            },
                            {
                                "tumbon":"ท่าบุญมี",
                                "postcode":"20240"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ฉะเชิงเทรา",
                    "listAmphur":[
                        {
                            "amphur":"เมืองฉะเชิงเทรา",
                            "listTumbon":[
                            {
                                "tumbon":"หน้าเมือง",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"ท่าไข่",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"คลองนา",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บางตีนเป็ด",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บางไผ่",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"คลองจุกกระเฌอ",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บางแก้ว",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บางขวัญ",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"คลองนครเนื่องเขต",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"วังตะเคียน",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"โสธร",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บางพระ",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บางกะไห",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"หนามแดง",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"คลองเปรง",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"คลองอุดมชลจร",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"คลองหลวงแพ่ง",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บางเตย",
                                "postcode":"24000"
                            }
                            ]
                        },
                        {
                            "amphur":"บางคล้า",
                            "listTumbon":[
                            {
                                "tumbon":"บางคล้า",
                                "postcode":"24110"
                            },
                            {
                                "tumbon":"บางสวน",
                                "postcode":"24110"
                            },
                            {
                                "tumbon":"บางกระเจ็ด",
                                "postcode":"24110"
                            },
                            {
                                "tumbon":"ปากน้ำ",
                                "postcode":"24110"
                            },
                            {
                                "tumbon":"ท่าทองหลาง",
                                "postcode":"24110"
                            },
                            {
                                "tumbon":"สาวชะโงก",
                                "postcode":"24110"
                            },
                            {
                                "tumbon":"เสม็ดเหนือ",
                                "postcode":"24110"
                            },
                            {
                                "tumbon":"เสม็ดใต้",
                                "postcode":"24110"
                            },
                            {
                                "tumbon":"หัวไทร",
                                "postcode":"24110"
                            }
                            ]
                        },
                        {
                            "amphur":"บางน้ำเปรี้ยว",
                            "listTumbon":[
                            {
                                "tumbon":"บางน้ำเปรี้ยว",
                                "postcode":"24150"
                            },
                            {
                                "tumbon":"บางขนาก",
                                "postcode":"24150"
                            },
                            {
                                "tumbon":"สิงโตทอง",
                                "postcode":"24150"
                            },
                            {
                                "tumbon":"หมอนทอง",
                                "postcode":"24150"
                            },
                            {
                                "tumbon":"บึงน้ำรักษ์",
                                "postcode":"24170"
                            },
                            {
                                "tumbon":"ดอนเกาะกา",
                                "postcode":"24170"
                            },
                            {
                                "tumbon":"โยธะกา",
                                "postcode":"24150"
                            },
                            {
                                "tumbon":"ดอนฉิมพลี",
                                "postcode":"24170"
                            },
                            {
                                "tumbon":"ศาลาแดง",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"โพรงอากาศ",
                                "postcode":"24150"
                            }
                            ]
                        },
                        {
                            "amphur":"บางปะกง",
                            "listTumbon":[
                            {
                                "tumbon":"บางปะกง",
                                "postcode":"24130"
                            },
                            {
                                "tumbon":"ท่าสะอ้าน",
                                "postcode":"24130"
                            },
                            {
                                "tumbon":"บางวัว",
                                "postcode":"24180"
                            },
                            {
                                "tumbon":"บางสมัคร",
                                "postcode":"24180"
                            },
                            {
                                "tumbon":"บางผึ้ง",
                                "postcode":"24130"
                            },
                            {
                                "tumbon":"บางเกลือ",
                                "postcode":"24180"
                            },
                            {
                                "tumbon":"สองคลอง",
                                "postcode":"24130"
                            },
                            {
                                "tumbon":"หนองจอก",
                                "postcode":"24130"
                            },
                            {
                                "tumbon":"พิมพา",
                                "postcode":"24180"
                            },
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"24130"
                            },
                            {
                                "tumbon":"หอมศีล",
                                "postcode":"24180"
                            },
                            {
                                "tumbon":"เขาดิน",
                                "postcode":"24130"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านโพธิ์",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านโพธิ์",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"เกาะไร่",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"คลองขุด",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"คลองบ้านโพธิ์",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"คลองประเวศ",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"ดอนทราย",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"เทพราช",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"ท่าพลับ",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"หนองตีนนก",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"บางซ่อน",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"บางกรูด",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"แหลมประดู่",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"ลาดขวาง",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"สนามจันทร์",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"แสนภูดาษ",
                                "postcode":"24140"
                            },
                            {
                                "tumbon":"สิบเอ็ดศอก",
                                "postcode":"24140"
                            }
                            ]
                        },
                        {
                            "amphur":"พนมสารคาม",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะขนุน",
                                "postcode":"24120"
                            },
                            {
                                "tumbon":"บ้านซ่อง",
                                "postcode":"24120"
                            },
                            {
                                "tumbon":"พนมสารคาม",
                                "postcode":"24120"
                            },
                            {
                                "tumbon":"เมืองเก่า",
                                "postcode":"24120"
                            },
                            {
                                "tumbon":"หนองยาว",
                                "postcode":"24120"
                            },
                            {
                                "tumbon":"ท่าถ่าน",
                                "postcode":"24120"
                            },
                            {
                                "tumbon":"หนองแหน",
                                "postcode":"24120"
                            },
                            {
                                "tumbon":"เขาหินซ้อน",
                                "postcode":"24120"
                            }
                            ]
                        },
                        {
                            "amphur":"ราชสาส์น",
                            "listTumbon":[
                            {
                                "tumbon":"บางคา",
                                "postcode":"24120"
                            },
                            {
                                "tumbon":"เมืองใหม่",
                                "postcode":"24120"
                            },
                            {
                                "tumbon":"ดงน้อย",
                                "postcode":"24120"
                            }
                            ]
                        },
                        {
                            "amphur":"สนามชัยเขต",
                            "listTumbon":[
                            {
                                "tumbon":"คู้ยายหมี",
                                "postcode":"24160"
                            },
                            {
                                "tumbon":"ท่ากระดาน",
                                "postcode":"24160"
                            },
                            {
                                "tumbon":"ทุ่งพระยา",
                                "postcode":"24160"
                            },
                            {
                                "tumbon":"ลาดกระทิง",
                                "postcode":"24160"
                            }
                            ]
                        },
                        {
                            "amphur":"แปลงยาว",
                            "listTumbon":[
                            {
                                "tumbon":"แปลงยาว",
                                "postcode":"24190"
                            },
                            {
                                "tumbon":"วังเย็น",
                                "postcode":"24190"
                            },
                            {
                                "tumbon":"หัวสำโรง",
                                "postcode":"24190"
                            },
                            {
                                "tumbon":"หนองไม้แก่น",
                                "postcode":"24190"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าตะเกียบ",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าตะเกียบ",
                                "postcode":"24160"
                            },
                            {
                                "tumbon":"คลองตะเกรา",
                                "postcode":"24160"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองเขื่อน",
                            "listTumbon":[
                            {
                                "tumbon":"ก้อนแก้ว",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"คลองเขื่อน",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บางเล่า",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บางโรง",
                                "postcode":"24000"
                            },
                            {
                                "tumbon":"บางตลาด",
                                "postcode":"24110"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ปราจีนบุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองปราจีนบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"หน้าเมือง",
                                "postcode":"25000"
                            },
                            {
                                "tumbon":"รอบเมือง",
                                "postcode":"25000"
                            },
                            {
                                "tumbon":"วัดโบสถ์",
                                "postcode":"25000"
                            },
                            {
                                "tumbon":"บางเดชะ",
                                "postcode":"25000"
                            },
                            {
                                "tumbon":"ท่างาม",
                                "postcode":"25000"
                            },
                            {
                                "tumbon":"บางบริบูรณ์",
                                "postcode":"25000"
                            },
                            {
                                "tumbon":"ดงพระราม",
                                "postcode":"25000"
                            },
                            {
                                "tumbon":"บ้านพระ",
                                "postcode":"25230"
                            },
                            {
                                "tumbon":"โคกไม้ลาย",
                                "postcode":"25230"
                            },
                            {
                                "tumbon":"ไม้เค็ด",
                                "postcode":"25230"
                            },
                            {
                                "tumbon":"ดงขี้เหล็ก",
                                "postcode":"25000"
                            },
                            {
                                "tumbon":"เนินหอม",
                                "postcode":"25230"
                            },
                            {
                                "tumbon":"โนนห้อม",
                                "postcode":"25000"
                            }
                            ]
                        },
                        {
                            "amphur":"กบินทร์บุรี",
                            "listTumbon":[
                            {
                                "tumbon":"กบินทร์",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"เมืองเก่า",
                                "postcode":"25240"
                            },
                            {
                                "tumbon":"วังดาล",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"นนทรี",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"ย่านรี",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"วังตะเคียน",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"หาดนางแก้ว",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"ลาดตะเคียน",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"บ่อทอง",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"หนองกี่",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"นาแขม",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"เขาไม้แก้ว",
                                "postcode":"25110"
                            },
                            {
                                "tumbon":"วังท่าช้าง",
                                "postcode":"25110"
                            }
                            ]
                        },
                        {
                            "amphur":"นาดี",
                            "listTumbon":[
                            {
                                "tumbon":"นาดี",
                                "postcode":"25220"
                            },
                            {
                                "tumbon":"สำพันตา",
                                "postcode":"25220"
                            },
                            {
                                "tumbon":"สะพานหิน",
                                "postcode":"25220"
                            },
                            {
                                "tumbon":"ทุ่งโพธิ์",
                                "postcode":"25220"
                            },
                            {
                                "tumbon":"แก่งดินสอ",
                                "postcode":"25220"
                            },
                            {
                                "tumbon":"บุพราหมณ์",
                                "postcode":"25220"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านสร้าง",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านสร้าง",
                                "postcode":"25150"
                            },
                            {
                                "tumbon":"บางกระเบา",
                                "postcode":"25150"
                            },
                            {
                                "tumbon":"บางเตย",
                                "postcode":"25150"
                            },
                            {
                                "tumbon":"บางยาง",
                                "postcode":"25150"
                            },
                            {
                                "tumbon":"บางแตน",
                                "postcode":"25150"
                            },
                            {
                                "tumbon":"บางพลวง",
                                "postcode":"25150"
                            },
                            {
                                "tumbon":"บางปลาร้า",
                                "postcode":"25150"
                            },
                            {
                                "tumbon":"บางขาม",
                                "postcode":"25150"
                            },
                            {
                                "tumbon":"กระทุ่มแพ้ว",
                                "postcode":"25150"
                            }
                            ]
                        },
                        {
                            "amphur":"ประจันตคาม",
                            "listTumbon":[
                            {
                                "tumbon":"ประจันตคาม",
                                "postcode":"25130"
                            },
                            {
                                "tumbon":"เกาะลอย",
                                "postcode":"25130"
                            },
                            {
                                "tumbon":"บ้านหอย",
                                "postcode":"25130"
                            },
                            {
                                "tumbon":"หนองแสง",
                                "postcode":"25130"
                            },
                            {
                                "tumbon":"ดงบัง",
                                "postcode":"25130"
                            },
                            {
                                "tumbon":"คำโตนด",
                                "postcode":"25130"
                            },
                            {
                                "tumbon":"บุฝ้าย",
                                "postcode":"25130"
                            },
                            {
                                "tumbon":"หนองแก้ว",
                                "postcode":"25130"
                            },
                            {
                                "tumbon":"โพธิ์งาม",
                                "postcode":"25130"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีมหาโพธิ",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีมหาโพธิ",
                                "postcode":"25140"
                            },
                            {
                                "tumbon":"สัมพันธ์",
                                "postcode":"25140"
                            },
                            {
                                "tumbon":"บ้านทาม",
                                "postcode":"25140"
                            },
                            {
                                "tumbon":"ท่าตูม",
                                "postcode":"25140"
                            },
                            {
                                "tumbon":"บางกุ้ง",
                                "postcode":"25140"
                            },
                            {
                                "tumbon":"ดงกระทงยาม",
                                "postcode":"25140"
                            },
                            {
                                "tumbon":"หนองโพรง",
                                "postcode":"25140"
                            },
                            {
                                "tumbon":"หัวหว้า",
                                "postcode":"25140"
                            },
                            {
                                "tumbon":"หาดยาง",
                                "postcode":"25140"
                            },
                            {
                                "tumbon":"กรอกสมบูรณ์",
                                "postcode":"25140"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีมโหสถ",
                            "listTumbon":[
                            {
                                "tumbon":"โคกปีบ",
                                "postcode":"25190"
                            },
                            {
                                "tumbon":"โคกไทย",
                                "postcode":"25190"
                            },
                            {
                                "tumbon":"คู้ลำพัน",
                                "postcode":"25190"
                            },
                            {
                                "tumbon":"ไผ่ชะเลือด",
                                "postcode":"25190"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ตราด",
                    "listAmphur":[
                        {
                            "amphur":"เมืองตราด",
                            "listTumbon":[
                            {
                                "tumbon":"บางพระ",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"หนองเสม็ด",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"หนองโสน",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"หนองคันทรง",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"ห้วงน้ำขาว",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"อ่าวใหญ่",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"วังกระแจะ",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"ห้วยแร้ง",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"เนินทราย",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"ท่าพริก",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"ท่ากุ่ม",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"ตะกาง",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"ชำราก",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"แหลมกลัด",
                                "postcode":"23000"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"คลองใหญ่",
                                "postcode":"23110"
                            },
                            {
                                "tumbon":"ไม้รูด",
                                "postcode":"23110"
                            },
                            {
                                "tumbon":"หาดเล็ก",
                                "postcode":"23110"
                            }
                            ]
                        },
                        {
                            "amphur":"เขาสมิง",
                            "listTumbon":[
                            {
                                "tumbon":"เขาสมิง",
                                "postcode":"23130"
                            },
                            {
                                "tumbon":"แสนตุ้ง",
                                "postcode":"23150"
                            },
                            {
                                "tumbon":"วังตะเคียน",
                                "postcode":"23130"
                            },
                            {
                                "tumbon":"ท่าโสม",
                                "postcode":"23150"
                            },
                            {
                                "tumbon":"สะตอ",
                                "postcode":"23150"
                            },
                            {
                                "tumbon":"ประณีต",
                                "postcode":"23150"
                            },
                            {
                                "tumbon":"เทพนิมิต",
                                "postcode":"23150"
                            },
                            {
                                "tumbon":"ทุ่งนนทรี",
                                "postcode":"23130"
                            }
                            ]
                        },
                        {
                            "amphur":"บ่อไร่",
                            "listTumbon":[
                            {
                                "tumbon":"บ่อพลอย",
                                "postcode":"23140"
                            },
                            {
                                "tumbon":"ช้างทูน",
                                "postcode":"23140"
                            },
                            {
                                "tumbon":"ด่านชุมพล",
                                "postcode":"23140"
                            },
                            {
                                "tumbon":"หนองบอน",
                                "postcode":"23140"
                            },
                            {
                                "tumbon":"นนทรีย์",
                                "postcode":"23140"
                            }
                            ]
                        },
                        {
                            "amphur":"แหลมงอบ",
                            "listTumbon":[
                            {
                                "tumbon":"แหลมงอบ",
                                "postcode":"23120"
                            },
                            {
                                "tumbon":"น้ำเชี่ยว",
                                "postcode":"23120"
                            },
                            {
                                "tumbon":"บางปิด",
                                "postcode":"23120"
                            },
                            {
                                "tumbon":"คลองใหญ่",
                                "postcode":"23120"
                            }
                            ]
                        },
                        {
                            "amphur":"เกาะกูด",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะหมาก",
                                "postcode":"23000"
                            },
                            {
                                "tumbon":"เกาะกูด",
                                "postcode":"23000"
                            }
                            ]
                        },
                        {
                            "amphur":"เกาะช้าง",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะช้าง",
                                "postcode":"23170"
                            },
                            {
                                "tumbon":"เกาะช้างใต้",
                                "postcode":"23170"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"จันทบุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองจันทบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"คลองนารายณ์",
                                "postcode":"22000"
                            },
                            {
                                "tumbon":"เกาะขวาง",
                                "postcode":"22000"
                            },
                            {
                                "tumbon":"คมบาง",
                                "postcode":"22000"
                            },
                            {
                                "tumbon":"ท่าช้าง",
                                "postcode":"22000"
                            },
                            {
                                "tumbon":"จันทนิมิต",
                                "postcode":"22000"
                            },
                            {
                                "tumbon":"บางกะจะ",
                                "postcode":"22000"
                            },
                            {
                                "tumbon":"แสลง",
                                "postcode":"22000"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"22000"
                            },
                            {
                                "tumbon":"พลับพลา",
                                "postcode":"22000"
                            },
                            {
                                "tumbon":"ตลาด",
                                "postcode":"22000"
                            },
                            {
                                "tumbon":"วัดใหม่",
                                "postcode":"22000"
                            }
                            ]
                        },
                        {
                            "amphur":"ขลุง",
                            "listTumbon":[
                            {
                                "tumbon":"ขลุง",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"บ่อ",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"เกวียนหัก",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"ตะปอน",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"บางชัน",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"วันยาว",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"ซึ้ง",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"มาบไพ",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"วังสรรพรส",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"ตรอกนอง",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"ตกพรม",
                                "postcode":"22110"
                            },
                            {
                                "tumbon":"บ่อเวฬุ",
                                "postcode":"22150"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าใหม่",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าใหม่",
                                "postcode":"22120"
                            },
                            {
                                "tumbon":"สีพยา",
                                "postcode":"22120"
                            },
                            {
                                "tumbon":"บ่อพุ",
                                "postcode":"22120"
                            },
                            {
                                "tumbon":"พลอยแหวน",
                                "postcode":"22120"
                            },
                            {
                                "tumbon":"เขาวัว",
                                "postcode":"22120"
                            },
                            {
                                "tumbon":"เขาบายศรี",
                                "postcode":"22120"
                            },
                            {
                                "tumbon":"สองพี่น้อง",
                                "postcode":"22120"
                            },
                            {
                                "tumbon":"ทุ่งเบญจา",
                                "postcode":"22170"
                            },
                            {
                                "tumbon":"รำพัน",
                                "postcode":"22170"
                            },
                            {
                                "tumbon":"โขมง",
                                "postcode":"22170"
                            },
                            {
                                "tumbon":"ตะกาดเง้า",
                                "postcode":"22120"
                            },
                            {
                                "tumbon":"คลองขุด",
                                "postcode":"22120"
                            },
                            {
                                "tumbon":"เขาแก้ว",
                                "postcode":"22170"
                            },
                            {
                                "tumbon":"ยายร้า",
                                "postcode":"22120"
                            }
                            ]
                        },
                        {
                            "amphur":"โป่งน้ำร้อน",
                            "listTumbon":[
                            {
                                "tumbon":"ทับไทร",
                                "postcode":"22140"
                            },
                            {
                                "tumbon":"โป่งน้ำร้อน",
                                "postcode":"22140"
                            },
                            {
                                "tumbon":"หนองตาคง",
                                "postcode":"22140"
                            },
                            {
                                "tumbon":"เทพนิมิต",
                                "postcode":"22140"
                            },
                            {
                                "tumbon":"คลองใหญ่",
                                "postcode":"22140"
                            }
                            ]
                        },
                        {
                            "amphur":"มะขาม",
                            "listTumbon":[
                            {
                                "tumbon":"มะขาม",
                                "postcode":"22150"
                            },
                            {
                                "tumbon":"ท่าหลวง",
                                "postcode":"22150"
                            },
                            {
                                "tumbon":"ปัถวี",
                                "postcode":"22150"
                            },
                            {
                                "tumbon":"วังแซ้ม",
                                "postcode":"22150"
                            },
                            {
                                "tumbon":"ฉมัน",
                                "postcode":"22150"
                            },
                            {
                                "tumbon":"อ่างคีรี",
                                "postcode":"22150"
                            }
                            ]
                        },
                        {
                            "amphur":"แหลมสิงห์",
                            "listTumbon":[
                            {
                                "tumbon":"ปากน้ำแหลมสิงห์",
                                "postcode":"22130"
                            },
                            {
                                "tumbon":"เกาะเปริด",
                                "postcode":"22130"
                            },
                            {
                                "tumbon":"หนองชิ่ม",
                                "postcode":"22130"
                            },
                            {
                                "tumbon":"พลิ้ว",
                                "postcode":"22190"
                            },
                            {
                                "tumbon":"คลองน้ำเค็ม",
                                "postcode":"22190"
                            },
                            {
                                "tumbon":"บางสระเก้า",
                                "postcode":"22190"
                            },
                            {
                                "tumbon":"บางกะไชย",
                                "postcode":"22120"
                            }
                            ]
                        },
                        {
                            "amphur":"สอยดาว",
                            "listTumbon":[
                            {
                                "tumbon":"ปะตง",
                                "postcode":"22180"
                            },
                            {
                                "tumbon":"ทุ่งขนาน",
                                "postcode":"22180"
                            },
                            {
                                "tumbon":"ทับช้าง",
                                "postcode":"22180"
                            },
                            {
                                "tumbon":"ทรายขาว",
                                "postcode":"22180"
                            },
                            {
                                "tumbon":"สะตอน",
                                "postcode":"22180"
                            }
                            ]
                        },
                        {
                            "amphur":"แก่งหางแมว",
                            "listTumbon":[
                            {
                                "tumbon":"แก่งหางแมว",
                                "postcode":"22220"
                            },
                            {
                                "tumbon":"ขุนซ่อง",
                                "postcode":"22220"
                            },
                            {
                                "tumbon":"สามพี่น้อง",
                                "postcode":"22220"
                            },
                            {
                                "tumbon":"พวา",
                                "postcode":"22220"
                            },
                            {
                                "tumbon":"เขาวงกต",
                                "postcode":"22220"
                            }
                            ]
                        },
                        {
                            "amphur":"นายายอาม",
                            "listTumbon":[
                            {
                                "tumbon":"นายายอาม",
                                "postcode":"22160"
                            },
                            {
                                "tumbon":"วังโตนด",
                                "postcode":"22170"
                            },
                            {
                                "tumbon":"กระแจะ",
                                "postcode":"22170"
                            },
                            {
                                "tumbon":"สนามไชย",
                                "postcode":"22170"
                            },
                            {
                                "tumbon":"ช้างข้าม",
                                "postcode":"22160"
                            },
                            {
                                "tumbon":"วังใหม่",
                                "postcode":"22170"
                            }
                            ]
                        },
                        {
                            "amphur":"เขาคิชฌกูฏ",
                            "listTumbon":[
                            {
                                "tumbon":"ชากไทย",
                                "postcode":"22210"
                            },
                            {
                                "tumbon":"พลวง",
                                "postcode":"22210"
                            },
                            {
                                "tumbon":"ตะเคียนทอง",
                                "postcode":"22210"
                            },
                            {
                                "tumbon":"คลองพลู",
                                "postcode":"22210"
                            },
                            {
                                "tumbon":"จันทเขลม",
                                "postcode":"22210"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ระยอง",
                    "listAmphur":[
                        {
                            "amphur":"เมืองระยอง",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าประดู่",
                                "postcode":"21000"
                            },
                            {
                                "tumbon":"เชิงเนิน",
                                "postcode":"21000"
                            },
                            {
                                "tumbon":"ตะพง",
                                "postcode":"21000"
                            },
                            {
                                "tumbon":"เพ",
                                "postcode":"21160"
                            },
                            {
                                "tumbon":"แกลง",
                                "postcode":"21160"
                            },
                            {
                                "tumbon":"บ้านแลง",
                                "postcode":"21000"
                            },
                            {
                                "tumbon":"นาตาขวัญ",
                                "postcode":"21000"
                            },
                            {
                                "tumbon":"เนินพระ",
                                "postcode":"21000"
                            },
                            {
                                "tumbon":"กะเฉด",
                                "postcode":"21100"
                            },
                            {
                                "tumbon":"ทับมา",
                                "postcode":"21000"
                            },
                            {
                                "tumbon":"น้ำคอก",
                                "postcode":"21000"
                            },
                            {
                                "tumbon":"ห้วยโป่ง",
                                "postcode":"21150"
                            },
                            {
                                "tumbon":"มาบตาพุด",
                                "postcode":"21150"
                            },
                            {
                                "tumbon":"สำนักทอง",
                                "postcode":"21100"
                            },
                            {
                                "tumbon":"ปากน้ำ",
                                "postcode":"21000"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านฉาง",
                            "listTumbon":[
                            {
                                "tumbon":"สำนักท้อน",
                                "postcode":"21130"
                            },
                            {
                                "tumbon":"พลา",
                                "postcode":"21130"
                            },
                            {
                                "tumbon":"บ้านฉาง",
                                "postcode":"21130"
                            }
                            ]
                        },
                        {
                            "amphur":"แกลง",
                            "listTumbon":[
                            {
                                "tumbon":"ทางเกวียน",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"วังหว้า",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"ชากโดน",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"เนินฆ้อ",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"กร่ำ",
                                "postcode":"21190"
                            },
                            {
                                "tumbon":"ชากพง",
                                "postcode":"21190"
                            },
                            {
                                "tumbon":"กระแสบน",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"ทุ่งควายกิน",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"กองดิน",
                                "postcode":"22160"
                            },
                            {
                                "tumbon":"คลองปูน",
                                "postcode":"21170"
                            },
                            {
                                "tumbon":"พังราด",
                                "postcode":"21170"
                            },
                            {
                                "tumbon":"ปากน้ำกระแส",
                                "postcode":"21170"
                            },
                            {
                                "tumbon":"ห้วยยาง",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"สองสลึง",
                                "postcode":"21110"
                            }
                            ]
                        },
                        {
                            "amphur":"วังจันทร์",
                            "listTumbon":[
                            {
                                "tumbon":"วังจันทร์",
                                "postcode":"21210"
                            },
                            {
                                "tumbon":"ชุมแสง",
                                "postcode":"21210"
                            },
                            {
                                "tumbon":"ป่ายุบใน",
                                "postcode":"21210"
                            },
                            {
                                "tumbon":"พลงตาเอี่ยม",
                                "postcode":"21210"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านค่าย",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านค่าย",
                                "postcode":"21120"
                            },
                            {
                                "tumbon":"หนองละลอก",
                                "postcode":"21120"
                            },
                            {
                                "tumbon":"หนองตะพาน",
                                "postcode":"21120"
                            },
                            {
                                "tumbon":"ตาขัน",
                                "postcode":"21120"
                            },
                            {
                                "tumbon":"บางบุตร",
                                "postcode":"21120"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"21120"
                            },
                            {
                                "tumbon":"ชากบก",
                                "postcode":"21120"
                            }
                            ]
                        },
                        {
                            "amphur":"ปลวกแดง",
                            "listTumbon":[
                            {
                                "tumbon":"ปลวกแดง",
                                "postcode":"21140"
                            },
                            {
                                "tumbon":"ตาสิทธิ์",
                                "postcode":"21140"
                            },
                            {
                                "tumbon":"ละหาร",
                                "postcode":"21140"
                            },
                            {
                                "tumbon":"แม่น้ำคู้",
                                "postcode":"21140"
                            },
                            {
                                "tumbon":"มาบยางพร",
                                "postcode":"21140"
                            },
                            {
                                "tumbon":"หนองไร่",
                                "postcode":"21140"
                            }
                            ]
                        },
                        {
                            "amphur":"เขาชะเมา",
                            "listTumbon":[
                            {
                                "tumbon":"น้ำเป็น",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"ห้วยทับมอญ",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"ชำฆ้อ",
                                "postcode":"21110"
                            },
                            {
                                "tumbon":"เขาน้อย",
                                "postcode":"21110"
                            }
                            ]
                        },
                        {
                            "amphur":"นิคมพัฒนา",
                            "listTumbon":[
                            {
                                "tumbon":"นิคมพัฒนา",
                                "postcode":"21180"
                            },
                            {
                                "tumbon":"มาบข่า",
                                "postcode":"21180"
                            },
                            {
                                "tumbon":"พนานิคม",
                                "postcode":"21180"
                            },
                            {
                                "tumbon":"มะขามคู่",
                                "postcode":"21180"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สระแก้ว",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสระแก้ว",
                            "listTumbon":[
                            {
                                "tumbon":"สระแก้ว",
                                "postcode":"27000"
                            },
                            {
                                "tumbon":"บ้านแก้ง",
                                "postcode":"27000"
                            },
                            {
                                "tumbon":"ศาลาลำดวน",
                                "postcode":"27000"
                            },
                            {
                                "tumbon":"โคกปี่ฆ้อง",
                                "postcode":"27000"
                            },
                            {
                                "tumbon":"ท่าแยก",
                                "postcode":"27000"
                            },
                            {
                                "tumbon":"ท่าเกษม",
                                "postcode":"27000"
                            },
                            {
                                "tumbon":"สระขวัญ",
                                "postcode":"27000"
                            },
                            {
                                "tumbon":"หนองบอน",
                                "postcode":"27000"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองหาด",
                            "listTumbon":[
                            {
                                "tumbon":"คลองหาด",
                                "postcode":"27260"
                            },
                            {
                                "tumbon":"ไทยอุดม",
                                "postcode":"27260"
                            },
                            {
                                "tumbon":"ซับมะกรูด",
                                "postcode":"27260"
                            },
                            {
                                "tumbon":"ไทรเดี่ยว",
                                "postcode":"27260"
                            },
                            {
                                "tumbon":"คลองไก่เถื่อน",
                                "postcode":"27260"
                            },
                            {
                                "tumbon":"เบญจขร",
                                "postcode":"27260"
                            },
                            {
                                "tumbon":"ไทรทอง",
                                "postcode":"27260"
                            }
                            ]
                        },
                        {
                            "amphur":"ตาพระยา",
                            "listTumbon":[
                            {
                                "tumbon":"ตาพระยา",
                                "postcode":"27180"
                            },
                            {
                                "tumbon":"ทัพเสด็จ",
                                "postcode":"27180"
                            },
                            {
                                "tumbon":"ทัพราช",
                                "postcode":"27180"
                            },
                            {
                                "tumbon":"ทัพไทย",
                                "postcode":"27180"
                            },
                            {
                                "tumbon":"โคคลาน",
                                "postcode":"27180"
                            }
                            ]
                        },
                        {
                            "amphur":"วังน้ำเย็น",
                            "listTumbon":[
                            {
                                "tumbon":"วังน้ำเย็น",
                                "postcode":"27210"
                            },
                            {
                                "tumbon":"ตาหลังใน",
                                "postcode":"27210"
                            },
                            {
                                "tumbon":"คลองหินปูน",
                                "postcode":"27210"
                            },
                            {
                                "tumbon":"ทุ่งมหาเจริญ",
                                "postcode":"27210"
                            }
                            ]
                        },
                        {
                            "amphur":"วัฒนานคร",
                            "listTumbon":[
                            {
                                "tumbon":"วัฒนานคร",
                                "postcode":"27160"
                            },
                            {
                                "tumbon":"ท่าเกวียน",
                                "postcode":"27160"
                            },
                            {
                                "tumbon":"ผักขะ",
                                "postcode":"27160"
                            },
                            {
                                "tumbon":"โนนหมากเค็ง",
                                "postcode":"27160"
                            },
                            {
                                "tumbon":"หนองน้ำใส",
                                "postcode":"27160"
                            },
                            {
                                "tumbon":"ช่องกุ่ม",
                                "postcode":"27160"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"27160"
                            },
                            {
                                "tumbon":"แซร์ออ",
                                "postcode":"27160"
                            },
                            {
                                "tumbon":"หนองหมากฝ้าย",
                                "postcode":"27160"
                            },
                            {
                                "tumbon":"หนองตะเคียนบอน",
                                "postcode":"27160"
                            },
                            {
                                "tumbon":"ห้วยโจด",
                                "postcode":"27160"
                            }
                            ]
                        },
                        {
                            "amphur":"อรัญประเทศ",
                            "listTumbon":[
                            {
                                "tumbon":"อรัญประเทศ",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"เมืองไผ่",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"หันทราย",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"คลองน้ำใส",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"ป่าไร่",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"ทับพริก",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"บ้านใหม่หนองไทร",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"ผ่านศึก",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"หนองสังข์",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"คลองทับจันทร์",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"ฟากห้วย",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"บ้านด่าน",
                                "postcode":"27120"
                            }
                            ]
                        },
                        {
                            "amphur":"เขาฉกรรจ์",
                            "listTumbon":[
                            {
                                "tumbon":"เขาฉกรรจ์",
                                "postcode":"27000"
                            },
                            {
                                "tumbon":"หนองหว้า",
                                "postcode":"27000"
                            },
                            {
                                "tumbon":"พระเพลิง",
                                "postcode":"27000"
                            },
                            {
                                "tumbon":"เขาสามสิบ",
                                "postcode":"27000"
                            }
                            ]
                        },
                        {
                            "amphur":"โคกสูง",
                            "listTumbon":[
                            {
                                "tumbon":"โคกสูง",
                                "postcode":"27120"
                            },
                            {
                                "tumbon":"หนองม่วง",
                                "postcode":"27180"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"27180"
                            },
                            {
                                "tumbon":"โนนหมากมุ่น",
                                "postcode":"27120"
                            }
                            ]
                        },
                        {
                            "amphur":"วังสมบูรณ์",
                            "listTumbon":[
                            {
                                "tumbon":"วังสมบูรณ์",
                                "postcode":"27250"
                            },
                            {
                                "tumbon":"วังใหม่",
                                "postcode":"27250"
                            },
                            {
                                "tumbon":"วังทอง",
                                "postcode":"27250"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ราชบุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองราชบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"หน้าเมือง",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"เจดีย์หัก",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"ดอนตะโก",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"หนองกลางนา",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"ห้วยไผ่",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"คุ้งน้ำวน",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"คุ้งกระถิน",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"อ่างทอง",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"โคกหม้อ",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"สามเรือน",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"พิกุลทอง",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"น้ำพุ",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"ดอนแร่",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"หินกอง",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"เขาแร้ง",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"เกาะพลับพลา",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"หลุมดิน",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"บางป่า",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"พงสวาย",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"คูบัว",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"ท่าราบ",
                                "postcode":"70000"
                            },
                            {
                                "tumbon":"บ้านไร่",
                                "postcode":"70000"
                            }
                            ]
                        },
                        {
                            "amphur":"จอมบึง",
                            "listTumbon":[
                            {
                                "tumbon":"จอมบึง",
                                "postcode":"70150"
                            },
                            {
                                "tumbon":"ปากช่อง",
                                "postcode":"70150"
                            },
                            {
                                "tumbon":"เบิกไพร",
                                "postcode":"70150"
                            },
                            {
                                "tumbon":"ด่านทับตะโก",
                                "postcode":"70150"
                            },
                            {
                                "tumbon":"แก้มอ้น",
                                "postcode":"70150"
                            },
                            {
                                "tumbon":"รางบัว",
                                "postcode":"70150"
                            }
                            ]
                        },
                        {
                            "amphur":"สวนผึ้ง",
                            "listTumbon":[
                            {
                                "tumbon":"สวนผึ้ง",
                                "postcode":"70180"
                            },
                            {
                                "tumbon":"ป่าหวาย",
                                "postcode":"70180"
                            },
                            {
                                "tumbon":"ท่าเคย",
                                "postcode":"70180"
                            },
                            {
                                "tumbon":"ตะนาวศรี",
                                "postcode":"70180"
                            }
                            ]
                        },
                        {
                            "amphur":"ดำเนินสะดวก",
                            "listTumbon":[
                            {
                                "tumbon":"ดำเนินสะดวก",
                                "postcode":"70130"
                            },
                            {
                                "tumbon":"ประสาทสิทธิ์",
                                "postcode":"70210"
                            },
                            {
                                "tumbon":"ศรีสุราษฎร์",
                                "postcode":"70130"
                            },
                            {
                                "tumbon":"ตาหลวง",
                                "postcode":"70130"
                            },
                            {
                                "tumbon":"ดอนกรวย",
                                "postcode":"70130"
                            },
                            {
                                "tumbon":"ดอนคลัง",
                                "postcode":"70130"
                            },
                            {
                                "tumbon":"บัวงาม",
                                "postcode":"70210"
                            },
                            {
                                "tumbon":"บ้านไร่",
                                "postcode":"70130"
                            },
                            {
                                "tumbon":"แพงพวย",
                                "postcode":"70130"
                            },
                            {
                                "tumbon":"สี่หมื่น",
                                "postcode":"70130"
                            },
                            {
                                "tumbon":"ท่านัด",
                                "postcode":"70130"
                            },
                            {
                                "tumbon":"ขุนพิทักษ์",
                                "postcode":"70130"
                            },
                            {
                                "tumbon":"ดอนไผ่",
                                "postcode":"70130"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านโป่ง",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านโป่ง",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"ท่าผา",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"กรับใหญ่",
                                "postcode":"70190"
                            },
                            {
                                "tumbon":"หนองกบ",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"หนองอ้อ",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"ดอนกระเบื้อง",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"สวนกล้วย",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"นครชุมน์",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"บ้านม่วง",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"คุ้งพยอม",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"หนองปลาหมอ",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"เขาขลุง",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"เบิกไพร",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"ลาดบัวขาว",
                                "postcode":"70110"
                            },
                            {
                                "tumbon":"ปากแรต",
                                "postcode":"70110"
                            }
                            ]
                        },
                        {
                            "amphur":"บางแพ",
                            "listTumbon":[
                            {
                                "tumbon":"บางแพ",
                                "postcode":"70160"
                            },
                            {
                                "tumbon":"วังเย็น",
                                "postcode":"70160"
                            },
                            {
                                "tumbon":"หัวโพ",
                                "postcode":"70160"
                            },
                            {
                                "tumbon":"วัดแก้ว",
                                "postcode":"70160"
                            },
                            {
                                "tumbon":"ดอนใหญ่",
                                "postcode":"70160"
                            },
                            {
                                "tumbon":"ดอนคา",
                                "postcode":"70160"
                            },
                            {
                                "tumbon":"โพหัก",
                                "postcode":"70160"
                            }
                            ]
                        },
                        {
                            "amphur":"โพธาราม",
                            "listTumbon":[
                            {
                                "tumbon":"โพธาราม",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"ดอนกระเบื้อง",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"หนองโพ",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"บ้านเลือก",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"บ้านฆ้อง",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"บ้านสิงห์",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"ดอนทราย",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"เจ็ดเสมียน",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"คลองข่อย",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"ชำแระ",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"สร้อยฟ้า",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"ท่าชุมพล",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"บางโตนด",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"เตาปูน",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"นางแก้ว",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"ธรรมเสน",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"เขาชะงุ้ม",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"หนองกวาง",
                                "postcode":"70120"
                            },
                            {
                                "tumbon":"คลองตาคต",
                                "postcode":"70120"
                            }
                            ]
                        },
                        {
                            "amphur":"ปากท่อ",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งหลวง",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"วังมะนาว",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"ดอนทราย",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"หนองกระทุ่ม",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"ปากท่อ",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"ป่าไก่",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"วัดยางงาม",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"อ่างหิน",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"บ่อกระดาน",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"ยางหัก",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"วันดาว",
                                "postcode":"70140"
                            },
                            {
                                "tumbon":"ห้วยยางโทน",
                                "postcode":"70140"
                            }
                            ]
                        },
                        {
                            "amphur":"วัดเพลง",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะศาลพระ",
                                "postcode":"70170"
                            },
                            {
                                "tumbon":"จอมประทัด",
                                "postcode":"70170"
                            },
                            {
                                "tumbon":"วัดเพลง",
                                "postcode":"70170"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านคา",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านคา",
                                "postcode":"70180"
                            },
                            {
                                "tumbon":"บ้านบึง",
                                "postcode":"70180"
                            },
                            {
                                "tumbon":"หนองพันจันทร์",
                                "postcode":"70180"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"นครปฐม",
                    "listAmphur":[
                        {
                            "amphur":"เมืองนครปฐม",
                            "listTumbon":[
                            {
                                "tumbon":"พระปฐมเจดีย์",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"บางแขม",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"พระประโทน",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"ธรรมศาลา",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"ตาก้อง",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"มาบแค",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"สนามจันทร์",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"ดอนยายหอม",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"ถนนขาด",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"บ่อพลับ",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"นครปฐม",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"วังตะกู",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"หนองปากโลง",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"สามควายเผือก",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"ทุ่งน้อย",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"หนองดินแดง",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"วังเย็น",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"โพรงมะเดื่อ",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"ลำพยา",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"สระกะเทียม",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"สวนป่าน",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"ห้วยจรเข้",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"ทัพหลวง",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"หนองงูเหลือม",
                                "postcode":"73000"
                            },
                            {
                                "tumbon":"บ้านยาง",
                                "postcode":"73000"
                            }
                            ]
                        },
                        {
                            "amphur":"กำแพงแสน",
                            "listTumbon":[
                            {
                                "tumbon":"กระตีบ",
                                "postcode":"73180"
                            },
                            {
                                "tumbon":"ทุ่งลูกนก",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"ห้วยขวาง",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"ทุ่งขวาง",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"สระสี่มุม",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"ทุ่งบัว",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"ดอนข่อย",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"สระพัฒนา",
                                "postcode":"73180"
                            },
                            {
                                "tumbon":"ห้วยหมอนทอง",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"ห้วยม่วง",
                                "postcode":"73180"
                            },
                            {
                                "tumbon":"กำแพงแสน",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"รางพิกุล",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"หนองกระทุ่ม",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"วังน้ำเขียว",
                                "postcode":"73140"
                            },
                            {
                                "tumbon":"ทุ่งกระพังโหม",
                                "postcode":"73140"
                            }
                            ]
                        },
                        {
                            "amphur":"นครชัยศรี",
                            "listTumbon":[
                            {
                                "tumbon":"นครชัยศรี",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"บางกระเบา",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"วัดแค",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"ท่าตำหนัก",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"บางแก้ว",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"ท่ากระชับ",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"ขุนแก้ว",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"ท่าพระยา",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"พะเนียด",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"บางระกำ",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"โคกพระเจดีย์",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"ศรีษะทอง",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"แหลมบัว",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"ศรีมหาโพธิ์",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"สัมปทวน",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"วัดสำโรง",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"ดอนแฝก",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"ห้วยพลู",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"วัดละมุด",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"บางพระ",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"บางแก้วฟ้า",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"ลานตากฟ้า",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"งิ้วราย",
                                "postcode":"73120"
                            },
                            {
                                "tumbon":"ไทยาวาส",
                                "postcode":"73120"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอนตูม",
                            "listTumbon":[
                            {
                                "tumbon":"สามง่าม",
                                "postcode":"73150"
                            },
                            {
                                "tumbon":"ห้วยพระ",
                                "postcode":"73150"
                            },
                            {
                                "tumbon":"ลำเหย",
                                "postcode":"73150"
                            },
                            {
                                "tumbon":"ดอนพุทรา",
                                "postcode":"73150"
                            },
                            {
                                "tumbon":"บ้านหลวง",
                                "postcode":"73150"
                            },
                            {
                                "tumbon":"ดอนรวก",
                                "postcode":"73150"
                            },
                            {
                                "tumbon":"ห้วยด้วน",
                                "postcode":"73150"
                            },
                            {
                                "tumbon":"ลำลูกบัว",
                                "postcode":"73150"
                            }
                            ]
                        },
                        {
                            "amphur":"บางเลน",
                            "listTumbon":[
                            {
                                "tumbon":"บางเลน",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"บางปลา",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"บางหลวง",
                                "postcode":"73190"
                            },
                            {
                                "tumbon":"บางภาษี",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"บางระกำ",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"บางไทรป่า",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"หินมูล",
                                "postcode":"73190"
                            },
                            {
                                "tumbon":"ไทรงาม",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"ดอนตูม",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"นิลเพชร",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"บัวปากท่า",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"คลองนกกระทุง",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"ลำพญา",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"ไผ่หูช้าง",
                                "postcode":"73130"
                            },
                            {
                                "tumbon":"นราภิรมย์",
                                "postcode":"73130"
                            }
                            ]
                        },
                        {
                            "amphur":"สามพราน",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"73110"
                            },
                            {
                                "tumbon":"ทรงคนอง",
                                "postcode":"73210"
                            },
                            {
                                "tumbon":"หอมเกร็ด",
                                "postcode":"73110"
                            },
                            {
                                "tumbon":"บางกระทึก",
                                "postcode":"73210"
                            },
                            {
                                "tumbon":"บางเตย",
                                "postcode":"73210"
                            },
                            {
                                "tumbon":"สามพราน",
                                "postcode":"73110"
                            },
                            {
                                "tumbon":"บางช้าง",
                                "postcode":"73110"
                            },
                            {
                                "tumbon":"ไร่ขิง",
                                "postcode":"73210"
                            },
                            {
                                "tumbon":"ท่าตลาด",
                                "postcode":"73110"
                            },
                            {
                                "tumbon":"กระทุ่มล้ม",
                                "postcode":"73220"
                            },
                            {
                                "tumbon":"คลองใหม่",
                                "postcode":"73110"
                            },
                            {
                                "tumbon":"ตลาดจินดา",
                                "postcode":"73110"
                            },
                            {
                                "tumbon":"คลองจินดา",
                                "postcode":"73110"
                            },
                            {
                                "tumbon":"ยายชา",
                                "postcode":"73110"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"73110"
                            },
                            {
                                "tumbon":"อ้อมใหญ่",
                                "postcode":"73160"
                            }
                            ]
                        },
                        {
                            "amphur":"พุทธมณฑล",
                            "listTumbon":[
                            {
                                "tumbon":"ศาลายา",
                                "postcode":"73170"
                            },
                            {
                                "tumbon":"คลองโยง",
                                "postcode":"73170"
                            },
                            {
                                "tumbon":"มหาสวัสดิ์",
                                "postcode":"73170"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"กาญจนบุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองกาญจนบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ปากแพรก",
                                "postcode":"71000"
                            },
                            {
                                "tumbon":"ท่ามะขาม",
                                "postcode":"71000"
                            },
                            {
                                "tumbon":"แก่งเสี้ยน",
                                "postcode":"71000"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"71190"
                            },
                            {
                                "tumbon":"ลาดหญ้า",
                                "postcode":"71190"
                            },
                            {
                                "tumbon":"วังด้ง",
                                "postcode":"71190"
                            },
                            {
                                "tumbon":"ช่องสะเดา",
                                "postcode":"71190"
                            },
                            {
                                "tumbon":"หนองหญ้า",
                                "postcode":"71000"
                            },
                            {
                                "tumbon":"เกาะสำโรง",
                                "postcode":"71000"
                            },
                            {
                                "tumbon":"บ้านเก่า",
                                "postcode":"71000"
                            },
                            {
                                "tumbon":"วังเย็น",
                                "postcode":"71000"
                            },
                            {
                                "tumbon":"บ้านเหนือ",
                                "postcode":"71000"
                            },
                            {
                                "tumbon":"บ้านใต้",
                                "postcode":"71000"
                            }
                            ]
                        },
                        {
                            "amphur":"ไทรโยค",
                            "listTumbon":[
                            {
                                "tumbon":"ลุ่มสุ่ม",
                                "postcode":"71150"
                            },
                            {
                                "tumbon":"ท่าเสา",
                                "postcode":"71150"
                            },
                            {
                                "tumbon":"สิงห์",
                                "postcode":"71150"
                            },
                            {
                                "tumbon":"ไทรโยค",
                                "postcode":"71150"
                            },
                            {
                                "tumbon":"วังกระแจะ",
                                "postcode":"71150"
                            },
                            {
                                "tumbon":"ศรีมงคล",
                                "postcode":"71150"
                            },
                            {
                                "tumbon":"บ้องตี้",
                                "postcode":"71150"
                            }
                            ]
                        },
                        {
                            "amphur":"บ่อพลอย",
                            "listTumbon":[
                            {
                                "tumbon":"บ่อพลอย",
                                "postcode":"71160"
                            },
                            {
                                "tumbon":"หนองกุ่ม",
                                "postcode":"71160"
                            },
                            {
                                "tumbon":"หนองรี",
                                "postcode":"71220"
                            },
                            {
                                "tumbon":"หลุมรัง",
                                "postcode":"71160"
                            },
                            {
                                "tumbon":"ช่องด่าน",
                                "postcode":"71160"
                            },
                            {
                                "tumbon":"หนองกร่าง",
                                "postcode":"71220"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีสวัสดิ์",
                            "listTumbon":[
                            {
                                "tumbon":"นาสวน",
                                "postcode":"71250"
                            },
                            {
                                "tumbon":"ด่านแม่แฉลบ",
                                "postcode":"71250"
                            },
                            {
                                "tumbon":"หนองเป็ด",
                                "postcode":"71250"
                            },
                            {
                                "tumbon":"ท่ากระดาน",
                                "postcode":"71250"
                            },
                            {
                                "tumbon":"เขาโจด",
                                "postcode":"71220"
                            },
                            {
                                "tumbon":"แม่กระบุง",
                                "postcode":"71250"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่ามะกา",
                            "listTumbon":[
                            {
                                "tumbon":"พงตึก",
                                "postcode":"71120"
                            },
                            {
                                "tumbon":"ยางม่วง",
                                "postcode":"71120"
                            },
                            {
                                "tumbon":"ดอนชะเอม",
                                "postcode":"71130"
                            },
                            {
                                "tumbon":"ท่าไม้",
                                "postcode":"71120"
                            },
                            {
                                "tumbon":"ตะคร้ำเอน",
                                "postcode":"71130"
                            },
                            {
                                "tumbon":"ท่ามะกา",
                                "postcode":"71120"
                            },
                            {
                                "tumbon":"ท่าเรือ",
                                "postcode":"71130"
                            },
                            {
                                "tumbon":"โคกตะบอง",
                                "postcode":"71120"
                            },
                            {
                                "tumbon":"ดอนขมิ้น",
                                "postcode":"71120"
                            },
                            {
                                "tumbon":"อุโลกสี่หมื่น",
                                "postcode":"71130"
                            },
                            {
                                "tumbon":"เขาสามสิบหาบ",
                                "postcode":"71120"
                            },
                            {
                                "tumbon":"พระแท่น",
                                "postcode":"71130"
                            },
                            {
                                "tumbon":"หวายเหนียว",
                                "postcode":"71120"
                            },
                            {
                                "tumbon":"แสนตอ",
                                "postcode":"71130"
                            },
                            {
                                "tumbon":"สนามแย้",
                                "postcode":"70190"
                            },
                            {
                                "tumbon":"ท่าเสา",
                                "postcode":"71120"
                            },
                            {
                                "tumbon":"หนองลาน",
                                "postcode":"71130"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าม่วง",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าม่วง",
                                "postcode":"71110"
                            },
                            {
                                "tumbon":"วังขนาย",
                                "postcode":"71110"
                            },
                            {
                                "tumbon":"วังศาลา",
                                "postcode":"71110"
                            },
                            {
                                "tumbon":"ท่าล้อ",
                                "postcode":"71000"
                            },
                            {
                                "tumbon":"หนองขาว",
                                "postcode":"71110"
                            },
                            {
                                "tumbon":"ทุ่งทอง",
                                "postcode":"71110"
                            },
                            {
                                "tumbon":"เขาน้อย",
                                "postcode":"71110"
                            },
                            {
                                "tumbon":"ม่วงชุม",
                                "postcode":"71110"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"71110"
                            },
                            {
                                "tumbon":"พังตรุ",
                                "postcode":"71110"
                            },
                            {
                                "tumbon":"ท่าตะคร้อ",
                                "postcode":"71130"
                            },
                            {
                                "tumbon":"รางสาลี่",
                                "postcode":"71110"
                            },
                            {
                                "tumbon":"หนองตากยา",
                                "postcode":"71110"
                            }
                            ]
                        },
                        {
                            "amphur":"ทองผาภูมิ",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าขนุน",
                                "postcode":"71180"
                            },
                            {
                                "tumbon":"ปิล๊อก",
                                "postcode":"71180"
                            },
                            {
                                "tumbon":"หินดาด",
                                "postcode":"71180"
                            },
                            {
                                "tumbon":"ลิ่นถิ่น",
                                "postcode":"71180"
                            },
                            {
                                "tumbon":"ชะแล",
                                "postcode":"71180"
                            },
                            {
                                "tumbon":"ห้วยเขย่ง",
                                "postcode":"71180"
                            },
                            {
                                "tumbon":"สหกรณ์นิคม",
                                "postcode":"71180"
                            }
                            ]
                        },
                        {
                            "amphur":"สังขละบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"หนองลู",
                                "postcode":"71240"
                            },
                            {
                                "tumbon":"ปรังเผล",
                                "postcode":"71240"
                            },
                            {
                                "tumbon":"ไล่โว่",
                                "postcode":"71240"
                            }
                            ]
                        },
                        {
                            "amphur":"พนมทวน",
                            "listTumbon":[
                            {
                                "tumbon":"พนมทวน",
                                "postcode":"71140"
                            },
                            {
                                "tumbon":"หนองโรง",
                                "postcode":"71140"
                            },
                            {
                                "tumbon":"ทุ่งสมอ",
                                "postcode":"71140"
                            },
                            {
                                "tumbon":"ดอนเจดีย์",
                                "postcode":"71140"
                            },
                            {
                                "tumbon":"รางหวาย",
                                "postcode":"71170"
                            },
                            {
                                "tumbon":"หนองสาหร่าย",
                                "postcode":"71140"
                            },
                            {
                                "tumbon":"ดอนตาเพชร",
                                "postcode":"71140"
                            },
                            {
                                "tumbon":"พังตรุ",
                                "postcode":"71140"
                            }
                            ]
                        },
                        {
                            "amphur":"เลาขวัญ",
                            "listTumbon":[
                            {
                                "tumbon":"เลาขวัญ",
                                "postcode":"71210"
                            },
                            {
                                "tumbon":"หนองโสน",
                                "postcode":"71210"
                            },
                            {
                                "tumbon":"หนองประดู่",
                                "postcode":"71210"
                            },
                            {
                                "tumbon":"หนองปลิง",
                                "postcode":"71210"
                            },
                            {
                                "tumbon":"หนองนกแก้ว",
                                "postcode":"71210"
                            },
                            {
                                "tumbon":"ทุ่งกระบ่ำ",
                                "postcode":"71210"
                            },
                            {
                                "tumbon":"หนองฝ้าย",
                                "postcode":"71210"
                            }
                            ]
                        },
                        {
                            "amphur":"ด่านมะขามเตี้ย",
                            "listTumbon":[
                            {
                                "tumbon":"ด่านมะขามเตี้ย",
                                "postcode":"71260"
                            },
                            {
                                "tumbon":"กลอนโด",
                                "postcode":"71260"
                            },
                            {
                                "tumbon":"จรเข้เผือก",
                                "postcode":"71260"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"71260"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองปรือ",
                            "listTumbon":[
                            {
                                "tumbon":"หนองปรือ",
                                "postcode":"71220"
                            },
                            {
                                "tumbon":"หนองปลาไหล",
                                "postcode":"71220"
                            },
                            {
                                "tumbon":"สมเด็จเจริญ",
                                "postcode":"71220"
                            }
                            ]
                        },
                        {
                            "amphur":"ห้วยกระเจา",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยกระเจา",
                                "postcode":"71170"
                            },
                            {
                                "tumbon":"วังไผ่",
                                "postcode":"71170"
                            },
                            {
                                "tumbon":"ดอนแสลบ",
                                "postcode":"71170"
                            },
                            {
                                "tumbon":"สระลงเรือ",
                                "postcode":"71170"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"เพชรบุรี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองเพชรบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าราบ",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"คลองกระแชง",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"บางจาน",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"นาพันสาม",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"ธงชัย",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"บ้านกุ่ม",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"หนองโสน",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"ไร่ส้ม",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"เวียงคอย",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"บางจาก",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"บ้านหม้อ",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"ต้นมะม่วง",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"ช่องสะแก",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"นาวุ้ง",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"สำมะโรง",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"โพพระ",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"หาดเจ้าสำราญ",
                                "postcode":"76100"
                            },
                            {
                                "tumbon":"หัวสะพาน",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"ต้นมะพร้าว",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"วังตะโก",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"โพไร่หวาน",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"ดอนยาง",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"หนองขนาน",
                                "postcode":"76000"
                            },
                            {
                                "tumbon":"หนองพลับ",
                                "postcode":"76000"
                            }
                            ]
                        },
                        {
                            "amphur":"เขาย้อย",
                            "listTumbon":[
                            {
                                "tumbon":"เขาย้อย",
                                "postcode":"76140"
                            },
                            {
                                "tumbon":"สระพัง",
                                "postcode":"76140"
                            },
                            {
                                "tumbon":"บางเค็ม",
                                "postcode":"76140"
                            },
                            {
                                "tumbon":"ทับคาง",
                                "postcode":"76140"
                            },
                            {
                                "tumbon":"หนองปลาไหล",
                                "postcode":"76140"
                            },
                            {
                                "tumbon":"หนองปรง",
                                "postcode":"76140"
                            },
                            {
                                "tumbon":"หนองชุมพล",
                                "postcode":"76140"
                            },
                            {
                                "tumbon":"ห้วยโรง",
                                "postcode":"76140"
                            },
                            {
                                "tumbon":"ห้วยท่าช้าง",
                                "postcode":"76140"
                            },
                            {
                                "tumbon":"หนองชุมพลเหนือ",
                                "postcode":"76140"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองหญ้าปล้อง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองหญ้าปล้อง",
                                "postcode":"76160"
                            },
                            {
                                "tumbon":"ยางน้ำกลัดเหนือ",
                                "postcode":"76160"
                            },
                            {
                                "tumbon":"ยางน้ำกลัดใต้",
                                "postcode":"76160"
                            },
                            {
                                "tumbon":"ท่าตะคร้อ",
                                "postcode":"76160"
                            }
                            ]
                        },
                        {
                            "amphur":"ชะอำ",
                            "listTumbon":[
                            {
                                "tumbon":"ชะอำ",
                                "postcode":"76120"
                            },
                            {
                                "tumbon":"บางเก่า",
                                "postcode":"76120"
                            },
                            {
                                "tumbon":"นายาง",
                                "postcode":"76120"
                            },
                            {
                                "tumbon":"เขาใหญ่",
                                "postcode":"76120"
                            },
                            {
                                "tumbon":"หนองศาลา",
                                "postcode":"76120"
                            },
                            {
                                "tumbon":"ห้วยทรายเหนือ",
                                "postcode":"76120"
                            },
                            {
                                "tumbon":"ไร่ใหม่พัฒนา",
                                "postcode":"76120"
                            },
                            {
                                "tumbon":"สามพระยา",
                                "postcode":"76120"
                            },
                            {
                                "tumbon":"ดอนขุนห้วย",
                                "postcode":"76120"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่ายาง",
                            "listTumbon":[
                            {
                                "tumbon":"ท่ายาง",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"ท่าคอย",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"ยางหย่อง",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"หนองจอก",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"มาบปลาเค้า",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"ท่าไม้รวก",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"วังไคร้",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"กลัดหลวง",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"ปึกเตียน",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"เขากระปุก",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"ท่าแลง",
                                "postcode":"76130"
                            },
                            {
                                "tumbon":"บ้านในดง",
                                "postcode":"76130"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านลาด",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านลาด",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"บ้านหาด",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"บ้านทาน",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"ตำหรุ",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"สมอพลือ",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"ไร่มะขาม",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"ท่าเสน",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"หนองกระเจ็ด",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"หนองกะปุ",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"ลาดโพธิ์",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"สะพานไกร",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"ไร่โคก",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"โรงเข้",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"ไร่สะท้อน",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"ห้วยข้อง",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"ท่าช้าง",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"ถ้ำรงค์",
                                "postcode":"76150"
                            },
                            {
                                "tumbon":"ห้วยลึก",
                                "postcode":"76150"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านแหลม",
                            "listTumbon":[
                            {
                                "tumbon":"บางขุนไทร",
                                "postcode":"76110"
                            },
                            {
                                "tumbon":"บางแก้ว",
                                "postcode":"76110"
                            },
                            {
                                "tumbon":"บ้านแหลม",
                                "postcode":"76110"
                            },
                            {
                                "tumbon":"ปากทะเล",
                                "postcode":"76110"
                            },
                            {
                                "tumbon":"แหลมผักเบี้ย",
                                "postcode":"76100"
                            },
                            {
                                "tumbon":"บางตะบูน",
                                "postcode":"76110"
                            },
                            {
                                "tumbon":"บางตะบูนออก",
                                "postcode":"76110"
                            },
                            {
                                "tumbon":"บางครก",
                                "postcode":"76110"
                            },
                            {
                                "tumbon":"ท่าแร้ง",
                                "postcode":"76110"
                            },
                            {
                                "tumbon":"ท่าแร้งออก",
                                "postcode":"76110"
                            }
                            ]
                        },
                        {
                            "amphur":"แก่งกระจาน",
                            "listTumbon":[
                            {
                                "tumbon":"แก่งกระจาน",
                                "postcode":"76170"
                            },
                            {
                                "tumbon":"สองพี่น้อง",
                                "postcode":"76170"
                            },
                            {
                                "tumbon":"วังจันทร์",
                                "postcode":"76170"
                            },
                            {
                                "tumbon":"ป่าเด็ง",
                                "postcode":"76170"
                            },
                            {
                                "tumbon":"พุสวรรค์",
                                "postcode":"76170"
                            },
                            {
                                "tumbon":"ห้วยแม่เพรียง",
                                "postcode":"76170"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ประจวบคีรีขันธ์",
                    "listAmphur":[
                        {
                            "amphur":"เมืองประจวบคีรีขันธ์",
                            "listTumbon":[
                            {
                                "tumbon":"ประจวบคีรีขันธ์",
                                "postcode":"77000"
                            },
                            {
                                "tumbon":"เกาะหลัก",
                                "postcode":"77000"
                            },
                            {
                                "tumbon":"คลองวาฬ",
                                "postcode":"77000"
                            },
                            {
                                "tumbon":"ห้วยทราย",
                                "postcode":"77000"
                            },
                            {
                                "tumbon":"อ่าวน้อย",
                                "postcode":"77210"
                            },
                            {
                                "tumbon":"บ่อนอก",
                                "postcode":"77210"
                            }
                            ]
                        },
                        {
                            "amphur":"กุยบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"กุยบุรี",
                                "postcode":"77150"
                            },
                            {
                                "tumbon":"กุยเหนือ",
                                "postcode":"77150"
                            },
                            {
                                "tumbon":"เขาแดง",
                                "postcode":"77150"
                            },
                            {
                                "tumbon":"ดอนยายหนู",
                                "postcode":"77150"
                            },
                            {
                                "tumbon":"สามกระทาย",
                                "postcode":"77150"
                            },
                            {
                                "tumbon":"หาดขาม",
                                "postcode":"77150"
                            }
                            ]
                        },
                        {
                            "amphur":"ทับสะแก",
                            "listTumbon":[
                            {
                                "tumbon":"ทับสะแก",
                                "postcode":"77130"
                            },
                            {
                                "tumbon":"อ่างทอง",
                                "postcode":"77130"
                            },
                            {
                                "tumbon":"นาหูกวาง",
                                "postcode":"77130"
                            },
                            {
                                "tumbon":"เขาล้าน",
                                "postcode":"77130"
                            },
                            {
                                "tumbon":"ห้วยยาง",
                                "postcode":"77130"
                            },
                            {
                                "tumbon":"แสงอรุณ",
                                "postcode":"77130"
                            }
                            ]
                        },
                        {
                            "amphur":"บางสะพาน",
                            "listTumbon":[
                            {
                                "tumbon":"กำเนิดนพคุณ",
                                "postcode":"77140"
                            },
                            {
                                "tumbon":"พงศ์ประศาสน์",
                                "postcode":"77140"
                            },
                            {
                                "tumbon":"ร่อนทอง",
                                "postcode":"77230"
                            },
                            {
                                "tumbon":"ธงชัย",
                                "postcode":"77190"
                            },
                            {
                                "tumbon":"ชัยเกษม",
                                "postcode":"77190"
                            },
                            {
                                "tumbon":"ทองมงคล",
                                "postcode":"77230"
                            },
                            {
                                "tumbon":"แม่รำพึง",
                                "postcode":"77140"
                            }
                            ]
                        },
                        {
                            "amphur":"บางสะพานน้อย",
                            "listTumbon":[
                            {
                                "tumbon":"ปากแพรก",
                                "postcode":"77170"
                            },
                            {
                                "tumbon":"บางสะพาน",
                                "postcode":"77170"
                            },
                            {
                                "tumbon":"ทรายทอง",
                                "postcode":"77170"
                            },
                            {
                                "tumbon":"ช้างแรก",
                                "postcode":"77170"
                            },
                            {
                                "tumbon":"ไชยราช",
                                "postcode":"77170"
                            }
                            ]
                        },
                        {
                            "amphur":"ปราณบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ปราณบุรี",
                                "postcode":"77120"
                            },
                            {
                                "tumbon":"เขาน้อย",
                                "postcode":"77120"
                            },
                            {
                                "tumbon":"ปากน้ำปราณ",
                                "postcode":"77220"
                            },
                            {
                                "tumbon":"หนองตาแต้ม",
                                "postcode":"77120"
                            },
                            {
                                "tumbon":"วังก์พง",
                                "postcode":"77120"
                            },
                            {
                                "tumbon":"เขาจ้าว",
                                "postcode":"77120"
                            },
                            {
                                "tumbon":"ปราณบุรี",
                                "postcode":"77160"
                            },
                            {
                                "tumbon":"วังก์พง",
                                "postcode":"77160"
                            },
                            {
                                "tumbon":"หนองตาแต้ม",
                                "postcode":"77160"
                            },
                            {
                                "tumbon":"เขาจ้าว",
                                "postcode":"77160"
                            },
                            {
                                "tumbon":"เขาน้อย",
                                "postcode":"77160"
                            }
                            ]
                        },
                        {
                            "amphur":"หัวหิน",
                            "listTumbon":[
                            {
                                "tumbon":"หัวหิน",
                                "postcode":"77110"
                            },
                            {
                                "tumbon":"หนองแก",
                                "postcode":"77110"
                            },
                            {
                                "tumbon":"หินเหล็กไฟ",
                                "postcode":"77110"
                            },
                            {
                                "tumbon":"หนองพลับ",
                                "postcode":"77110"
                            },
                            {
                                "tumbon":"ทับใต้",
                                "postcode":"77110"
                            },
                            {
                                "tumbon":"ห้วยสัตว์ใหญ่",
                                "postcode":"77110"
                            },
                            {
                                "tumbon":"บึงนคร",
                                "postcode":"77110"
                            }
                            ]
                        },
                        {
                            "amphur":"สามร้อยยอด",
                            "listTumbon":[
                            {
                                "tumbon":"สามร้อยยอด",
                                "postcode":"77120"
                            },
                            {
                                "tumbon":"ศิลาลอย",
                                "postcode":"77180"
                            },
                            {
                                "tumbon":"ไร่เก่า",
                                "postcode":"77180"
                            },
                            {
                                "tumbon":"ไร่ใหม่",
                                "postcode":"77180"
                            },
                            {
                                "tumbon":"ศาลาลัย",
                                "postcode":"77180"
                            },
                            {
                                "tumbon":"สามร้อยยอด",
                                "postcode":"77160"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สมุทรสาคร",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสมุทรสาคร",
                            "listTumbon":[
                            {
                                "tumbon":"มหาชัย",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"บ้านบ่อ",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"บางโทรัด",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"กาหลง",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"นาโคก",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"ท่าจีน",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"นาดี",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"ท่าทราย",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"คอกกระบือ",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"บางน้ำจืด",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"พันท้ายนรสิงห์",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"โคกขาม",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"บ้านเกาะ",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"บางกระเจ้า",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"บางหญ้าแพรก",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"ชัยมงคล",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"ท่าฉลอม",
                                "postcode":"74000"
                            },
                            {
                                "tumbon":"โกรกกราก",
                                "postcode":"74000"
                            }
                            ]
                        },
                        {
                            "amphur":"กระทุ่มแบน",
                            "listTumbon":[
                            {
                                "tumbon":"ตลาดกระทุ่มแบน",
                                "postcode":"74110"
                            },
                            {
                                "tumbon":"อ้อมน้อย",
                                "postcode":"74130"
                            },
                            {
                                "tumbon":"ท่าไม้",
                                "postcode":"74110"
                            },
                            {
                                "tumbon":"สวนหลวง",
                                "postcode":"74110"
                            },
                            {
                                "tumbon":"บางยาง",
                                "postcode":"74110"
                            },
                            {
                                "tumbon":"คลองมะเดื่อ",
                                "postcode":"74110"
                            },
                            {
                                "tumbon":"หนองนกไข่",
                                "postcode":"74110"
                            },
                            {
                                "tumbon":"ดอนไก่ดี",
                                "postcode":"74110"
                            },
                            {
                                "tumbon":"แคราย",
                                "postcode":"74110"
                            },
                            {
                                "tumbon":"ท่าเสา",
                                "postcode":"74110"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านแพ้ว",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านแพ้ว",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"หลักสาม",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"ยกกระบัตร",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"โรงเข้",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"หนองสองห้อง",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"หลักสอง",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"เจ็ดริ้ว",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"คลองตัน",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"อำแพง",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"สวนส้ม",
                                "postcode":"74120"
                            },
                            {
                                "tumbon":"เกษตรพัฒนา",
                                "postcode":"74120"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สมุทรสงคราม",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสมุทรสงคราม",
                            "listTumbon":[
                            {
                                "tumbon":"แม่กลอง",
                                "postcode":"75000"
                            },
                            {
                                "tumbon":"บางขันแตก",
                                "postcode":"75000"
                            },
                            {
                                "tumbon":"ลาดใหญ่",
                                "postcode":"75000"
                            },
                            {
                                "tumbon":"บ้านปรก",
                                "postcode":"75000"
                            },
                            {
                                "tumbon":"บางแก้ว",
                                "postcode":"75000"
                            },
                            {
                                "tumbon":"ท้ายหาด",
                                "postcode":"75000"
                            },
                            {
                                "tumbon":"แหลมใหญ่",
                                "postcode":"75000"
                            },
                            {
                                "tumbon":"คลองเขิน",
                                "postcode":"75000"
                            },
                            {
                                "tumbon":"คลองโคน",
                                "postcode":"75000"
                            },
                            {
                                "tumbon":"นางตะเคียน",
                                "postcode":"75000"
                            },
                            {
                                "tumbon":"บางจะเกร็ง",
                                "postcode":"75000"
                            }
                            ]
                        },
                        {
                            "amphur":"บางคนที",
                            "listTumbon":[
                            {
                                "tumbon":"กระดังงา",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"บางสะแก",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"บางยี่รงค์",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"โรงหีบ",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"บางคนที",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"ดอนมะโนรา",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"บางพรม",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"บางกุ้ง",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"จอมปลวก",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"บางนกแขวก",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"ยายแพง",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"บางกระบือ",
                                "postcode":"75120"
                            },
                            {
                                "tumbon":"บ้านปราโมทย์",
                                "postcode":"75120"
                            }
                            ]
                        },
                        {
                            "amphur":"อัมพวา",
                            "listTumbon":[
                            {
                                "tumbon":"อัมพวา",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"สวนหลวง",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"ท่าคา",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"วัดประดู่",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"เหมืองใหม่",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"บางช้าง",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"แควอ้อม",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"ปลายโพงพาง",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"บางแค",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"แพรกหนามแดง",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"ยี่สาร",
                                "postcode":"75110"
                            },
                            {
                                "tumbon":"บางนางลี่",
                                "postcode":"75110"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"นครราชสีมา",
                    "listAmphur":[
                        {
                            "amphur":"เมืองนครราชสีมา",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"โพธิ์กลาง",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"หนองจะบก",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"โคกสูง",
                                "postcode":"30310"
                            },
                            {
                                "tumbon":"มะเริง",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"หนองระเวียง",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"ปรุใหญ่",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"หมื่นไวย",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"พลกรัง",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"หนองไผ่ล้อม",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"หัวทะเล",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"บ้านเกาะ",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"พุดซา",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"บ้านโพธิ์",
                                "postcode":"30310"
                            },
                            {
                                "tumbon":"จอหอ",
                                "postcode":"30310"
                            },
                            {
                                "tumbon":"โคกกรวด",
                                "postcode":"30280"
                            },
                            {
                                "tumbon":"ไชยมงคล",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"หนองบัวศาลา",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"สุรนารี",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"สีมุม",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"ตลาด",
                                "postcode":"30310"
                            },
                            {
                                "tumbon":"พะเนา",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"หนองกระทุ่ม",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"หนองไข่น้ำ",
                                "postcode":"30310"
                            }
                            ]
                        },
                        {
                            "amphur":"ครบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"แชะ",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"เฉลียง",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"ครบุรี",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"โคกกระชาย",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"จระเข้หิน",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"มาบตะโกเอน",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"อรพิมพ์",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"ลำเพียก",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"ครบุรีใต้",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"ตะแบกบาน",
                                "postcode":"30250"
                            },
                            {
                                "tumbon":"สระว่านพระยา",
                                "postcode":"30250"
                            }
                            ]
                        },
                        {
                            "amphur":"เสิงสาง",
                            "listTumbon":[
                            {
                                "tumbon":"เสิงสาง",
                                "postcode":"30330"
                            },
                            {
                                "tumbon":"สระตะเคียน",
                                "postcode":"30330"
                            },
                            {
                                "tumbon":"โนนสมบูรณ์",
                                "postcode":"30330"
                            },
                            {
                                "tumbon":"กุดโบสถ์",
                                "postcode":"30330"
                            },
                            {
                                "tumbon":"สุขไพบูลย์",
                                "postcode":"30330"
                            },
                            {
                                "tumbon":"บ้านราษฎร์",
                                "postcode":"30330"
                            }
                            ]
                        },
                        {
                            "amphur":"คง",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองคง",
                                "postcode":"30260"
                            },
                            {
                                "tumbon":"คูขาด",
                                "postcode":"30260"
                            },
                            {
                                "tumbon":"เทพาลัย",
                                "postcode":"30260"
                            },
                            {
                                "tumbon":"ตาจั่น",
                                "postcode":"30260"
                            },
                            {
                                "tumbon":"บ้านปรางค์",
                                "postcode":"30260"
                            },
                            {
                                "tumbon":"หนองมะนาว",
                                "postcode":"30260"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"30260"
                            },
                            {
                                "tumbon":"โนนเต็ง",
                                "postcode":"30260"
                            },
                            {
                                "tumbon":"ดอนใหญ่",
                                "postcode":"30260"
                            },
                            {
                                "tumbon":"ขามสมบูรณ์",
                                "postcode":"30260"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านเหลื่อม",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านเหลื่อม",
                                "postcode":"30350"
                            },
                            {
                                "tumbon":"วังโพธิ์",
                                "postcode":"30350"
                            },
                            {
                                "tumbon":"โคกกระเบื้อง",
                                "postcode":"30350"
                            },
                            {
                                "tumbon":"ช่อระกา",
                                "postcode":"30350"
                            }
                            ]
                        },
                        {
                            "amphur":"จักราช",
                            "listTumbon":[
                            {
                                "tumbon":"จักราช",
                                "postcode":"30230"
                            },
                            {
                                "tumbon":"ทองหลาง",
                                "postcode":"30230"
                            },
                            {
                                "tumbon":"สีสุก",
                                "postcode":"30230"
                            },
                            {
                                "tumbon":"หนองขาม",
                                "postcode":"30230"
                            },
                            {
                                "tumbon":"หนองพลวง",
                                "postcode":"30230"
                            },
                            {
                                "tumbon":"ศรีละกอ",
                                "postcode":"30230"
                            },
                            {
                                "tumbon":"คลองเมือง",
                                "postcode":"30230"
                            },
                            {
                                "tumbon":"หินโคน",
                                "postcode":"30230"
                            }
                            ]
                        },
                        {
                            "amphur":"โชคชัย",
                            "listTumbon":[
                            {
                                "tumbon":"กระโทก",
                                "postcode":"30190"
                            },
                            {
                                "tumbon":"พลับพลา",
                                "postcode":"30190"
                            },
                            {
                                "tumbon":"ท่าอ่าง",
                                "postcode":"30190"
                            },
                            {
                                "tumbon":"ทุ่งอรุณ",
                                "postcode":"30190"
                            },
                            {
                                "tumbon":"ท่าลาดขาว",
                                "postcode":"30190"
                            },
                            {
                                "tumbon":"ท่าจะหลุง",
                                "postcode":"30190"
                            },
                            {
                                "tumbon":"ท่าเยี่ยม",
                                "postcode":"30190"
                            },
                            {
                                "tumbon":"โชคชัย",
                                "postcode":"30190"
                            },
                            {
                                "tumbon":"ละลมใหม่พัฒนา",
                                "postcode":"30190"
                            },
                            {
                                "tumbon":"ด่านเกวียน",
                                "postcode":"30190"
                            }
                            ]
                        },
                        {
                            "amphur":"ด่านขุนทด",
                            "listTumbon":[
                            {
                                "tumbon":"กุดพิมาน",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"ด่านขุนทด",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"ด่านนอก",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"ด่านใน",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"ตะเคียน",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"บ้านเก่า",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"บ้านแปรง",
                                "postcode":"36220"
                            },
                            {
                                "tumbon":"พันชนะ",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"สระจรเข้",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"หนองกราด",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"หนองบัวตะเกียด",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"หนองบัวละคร",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"หินดาด",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"ห้วยบง",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"โนนเมืองพัฒนา",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"หนองไทร",
                                "postcode":"36220"
                            }
                            ]
                        },
                        {
                            "amphur":"โนนไทย",
                            "listTumbon":[
                            {
                                "tumbon":"โนนไทย",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"ด่านจาก",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"กำปัง",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"ค้างพลู",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"บ้านวัง",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"บัลลังก์",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"สายออ",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"ถนนโพธิ์",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"มะค่า",
                                "postcode":"30220"
                            }
                            ]
                        },
                        {
                            "amphur":"โนนสูง",
                            "listTumbon":[
                            {
                                "tumbon":"โนนสูง",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"ใหม่",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"โตนด",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"บิง",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"ดอนชมพู",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"ธารปราสาท",
                                "postcode":"30420"
                            },
                            {
                                "tumbon":"หลุมข้าว",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"มะค่า",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"พลสงคราม",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"จันอัด",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"ขามเฒ่า",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"ด่านคล้า",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"ลำคอหงษ์",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"เมืองปราสาท",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"ดอนหวาย",
                                "postcode":"30160"
                            },
                            {
                                "tumbon":"ลำมูล",
                                "postcode":"30160"
                            }
                            ]
                        },
                        {
                            "amphur":"ขามสะแกแสง",
                            "listTumbon":[
                            {
                                "tumbon":"ขามสะแกแสง",
                                "postcode":"30290"
                            },
                            {
                                "tumbon":"โนนเมือง",
                                "postcode":"30290"
                            },
                            {
                                "tumbon":"เมืองนาท",
                                "postcode":"30290"
                            },
                            {
                                "tumbon":"ชีวึก",
                                "postcode":"30290"
                            },
                            {
                                "tumbon":"พะงาด",
                                "postcode":"30290"
                            },
                            {
                                "tumbon":"หนองหัวฟาน",
                                "postcode":"30290"
                            },
                            {
                                "tumbon":"เมืองเกษตร",
                                "postcode":"30290"
                            }
                            ]
                        },
                        {
                            "amphur":"บัวใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"บัวใหญ่",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"ห้วยยาง",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"เสมาใหญ่",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"ดอนตะหนิน",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"หนองบัวสะอาด",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"โนนทองหลาง",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"กุดจอก",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"ด่านช้าง",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"ขุนทอง",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"หนองแจ้งใหญ่",
                                "postcode":"30120"
                            }
                            ]
                        },
                        {
                            "amphur":"ประทาย",
                            "listTumbon":[
                            {
                                "tumbon":"ประทาย",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"กระทุ่มราย",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"วังไม้แดง",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"ตลาดไทร",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"หนองพลวง",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"หนองค่าย",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"หันห้วยทราย",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"ดอนมัน",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"นางรำ",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"โนนเพ็ด",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"ทุ่งสว่าง",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"โคกกลาง",
                                "postcode":"30180"
                            },
                            {
                                "tumbon":"เมืองโดน",
                                "postcode":"30180"
                            }
                            ]
                        },
                        {
                            "amphur":"ปักธงชัย",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองปัก",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"ตะคุ",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"โคกไทย",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"ตะขบ",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"นกออก",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"ดอน",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"ตูม",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"งิ้ว",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"สะแกราช",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"ลำนางแก้ว",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"ภูหลวง",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"ธงชัยเหนือ",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"สุขเกษม",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"เกษมทรัพย์",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"บ่อปลาทอง",
                                "postcode":"30150"
                            }
                            ]
                        },
                        {
                            "amphur":"พิมาย",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"สัมฤทธิ์",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"โบสถ์",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"กระเบื้องใหญ่",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"ท่าหลวง",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"รังกาใหญ่",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"ชีวาน",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"นิคมสร้างตนเอง",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"กระชอน",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"ดงใหญ่",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"ธารละหลอด",
                                "postcode":"30110"
                            },
                            {
                                "tumbon":"หนองระเวียง",
                                "postcode":"30110"
                            }
                            ]
                        },
                        {
                            "amphur":"ห้วยแถลง",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยแถลง",
                                "postcode":"30240"
                            },
                            {
                                "tumbon":"ทับสวาย",
                                "postcode":"30240"
                            },
                            {
                                "tumbon":"เมืองพลับพลา",
                                "postcode":"30240"
                            },
                            {
                                "tumbon":"หลุ่งตะเคียน",
                                "postcode":"30240"
                            },
                            {
                                "tumbon":"หินดาด",
                                "postcode":"30240"
                            },
                            {
                                "tumbon":"งิ้ว",
                                "postcode":"30240"
                            },
                            {
                                "tumbon":"กงรถ",
                                "postcode":"30240"
                            },
                            {
                                "tumbon":"หลุ่งประดู่",
                                "postcode":"30240"
                            },
                            {
                                "tumbon":"ตะโก",
                                "postcode":"30240"
                            },
                            {
                                "tumbon":"ห้วยแคน",
                                "postcode":"30240"
                            }
                            ]
                        },
                        {
                            "amphur":"ชุมพวง",
                            "listTumbon":[
                            {
                                "tumbon":"ชุมพวง",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"ประสุข",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"ท่าลาด",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"สาหร่าย",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"ตลาดไทร",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"โนนรัง",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"หนองหลัก",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"โนนตูม",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"โนนยอ",
                                "postcode":"30270"
                            }
                            ]
                        },
                        {
                            "amphur":"สูงเนิน",
                            "listTumbon":[
                            {
                                "tumbon":"สูงเนิน",
                                "postcode":"30170"
                            },
                            {
                                "tumbon":"เสมา",
                                "postcode":"30170"
                            },
                            {
                                "tumbon":"โคราช",
                                "postcode":"30170"
                            },
                            {
                                "tumbon":"บุ่งขี้เหล็ก",
                                "postcode":"30170"
                            },
                            {
                                "tumbon":"โนนค่า",
                                "postcode":"30170"
                            },
                            {
                                "tumbon":"โค้งยาง",
                                "postcode":"30170"
                            },
                            {
                                "tumbon":"มะเกลือเก่า",
                                "postcode":"30170"
                            },
                            {
                                "tumbon":"มะเกลือใหม่",
                                "postcode":"30170"
                            },
                            {
                                "tumbon":"นากลาง",
                                "postcode":"30380"
                            },
                            {
                                "tumbon":"หนองตะไก้",
                                "postcode":"30380"
                            },
                            {
                                "tumbon":"กุดจิก",
                                "postcode":"30380"
                            }
                            ]
                        },
                        {
                            "amphur":"ขามทะเลสอ",
                            "listTumbon":[
                            {
                                "tumbon":"ขามทะเลสอ",
                                "postcode":"30280"
                            },
                            {
                                "tumbon":"โป่งแดง",
                                "postcode":"30280"
                            },
                            {
                                "tumbon":"พันดุง",
                                "postcode":"30280"
                            },
                            {
                                "tumbon":"หนองสรวง",
                                "postcode":"30280"
                            },
                            {
                                "tumbon":"บึงอ้อ",
                                "postcode":"30280"
                            }
                            ]
                        },
                        {
                            "amphur":"สีคิ้ว",
                            "listTumbon":[
                            {
                                "tumbon":"สีคิ้ว",
                                "postcode":"30140"
                            },
                            {
                                "tumbon":"บ้านหัน",
                                "postcode":"30140"
                            },
                            {
                                "tumbon":"กฤษณา",
                                "postcode":"30140"
                            },
                            {
                                "tumbon":"ลาดบัวขาว",
                                "postcode":"30340"
                            },
                            {
                                "tumbon":"หนองหญ้าขาว",
                                "postcode":"30140"
                            },
                            {
                                "tumbon":"กุดน้อย",
                                "postcode":"30140"
                            },
                            {
                                "tumbon":"หนองน้ำใส",
                                "postcode":"30140"
                            },
                            {
                                "tumbon":"วังโรงใหญ่",
                                "postcode":"30140"
                            },
                            {
                                "tumbon":"มิตรภาพ",
                                "postcode":"30140"
                            },
                            {
                                "tumbon":"คลองไผ่",
                                "postcode":"30340"
                            },
                            {
                                "tumbon":"ดอนเมือง",
                                "postcode":"30140"
                            },
                            {
                                "tumbon":"หนองบัวน้อย",
                                "postcode":"30140"
                            }
                            ]
                        },
                        {
                            "amphur":"ปากช่อง",
                            "listTumbon":[
                            {
                                "tumbon":"ปากช่อง",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"กลางดง",
                                "postcode":"30320"
                            },
                            {
                                "tumbon":"จันทึก",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"วังกะทะ",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"หมูสี",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"หนองสาหร่าย",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"ขนงพระ",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"โป่งตาลอง",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"คลองม่วง",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"หนองน้ำแดง",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"วังไทร",
                                "postcode":"30130"
                            },
                            {
                                "tumbon":"พญาเย็น",
                                "postcode":"30320"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองบุญมาก",
                            "listTumbon":[
                            {
                                "tumbon":"หนองบุนนาก",
                                "postcode":"30410"
                            },
                            {
                                "tumbon":"สารภี",
                                "postcode":"30410"
                            },
                            {
                                "tumbon":"ไทยเจริญ",
                                "postcode":"30410"
                            },
                            {
                                "tumbon":"หนองหัวแรต",
                                "postcode":"30410"
                            },
                            {
                                "tumbon":"แหลมทอง",
                                "postcode":"30410"
                            },
                            {
                                "tumbon":"หนองตะไก้",
                                "postcode":"30410"
                            },
                            {
                                "tumbon":"ลุงเขว้า",
                                "postcode":"30410"
                            },
                            {
                                "tumbon":"หนองไม้ไผ่",
                                "postcode":"30410"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"30410"
                            }
                            ]
                        },
                        {
                            "amphur":"แก้งสนามนาง",
                            "listTumbon":[
                            {
                                "tumbon":"แก้งสนามนาง",
                                "postcode":"30440"
                            },
                            {
                                "tumbon":"โนนสำราญ",
                                "postcode":"30440"
                            },
                            {
                                "tumbon":"บึงพะไล",
                                "postcode":"30440"
                            },
                            {
                                "tumbon":"สีสุก",
                                "postcode":"30440"
                            },
                            {
                                "tumbon":"บึงสำโรง",
                                "postcode":"30440"
                            }
                            ]
                        },
                        {
                            "amphur":"โนนแดง",
                            "listTumbon":[
                            {
                                "tumbon":"โนนแดง",
                                "postcode":"30360"
                            },
                            {
                                "tumbon":"โนนตาเถร",
                                "postcode":"30360"
                            },
                            {
                                "tumbon":"สำพะเนียง",
                                "postcode":"30360"
                            },
                            {
                                "tumbon":"วังหิน",
                                "postcode":"30360"
                            },
                            {
                                "tumbon":"ดอนยาวใหญ่",
                                "postcode":"30360"
                            }
                            ]
                        },
                        {
                            "amphur":"วังน้ำเขียว",
                            "listTumbon":[
                            {
                                "tumbon":"วังน้ำเขียว",
                                "postcode":"30370"
                            },
                            {
                                "tumbon":"วังหมี",
                                "postcode":"30370"
                            },
                            {
                                "tumbon":"ระเริง",
                                "postcode":"30150"
                            },
                            {
                                "tumbon":"อุดมทรัพย์",
                                "postcode":"30370"
                            },
                            {
                                "tumbon":"ไทยสามัคคี",
                                "postcode":"30370"
                            }
                            ]
                        },
                        {
                            "amphur":"เทพารักษ์",
                            "listTumbon":[
                            {
                                "tumbon":"สำนักตะคร้อ",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"บึงปรือ",
                                "postcode":"30210"
                            },
                            {
                                "tumbon":"วังยายทอง",
                                "postcode":"30210"
                            }
                            ]
                        },
                        {
                            "amphur":"เมืองยาง",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองยาง",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"กระเบื้องนอก",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"ละหานปลาค้าว",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"โนนอุดม",
                                "postcode":"30270"
                            }
                            ]
                        },
                        {
                            "amphur":"พระทองคำ",
                            "listTumbon":[
                            {
                                "tumbon":"สระพระ",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"มาบกราด",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"พังเทียม",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"ทัพรั้ง",
                                "postcode":"30220"
                            },
                            {
                                "tumbon":"หนองหอย",
                                "postcode":"30220"
                            }
                            ]
                        },
                        {
                            "amphur":"ลำทะเมนชัย",
                            "listTumbon":[
                            {
                                "tumbon":"ขุย",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"บ้านยาง",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"ช่องแมว",
                                "postcode":"30270"
                            },
                            {
                                "tumbon":"ไพล",
                                "postcode":"30270"
                            }
                            ]
                        },
                        {
                            "amphur":"บัวลาย",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองพะไล",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"โนนจาน",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"บัวลาย",
                                "postcode":"30120"
                            },
                            {
                                "tumbon":"หนองหว้า",
                                "postcode":"30120"
                            }
                            ]
                        },
                        {
                            "amphur":"สีดา",
                            "listTumbon":[
                            {
                                "tumbon":"สีดา",
                                "postcode":"30430"
                            },
                            {
                                "tumbon":"โพนทอง",
                                "postcode":"30430"
                            },
                            {
                                "tumbon":"โนนประดู่",
                                "postcode":"30430"
                            },
                            {
                                "tumbon":"สามเมือง",
                                "postcode":"30430"
                            },
                            {
                                "tumbon":"หนองตาดใหญ่",
                                "postcode":"30430"
                            }
                            ]
                        },
                        {
                            "amphur":"เฉลิมพระเกียรติ",
                            "listTumbon":[
                            {
                                "tumbon":"ช้างทอง",
                                "postcode":"30230"
                            },
                            {
                                "tumbon":"ท่าช้าง",
                                "postcode":"30230"
                            },
                            {
                                "tumbon":"พระพุทธ",
                                "postcode":"30230"
                            },
                            {
                                "tumbon":"หนองงูเหลือม",
                                "postcode":"30000"
                            },
                            {
                                "tumbon":"หนองยาง",
                                "postcode":"30230"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ชัยภูมิ",
                    "listAmphur":[
                        {
                            "amphur":"เมืองชัยภูมิ",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"รอบเมือง",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"โพนทอง",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"นาฝาย",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"บ้านค่าย",
                                "postcode":"36240"
                            },
                            {
                                "tumbon":"กุดตุ้ม",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"ชีลอง",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"บ้านเล่า",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"นาเสียว",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"หนองนาแซง",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"ลาดใหญ่",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"36240"
                            },
                            {
                                "tumbon":"ท่าหินโงม",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"ห้วยต้อน",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"ห้วยบง",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"โนนสำราญ",
                                "postcode":"36240"
                            },
                            {
                                "tumbon":"โคกสูง",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"บุ่งคล้า",
                                "postcode":"36000"
                            },
                            {
                                "tumbon":"ซับสีทอง",
                                "postcode":"36000"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านเขว้า",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านเขว้า",
                                "postcode":"36170"
                            },
                            {
                                "tumbon":"ตลาดแร้ง",
                                "postcode":"36170"
                            },
                            {
                                "tumbon":"ลุ่มลำชี",
                                "postcode":"36170"
                            },
                            {
                                "tumbon":"ชีบน",
                                "postcode":"36170"
                            },
                            {
                                "tumbon":"ภูแลนคา",
                                "postcode":"36170"
                            },
                            {
                                "tumbon":"โนนแดง",
                                "postcode":"36170"
                            }
                            ]
                        },
                        {
                            "amphur":"คอนสวรรค์",
                            "listTumbon":[
                            {
                                "tumbon":"คอนสวรรค์",
                                "postcode":"36140"
                            },
                            {
                                "tumbon":"ยางหวาย",
                                "postcode":"36140"
                            },
                            {
                                "tumbon":"โนนสะอาด",
                                "postcode":"36140"
                            },
                            {
                                "tumbon":"ห้วยไร่",
                                "postcode":"36140"
                            },
                            {
                                "tumbon":"บ้านโสก",
                                "postcode":"36140"
                            },
                            {
                                "tumbon":"โคกมั่งงอย",
                                "postcode":"36140"
                            },
                            {
                                "tumbon":"หนองขาม",
                                "postcode":"36140"
                            },
                            {
                                "tumbon":"ศรีสำราญ",
                                "postcode":"36140"
                            },
                            {
                                "tumbon":"ช่องสามหมอ",
                                "postcode":"36140"
                            }
                            ]
                        },
                        {
                            "amphur":"เกษตรสมบูรณ์",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านยาง",
                                "postcode":"36120"
                            },
                            {
                                "tumbon":"บ้านหัน",
                                "postcode":"36120"
                            },
                            {
                                "tumbon":"บ้านเดื่อ",
                                "postcode":"36120"
                            },
                            {
                                "tumbon":"บ้านเป้า",
                                "postcode":"36120"
                            },
                            {
                                "tumbon":"กุดเลาะ",
                                "postcode":"36120"
                            },
                            {
                                "tumbon":"โนนกอก",
                                "postcode":"36120"
                            },
                            {
                                "tumbon":"สระโพนทอง",
                                "postcode":"36120"
                            },
                            {
                                "tumbon":"หนองข่า",
                                "postcode":"36120"
                            },
                            {
                                "tumbon":"หนองโพนงาม",
                                "postcode":"36120"
                            },
                            {
                                "tumbon":"บ้านบัว",
                                "postcode":"36120"
                            },
                            {
                                "tumbon":"โนนทอง",
                                "postcode":"36120"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองบัวแดง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองบัวแดง",
                                "postcode":"36210"
                            },
                            {
                                "tumbon":"กุดชุมแสง",
                                "postcode":"36210"
                            },
                            {
                                "tumbon":"ถ้ำวัวแดง",
                                "postcode":"36210"
                            },
                            {
                                "tumbon":"นางแดด",
                                "postcode":"36210"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"36210"
                            },
                            {
                                "tumbon":"คูเมือง",
                                "postcode":"36210"
                            },
                            {
                                "tumbon":"ท่าใหญ่",
                                "postcode":"36210"
                            },
                            {
                                "tumbon":"วังชมภู",
                                "postcode":"36210"
                            }
                            ]
                        },
                        {
                            "amphur":"จัตุรัส",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านกอก",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"หนองบัวบาน",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"บ้านขาม",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"กุดน้ำใส",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"หนองโดน",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"ละหาน",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"หนองบัวใหญ่",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"หนองบัวโคก",
                                "postcode":"36220"
                            },
                            {
                                "tumbon":"ส้มป่อย",
                                "postcode":"36130"
                            }
                            ]
                        },
                        {
                            "amphur":"บำเหน็จณรงค์",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านชวน",
                                "postcode":"36160"
                            },
                            {
                                "tumbon":"บ้านตาล",
                                "postcode":"36220"
                            },
                            {
                                "tumbon":"หัวทะเล",
                                "postcode":"36220"
                            },
                            {
                                "tumbon":"เกาะมะนาว",
                                "postcode":"36160"
                            },
                            {
                                "tumbon":"โคกเพชรพัฒนา",
                                "postcode":"36160"
                            },
                            {
                                "tumbon":"บ้านเพชร",
                                "postcode":"36160"
                            },
                            {
                                "tumbon":"โคกเริงรมย์",
                                "postcode":"36160"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองบัวระเหว",
                            "listTumbon":[
                            {
                                "tumbon":"หนองบัวระเหว",
                                "postcode":"36250"
                            },
                            {
                                "tumbon":"วังตะเฆ่",
                                "postcode":"36250"
                            },
                            {
                                "tumbon":"ห้วยแย้",
                                "postcode":"36250"
                            },
                            {
                                "tumbon":"โคกสะอาด",
                                "postcode":"36250"
                            },
                            {
                                "tumbon":"โสกปลาดุก",
                                "postcode":"36250"
                            }
                            ]
                        },
                        {
                            "amphur":"เทพสถิต",
                            "listTumbon":[
                            {
                                "tumbon":"วะตะแบก",
                                "postcode":"36230"
                            },
                            {
                                "tumbon":"ห้วยยายจิ๋ว",
                                "postcode":"36230"
                            },
                            {
                                "tumbon":"นายางกลัก",
                                "postcode":"36230"
                            },
                            {
                                "tumbon":"บ้านไร่",
                                "postcode":"36230"
                            },
                            {
                                "tumbon":"โป่งนก",
                                "postcode":"36230"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูเขียว",
                            "listTumbon":[
                            {
                                "tumbon":"ผักปัง",
                                "postcode":"36110"
                            },
                            {
                                "tumbon":"กวางโจน",
                                "postcode":"36110"
                            },
                            {
                                "tumbon":"หนองคอนไทย",
                                "postcode":"36110"
                            },
                            {
                                "tumbon":"บ้านแก้ง",
                                "postcode":"36110"
                            },
                            {
                                "tumbon":"กุดยม",
                                "postcode":"36110"
                            },
                            {
                                "tumbon":"บ้านเพชร",
                                "postcode":"36110"
                            },
                            {
                                "tumbon":"โคกสะอาด",
                                "postcode":"36110"
                            },
                            {
                                "tumbon":"หนองตูม",
                                "postcode":"36110"
                            },
                            {
                                "tumbon":"โอโล",
                                "postcode":"36110"
                            },
                            {
                                "tumbon":"ธาตุทอง",
                                "postcode":"36110"
                            },
                            {
                                "tumbon":"บ้านดอน",
                                "postcode":"36110"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านแท่น",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านแท่น",
                                "postcode":"36190"
                            },
                            {
                                "tumbon":"สามสวน",
                                "postcode":"36190"
                            },
                            {
                                "tumbon":"สระพัง",
                                "postcode":"36190"
                            },
                            {
                                "tumbon":"บ้านเต่า",
                                "postcode":"36190"
                            },
                            {
                                "tumbon":"หนองคู",
                                "postcode":"36190"
                            }
                            ]
                        },
                        {
                            "amphur":"แก้งคร้อ",
                            "listTumbon":[
                            {
                                "tumbon":"หนองขาม",
                                "postcode":"36150"
                            },
                            {
                                "tumbon":"ช่องสามหมอ",
                                "postcode":"36150"
                            },
                            {
                                "tumbon":"นาหนองทุ่ม",
                                "postcode":"36150"
                            },
                            {
                                "tumbon":"บ้านแก้ง",
                                "postcode":"36150"
                            },
                            {
                                "tumbon":"หนองสังข์",
                                "postcode":"36150"
                            },
                            {
                                "tumbon":"หลุบคา",
                                "postcode":"36150"
                            },
                            {
                                "tumbon":"โคกกุง",
                                "postcode":"36150"
                            },
                            {
                                "tumbon":"เก่าย่าดี",
                                "postcode":"36150"
                            },
                            {
                                "tumbon":"ท่ามะไฟหวาน",
                                "postcode":"36150"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"36150"
                            }
                            ]
                        },
                        {
                            "amphur":"คอนสาร",
                            "listTumbon":[
                            {
                                "tumbon":"คอนสาร",
                                "postcode":"36180"
                            },
                            {
                                "tumbon":"ทุ่งพระ",
                                "postcode":"36180"
                            },
                            {
                                "tumbon":"โนนคูณ",
                                "postcode":"36180"
                            },
                            {
                                "tumbon":"ห้วยยาง",
                                "postcode":"36180"
                            },
                            {
                                "tumbon":"ทุ่งลุยลาย",
                                "postcode":"36180"
                            },
                            {
                                "tumbon":"ดงบัง",
                                "postcode":"36180"
                            },
                            {
                                "tumbon":"ดงกลาง",
                                "postcode":"36180"
                            },
                            {
                                "tumbon":"ทุ่งนาเลา",
                                "postcode":"36180"
                            }
                            ]
                        },
                        {
                            "amphur":"ภักดีชุมพล",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านเจียง",
                                "postcode":"36260"
                            },
                            {
                                "tumbon":"เจาทอง",
                                "postcode":"36260"
                            },
                            {
                                "tumbon":"วังทอง",
                                "postcode":"36260"
                            },
                            {
                                "tumbon":"แหลมทอง",
                                "postcode":"36260"
                            }
                            ]
                        },
                        {
                            "amphur":"เนินสง่า",
                            "listTumbon":[
                            {
                                "tumbon":"หนองฉิม",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"ตาเนิน",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"กะฮาด",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"รังงาม",
                                "postcode":"36130"
                            }
                            ]
                        },
                        {
                            "amphur":"ซับใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"ซับใหญ่",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"ท่ากูบ",
                                "postcode":"36130"
                            },
                            {
                                "tumbon":"ตะโกทอง",
                                "postcode":"36130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"บุรีรัมย์",
                    "listAmphur":[
                        {
                            "amphur":"เมืองบุรีรัมย์",
                            "listTumbon":[
                            {
                                "tumbon":"อิสาณ",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"เสม็ด",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"บ้านบัว",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"สะแกโพรง",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"สวายจีก",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"พระครู",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"ถลุงเหล็ก",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"หนองตาด",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"ลุมปุ๊ก",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"สองห้อง",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"บัวทอง",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"ชุมเห็ด",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"หลักเขต",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"สะแกซำ",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"กลันทา",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"บ้านยาง",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"กระสัง",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"เมืองฝาง",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"31000"
                            }
                            ]
                        },
                        {
                            "amphur":"คูเมือง",
                            "listTumbon":[
                            {
                                "tumbon":"คูเมือง",
                                "postcode":"31190"
                            },
                            {
                                "tumbon":"ปะเคียบ",
                                "postcode":"31190"
                            },
                            {
                                "tumbon":"บ้านแพ",
                                "postcode":"31190"
                            },
                            {
                                "tumbon":"พรสำราญ",
                                "postcode":"31190"
                            },
                            {
                                "tumbon":"หินเหล็กไฟ",
                                "postcode":"31190"
                            },
                            {
                                "tumbon":"ตูมใหญ่",
                                "postcode":"31190"
                            },
                            {
                                "tumbon":"หนองขมาร",
                                "postcode":"31190"
                            }
                            ]
                        },
                        {
                            "amphur":"กระสัง",
                            "listTumbon":[
                            {
                                "tumbon":"ลำดวน",
                                "postcode":"31160"
                            },
                            {
                                "tumbon":"สองชั้น",
                                "postcode":"31160"
                            },
                            {
                                "tumbon":"สูงเนิน",
                                "postcode":"31160"
                            },
                            {
                                "tumbon":"หนองเต็ง",
                                "postcode":"31160"
                            },
                            {
                                "tumbon":"ชุมแสง",
                                "postcode":"31160"
                            },
                            {
                                "tumbon":"บ้านปรือ",
                                "postcode":"31160"
                            },
                            {
                                "tumbon":"ห้วยสำราญ",
                                "postcode":"31160"
                            },
                            {
                                "tumbon":"กันทรารมย์",
                                "postcode":"31160"
                            },
                            {
                                "tumbon":"ศรีภูมิ",
                                "postcode":"31160"
                            },
                            {
                                "tumbon":"เมืองไผ่",
                                "postcode":"31160"
                            },
                            {
                                "tumbon":"กระสัง",
                                "postcode":"31160"
                            }
                            ]
                        },
                        {
                            "amphur":"นางรอง",
                            "listTumbon":[
                            {
                                "tumbon":"นางรอง",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"สะเดา",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ชุมแสง",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"หนองโบสถ์",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"หนองกง",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ถนนหัก",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"หนองไทร",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ก้านเหลือง",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"บ้านสิงห์",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ลำไทรโยง",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ทรัพย์พระยา",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"หนองยายพิมพ์",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"หัวถนน",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ทุ่งแสงทอง",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"หนองโสน",
                                "postcode":"31110"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองกี่",
                            "listTumbon":[
                            {
                                "tumbon":"หนองกี่",
                                "postcode":"31210"
                            },
                            {
                                "tumbon":"เย้ยปราสาท",
                                "postcode":"31210"
                            },
                            {
                                "tumbon":"เมืองไผ่",
                                "postcode":"31210"
                            },
                            {
                                "tumbon":"ดอนอะราง",
                                "postcode":"31210"
                            },
                            {
                                "tumbon":"โคกสว่าง",
                                "postcode":"31210"
                            },
                            {
                                "tumbon":"ทุ่งกระตาดพัฒนา",
                                "postcode":"31210"
                            },
                            {
                                "tumbon":"ทุ่งกระเต็น",
                                "postcode":"31210"
                            },
                            {
                                "tumbon":"ท่าโพธิ์ชัย",
                                "postcode":"31210"
                            },
                            {
                                "tumbon":"โคกสูง",
                                "postcode":"31210"
                            },
                            {
                                "tumbon":"บุกระสัง",
                                "postcode":"31210"
                            }
                            ]
                        },
                        {
                            "amphur":"ละหานทราย",
                            "listTumbon":[
                            {
                                "tumbon":"ละหานทราย",
                                "postcode":"31170"
                            },
                            {
                                "tumbon":"ตาจง",
                                "postcode":"31170"
                            },
                            {
                                "tumbon":"สำโรงใหม่",
                                "postcode":"31170"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"31170"
                            },
                            {
                                "tumbon":"หนองตะครอง",
                                "postcode":"31170"
                            },
                            {
                                "tumbon":"โคกว่าน",
                                "postcode":"31170"
                            }
                            ]
                        },
                        {
                            "amphur":"ประโคนชัย",
                            "listTumbon":[
                            {
                                "tumbon":"ประโคนชัย",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"แสลงโทน",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"บ้านไทร",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"ละเวี้ย",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"จรเข้มาก",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"ปังกู",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"โคกย่าง",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"โคกม้า",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"ไพศาล",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"ตะโกตาพิ",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"เขาคอก",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"หนองบอน",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"โคกมะขาม",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"โคกตูม",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"ประทัดบุ",
                                "postcode":"31140"
                            },
                            {
                                "tumbon":"สี่เหลี่ยม",
                                "postcode":"31140"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านกรวด",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านกรวด",
                                "postcode":"31180"
                            },
                            {
                                "tumbon":"โนนเจริญ",
                                "postcode":"31180"
                            },
                            {
                                "tumbon":"หนองไม้งาม",
                                "postcode":"31180"
                            },
                            {
                                "tumbon":"ปราสาท",
                                "postcode":"31180"
                            },
                            {
                                "tumbon":"สายตะกู",
                                "postcode":"31180"
                            },
                            {
                                "tumbon":"หินลาด",
                                "postcode":"31180"
                            },
                            {
                                "tumbon":"บึงเจริญ",
                                "postcode":"31180"
                            },
                            {
                                "tumbon":"จันทบเพชร",
                                "postcode":"31180"
                            },
                            {
                                "tumbon":"เขาดินเหนือ",
                                "postcode":"31180"
                            }
                            ]
                        },
                        {
                            "amphur":"พุทไธสง",
                            "listTumbon":[
                            {
                                "tumbon":"พุทไธสง",
                                "postcode":"31120"
                            },
                            {
                                "tumbon":"มะเฟือง",
                                "postcode":"31120"
                            },
                            {
                                "tumbon":"บ้านจาน",
                                "postcode":"31120"
                            },
                            {
                                "tumbon":"บ้านเป้า",
                                "postcode":"31120"
                            },
                            {
                                "tumbon":"บ้านแวง",
                                "postcode":"31120"
                            },
                            {
                                "tumbon":"บ้านยาง",
                                "postcode":"31120"
                            },
                            {
                                "tumbon":"หายโศก",
                                "postcode":"31120"
                            }
                            ]
                        },
                        {
                            "amphur":"ลำปลายมาศ",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านยาง",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"ลำปลายมาศ",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"หนองคู",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"แสลงพัน",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"ทะเมนชัย",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"ตลาดโพธิ์",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"หนองกะทิง",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"โคกกลาง",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"โคกสะอาด",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"เมืองแฝก",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"ผไทรินทร์",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"โคกล่าม",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"หินโคน",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"หนองบัวโคก",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"บุโพธิ์",
                                "postcode":"31130"
                            },
                            {
                                "tumbon":"หนองโดน",
                                "postcode":"31130"
                            }
                            ]
                        },
                        {
                            "amphur":"สตึก",
                            "listTumbon":[
                            {
                                "tumbon":"สตึก",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"นิคม",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"ทุ่งวัง",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"เมืองแก",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"หนองใหญ่",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"ร่อนทอง",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"ดอนมนต์",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"ท่าม่วง",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"สะแก",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"สนามชัย",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"กระสัง",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"ชุมแสง",
                                "postcode":"31150"
                            }
                            ]
                        },
                        {
                            "amphur":"ปะคำ",
                            "listTumbon":[
                            {
                                "tumbon":"ปะคำ",
                                "postcode":"31220"
                            },
                            {
                                "tumbon":"ไทยเจริญ",
                                "postcode":"31220"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"31220"
                            },
                            {
                                "tumbon":"โคกมะม่วง",
                                "postcode":"31220"
                            },
                            {
                                "tumbon":"หูทำนบ",
                                "postcode":"31220"
                            }
                            ]
                        },
                        {
                            "amphur":"นาโพธิ์",
                            "listTumbon":[
                            {
                                "tumbon":"นาโพธิ์",
                                "postcode":"31230"
                            },
                            {
                                "tumbon":"บ้านคู",
                                "postcode":"31230"
                            },
                            {
                                "tumbon":"บ้านดู่",
                                "postcode":"31230"
                            },
                            {
                                "tumbon":"ดอนกอก",
                                "postcode":"31230"
                            },
                            {
                                "tumbon":"ศรีสว่าง",
                                "postcode":"31230"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองหงส์",
                            "listTumbon":[
                            {
                                "tumbon":"สระแก้ว",
                                "postcode":"31240"
                            },
                            {
                                "tumbon":"ห้วยหิน",
                                "postcode":"31240"
                            },
                            {
                                "tumbon":"ไทยสามัคคี",
                                "postcode":"31240"
                            },
                            {
                                "tumbon":"หนองชัยศรี",
                                "postcode":"31240"
                            },
                            {
                                "tumbon":"เสาเดียว",
                                "postcode":"31240"
                            },
                            {
                                "tumbon":"เมืองฝ้าย",
                                "postcode":"31240"
                            },
                            {
                                "tumbon":"สระทอง",
                                "postcode":"31240"
                            }
                            ]
                        },
                        {
                            "amphur":"พลับพลาชัย",
                            "listTumbon":[
                            {
                                "tumbon":"สะเดา",
                                "postcode":"31250"
                            },
                            {
                                "tumbon":"จันดุม",
                                "postcode":"31250"
                            },
                            {
                                "tumbon":"โคกขมิ้น",
                                "postcode":"31250"
                            },
                            {
                                "tumbon":"ป่าชัน",
                                "postcode":"31250"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"31250"
                            }
                            ]
                        },
                        {
                            "amphur":"ห้วยราช",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยราช",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"สามแวง",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"ตาเสา",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"บ้านตะโก",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"สนวน",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"โคกเหล็ก",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"เมืองโพธิ์",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"ห้วยราชา",
                                "postcode":"31000"
                            }
                            ]
                        },
                        {
                            "amphur":"โนนสุวรรณ",
                            "listTumbon":[
                            {
                                "tumbon":"โนนสุวรรณ",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ทุ่งจังหัน",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"โกรกแก้ว",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ดงอีจาน",
                                "postcode":"31110"
                            }
                            ]
                        },
                        {
                            "amphur":"ชำนิ",
                            "listTumbon":[
                            {
                                "tumbon":"ชำนิ",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"หนองปล่อง",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"เมืองยาง",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ช่อผกา",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ละลวด",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"โคกสนวน",
                                "postcode":"31110"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านใหม่ไชยพจน์",
                            "listTumbon":[
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"31120"
                            },
                            {
                                "tumbon":"ทองหลาง",
                                "postcode":"31120"
                            },
                            {
                                "tumbon":"แดงใหญ่",
                                "postcode":"31120"
                            },
                            {
                                "tumbon":"กู่สวนแตง",
                                "postcode":"31120"
                            },
                            {
                                "tumbon":"หนองเยือง",
                                "postcode":"31120"
                            }
                            ]
                        },
                        {
                            "amphur":"โนนดินแดง",
                            "listTumbon":[
                            {
                                "tumbon":"โนนดินแดง",
                                "postcode":"31260"
                            },
                            {
                                "tumbon":"ส้มป่อย",
                                "postcode":"31260"
                            },
                            {
                                "tumbon":"ลำนางรอง",
                                "postcode":"31260"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านด่าน",
                            "listTumbon":[
                            {
                                "tumbon":"ปราสาท",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"บ้านด่าน",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"วังเหนือ",
                                "postcode":"31000"
                            },
                            {
                                "tumbon":"โนนขวาง",
                                "postcode":"31000"
                            }
                            ]
                        },
                        {
                            "amphur":"แคนดง",
                            "listTumbon":[
                            {
                                "tumbon":"แคนดง",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"ดงพลอง",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"สระบัว",
                                "postcode":"31150"
                            },
                            {
                                "tumbon":"หัวฝาย",
                                "postcode":"31150"
                            }
                            ]
                        },
                        {
                            "amphur":"เฉลิมพระเกียรติ",
                            "listTumbon":[
                            {
                                "tumbon":"เจริญสุข",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"อีสานเขต",
                                "postcode":"31110"
                            },
                            {
                                "tumbon":"ถาวร",
                                "postcode":"31170"
                            },
                            {
                                "tumbon":"ยายแย้มวัฒนา",
                                "postcode":"31170"
                            },
                            {
                                "tumbon":"ตาเป๊ก",
                                "postcode":"31110"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สุรินทร์",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสุรินทร์",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"ตั้งใจ",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"เพี้ยราม",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"นาดี",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"ท่าสว่าง",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"สลักได",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"ตาอ็อง",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"แกใหญ่",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"นอกเมือง",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"คอโค",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"สวาย",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"เฉนียง",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"เทนมีย์",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"นาบัว",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"เมืองที",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"ราม",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"บุฤาษี",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"ตระแสง",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"แสลงพันธ์",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"กาเกาะ",
                                "postcode":"32000"
                            }
                            ]
                        },
                        {
                            "amphur":"ชุมพลบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ชุมพลบุรี",
                                "postcode":"32190"
                            },
                            {
                                "tumbon":"นาหนองไผ่",
                                "postcode":"32190"
                            },
                            {
                                "tumbon":"ไพรขลา",
                                "postcode":"32190"
                            },
                            {
                                "tumbon":"ศรีณรงค์",
                                "postcode":"32190"
                            },
                            {
                                "tumbon":"ยะวึก",
                                "postcode":"32190"
                            },
                            {
                                "tumbon":"เมืองบัว",
                                "postcode":"32190"
                            },
                            {
                                "tumbon":"สระขุด",
                                "postcode":"32190"
                            },
                            {
                                "tumbon":"กระเบื้อง",
                                "postcode":"32190"
                            },
                            {
                                "tumbon":"หนองเรือ",
                                "postcode":"32190"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าตูม",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าตูม",
                                "postcode":"32120"
                            },
                            {
                                "tumbon":"กระโพ",
                                "postcode":"32120"
                            },
                            {
                                "tumbon":"พรมเทพ",
                                "postcode":"32120"
                            },
                            {
                                "tumbon":"โพนครก",
                                "postcode":"32120"
                            },
                            {
                                "tumbon":"เมืองแก",
                                "postcode":"32120"
                            },
                            {
                                "tumbon":"บะ",
                                "postcode":"32120"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"32120"
                            },
                            {
                                "tumbon":"บัวโคก",
                                "postcode":"32120"
                            },
                            {
                                "tumbon":"หนองเมธี",
                                "postcode":"32120"
                            },
                            {
                                "tumbon":"ทุ่งกุลา",
                                "postcode":"32120"
                            }
                            ]
                        },
                        {
                            "amphur":"จอมพระ",
                            "listTumbon":[
                            {
                                "tumbon":"จอมพระ",
                                "postcode":"32180"
                            },
                            {
                                "tumbon":"เมืองลีง",
                                "postcode":"32180"
                            },
                            {
                                "tumbon":"กระหาด",
                                "postcode":"32180"
                            },
                            {
                                "tumbon":"บุแกรง",
                                "postcode":"32180"
                            },
                            {
                                "tumbon":"หนองสนิท",
                                "postcode":"32180"
                            },
                            {
                                "tumbon":"บ้านผือ",
                                "postcode":"32180"
                            },
                            {
                                "tumbon":"ลุ่มระวี",
                                "postcode":"32180"
                            },
                            {
                                "tumbon":"ชุมแสง",
                                "postcode":"32180"
                            },
                            {
                                "tumbon":"เป็นสุข",
                                "postcode":"32180"
                            }
                            ]
                        },
                        {
                            "amphur":"ปราสาท",
                            "listTumbon":[
                            {
                                "tumbon":"กังแอน",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"ทมอ",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"ไพล",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"ปรือ",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"ทุ่งมน",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"ตาเบา",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"หนองใหญ่",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"โคกยาง",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"โคกสะอาด",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"บ้านไทร",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"โชคนาสาม",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"เชื้อเพลิง",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"ปราสาททนง",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"ตานี",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"บ้านพลวง",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"กันตวจระมวล",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"สมุด",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"ประทัดบุ",
                                "postcode":"32140"
                            }
                            ]
                        },
                        {
                            "amphur":"กาบเชิง",
                            "listTumbon":[
                            {
                                "tumbon":"กาบเชิง",
                                "postcode":"32210"
                            },
                            {
                                "tumbon":"คูตัน",
                                "postcode":"32210"
                            },
                            {
                                "tumbon":"ด่าน",
                                "postcode":"32210"
                            },
                            {
                                "tumbon":"แนงมุด",
                                "postcode":"32210"
                            },
                            {
                                "tumbon":"โคกตะเคียน",
                                "postcode":"32210"
                            },
                            {
                                "tumbon":"ตะเคียน",
                                "postcode":"32210"
                            }
                            ]
                        },
                        {
                            "amphur":"รัตนบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"รัตนบุรี",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"ธาตุ",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"แก",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"ดอนแรด",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"หนองบัวทอง",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"หนองบัวบาน",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"ไผ่",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"เบิด",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"น้ำเขียว",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"กุดขาคีม",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"ยางสว่าง",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"ทับใหญ่",
                                "postcode":"32130"
                            }
                            ]
                        },
                        {
                            "amphur":"สนม",
                            "listTumbon":[
                            {
                                "tumbon":"สนม",
                                "postcode":"32160"
                            },
                            {
                                "tumbon":"โพนโก",
                                "postcode":"32160"
                            },
                            {
                                "tumbon":"หนองระฆัง",
                                "postcode":"32160"
                            },
                            {
                                "tumbon":"นานวน",
                                "postcode":"32160"
                            },
                            {
                                "tumbon":"แคน",
                                "postcode":"32160"
                            },
                            {
                                "tumbon":"หัวงัว",
                                "postcode":"32160"
                            },
                            {
                                "tumbon":"หนองอียอ",
                                "postcode":"32160"
                            }
                            ]
                        },
                        {
                            "amphur":"ศีขรภูมิ",
                            "listTumbon":[
                            {
                                "tumbon":"ระแงง",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"ตรึม",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"จารพัต",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"ยาง",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"แตล",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"คาละแมะ",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"หนองเหล็ก",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"หนองขวาว",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"ช่างปี่",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"กุดหวาย",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"ขวาวใหญ่",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"นารุ่ง",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"ตรมไพร",
                                "postcode":"32110"
                            },
                            {
                                "tumbon":"ผักไหม",
                                "postcode":"32110"
                            }
                            ]
                        },
                        {
                            "amphur":"สังขะ",
                            "listTumbon":[
                            {
                                "tumbon":"สังขะ",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"ขอนแตก",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"ดม",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"พระแก้ว",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"บ้านจารย์",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"กระเทียม",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"สะกาด",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"ตาตุม",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"ทับทัน",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"ตาคง",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"บ้านชบ",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"เทพรักษา",
                                "postcode":"32150"
                            }
                            ]
                        },
                        {
                            "amphur":"ลำดวน",
                            "listTumbon":[
                            {
                                "tumbon":"ลำดวน",
                                "postcode":"32220"
                            },
                            {
                                "tumbon":"โชคเหนือ",
                                "postcode":"32220"
                            },
                            {
                                "tumbon":"อู่โลก",
                                "postcode":"32220"
                            },
                            {
                                "tumbon":"ตรำดม",
                                "postcode":"32220"
                            },
                            {
                                "tumbon":"ตระเปียงเตีย",
                                "postcode":"32220"
                            }
                            ]
                        },
                        {
                            "amphur":"สำโรงทาบ",
                            "listTumbon":[
                            {
                                "tumbon":"สำโรงทาบ",
                                "postcode":"32170"
                            },
                            {
                                "tumbon":"หนองไผ่ล้อม",
                                "postcode":"32170"
                            },
                            {
                                "tumbon":"กระออม",
                                "postcode":"32170"
                            },
                            {
                                "tumbon":"หนองฮะ",
                                "postcode":"32170"
                            },
                            {
                                "tumbon":"ศรีสุข",
                                "postcode":"32170"
                            },
                            {
                                "tumbon":"เกาะแก้ว",
                                "postcode":"32170"
                            },
                            {
                                "tumbon":"หมื่นศรี",
                                "postcode":"32170"
                            },
                            {
                                "tumbon":"เสม็จ",
                                "postcode":"32170"
                            },
                            {
                                "tumbon":"สะโน",
                                "postcode":"32170"
                            },
                            {
                                "tumbon":"ประดู่",
                                "postcode":"32170"
                            }
                            ]
                        },
                        {
                            "amphur":"บัวเชด",
                            "listTumbon":[
                            {
                                "tumbon":"บัวเชด",
                                "postcode":"32230"
                            },
                            {
                                "tumbon":"สะเดา",
                                "postcode":"32230"
                            },
                            {
                                "tumbon":"จรัส",
                                "postcode":"32230"
                            },
                            {
                                "tumbon":"ตาวัง",
                                "postcode":"32230"
                            },
                            {
                                "tumbon":"อาโพน",
                                "postcode":"32230"
                            },
                            {
                                "tumbon":"สำเภาลูน",
                                "postcode":"32230"
                            }
                            ]
                        },
                        {
                            "amphur":"พนมดงรัก",
                            "listTumbon":[
                            {
                                "tumbon":"บักได",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"โคกกลาง",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"จีกแดก",
                                "postcode":"32140"
                            },
                            {
                                "tumbon":"ตาเมียง",
                                "postcode":"32140"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีณรงค์",
                            "listTumbon":[
                            {
                                "tumbon":"ณรงค์",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"แจนแวน",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"ตรวจ",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"32150"
                            },
                            {
                                "tumbon":"ศรีสุข",
                                "postcode":"32150"
                            }
                            ]
                        },
                        {
                            "amphur":"เขวาสินรินทร์",
                            "listTumbon":[
                            {
                                "tumbon":"เขวาสินรินทร์",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"บึง",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"ตากูก",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"ปราสาททอง",
                                "postcode":"32000"
                            },
                            {
                                "tumbon":"บ้านแร่",
                                "postcode":"32000"
                            }
                            ]
                        },
                        {
                            "amphur":"โนนนารายณ์",
                            "listTumbon":[
                            {
                                "tumbon":"หนองหลวง",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"คำผง",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"โนน",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"ระเวียง",
                                "postcode":"32130"
                            },
                            {
                                "tumbon":"หนองเทพ",
                                "postcode":"32130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"มหาสารคาม",
                    "listAmphur":[
                        {
                            "amphur":"เมืองมหาสารคาม",
                            "listTumbon":[
                            {
                                "tumbon":"ตลาด",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"เขวา",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"ท่าตูม",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"แวงน่าง",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"โคกก่อ",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"ดอนหว่าน",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"เกิ้ง",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"แก่งเลิงจาน",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"ท่าสองคอน",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"ลาดพัฒนา",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"หนองปลิง",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"ห้วยแอ่ง",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"หนองโน",
                                "postcode":"44000"
                            },
                            {
                                "tumbon":"บัวค้อ",
                                "postcode":"44000"
                            }
                            ]
                        },
                        {
                            "amphur":"แกดำ",
                            "listTumbon":[
                            {
                                "tumbon":"แกดำ",
                                "postcode":"44190"
                            },
                            {
                                "tumbon":"วังแสง",
                                "postcode":"44190"
                            },
                            {
                                "tumbon":"มิตรภาพ",
                                "postcode":"44190"
                            },
                            {
                                "tumbon":"หนองกุง",
                                "postcode":"44190"
                            },
                            {
                                "tumbon":"โนนภิบาล",
                                "postcode":"44190"
                            }
                            ]
                        },
                        {
                            "amphur":"โกสุมพิสัย",
                            "listTumbon":[
                            {
                                "tumbon":"หัวขวาง",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"ยางน้อย",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"วังยาว",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"เขวาไร่",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"แพง",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"แก้งแก",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"หนองเหล็ก",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"เหล่า",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"เขื่อน",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"หนองบอน",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"โพนงาม",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"ยางท่าแจ้ง",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"แห่ใต้",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"หนองกุงสวรรค์",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"เลิงใต้",
                                "postcode":"44140"
                            },
                            {
                                "tumbon":"ดอนกลาง",
                                "postcode":"44140"
                            }
                            ]
                        },
                        {
                            "amphur":"กันทรวิชัย",
                            "listTumbon":[
                            {
                                "tumbon":"โคกพระ",
                                "postcode":"44150"
                            },
                            {
                                "tumbon":"คันธารราษฎร์",
                                "postcode":"44150"
                            },
                            {
                                "tumbon":"มะค่า",
                                "postcode":"44150"
                            },
                            {
                                "tumbon":"ท่าขอนยาง",
                                "postcode":"44150"
                            },
                            {
                                "tumbon":"นาสีนวน",
                                "postcode":"44150"
                            },
                            {
                                "tumbon":"ขามเรียง",
                                "postcode":"44150"
                            },
                            {
                                "tumbon":"เขวาใหญ่",
                                "postcode":"44150"
                            },
                            {
                                "tumbon":"ศรีสุข",
                                "postcode":"44150"
                            },
                            {
                                "tumbon":"กุดใส้จ่อ",
                                "postcode":"44150"
                            },
                            {
                                "tumbon":"ขามเฒ่าพัฒนา",
                                "postcode":"44150"
                            }
                            ]
                        },
                        {
                            "amphur":"เชียงยืน",
                            "listTumbon":[
                            {
                                "tumbon":"เชียงยืน",
                                "postcode":"44160"
                            },
                            {
                                "tumbon":"หนองซอน",
                                "postcode":"44160"
                            },
                            {
                                "tumbon":"ดอนเงิน",
                                "postcode":"44160"
                            },
                            {
                                "tumbon":"กู่ทอง",
                                "postcode":"44160"
                            },
                            {
                                "tumbon":"นาทอง",
                                "postcode":"44160"
                            },
                            {
                                "tumbon":"เสือเฒ่า",
                                "postcode":"44160"
                            },
                            {
                                "tumbon":"โพนทอง",
                                "postcode":"44160"
                            },
                            {
                                "tumbon":"เหล่าบัวบาน",
                                "postcode":"44160"
                            }
                            ]
                        },
                        {
                            "amphur":"บรบือ",
                            "listTumbon":[
                            {
                                "tumbon":"บรบือ",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"บ่อใหญ่",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"วังไชย",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"หนองม่วง",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"กำพี้",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"โนนราษี",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"โนนแดง",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"หนองจิก",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"บัวมาศ",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"หนองคูขาด",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"วังใหม่",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"ยาง",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"หนองสิม",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"หนองโก",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"ดอนงัว",
                                "postcode":"44130"
                            }
                            ]
                        },
                        {
                            "amphur":"นาเชือก",
                            "listTumbon":[
                            {
                                "tumbon":"นาเชือก",
                                "postcode":"44170"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"44170"
                            },
                            {
                                "tumbon":"หนองแดง",
                                "postcode":"44170"
                            },
                            {
                                "tumbon":"เขวาไร่",
                                "postcode":"44170"
                            },
                            {
                                "tumbon":"หนองโพธิ์",
                                "postcode":"44170"
                            },
                            {
                                "tumbon":"ปอพาน",
                                "postcode":"44170"
                            },
                            {
                                "tumbon":"หนองเม็ก",
                                "postcode":"44170"
                            },
                            {
                                "tumbon":"หนองเรือ",
                                "postcode":"44170"
                            },
                            {
                                "tumbon":"หนองกุง",
                                "postcode":"44170"
                            },
                            {
                                "tumbon":"สันป่าตอง",
                                "postcode":"44170"
                            }
                            ]
                        },
                        {
                            "amphur":"พยัคฆภูมิพิสัย",
                            "listTumbon":[
                            {
                                "tumbon":"ปะหลาน",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"ก้ามปู",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"เวียงสะอาด",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"เม็กดำ",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"นาสีนวล",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"ราษฎร์เจริญ",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"หนองบัวแก้ว",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"เมืองเตา",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"ลานสะแก",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"เวียงชัย",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"ราษฎร์พัฒนา",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"เมืองเสือ",
                                "postcode":"44110"
                            },
                            {
                                "tumbon":"ภารแอ่น",
                                "postcode":"44110"
                            }
                            ]
                        },
                        {
                            "amphur":"วาปีปทุม",
                            "listTumbon":[
                            {
                                "tumbon":"หนองแสง",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"ขามป้อม",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"เสือโก้ก",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"ดงใหญ่",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"โพธิ์ชัย",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"หัวเรือ",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"แคน",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"งัวบา",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"นาข่า",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"บ้านหวาย",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"หนองไฮ",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"ประชาพัฒนา",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"หนองทุ่ม",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"หนองแสน",
                                "postcode":"44120"
                            },
                            {
                                "tumbon":"โคกสีทองหลาง",
                                "postcode":"44120"
                            }
                            ]
                        },
                        {
                            "amphur":"นาดูน",
                            "listTumbon":[
                            {
                                "tumbon":"นาดูน",
                                "postcode":"44180"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"44180"
                            },
                            {
                                "tumbon":"หนองคู",
                                "postcode":"44180"
                            },
                            {
                                "tumbon":"ดงบัง",
                                "postcode":"44180"
                            },
                            {
                                "tumbon":"ดงดวน",
                                "postcode":"44180"
                            },
                            {
                                "tumbon":"หัวดง",
                                "postcode":"44180"
                            },
                            {
                                "tumbon":"ดงยาง",
                                "postcode":"44180"
                            },
                            {
                                "tumbon":"กู่สันตรัตน์",
                                "postcode":"44180"
                            },
                            {
                                "tumbon":"พระธาตุ",
                                "postcode":"44180"
                            }
                            ]
                        },
                        {
                            "amphur":"ยางสีสุราช",
                            "listTumbon":[
                            {
                                "tumbon":"ยางสีสุราช",
                                "postcode":"44210"
                            },
                            {
                                "tumbon":"นาภู",
                                "postcode":"44210"
                            },
                            {
                                "tumbon":"แวงดง",
                                "postcode":"44210"
                            },
                            {
                                "tumbon":"บ้านกู่",
                                "postcode":"44210"
                            },
                            {
                                "tumbon":"ดงเมือง",
                                "postcode":"44210"
                            },
                            {
                                "tumbon":"ขามเรียน",
                                "postcode":"44210"
                            },
                            {
                                "tumbon":"หนองบัวสันตุ",
                                "postcode":"44210"
                            }
                            ]
                        },
                        {
                            "amphur":"กุดรัง",
                            "listTumbon":[
                            {
                                "tumbon":"กุดรัง",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"นาโพธิ์",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"เลิงแฝก",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"44130"
                            },
                            {
                                "tumbon":"ห้วยเตย",
                                "postcode":"44130"
                            }
                            ]
                        },
                        {
                            "amphur":"ชื่นชม",
                            "listTumbon":[
                            {
                                "tumbon":"ชื่นชม",
                                "postcode":"44160"
                            },
                            {
                                "tumbon":"กุดปลาดุก",
                                "postcode":"44160"
                            },
                            {
                                "tumbon":"เหล่าดอกไม้",
                                "postcode":"44160"
                            },
                            {
                                "tumbon":"หนองกุง",
                                "postcode":"44160"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ขอนแก่น",
                    "listAmphur":[
                        {
                            "amphur":"เมืองขอนแก่น",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"สำราญ",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"โคกสี",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"ท่าพระ",
                                "postcode":"40260"
                            },
                            {
                                "tumbon":"บ้านทุ่ม",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"เมืองเก่า",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"พระลับ",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"สาวะถี",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"บ้านหว้า",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"บ้านค้อ",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"แดงใหญ่",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"ดอนช้าง",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"ดอนหัน",
                                "postcode":"40260"
                            },
                            {
                                "tumbon":"ศิลา",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"บ้านเป็ด",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"หนองตูม",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"บึงเนียม",
                                "postcode":"40000"
                            },
                            {
                                "tumbon":"โนนท่อน",
                                "postcode":"40000"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านฝาง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"40270"
                            },
                            {
                                "tumbon":"ป่าหวายนั่ง",
                                "postcode":"40270"
                            },
                            {
                                "tumbon":"โนนฆ้อง",
                                "postcode":"40270"
                            },
                            {
                                "tumbon":"บ้านเหล่า",
                                "postcode":"40270"
                            },
                            {
                                "tumbon":"ป่ามะนาว",
                                "postcode":"40270"
                            },
                            {
                                "tumbon":"บ้านฝาง",
                                "postcode":"40270"
                            },
                            {
                                "tumbon":"โคกงาม",
                                "postcode":"40270"
                            }
                            ]
                        },
                        {
                            "amphur":"พระยืน",
                            "listTumbon":[
                            {
                                "tumbon":"พระยืน",
                                "postcode":"40320"
                            },
                            {
                                "tumbon":"พระบุ",
                                "postcode":"40320"
                            },
                            {
                                "tumbon":"บ้านโต้น",
                                "postcode":"40320"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"40320"
                            },
                            {
                                "tumbon":"ขามป้อม",
                                "postcode":"40320"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองเรือ",
                            "listTumbon":[
                            {
                                "tumbon":"หนองเรือ",
                                "postcode":"40210"
                            },
                            {
                                "tumbon":"บ้านเม็ง",
                                "postcode":"40210"
                            },
                            {
                                "tumbon":"บ้านกง",
                                "postcode":"40240"
                            },
                            {
                                "tumbon":"ยางคำ",
                                "postcode":"40240"
                            },
                            {
                                "tumbon":"จระเข้",
                                "postcode":"40240"
                            },
                            {
                                "tumbon":"โนนทอง",
                                "postcode":"40210"
                            },
                            {
                                "tumbon":"กุดกว้าง",
                                "postcode":"40210"
                            },
                            {
                                "tumbon":"โนนทัน",
                                "postcode":"40210"
                            },
                            {
                                "tumbon":"โนนสะอาด",
                                "postcode":"40210"
                            },
                            {
                                "tumbon":"บ้านผือ",
                                "postcode":"40240"
                            }
                            ]
                        },
                        {
                            "amphur":"ชุมแพ",
                            "listTumbon":[
                            {
                                "tumbon":"ชุมแพ",
                                "postcode":"40130"
                            },
                            {
                                "tumbon":"โนนหัน",
                                "postcode":"40290"
                            },
                            {
                                "tumbon":"นาหนองทุ่ม",
                                "postcode":"40290"
                            },
                            {
                                "tumbon":"โนนอุดม",
                                "postcode":"40130"
                            },
                            {
                                "tumbon":"ขัวเรียง",
                                "postcode":"40130"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"40130"
                            },
                            {
                                "tumbon":"ไชยสอ",
                                "postcode":"40130"
                            },
                            {
                                "tumbon":"วังหินลาด",
                                "postcode":"40130"
                            },
                            {
                                "tumbon":"นาเพียง",
                                "postcode":"40130"
                            },
                            {
                                "tumbon":"หนองเขียด",
                                "postcode":"40290"
                            },
                            {
                                "tumbon":"หนองเสาเล้า",
                                "postcode":"40130"
                            },
                            {
                                "tumbon":"โนนสะอาด",
                                "postcode":"40290"
                            }
                            ]
                        },
                        {
                            "amphur":"สีชมพู",
                            "listTumbon":[
                            {
                                "tumbon":"สีชมพู",
                                "postcode":"40220"
                            },
                            {
                                "tumbon":"ศรีสุข",
                                "postcode":"40220"
                            },
                            {
                                "tumbon":"นาจาน",
                                "postcode":"40220"
                            },
                            {
                                "tumbon":"วังเพิ่ม",
                                "postcode":"40220"
                            },
                            {
                                "tumbon":"ซำยาง",
                                "postcode":"40220"
                            },
                            {
                                "tumbon":"หนองแดง",
                                "postcode":"40220"
                            },
                            {
                                "tumbon":"ดงลาน",
                                "postcode":"40220"
                            },
                            {
                                "tumbon":"บริบูรณ์",
                                "postcode":"40220"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"40220"
                            },
                            {
                                "tumbon":"ภูห่าน",
                                "postcode":"40220"
                            }
                            ]
                        },
                        {
                            "amphur":"น้ำพอง",
                            "listTumbon":[
                            {
                                "tumbon":"น้ำพอง",
                                "postcode":"40140"
                            },
                            {
                                "tumbon":"วังชัย",
                                "postcode":"40140"
                            },
                            {
                                "tumbon":"หนองกุง",
                                "postcode":"40140"
                            },
                            {
                                "tumbon":"บัวใหญ่",
                                "postcode":"40140"
                            },
                            {
                                "tumbon":"สะอาด",
                                "postcode":"40310"
                            },
                            {
                                "tumbon":"ม่วงหวาน",
                                "postcode":"40310"
                            },
                            {
                                "tumbon":"บ้านขาม",
                                "postcode":"40140"
                            },
                            {
                                "tumbon":"บัวเงิน",
                                "postcode":"40140"
                            },
                            {
                                "tumbon":"ทรายมูล",
                                "postcode":"40140"
                            },
                            {
                                "tumbon":"ท่ากระเสริม",
                                "postcode":"40140"
                            },
                            {
                                "tumbon":"พังทุย",
                                "postcode":"40140"
                            },
                            {
                                "tumbon":"กุดน้ำใส",
                                "postcode":"40310"
                            }
                            ]
                        },
                        {
                            "amphur":"อุบลรัตน์",
                            "listTumbon":[
                            {
                                "tumbon":"โคกสูง",
                                "postcode":"40250"
                            },
                            {
                                "tumbon":"บ้านดง",
                                "postcode":"40250"
                            },
                            {
                                "tumbon":"เขื่อนอุบลรัตน์",
                                "postcode":"40250"
                            },
                            {
                                "tumbon":"นาคำ",
                                "postcode":"40250"
                            },
                            {
                                "tumbon":"ศรีสุขสำราญ",
                                "postcode":"40250"
                            },
                            {
                                "tumbon":"ทุ่งโป่ง",
                                "postcode":"40250"
                            }
                            ]
                        },
                        {
                            "amphur":"กระนวน",
                            "listTumbon":[
                            {
                                "tumbon":"หนองโก",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"หนองกุงใหญ่",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"ห้วยโจด",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"ห้วยยาง",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"บ้านฝาง",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"ดูนสาด",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"หนองโน",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"น้ำอ้อม",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"หัวนาคำ",
                                "postcode":"40170"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านไผ่",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านไผ่",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"เมืองเพีย",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"บ้านลาน",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"แคนเหนือ",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"ภูเหล็ก",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"ป่าปอ",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"หินตั้ง",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"หนองน้ำใส",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"หัวหนอง",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"บ้านไผ่",
                                "postcode":"40110"
                            }
                            ]
                        },
                        {
                            "amphur":"เปือยน้อย",
                            "listTumbon":[
                            {
                                "tumbon":"เปือยน้อย",
                                "postcode":"40340"
                            },
                            {
                                "tumbon":"วังม่วง",
                                "postcode":"40340"
                            },
                            {
                                "tumbon":"ขามป้อม",
                                "postcode":"40340"
                            },
                            {
                                "tumbon":"สระแก้ว",
                                "postcode":"40340"
                            }
                            ]
                        },
                        {
                            "amphur":"พล",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองพล",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"โจดหนองแก",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"เก่างิ้ว",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"หนองมะเขือ",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"หนองแวงโสกพระ",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"เพ็กใหญ่",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"โคกสง่า",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"หนองแวงนางเบ้า",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"ลอมคอม",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"โนนข่า",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"โสกนกเต็น",
                                "postcode":"40120"
                            },
                            {
                                "tumbon":"หัวทุ่ง",
                                "postcode":"40120"
                            }
                            ]
                        },
                        {
                            "amphur":"แวงใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"คอนฉิม",
                                "postcode":"40330"
                            },
                            {
                                "tumbon":"ใหม่นาเพียง",
                                "postcode":"40330"
                            },
                            {
                                "tumbon":"โนนทอง",
                                "postcode":"40330"
                            },
                            {
                                "tumbon":"แวงใหญ่",
                                "postcode":"40330"
                            },
                            {
                                "tumbon":"โนนสะอาด",
                                "postcode":"40330"
                            }
                            ]
                        },
                        {
                            "amphur":"แวงน้อย",
                            "listTumbon":[
                            {
                                "tumbon":"แวงน้อย",
                                "postcode":"40230"
                            },
                            {
                                "tumbon":"ก้านเหลือง",
                                "postcode":"40230"
                            },
                            {
                                "tumbon":"ท่านางแนว",
                                "postcode":"40230"
                            },
                            {
                                "tumbon":"ละหานนา",
                                "postcode":"40230"
                            },
                            {
                                "tumbon":"ท่าวัด",
                                "postcode":"40230"
                            },
                            {
                                "tumbon":"ทางขวาง",
                                "postcode":"40230"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองสองห้อง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองสองห้อง",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"คึมชาด",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"โนนธาตุ",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"ตะกั่วป่า",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"หนองเม็ก",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"ดอนดู่",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"ดงเค็ง",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"หันโจด",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"ดอนดั่ง",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"วังหิน",
                                "postcode":"40190"
                            },
                            {
                                "tumbon":"หนองไผ่ล้อม",
                                "postcode":"40190"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูเวียง",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านเรือ",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"หว้าทอง",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"กุดขอนแก่น",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"นาชุมแสง",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"นาหว้า",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"เขาน้อย",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"หนองกุงธนสาร",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"หนองกุงเซิน",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"สงเปือย",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"ทุ่งชมพู",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"เมืองเก่าพัฒนา",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"ดินดำ",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"ภูเวียง",
                                "postcode":"40150"
                            }
                            ]
                        },
                        {
                            "amphur":"มัญจาคีรี",
                            "listTumbon":[
                            {
                                "tumbon":"กุดเค้า",
                                "postcode":"40160"
                            },
                            {
                                "tumbon":"สวนหม่อน",
                                "postcode":"40160"
                            },
                            {
                                "tumbon":"หนองแปน",
                                "postcode":"40160"
                            },
                            {
                                "tumbon":"โพนเพ็ก",
                                "postcode":"40160"
                            },
                            {
                                "tumbon":"คำแคน",
                                "postcode":"40160"
                            },
                            {
                                "tumbon":"นาข่า",
                                "postcode":"40160"
                            },
                            {
                                "tumbon":"นางาม",
                                "postcode":"40160"
                            },
                            {
                                "tumbon":"ท่าศาลา",
                                "postcode":"40160"
                            }
                            ]
                        },
                        {
                            "amphur":"ชนบท",
                            "listTumbon":[
                            {
                                "tumbon":"ชนบท",
                                "postcode":"40180"
                            },
                            {
                                "tumbon":"กุดเพียขอม",
                                "postcode":"40180"
                            },
                            {
                                "tumbon":"วังแสง",
                                "postcode":"40180"
                            },
                            {
                                "tumbon":"ห้วยแก",
                                "postcode":"40180"
                            },
                            {
                                "tumbon":"บ้านแท่น",
                                "postcode":"40180"
                            },
                            {
                                "tumbon":"ศรีบุญเรือง",
                                "postcode":"40180"
                            },
                            {
                                "tumbon":"โนนพะยอม",
                                "postcode":"40180"
                            },
                            {
                                "tumbon":"ปอแดง",
                                "postcode":"40180"
                            }
                            ]
                        },
                        {
                            "amphur":"เขาสวนกวาง",
                            "listTumbon":[
                            {
                                "tumbon":"เขาสวนกวาง",
                                "postcode":"40280"
                            },
                            {
                                "tumbon":"ดงเมืองแอม",
                                "postcode":"40280"
                            },
                            {
                                "tumbon":"นางิ้ว",
                                "postcode":"40280"
                            },
                            {
                                "tumbon":"โนนสมบูรณ์",
                                "postcode":"40280"
                            },
                            {
                                "tumbon":"คำม่วง",
                                "postcode":"40280"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูผาม่าน",
                            "listTumbon":[
                            {
                                "tumbon":"โนนคอม",
                                "postcode":"40350"
                            },
                            {
                                "tumbon":"นาฝาย",
                                "postcode":"40350"
                            },
                            {
                                "tumbon":"ภูผาม่าน",
                                "postcode":"40350"
                            },
                            {
                                "tumbon":"วังสวาบ",
                                "postcode":"40350"
                            },
                            {
                                "tumbon":"ห้วยม่วง",
                                "postcode":"40350"
                            }
                            ]
                        },
                        {
                            "amphur":"ซำสูง",
                            "listTumbon":[
                            {
                                "tumbon":"กระนวน",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"คำแมด",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"บ้านโนน",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"คูคำ",
                                "postcode":"40170"
                            },
                            {
                                "tumbon":"ห้วยเตย",
                                "postcode":"40170"
                            }
                            ]
                        },
                        {
                            "amphur":"โคกโพธิ์ไชย",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านโคก",
                                "postcode":"40160"
                            },
                            {
                                "tumbon":"โพธิ์ไชย",
                                "postcode":"40160"
                            },
                            {
                                "tumbon":"ซับสมบูรณ์",
                                "postcode":"40160"
                            },
                            {
                                "tumbon":"นาแพง",
                                "postcode":"40160"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองนาคำ",
                            "listTumbon":[
                            {
                                "tumbon":"กุดธาตุ",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"บ้านโคก",
                                "postcode":"40150"
                            },
                            {
                                "tumbon":"ขนวน",
                                "postcode":"40150"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านแฮด",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านแฮด",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"โคกสำราญ",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"โนนสมบูรณ์",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"หนองแซง",
                                "postcode":"40110"
                            }
                            ]
                        },
                        {
                            "amphur":"โนนศิลา",
                            "listTumbon":[
                            {
                                "tumbon":"โนนศิลา",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"หนองปลาหมอ",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"บ้านหัน",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"เปือยใหญ่",
                                "postcode":"40110"
                            },
                            {
                                "tumbon":"โนนแดง",
                                "postcode":"40110"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"เลย",
                    "listAmphur":[
                        {
                            "amphur":"เมืองเลย",
                            "listTumbon":[
                            {
                                "tumbon":"เมือง",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"นาอ้อ",
                                "postcode":"42100"
                            },
                            {
                                "tumbon":"กกดู่",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"น้ำหมาน",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"เสี้ยว",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"นาอาน",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"นาโป่ง",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"นาดินดำ",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"น้ำสวย",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"ชัยพฤกษ์",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"นาแขม",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"ศรีสองรัก",
                                "postcode":"42100"
                            },
                            {
                                "tumbon":"กกทอง",
                                "postcode":"42000"
                            },
                            {
                                "tumbon":"กุดป่อง",
                                "postcode":"42000"
                            }
                            ]
                        },
                        {
                            "amphur":"นาด้วง",
                            "listTumbon":[
                            {
                                "tumbon":"นาด้วง",
                                "postcode":"42210"
                            },
                            {
                                "tumbon":"นาดอกคำ",
                                "postcode":"42210"
                            },
                            {
                                "tumbon":"ท่าสะอาด",
                                "postcode":"42210"
                            },
                            {
                                "tumbon":"ท่าสวรรค์",
                                "postcode":"42210"
                            }
                            ]
                        },
                        {
                            "amphur":"เชียงคาน",
                            "listTumbon":[
                            {
                                "tumbon":"เชียงคาน",
                                "postcode":"42110"
                            },
                            {
                                "tumbon":"ธาตุ",
                                "postcode":"42110"
                            },
                            {
                                "tumbon":"นาซ่าว",
                                "postcode":"42110"
                            },
                            {
                                "tumbon":"เขาแก้ว",
                                "postcode":"42110"
                            },
                            {
                                "tumbon":"ปากตม",
                                "postcode":"42110"
                            },
                            {
                                "tumbon":"บุฮม",
                                "postcode":"42110"
                            },
                            {
                                "tumbon":"จอมศรี",
                                "postcode":"42110"
                            },
                            {
                                "tumbon":"หาดทรายขาว",
                                "postcode":"42110"
                            }
                            ]
                        },
                        {
                            "amphur":"ปากชม",
                            "listTumbon":[
                            {
                                "tumbon":"ปากชม",
                                "postcode":"42150"
                            },
                            {
                                "tumbon":"เชียงกลม",
                                "postcode":"42150"
                            },
                            {
                                "tumbon":"หาดคัมภีร์",
                                "postcode":"42150"
                            },
                            {
                                "tumbon":"ห้วยบ่อซืน",
                                "postcode":"42150"
                            },
                            {
                                "tumbon":"ห้วยพิชัย",
                                "postcode":"42150"
                            },
                            {
                                "tumbon":"ชมเจริญ",
                                "postcode":"42150"
                            }
                            ]
                        },
                        {
                            "amphur":"ด่านซ้าย",
                            "listTumbon":[
                            {
                                "tumbon":"ด่านซ้าย",
                                "postcode":"42120"
                            },
                            {
                                "tumbon":"ปากหมัน",
                                "postcode":"42120"
                            },
                            {
                                "tumbon":"นาดี",
                                "postcode":"42120"
                            },
                            {
                                "tumbon":"โคกงาม",
                                "postcode":"42120"
                            },
                            {
                                "tumbon":"โพนสูง",
                                "postcode":"42120"
                            },
                            {
                                "tumbon":"อิปุ่ม",
                                "postcode":"42120"
                            },
                            {
                                "tumbon":"กกสะทอน",
                                "postcode":"42120"
                            },
                            {
                                "tumbon":"โป่ง",
                                "postcode":"42120"
                            },
                            {
                                "tumbon":"วังยาว",
                                "postcode":"42120"
                            },
                            {
                                "tumbon":"นาหอ",
                                "postcode":"42120"
                            }
                            ]
                        },
                        {
                            "amphur":"นาแห้ว",
                            "listTumbon":[
                            {
                                "tumbon":"นาแห้ว",
                                "postcode":"42170"
                            },
                            {
                                "tumbon":"แสงภา",
                                "postcode":"42170"
                            },
                            {
                                "tumbon":"นาพึง",
                                "postcode":"42170"
                            },
                            {
                                "tumbon":"นามาลา",
                                "postcode":"42170"
                            },
                            {
                                "tumbon":"เหล่ากอหก",
                                "postcode":"42170"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูเรือ",
                            "listTumbon":[
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"42160"
                            },
                            {
                                "tumbon":"ท่าศาลา",
                                "postcode":"42160"
                            },
                            {
                                "tumbon":"ร่องจิก",
                                "postcode":"42160"
                            },
                            {
                                "tumbon":"ปลาบ่า",
                                "postcode":"42160"
                            },
                            {
                                "tumbon":"ลาดค่าง",
                                "postcode":"42160"
                            },
                            {
                                "tumbon":"สานตม",
                                "postcode":"42160"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าลี่",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าลี่",
                                "postcode":"42140"
                            },
                            {
                                "tumbon":"หนองผือ",
                                "postcode":"42140"
                            },
                            {
                                "tumbon":"อาฮี",
                                "postcode":"42140"
                            },
                            {
                                "tumbon":"น้ำแคม",
                                "postcode":"42140"
                            },
                            {
                                "tumbon":"โคกใหญ่",
                                "postcode":"42140"
                            },
                            {
                                "tumbon":"น้ำทูน",
                                "postcode":"42140"
                            }
                            ]
                        },
                        {
                            "amphur":"วังสะพุง",
                            "listTumbon":[
                            {
                                "tumbon":"วังสะพุง",
                                "postcode":"42130"
                            },
                            {
                                "tumbon":"ทรายขาว",
                                "postcode":"42130"
                            },
                            {
                                "tumbon":"หนองหญ้าปล้อง",
                                "postcode":"42130"
                            },
                            {
                                "tumbon":"หนองงิ้ว",
                                "postcode":"42130"
                            },
                            {
                                "tumbon":"ปากปวน",
                                "postcode":"42130"
                            },
                            {
                                "tumbon":"ผาน้อย",
                                "postcode":"42130"
                            },
                            {
                                "tumbon":"ผาบิ้ง",
                                "postcode":"42130"
                            },
                            {
                                "tumbon":"เขาหลวง",
                                "postcode":"42130"
                            },
                            {
                                "tumbon":"โคกขมิ้น",
                                "postcode":"42130"
                            },
                            {
                                "tumbon":"ศรีสงคราม",
                                "postcode":"42130"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูกระดึง",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีฐาน",
                                "postcode":"42180"
                            },
                            {
                                "tumbon":"ผานกเค้า",
                                "postcode":"42180"
                            },
                            {
                                "tumbon":"ภูกระดึง",
                                "postcode":"42180"
                            },
                            {
                                "tumbon":"ห้วยส้ม",
                                "postcode":"42180"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"ภูหอ",
                                "postcode":"42230"
                            },
                            {
                                "tumbon":"หนองคัน",
                                "postcode":"42230"
                            },
                            {
                                "tumbon":"ห้วยสีเสียด",
                                "postcode":"42230"
                            },
                            {
                                "tumbon":"เลยวังไสย์",
                                "postcode":"42230"
                            },
                            {
                                "tumbon":"แก่งศรีภูมิ",
                                "postcode":"42230"
                            }
                            ]
                        },
                        {
                            "amphur":"ผาขาว",
                            "listTumbon":[
                            {
                                "tumbon":"ผาขาว",
                                "postcode":"42240"
                            },
                            {
                                "tumbon":"ท่าช้างคล้อง",
                                "postcode":"42240"
                            },
                            {
                                "tumbon":"โนนปอแดง",
                                "postcode":"42240"
                            },
                            {
                                "tumbon":"โนนป่าซาง",
                                "postcode":"42240"
                            },
                            {
                                "tumbon":"บ้านเพิ่ม",
                                "postcode":"42240"
                            }
                            ]
                        },
                        {
                            "amphur":"เอราวัณ",
                            "listTumbon":[
                            {
                                "tumbon":"เอราวัณ",
                                "postcode":"42220"
                            },
                            {
                                "tumbon":"ผาอินทร์แปลง",
                                "postcode":"42220"
                            },
                            {
                                "tumbon":"ผาสามยอด",
                                "postcode":"42220"
                            },
                            {
                                "tumbon":"ทรัพย์ไพวัลย์",
                                "postcode":"42220"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองหิน",
                            "listTumbon":[
                            {
                                "tumbon":"หนองหิน",
                                "postcode":"42190"
                            },
                            {
                                "tumbon":"ตาดข่า",
                                "postcode":"42190"
                            },
                            {
                                "tumbon":"ปวนพุ",
                                "postcode":"42190"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"หนองคาย",
                    "listAmphur":[
                        {
                            "amphur":"เมืองหนองคาย",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"โพธิ์ชัย",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"กวนวัน",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"เวียงคุก",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"วัดธาตุ",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"หาดคำ",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"หินโงม",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"บ้านเดื่อ",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"ค่ายบกหวาน",
                                "postcode":"43100"
                            },
                            {
                                "tumbon":"สองห้อง",
                                "postcode":"43100"
                            },
                            {
                                "tumbon":"พระธาตุบังพวน",
                                "postcode":"43100"
                            },
                            {
                                "tumbon":"หนองกอมเกาะ",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"ปะโค",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"เมืองหมี",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"สีกาย",
                                "postcode":"43000"
                            },
                            {
                                "tumbon":"มีชัย",
                                "postcode":"43000"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าบ่อ",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าบ่อ",
                                "postcode":"43110"
                            },
                            {
                                "tumbon":"น้ำโมง",
                                "postcode":"43110"
                            },
                            {
                                "tumbon":"กองนาง",
                                "postcode":"43110"
                            },
                            {
                                "tumbon":"โคกคอน",
                                "postcode":"43110"
                            },
                            {
                                "tumbon":"บ้านเดื่อ",
                                "postcode":"43110"
                            },
                            {
                                "tumbon":"บ้านถ่อน",
                                "postcode":"43110"
                            },
                            {
                                "tumbon":"บ้านว่าน",
                                "postcode":"43110"
                            },
                            {
                                "tumbon":"นาข่า",
                                "postcode":"43110"
                            },
                            {
                                "tumbon":"โพนสา",
                                "postcode":"43110"
                            },
                            {
                                "tumbon":"หนองนาง",
                                "postcode":"43110"
                            }
                            ]
                        },
                        {
                            "amphur":"โพนพิสัย",
                            "listTumbon":[
                            {
                                "tumbon":"จุมพล",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"วัดหลวง",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"กุดบง",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"ชุมช้าง",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"ทุ่งหลวง",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"เหล่าต่างคำ",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"นาหนัง",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"เซิม",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"บ้านโพธิ์",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"บ้านผือ",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"สร้างนางขาว",
                                "postcode":"43120"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีเชียงใหม่",
                            "listTumbon":[
                            {
                                "tumbon":"พานพร้าว",
                                "postcode":"43130"
                            },
                            {
                                "tumbon":"บ้านหม้อ",
                                "postcode":"43130"
                            },
                            {
                                "tumbon":"พระพุทธบาท",
                                "postcode":"43130"
                            },
                            {
                                "tumbon":"หนองปลาปาก",
                                "postcode":"43130"
                            }
                            ]
                        },
                        {
                            "amphur":"สังคม",
                            "listTumbon":[
                            {
                                "tumbon":"แก้งไก่",
                                "postcode":"43160"
                            },
                            {
                                "tumbon":"ผาตั้ง",
                                "postcode":"43160"
                            },
                            {
                                "tumbon":"บ้านม่วง",
                                "postcode":"43160"
                            },
                            {
                                "tumbon":"นางิ้ว",
                                "postcode":"43160"
                            },
                            {
                                "tumbon":"สังคม",
                                "postcode":"43160"
                            }
                            ]
                        },
                        {
                            "amphur":"สระใคร",
                            "listTumbon":[
                            {
                                "tumbon":"สระใคร",
                                "postcode":"43100"
                            },
                            {
                                "tumbon":"คอกช้าง",
                                "postcode":"43100"
                            },
                            {
                                "tumbon":"บ้านฝาง",
                                "postcode":"43100"
                            }
                            ]
                        },
                        {
                            "amphur":"เฝ้าไร่",
                            "listTumbon":[
                            {
                                "tumbon":"เฝ้าไร่",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"นาดี",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"หนองหลวง",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"วังหลวง",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"อุดมพร",
                                "postcode":"43120"
                            }
                            ]
                        },
                        {
                            "amphur":"รัตนวาปี",
                            "listTumbon":[
                            {
                                "tumbon":"รัตนวาปี",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"นาทับไฮ",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"บ้านต้อน",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"พระบาทนาสิงห์",
                                "postcode":"43120"
                            },
                            {
                                "tumbon":"โพนแพง",
                                "postcode":"43120"
                            }
                            ]
                        },
                        {
                            "amphur":"โพธิ์ตาก",
                            "listTumbon":[
                            {
                                "tumbon":"โพนทอง",
                                "postcode":"43130"
                            },
                            {
                                "tumbon":"โพธิ์ตาก",
                                "postcode":"43130"
                            },
                            {
                                "tumbon":"ด่านศรีสุข",
                                "postcode":"43130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"อุดรธานี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองอุดรธานี",
                            "listTumbon":[
                            {
                                "tumbon":"หมากแข้ง",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"นิคมสงเคราะห์",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"บ้านขาว",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"บ้านตาด",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"โนนสูง",
                                "postcode":"41330"
                            },
                            {
                                "tumbon":"หมูม่น",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"เชียงยืน",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"หนองนาคำ",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"กุดสระ",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"นาดี",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"บ้านเลื่อม",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"เชียงพิณ",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"สามพร้าว",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"หนองไฮ",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"นาข่า",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"บ้านจั่น",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"หนองขอนกว้าง",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"โคกสะอาด",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"นากว้าง",
                                "postcode":"41000"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"41330"
                            }
                            ]
                        },
                        {
                            "amphur":"กุดจับ",
                            "listTumbon":[
                            {
                                "tumbon":"กุดจับ",
                                "postcode":"41250"
                            },
                            {
                                "tumbon":"ปะโค",
                                "postcode":"41250"
                            },
                            {
                                "tumbon":"ขอนยูง",
                                "postcode":"41250"
                            },
                            {
                                "tumbon":"เชียงเพ็ง",
                                "postcode":"41250"
                            },
                            {
                                "tumbon":"สร้างก่อ",
                                "postcode":"41250"
                            },
                            {
                                "tumbon":"เมืองเพีย",
                                "postcode":"41250"
                            },
                            {
                                "tumbon":"ตาลเลียน",
                                "postcode":"41250"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองวัวซอ",
                            "listTumbon":[
                            {
                                "tumbon":"หมากหญ้า",
                                "postcode":"41360"
                            },
                            {
                                "tumbon":"หนองอ้อ",
                                "postcode":"41220"
                            },
                            {
                                "tumbon":"อูบมุง",
                                "postcode":"41220"
                            },
                            {
                                "tumbon":"กุดหมากไฟ",
                                "postcode":"41220"
                            },
                            {
                                "tumbon":"น้ำพ่น",
                                "postcode":"41360"
                            },
                            {
                                "tumbon":"หนองบัวบาน",
                                "postcode":"41360"
                            },
                            {
                                "tumbon":"โนนหวาย",
                                "postcode":"41220"
                            },
                            {
                                "tumbon":"หนองวัวซอ",
                                "postcode":"41360"
                            }
                            ]
                        },
                        {
                            "amphur":"กุมภวาปี",
                            "listTumbon":[
                            {
                                "tumbon":"ตูมใต้",
                                "postcode":"41110"
                            },
                            {
                                "tumbon":"พันดอน",
                                "postcode":"41370"
                            },
                            {
                                "tumbon":"เวียงคำ",
                                "postcode":"41110"
                            },
                            {
                                "tumbon":"แชแล",
                                "postcode":"41110"
                            },
                            {
                                "tumbon":"เชียงแหว",
                                "postcode":"41110"
                            },
                            {
                                "tumbon":"ห้วยเกิ้ง",
                                "postcode":"41110"
                            },
                            {
                                "tumbon":"เสอเพลอ",
                                "postcode":"41370"
                            },
                            {
                                "tumbon":"สีออ",
                                "postcode":"41110"
                            },
                            {
                                "tumbon":"ปะโค",
                                "postcode":"41370"
                            },
                            {
                                "tumbon":"ผาสุก",
                                "postcode":"41370"
                            },
                            {
                                "tumbon":"ท่าลี่",
                                "postcode":"41110"
                            },
                            {
                                "tumbon":"กุมภวาปี",
                                "postcode":"41110"
                            },
                            {
                                "tumbon":"หนองหว้า",
                                "postcode":"41110"
                            }
                            ]
                        },
                        {
                            "amphur":"โนนสะอาด",
                            "listTumbon":[
                            {
                                "tumbon":"โนนสะอาด",
                                "postcode":"41240"
                            },
                            {
                                "tumbon":"บุ่งแก้ว",
                                "postcode":"41240"
                            },
                            {
                                "tumbon":"โพธิ์ศรีสำราญ",
                                "postcode":"41240"
                            },
                            {
                                "tumbon":"ทมนางาม",
                                "postcode":"41240"
                            },
                            {
                                "tumbon":"หนองกุงศรี",
                                "postcode":"41240"
                            },
                            {
                                "tumbon":"โคกกลาง",
                                "postcode":"41240"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองหาน",
                            "listTumbon":[
                            {
                                "tumbon":"หนองหาน",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"หนองเม็ก",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"พังงู",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"สะแบง",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"สร้อยพร้าว",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"บ้านเชียง",
                                "postcode":"41320"
                            },
                            {
                                "tumbon":"บ้านยา",
                                "postcode":"41320"
                            },
                            {
                                "tumbon":"โพนงาม",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"ผักตบ",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"ดอนหายโศก",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"หนองสระปลา",
                                "postcode":"41320"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งฝน",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งฝน",
                                "postcode":"41310"
                            },
                            {
                                "tumbon":"ทุ่งใหญ่",
                                "postcode":"41310"
                            },
                            {
                                "tumbon":"นาชุมแสง",
                                "postcode":"41310"
                            },
                            {
                                "tumbon":"นาทม",
                                "postcode":"41310"
                            }
                            ]
                        },
                        {
                            "amphur":"ไชยวาน",
                            "listTumbon":[
                            {
                                "tumbon":"ไชยวาน",
                                "postcode":"41290"
                            },
                            {
                                "tumbon":"หนองหลัก",
                                "postcode":"41290"
                            },
                            {
                                "tumbon":"คำเลาะ",
                                "postcode":"41290"
                            },
                            {
                                "tumbon":"โพนสูง",
                                "postcode":"41290"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีธาตุ",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านโปร่ง",
                                "postcode":"41230"
                            },
                            {
                                "tumbon":"ศรีธาตุ",
                                "postcode":"41230"
                            },
                            {
                                "tumbon":"จำปี",
                                "postcode":"41230"
                            },
                            {
                                "tumbon":"หัวนาคำ",
                                "postcode":"41230"
                            },
                            {
                                "tumbon":"หนองนกเขียน",
                                "postcode":"41230"
                            },
                            {
                                "tumbon":"นายูง",
                                "postcode":"41230"
                            },
                            {
                                "tumbon":"ตาดทอง",
                                "postcode":"41230"
                            }
                            ]
                        },
                        {
                            "amphur":"วังสามหมอ",
                            "listTumbon":[
                            {
                                "tumbon":"หนองกุงทับม้า",
                                "postcode":"41280"
                            },
                            {
                                "tumbon":"หนองหญ้าไซ",
                                "postcode":"41280"
                            },
                            {
                                "tumbon":"บะยาว",
                                "postcode":"41280"
                            },
                            {
                                "tumbon":"ผาสุก",
                                "postcode":"41280"
                            },
                            {
                                "tumbon":"คำโคกสูง",
                                "postcode":"41280"
                            },
                            {
                                "tumbon":"วังสามหมอ",
                                "postcode":"41280"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านดุง",
                            "listTumbon":[
                            {
                                "tumbon":"โพนสูง",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"ศรีสุทโธ",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"บ้านดุง",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"ดงเย็น",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"อ้อมกอ",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"บ้านจันทร์",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"บ้านชัย",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"นาไหม",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"ถ่อนนาลับ",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"วังทอง",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"บ้านม่วง",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"บ้านตาด",
                                "postcode":"41190"
                            },
                            {
                                "tumbon":"นาคำ",
                                "postcode":"41190"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านผือ",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านผือ",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"หายโศก",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"เขือน้ำ",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"คำบง",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"โนนทอง",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"ข้าวสาร",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"จำปาโมง",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"กลางใหญ่",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"เมืองพาน",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"คำด้วง",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"หนองหัวคู",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"บ้านค้อ",
                                "postcode":"41160"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"41160"
                            }
                            ]
                        },
                        {
                            "amphur":"น้ำโสม",
                            "listTumbon":[
                            {
                                "tumbon":"นางัว",
                                "postcode":"41210"
                            },
                            {
                                "tumbon":"น้ำโสม",
                                "postcode":"41210"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"41210"
                            },
                            {
                                "tumbon":"บ้านหยวก",
                                "postcode":"41210"
                            },
                            {
                                "tumbon":"โสมเยี่ยม",
                                "postcode":"41210"
                            },
                            {
                                "tumbon":"ศรีสำราญ",
                                "postcode":"41210"
                            },
                            {
                                "tumbon":"สามัคคี",
                                "postcode":"41210"
                            }
                            ]
                        },
                        {
                            "amphur":"เพ็ญ",
                            "listTumbon":[
                            {
                                "tumbon":"เพ็ญ",
                                "postcode":"41150"
                            },
                            {
                                "tumbon":"บ้านธาตุ",
                                "postcode":"41150"
                            },
                            {
                                "tumbon":"นาพู่",
                                "postcode":"41150"
                            },
                            {
                                "tumbon":"เชียงหวาง",
                                "postcode":"41150"
                            },
                            {
                                "tumbon":"สุมเส้า",
                                "postcode":"41150"
                            },
                            {
                                "tumbon":"นาบัว",
                                "postcode":"41150"
                            },
                            {
                                "tumbon":"บ้านเหล่า",
                                "postcode":"41150"
                            },
                            {
                                "tumbon":"จอมศรี",
                                "postcode":"41150"
                            },
                            {
                                "tumbon":"เตาไห",
                                "postcode":"41150"
                            },
                            {
                                "tumbon":"โคกกลาง",
                                "postcode":"41150"
                            },
                            {
                                "tumbon":"สร้างแป้น",
                                "postcode":"41150"
                            }
                            ]
                        },
                        {
                            "amphur":"สร้างคอม",
                            "listTumbon":[
                            {
                                "tumbon":"สร้างคอม",
                                "postcode":"41260"
                            },
                            {
                                "tumbon":"เชียงดา",
                                "postcode":"41260"
                            },
                            {
                                "tumbon":"บ้านยวด",
                                "postcode":"41260"
                            },
                            {
                                "tumbon":"บ้านโคก",
                                "postcode":"41260"
                            },
                            {
                                "tumbon":"นาสะอาด",
                                "postcode":"41260"
                            },
                            {
                                "tumbon":"บ้านหินโงม",
                                "postcode":"41260"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองแสง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองแสง",
                                "postcode":"41340"
                            },
                            {
                                "tumbon":"แสงสว่าง",
                                "postcode":"41340"
                            },
                            {
                                "tumbon":"นาดี",
                                "postcode":"41340"
                            },
                            {
                                "tumbon":"ทับกุง",
                                "postcode":"41340"
                            }
                            ]
                        },
                        {
                            "amphur":"นายูง",
                            "listTumbon":[
                            {
                                "tumbon":"นายูง",
                                "postcode":"41380"
                            },
                            {
                                "tumbon":"บ้านก้อง",
                                "postcode":"41380"
                            },
                            {
                                "tumbon":"นาแค",
                                "postcode":"41380"
                            },
                            {
                                "tumbon":"โนนทอง",
                                "postcode":"41380"
                            }
                            ]
                        },
                        {
                            "amphur":"พิบูลย์รักษ์",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านแดง",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"นาทราย",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"ดอนกลอย",
                                "postcode":"41130"
                            }
                            ]
                        },
                        {
                            "amphur":"กู่แก้ว",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านจีต",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"โนนทองอินทร์",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"ค้อใหญ่",
                                "postcode":"41130"
                            },
                            {
                                "tumbon":"คอนสาย",
                                "postcode":"41130"
                            }
                            ]
                        },
                        {
                            "amphur":"ประจักษ์ศิลปาคม",
                            "listTumbon":[
                            {
                                "tumbon":"นาม่วง",
                                "postcode":"41110"
                            },
                            {
                                "tumbon":"ห้วยสามพาด",
                                "postcode":"41110"
                            },
                            {
                                "tumbon":"อุ่มจาน",
                                "postcode":"41110"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สกลนคร",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสกลนคร",
                            "listTumbon":[
                            {
                                "tumbon":"ธาตุเชิงชุม",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"ขมิ้น",
                                "postcode":"47220"
                            },
                            {
                                "tumbon":"งิ้วด่อน",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"โนนหอม",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"เชียงเครือ",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"ท่าแร่",
                                "postcode":"47230"
                            },
                            {
                                "tumbon":"ม่วงลาย",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"ดงชน",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"ห้วยยาง",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"พังขว้าง",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"ดงมะไฟ",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"ธาตุนาเวง",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"เหล่าปอแดง",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"หนองลาด",
                                "postcode":"47220"
                            },
                            {
                                "tumbon":"ฮางโฮง",
                                "postcode":"47000"
                            },
                            {
                                "tumbon":"โคกก่อง",
                                "postcode":"47000"
                            }
                            ]
                        },
                        {
                            "amphur":"กุสุมาลย์",
                            "listTumbon":[
                            {
                                "tumbon":"กุสุมาลย์",
                                "postcode":"47210"
                            },
                            {
                                "tumbon":"นาโพธิ์",
                                "postcode":"47210"
                            },
                            {
                                "tumbon":"นาเพียง",
                                "postcode":"47230"
                            },
                            {
                                "tumbon":"โพธิ์ไพศาล",
                                "postcode":"47210"
                            },
                            {
                                "tumbon":"อุ่มจาน",
                                "postcode":"47230"
                            }
                            ]
                        },
                        {
                            "amphur":"กุดบาก",
                            "listTumbon":[
                            {
                                "tumbon":"กุดบาก",
                                "postcode":"47180"
                            },
                            {
                                "tumbon":"นาม่อง",
                                "postcode":"47180"
                            },
                            {
                                "tumbon":"กุดไห",
                                "postcode":"47180"
                            }
                            ]
                        },
                        {
                            "amphur":"พรรณานิคม",
                            "listTumbon":[
                            {
                                "tumbon":"พรรณา",
                                "postcode":"47130"
                            },
                            {
                                "tumbon":"วังยาง",
                                "postcode":"47130"
                            },
                            {
                                "tumbon":"พอกน้อย",
                                "postcode":"47220"
                            },
                            {
                                "tumbon":"นาหัวบ่อ",
                                "postcode":"47220"
                            },
                            {
                                "tumbon":"ไร่",
                                "postcode":"47130"
                            },
                            {
                                "tumbon":"ช้างมิ่ง",
                                "postcode":"47130"
                            },
                            {
                                "tumbon":"นาใน",
                                "postcode":"47130"
                            },
                            {
                                "tumbon":"สว่าง",
                                "postcode":"47130"
                            },
                            {
                                "tumbon":"บะฮี",
                                "postcode":"47130"
                            },
                            {
                                "tumbon":"เชิงชุม",
                                "postcode":"47130"
                            }
                            ]
                        },
                        {
                            "amphur":"พังโคน",
                            "listTumbon":[
                            {
                                "tumbon":"พังโคน",
                                "postcode":"47160"
                            },
                            {
                                "tumbon":"ม่วงไข่",
                                "postcode":"47160"
                            },
                            {
                                "tumbon":"แร่",
                                "postcode":"47160"
                            },
                            {
                                "tumbon":"ไฮหย่อง",
                                "postcode":"47160"
                            },
                            {
                                "tumbon":"ต้นผึ้ง",
                                "postcode":"47160"
                            }
                            ]
                        },
                        {
                            "amphur":"วาริชภูมิ",
                            "listTumbon":[
                            {
                                "tumbon":"วาริชภูมิ",
                                "postcode":"47150"
                            },
                            {
                                "tumbon":"ปลาโหล",
                                "postcode":"47150"
                            },
                            {
                                "tumbon":"หนองลาด",
                                "postcode":"47150"
                            },
                            {
                                "tumbon":"คำบ่อ",
                                "postcode":"47150"
                            },
                            {
                                "tumbon":"ค้อเขียว",
                                "postcode":"47150"
                            }
                            ]
                        },
                        {
                            "amphur":"นิคมน้ำอูน",
                            "listTumbon":[
                            {
                                "tumbon":"นิคมน้ำอูน",
                                "postcode":"47270"
                            },
                            {
                                "tumbon":"หนองปลิง",
                                "postcode":"47270"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"47270"
                            },
                            {
                                "tumbon":"สุวรรณคาม",
                                "postcode":"47270"
                            }
                            ]
                        },
                        {
                            "amphur":"วานรนิวาส",
                            "listTumbon":[
                            {
                                "tumbon":"วานรนิวาส",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"เดื่อศรีคันไชย",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"ขัวก่าย",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"หนองสนม",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"คูสะคาม",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"ธาตุ",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"ศรีวิชัย",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"นาซอ",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"อินทร์แปลง",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"นาคำ",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"คอนสวรรค์",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"กุดเรือคำ",
                                "postcode":"47120"
                            },
                            {
                                "tumbon":"หนองแวงใต้",
                                "postcode":"47120"
                            }
                            ]
                        },
                        {
                            "amphur":"คำตากล้า",
                            "listTumbon":[
                            {
                                "tumbon":"คำตากล้า",
                                "postcode":"47250"
                            },
                            {
                                "tumbon":"หนองบัวสิม",
                                "postcode":"47250"
                            },
                            {
                                "tumbon":"นาแต้",
                                "postcode":"47250"
                            },
                            {
                                "tumbon":"แพด",
                                "postcode":"47250"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านม่วง",
                            "listTumbon":[
                            {
                                "tumbon":"ม่วง",
                                "postcode":"47140"
                            },
                            {
                                "tumbon":"มาย",
                                "postcode":"47140"
                            },
                            {
                                "tumbon":"ดงหม้อทอง",
                                "postcode":"47140"
                            },
                            {
                                "tumbon":"ดงเหนือ",
                                "postcode":"47140"
                            },
                            {
                                "tumbon":"ดงหม้อทองใต้",
                                "postcode":"47140"
                            },
                            {
                                "tumbon":"ห้วยหลัว",
                                "postcode":"47140"
                            },
                            {
                                "tumbon":"โนนสะอาด",
                                "postcode":"47140"
                            },
                            {
                                "tumbon":"หนองกวั่ง",
                                "postcode":"47140"
                            },
                            {
                                "tumbon":"บ่อแก้ว",
                                "postcode":"47140"
                            }
                            ]
                        },
                        {
                            "amphur":"อากาศอำนวย",
                            "listTumbon":[
                            {
                                "tumbon":"อากาศ",
                                "postcode":"47170"
                            },
                            {
                                "tumbon":"โพนแพง",
                                "postcode":"47170"
                            },
                            {
                                "tumbon":"วาใหญ่",
                                "postcode":"47170"
                            },
                            {
                                "tumbon":"โพนงาม",
                                "postcode":"47170"
                            },
                            {
                                "tumbon":"ท่าก้อน",
                                "postcode":"47170"
                            },
                            {
                                "tumbon":"นาฮี",
                                "postcode":"47170"
                            },
                            {
                                "tumbon":"บะหว้า",
                                "postcode":"47170"
                            },
                            {
                                "tumbon":"สามัคคีพัฒนา",
                                "postcode":"47170"
                            }
                            ]
                        },
                        {
                            "amphur":"สว่างแดนดิน",
                            "listTumbon":[
                            {
                                "tumbon":"สว่างแดนดิน",
                                "postcode":"47110"
                            },
                            {
                                "tumbon":"คำสะอาด",
                                "postcode":"47110"
                            },
                            {
                                "tumbon":"บ้านต้าย",
                                "postcode":"47110"
                            },
                            {
                                "tumbon":"บงเหนือ",
                                "postcode":"47110"
                            },
                            {
                                "tumbon":"โพนสูง",
                                "postcode":"47110"
                            },
                            {
                                "tumbon":"โคกสี",
                                "postcode":"47110"
                            },
                            {
                                "tumbon":"หนองหลวง",
                                "postcode":"47110"
                            },
                            {
                                "tumbon":"บงใต้",
                                "postcode":"47110"
                            },
                            {
                                "tumbon":"ค้อใต้",
                                "postcode":"47110"
                            },
                            {
                                "tumbon":"พันนา",
                                "postcode":"47240"
                            },
                            {
                                "tumbon":"แวง",
                                "postcode":"47240"
                            },
                            {
                                "tumbon":"ทรายมูล",
                                "postcode":"47110"
                            },
                            {
                                "tumbon":"ตาลโกน",
                                "postcode":"47240"
                            },
                            {
                                "tumbon":"ตาลเนิ้ง",
                                "postcode":"47240"
                            },
                            {
                                "tumbon":"ธาตุทอง",
                                "postcode":"47240"
                            },
                            {
                                "tumbon":"บ้านถ่อน",
                                "postcode":"47110"
                            }
                            ]
                        },
                        {
                            "amphur":"ส่องดาว",
                            "listTumbon":[
                            {
                                "tumbon":"ส่องดาว",
                                "postcode":"47190"
                            },
                            {
                                "tumbon":"ท่าศิลา",
                                "postcode":"47190"
                            },
                            {
                                "tumbon":"วัฒนา",
                                "postcode":"47190"
                            },
                            {
                                "tumbon":"ปทุมวาปี",
                                "postcode":"47190"
                            }
                            ]
                        },
                        {
                            "amphur":"เต่างอย",
                            "listTumbon":[
                            {
                                "tumbon":"เต่างอย",
                                "postcode":"47260"
                            },
                            {
                                "tumbon":"บึงทวาย",
                                "postcode":"47260"
                            },
                            {
                                "tumbon":"นาตาล",
                                "postcode":"47260"
                            },
                            {
                                "tumbon":"จันทร์เพ็ญ",
                                "postcode":"47260"
                            }
                            ]
                        },
                        {
                            "amphur":"โคกศรีสุพรรณ",
                            "listTumbon":[
                            {
                                "tumbon":"ตองโขบ",
                                "postcode":"47280"
                            },
                            {
                                "tumbon":"เหล่าโพนค้อ",
                                "postcode":"47280"
                            },
                            {
                                "tumbon":"ด่านม่วงคำ",
                                "postcode":"47280"
                            },
                            {
                                "tumbon":"แมดนาท่ม",
                                "postcode":"47280"
                            }
                            ]
                        },
                        {
                            "amphur":"เจริญศิลป์",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านเหล่า",
                                "postcode":"47290"
                            },
                            {
                                "tumbon":"เจริญศิลป์",
                                "postcode":"47290"
                            },
                            {
                                "tumbon":"ทุ่งแก",
                                "postcode":"47290"
                            },
                            {
                                "tumbon":"โคกศิลา",
                                "postcode":"47290"
                            },
                            {
                                "tumbon":"หนองแปน",
                                "postcode":"47290"
                            }
                            ]
                        },
                        {
                            "amphur":"โพนนาแก้ว",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านโพน",
                                "postcode":"47230"
                            },
                            {
                                "tumbon":"นาแก้ว",
                                "postcode":"47230"
                            },
                            {
                                "tumbon":"นาตงวัฒนา",
                                "postcode":"47230"
                            },
                            {
                                "tumbon":"บ้านแป้น",
                                "postcode":"47230"
                            },
                            {
                                "tumbon":"เชียงสือ",
                                "postcode":"47230"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูพาน",
                            "listTumbon":[
                            {
                                "tumbon":"สร้างค้อ",
                                "postcode":"47180"
                            },
                            {
                                "tumbon":"หลุบเลา",
                                "postcode":"47180"
                            },
                            {
                                "tumbon":"โคกภู",
                                "postcode":"47180"
                            },
                            {
                                "tumbon":"กกปลาซิว",
                                "postcode":"47180"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"หนองบัวลำภู",
                    "listAmphur":[
                        {
                            "amphur":"เมืองหนองบัวลำภู",
                            "listTumbon":[
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"หนองภัยศูนย์",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"โพธิ์ชัย",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"หนองสวรรค์",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"หัวนา",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"บ้านขาม",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"นามะเฟือง",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"บ้านพร้าว",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"โนนขมิ้น",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"ลำภู",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"กุดจิก",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"โนนทัน",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"นาคำไฮ",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"ป่าไม้งาม",
                                "postcode":"39000"
                            },
                            {
                                "tumbon":"หนองหว้า",
                                "postcode":"39000"
                            }
                            ]
                        },
                        {
                            "amphur":"นากลาง",
                            "listTumbon":[
                            {
                                "tumbon":"นากลาง",
                                "postcode":"39170"
                            },
                            {
                                "tumbon":"ด่านช้าง",
                                "postcode":"39170"
                            },
                            {
                                "tumbon":"กุดดินจี่",
                                "postcode":"39350"
                            },
                            {
                                "tumbon":"ฝั่งแดง",
                                "postcode":"39170"
                            },
                            {
                                "tumbon":"เก่ากลอย",
                                "postcode":"39350"
                            },
                            {
                                "tumbon":"โนนเมือง",
                                "postcode":"39170"
                            },
                            {
                                "tumbon":"อุทัยสวรรค์",
                                "postcode":"39170"
                            },
                            {
                                "tumbon":"ดงสวรรค์",
                                "postcode":"39350"
                            },
                            {
                                "tumbon":"กุดแห่",
                                "postcode":"39170"
                            }
                            ]
                        },
                        {
                            "amphur":"โนนสัง",
                            "listTumbon":[
                            {
                                "tumbon":"โนนสัง",
                                "postcode":"39140"
                            },
                            {
                                "tumbon":"บ้านถิ่น",
                                "postcode":"39140"
                            },
                            {
                                "tumbon":"หนองเรือ",
                                "postcode":"39140"
                            },
                            {
                                "tumbon":"กุดดู่",
                                "postcode":"39140"
                            },
                            {
                                "tumbon":"บ้านค้อ",
                                "postcode":"39140"
                            },
                            {
                                "tumbon":"โนนเมือง",
                                "postcode":"39140"
                            },
                            {
                                "tumbon":"โคกใหญ่",
                                "postcode":"39140"
                            },
                            {
                                "tumbon":"โคกม่วง",
                                "postcode":"39140"
                            },
                            {
                                "tumbon":"นิคมพัฒนา",
                                "postcode":"39140"
                            },
                            {
                                "tumbon":"ปางกู่",
                                "postcode":"39140"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีบุญเรือง",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองใหม่",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"ศรีบุญเรือง",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"หนองบัวใต้",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"กุดสะเทียน",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"นากอก",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"โนนสะอาด",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"ยางหล่อ",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"โนนม่วง",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"หนองกุงแก้ว",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"หนองแก",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"ทรายทอง",
                                "postcode":"39180"
                            },
                            {
                                "tumbon":"หันนางาม",
                                "postcode":"39180"
                            }
                            ]
                        },
                        {
                            "amphur":"สุวรรณคูหา",
                            "listTumbon":[
                            {
                                "tumbon":"นาสี",
                                "postcode":"39270"
                            },
                            {
                                "tumbon":"บ้านโคก",
                                "postcode":"39270"
                            },
                            {
                                "tumbon":"นาดี",
                                "postcode":"39270"
                            },
                            {
                                "tumbon":"นาด่าน",
                                "postcode":"39270"
                            },
                            {
                                "tumbon":"ดงมะไฟ",
                                "postcode":"39270"
                            },
                            {
                                "tumbon":"สุวรรณคูหา",
                                "postcode":"39270"
                            },
                            {
                                "tumbon":"บุญทัน",
                                "postcode":"39270"
                            },
                            {
                                "tumbon":"กุดผึ้ง",
                                "postcode":"39270"
                            }
                            ]
                        },
                        {
                            "amphur":"นาวัง",
                            "listTumbon":[
                            {
                                "tumbon":"นาเหล่า",
                                "postcode":"39170"
                            },
                            {
                                "tumbon":"นาแก",
                                "postcode":"39170"
                            },
                            {
                                "tumbon":"วังทอง",
                                "postcode":"39170"
                            },
                            {
                                "tumbon":"วังปลาป้อม",
                                "postcode":"39170"
                            },
                            {
                                "tumbon":"เทพคีรี",
                                "postcode":"39170"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"กาฬสินธุ์",
                    "listAmphur":[
                        {
                            "amphur":"เมืองกาฬสินธุ์",
                            "listTumbon":[
                            {
                                "tumbon":"กาฬสินธุ์",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"เหนือ",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"หลุบ",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"ไผ่",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"ลำปาว",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"ลำพาน",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"เชียงเครือ",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"บึงวิชัย",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"ห้วยโพธิ์",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"ภูปอ",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"ภูดิน",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"หนองกุง",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"กลางหมื่น",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"ขมิ้น",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"โพนทอง",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"นาจารย์",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"ลำคลอง",
                                "postcode":"46000"
                            }
                            ]
                        },
                        {
                            "amphur":"นามน",
                            "listTumbon":[
                            {
                                "tumbon":"นามน",
                                "postcode":"46230"
                            },
                            {
                                "tumbon":"ยอดแกง",
                                "postcode":"46230"
                            },
                            {
                                "tumbon":"สงเปลือย",
                                "postcode":"46230"
                            },
                            {
                                "tumbon":"หลักเหลี่ยม",
                                "postcode":"46230"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"46230"
                            }
                            ]
                        },
                        {
                            "amphur":"กมลาไสย",
                            "listTumbon":[
                            {
                                "tumbon":"กมลาไสย",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"หลักเมือง",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"โพนงาม",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"ดงลิง",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"ธัญญา",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"หนองแปน",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"เจ้าท่า",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"โคกสมบูรณ์",
                                "postcode":"46130"
                            }
                            ]
                        },
                        {
                            "amphur":"ร่องคำ",
                            "listTumbon":[
                            {
                                "tumbon":"ร่องคำ",
                                "postcode":"46210"
                            },
                            {
                                "tumbon":"สามัคคี",
                                "postcode":"46210"
                            },
                            {
                                "tumbon":"เหล่าอ้อย",
                                "postcode":"46210"
                            }
                            ]
                        },
                        {
                            "amphur":"กุฉินารายณ์",
                            "listTumbon":[
                            {
                                "tumbon":"บัวขาว",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"แจนแลน",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"เหล่าใหญ่",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"จุมจัง",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"เหล่าไฮงาม",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"กุดหว้า",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"สามขา",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"นาขาม",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"หนองห้าง",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"นาโก",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"สมสะอาด",
                                "postcode":"46110"
                            },
                            {
                                "tumbon":"กุดค้าว",
                                "postcode":"46110"
                            }
                            ]
                        },
                        {
                            "amphur":"เขาวง",
                            "listTumbon":[
                            {
                                "tumbon":"สงเปลือย",
                                "postcode":"46160"
                            },
                            {
                                "tumbon":"คุ้มเก่า",
                                "postcode":"46160"
                            },
                            {
                                "tumbon":"หนองผือ",
                                "postcode":"46160"
                            },
                            {
                                "tumbon":"กุดสิมคุ้มใหม่",
                                "postcode":"46160"
                            },
                            {
                                "tumbon":"สระพังทอง",
                                "postcode":"46160"
                            },
                            {
                                "tumbon":"กุดปลาค้าว",
                                "postcode":"46160"
                            }
                            ]
                        },
                        {
                            "amphur":"ยางตลาด",
                            "listTumbon":[
                            {
                                "tumbon":"ยางตลาด",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"หัวงัว",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"อุ่มเม่า",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"บัวบาน",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"เว่อ",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"อิตื้อ",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"หัวนาคำ",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"หนองอิเฒ่า",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"ดอนสมบูรณ์",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"นาเชือก",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"คลองขาม",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"เขาพระนอน",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"นาดี",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"โนนสูง",
                                "postcode":"46120"
                            },
                            {
                                "tumbon":"หนองตอกแป้น",
                                "postcode":"46120"
                            }
                            ]
                        },
                        {
                            "amphur":"ห้วยเม็ก",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยเม็ก",
                                "postcode":"46170"
                            },
                            {
                                "tumbon":"คำใหญ่",
                                "postcode":"46170"
                            },
                            {
                                "tumbon":"กุดโดน",
                                "postcode":"46170"
                            },
                            {
                                "tumbon":"บึงนาเรียง",
                                "postcode":"46170"
                            },
                            {
                                "tumbon":"หัวหิน",
                                "postcode":"46170"
                            },
                            {
                                "tumbon":"พิมูล",
                                "postcode":"46170"
                            },
                            {
                                "tumbon":"คำเหมือดแก้ว",
                                "postcode":"46170"
                            },
                            {
                                "tumbon":"โนนสะอาด",
                                "postcode":"46170"
                            },
                            {
                                "tumbon":"ทรายทอง",
                                "postcode":"46170"
                            }
                            ]
                        },
                        {
                            "amphur":"สหัสขันธ์",
                            "listTumbon":[
                            {
                                "tumbon":"ภูสิงห์",
                                "postcode":"46140"
                            },
                            {
                                "tumbon":"สหัสขันธ์",
                                "postcode":"46140"
                            },
                            {
                                "tumbon":"นามะเขือ",
                                "postcode":"46140"
                            },
                            {
                                "tumbon":"โนนศิลา",
                                "postcode":"46140"
                            },
                            {
                                "tumbon":"นิคม",
                                "postcode":"46140"
                            },
                            {
                                "tumbon":"โนนแหลมทอง",
                                "postcode":"46140"
                            },
                            {
                                "tumbon":"โนนบุรี",
                                "postcode":"46140"
                            },
                            {
                                "tumbon":"โนนน้ำเกลี้ยง",
                                "postcode":"46140"
                            }
                            ]
                        },
                        {
                            "amphur":"คำม่วง",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งคลอง",
                                "postcode":"46180"
                            },
                            {
                                "tumbon":"โพน",
                                "postcode":"46180"
                            },
                            {
                                "tumbon":"ดินจี่",
                                "postcode":"46180"
                            },
                            {
                                "tumbon":"นาบอน",
                                "postcode":"46180"
                            },
                            {
                                "tumbon":"นาทัน",
                                "postcode":"46180"
                            },
                            {
                                "tumbon":"เนินยาง",
                                "postcode":"46180"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าคันโท",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าคันโท",
                                "postcode":"46190"
                            },
                            {
                                "tumbon":"กุงเก่า",
                                "postcode":"46190"
                            },
                            {
                                "tumbon":"ยางอู้ม",
                                "postcode":"46190"
                            },
                            {
                                "tumbon":"กุดจิก",
                                "postcode":"46190"
                            },
                            {
                                "tumbon":"นาตาล",
                                "postcode":"46190"
                            },
                            {
                                "tumbon":"ดงสมบูรณ์",
                                "postcode":"46190"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองกุงศรี",
                            "listTumbon":[
                            {
                                "tumbon":"หนองกุงศรี",
                                "postcode":"46220"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"46220"
                            },
                            {
                                "tumbon":"โคกเครือ",
                                "postcode":"46220"
                            },
                            {
                                "tumbon":"หนองสรวง",
                                "postcode":"46220"
                            },
                            {
                                "tumbon":"เสาเล้า",
                                "postcode":"46220"
                            },
                            {
                                "tumbon":"หนองใหญ่",
                                "postcode":"46220"
                            },
                            {
                                "tumbon":"ดงมูล",
                                "postcode":"46220"
                            },
                            {
                                "tumbon":"ลำหนองแสน",
                                "postcode":"46220"
                            },
                            {
                                "tumbon":"หนองหิน",
                                "postcode":"46220"
                            }
                            ]
                        },
                        {
                            "amphur":"สมเด็จ",
                            "listTumbon":[
                            {
                                "tumbon":"สมเด็จ",
                                "postcode":"46150"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"46150"
                            },
                            {
                                "tumbon":"แซงบาดาล",
                                "postcode":"46150"
                            },
                            {
                                "tumbon":"มหาไชย",
                                "postcode":"46150"
                            },
                            {
                                "tumbon":"หมูม่น",
                                "postcode":"46150"
                            },
                            {
                                "tumbon":"ผาเสวย",
                                "postcode":"46150"
                            },
                            {
                                "tumbon":"ศรีสมเด็จ",
                                "postcode":"46150"
                            },
                            {
                                "tumbon":"ลำห้วยหลัว",
                                "postcode":"46150"
                            }
                            ]
                        },
                        {
                            "amphur":"ห้วยผึ้ง",
                            "listTumbon":[
                            {
                                "tumbon":"คำบง",
                                "postcode":"46240"
                            },
                            {
                                "tumbon":"ไค้นุ่น",
                                "postcode":"46240"
                            },
                            {
                                "tumbon":"นิคมห้วยผึ้ง",
                                "postcode":"46240"
                            },
                            {
                                "tumbon":"หนองอีบุตร",
                                "postcode":"46240"
                            }
                            ]
                        },
                        {
                            "amphur":"สามชัย",
                            "listTumbon":[
                            {
                                "tumbon":"สำราญ",
                                "postcode":"46180"
                            },
                            {
                                "tumbon":"สำราญใต้",
                                "postcode":"46180"
                            },
                            {
                                "tumbon":"คำสร้างเที่ยง",
                                "postcode":"46180"
                            },
                            {
                                "tumbon":"หนองช้าง",
                                "postcode":"46180"
                            }
                            ]
                        },
                        {
                            "amphur":"นาคู",
                            "listTumbon":[
                            {
                                "tumbon":"นาคู",
                                "postcode":"46160"
                            },
                            {
                                "tumbon":"สายนาวัง",
                                "postcode":"46160"
                            },
                            {
                                "tumbon":"โนนนาจาน",
                                "postcode":"46160"
                            },
                            {
                                "tumbon":"บ่อแก้ว",
                                "postcode":"46160"
                            },
                            {
                                "tumbon":"ภูแล่นช้าง",
                                "postcode":"46160"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอนจาน",
                            "listTumbon":[
                            {
                                "tumbon":"ดอนจาน",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"สะอาดไชยศรี",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"ดงพยุง",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"ม่วงนา",
                                "postcode":"46000"
                            },
                            {
                                "tumbon":"นาจำปา",
                                "postcode":"46000"
                            }
                            ]
                        },
                        {
                            "amphur":"ฆ้องชัย",
                            "listTumbon":[
                            {
                                "tumbon":"ฆ้องชัยพัฒนา",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"เหล่ากลาง",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"โคกสะอาด",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"โนนศิลาเลิง",
                                "postcode":"46130"
                            },
                            {
                                "tumbon":"ลำชี",
                                "postcode":"46130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"อุบลราชธานี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองอุบลราชธานี",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"หัวเรือ",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"หนองขอน",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"ขามใหญ่",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"แจระแม",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"หนองบ่อ",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"ไร่น้อย",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"กระโสบ",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"กุดลาด",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"ขี้เหล็ก",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"ปทุม",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"ปะอาว",
                                "postcode":"34000"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีเมืองใหม่",
                            "listTumbon":[
                            {
                                "tumbon":"นาคำ",
                                "postcode":"34250"
                            },
                            {
                                "tumbon":"แก้งกอก",
                                "postcode":"34250"
                            },
                            {
                                "tumbon":"เอือดใหญ่",
                                "postcode":"34250"
                            },
                            {
                                "tumbon":"วาริน",
                                "postcode":"34250"
                            },
                            {
                                "tumbon":"ลาดควาย",
                                "postcode":"34250"
                            },
                            {
                                "tumbon":"สงยาง",
                                "postcode":"34250"
                            },
                            {
                                "tumbon":"ตะบ่าย",
                                "postcode":"34250"
                            },
                            {
                                "tumbon":"คำไหล",
                                "postcode":"34250"
                            },
                            {
                                "tumbon":"หนามแท่ง",
                                "postcode":"34250"
                            },
                            {
                                "tumbon":"นาเลิน",
                                "postcode":"34250"
                            },
                            {
                                "tumbon":"ดอนใหญ่",
                                "postcode":"34250"
                            }
                            ]
                        },
                        {
                            "amphur":"โขงเจียม",
                            "listTumbon":[
                            {
                                "tumbon":"โขงเจียม",
                                "postcode":"34220"
                            },
                            {
                                "tumbon":"ห้วยยาง",
                                "postcode":"34220"
                            },
                            {
                                "tumbon":"นาโพธิ์กลาง",
                                "postcode":"34220"
                            },
                            {
                                "tumbon":"หนองแสงใหญ่",
                                "postcode":"34220"
                            },
                            {
                                "tumbon":"ห้วยไผ่",
                                "postcode":"34220"
                            }
                            ]
                        },
                        {
                            "amphur":"เขื่องใน",
                            "listTumbon":[
                            {
                                "tumbon":"เขื่องใน",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"สร้างถ่อ",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"ค้อทอง",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"ก่อเอ้",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"หัวดอน",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"ชีทวน",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"ท่าไห",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"นาคำใหญ่",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"แดงหม้อ",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"ธาตุน้อย",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"บ้านไทย",
                                "postcode":"34320"
                            },
                            {
                                "tumbon":"บ้านกอก",
                                "postcode":"34320"
                            },
                            {
                                "tumbon":"กลางใหญ่",
                                "postcode":"34320"
                            },
                            {
                                "tumbon":"โนนรัง",
                                "postcode":"34320"
                            },
                            {
                                "tumbon":"ยางขี้นก",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"ศรีสุข",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"สหธาตุ",
                                "postcode":"34150"
                            },
                            {
                                "tumbon":"หนองเหล่า",
                                "postcode":"34150"
                            }
                            ]
                        },
                        {
                            "amphur":"เขมราฐ",
                            "listTumbon":[
                            {
                                "tumbon":"เขมราฐ",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"ขามป้อม",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"เจียด",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"หนองผือ",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"นาแวง",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"แก้งเหนือ",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"หนองนกทา",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"หนองสิม",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"หัวนา",
                                "postcode":"34170"
                            }
                            ]
                        },
                        {
                            "amphur":"เดชอุดม",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองเดช",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"นาส่วง",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"นาเจริญ",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"ทุ่งเทิง",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"สมสะอาด",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"กุดประทาย",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"ตบหู",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"กลาง",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"แก้ง",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"ท่าโพธิ์ศรี",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"บัวงาม",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"คำครั่ง",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"นากระแซง",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"โพนงาม",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"ป่าโมง",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"โนนสมบูรณ์",
                                "postcode":"34160"
                            }
                            ]
                        },
                        {
                            "amphur":"นาจะหลวย",
                            "listTumbon":[
                            {
                                "tumbon":"นาจะหลวย",
                                "postcode":"34280"
                            },
                            {
                                "tumbon":"โนนสมบูรณ์",
                                "postcode":"34280"
                            },
                            {
                                "tumbon":"พรสวรรค์",
                                "postcode":"34280"
                            },
                            {
                                "tumbon":"บ้านตูม",
                                "postcode":"34280"
                            },
                            {
                                "tumbon":"โสกแสง",
                                "postcode":"34280"
                            },
                            {
                                "tumbon":"โนนสวรรค์",
                                "postcode":"34280"
                            }
                            ]
                        },
                        {
                            "amphur":"น้ำยืน",
                            "listTumbon":[
                            {
                                "tumbon":"โซง",
                                "postcode":"34260"
                            },
                            {
                                "tumbon":"ยาง",
                                "postcode":"34260"
                            },
                            {
                                "tumbon":"โดมประดิษฐ์",
                                "postcode":"34260"
                            },
                            {
                                "tumbon":"บุเปือย",
                                "postcode":"34260"
                            },
                            {
                                "tumbon":"สีวิเชียร",
                                "postcode":"34260"
                            },
                            {
                                "tumbon":"ยางใหญ่",
                                "postcode":"34260"
                            },
                            {
                                "tumbon":"เก่าขาม",
                                "postcode":"34260"
                            }
                            ]
                        },
                        {
                            "amphur":"บุณฑริก",
                            "listTumbon":[
                            {
                                "tumbon":"โพนงาม",
                                "postcode":"34230"
                            },
                            {
                                "tumbon":"ห้วยข่า",
                                "postcode":"34230"
                            },
                            {
                                "tumbon":"คอแลน",
                                "postcode":"34230"
                            },
                            {
                                "tumbon":"นาโพธิ์",
                                "postcode":"34230"
                            },
                            {
                                "tumbon":"หนองสะโน",
                                "postcode":"34230"
                            },
                            {
                                "tumbon":"โนนค้อ",
                                "postcode":"34230"
                            },
                            {
                                "tumbon":"บัวงาม",
                                "postcode":"34230"
                            },
                            {
                                "tumbon":"บ้านแมด",
                                "postcode":"34230"
                            }
                            ]
                        },
                        {
                            "amphur":"ตระการพืชผล",
                            "listTumbon":[
                            {
                                "tumbon":"ขุหลุ",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"กระเดียน",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"เกษม",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"กุศกร",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"ขามเปี้ย",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"คอนสาย",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"โคกจาน",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"นาพิน",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"นาสะไม",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"โนนกุง",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"ตระการ",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"ตากแดด",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"ไหล่ทุ่ง",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"เป้า",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"เซเป็ด",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"สะพือ",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"หนองเต่า",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"ถ้ำแข้",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"ท่าหลวง",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"ห้วยฝ้ายพัฒนา",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"กุดยาลวน",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"บ้านแดง",
                                "postcode":"34130"
                            },
                            {
                                "tumbon":"คำเจริญ",
                                "postcode":"34130"
                            }
                            ]
                        },
                        {
                            "amphur":"กุดข้าวปุ้น",
                            "listTumbon":[
                            {
                                "tumbon":"ข้าวปุ้น",
                                "postcode":"34270"
                            },
                            {
                                "tumbon":"โนนสวาง",
                                "postcode":"34270"
                            },
                            {
                                "tumbon":"แก่งเค็ง",
                                "postcode":"34270"
                            },
                            {
                                "tumbon":"กาบิน",
                                "postcode":"34270"
                            },
                            {
                                "tumbon":"หนองทันน้ำ",
                                "postcode":"34270"
                            }
                            ]
                        },
                        {
                            "amphur":"ม่วงสามสิบ",
                            "listTumbon":[
                            {
                                "tumbon":"ม่วงสามสิบ",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"เหล่าบก",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"ดุมใหญ่",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"หนองช้างใหญ่",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"หนองเมือง",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"เตย",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"ยางสักกระโพหลุ่ม",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"หนองไข่นก",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"หนองเหล่า",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"หนองฮาง",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"ยางโยภาพ",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"ไผ่ใหญ่",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"นาเลิง",
                                "postcode":"34140"
                            },
                            {
                                "tumbon":"โพนแพง",
                                "postcode":"34140"
                            }
                            ]
                        },
                        {
                            "amphur":"วารินชำราบ",
                            "listTumbon":[
                            {
                                "tumbon":"ธาตุ",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"ท่าลาด",
                                "postcode":"34310"
                            },
                            {
                                "tumbon":"โนนโหนน",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"คูเมือง",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"สระสมิง",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"คำน้ำแซบ",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"บุ่งหวาย",
                                "postcode":"34310"
                            },
                            {
                                "tumbon":"คำขวาง",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"โพธิ์ใหญ่",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"แสนสุข",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"หนองกินเพล",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"โนนผึ้ง",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"เมืองศรีไค",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"ห้วยขะยูง",
                                "postcode":"34310"
                            },
                            {
                                "tumbon":"บุ่งไหม",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"วารินชำราบ",
                                "postcode":"34190"
                            }
                            ]
                        },
                        {
                            "amphur":"พิบูลมังสาหาร",
                            "listTumbon":[
                            {
                                "tumbon":"กุดชมภู",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"ดอนจิก",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"ทรายมูล",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"นาโพธิ์",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"โนนกลาง",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"โพธิ์ไทร",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"โพธิ์ศรี",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"ระเว",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"ไร่ใต้",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"หนองบัวฮี",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"อ่างศิลา",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"โนนกาหลง",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"บ้านแขม",
                                "postcode":"34110"
                            },
                            {
                                "tumbon":"พิบูล",
                                "postcode":"34110"
                            }
                            ]
                        },
                        {
                            "amphur":"ตาลสุม",
                            "listTumbon":[
                            {
                                "tumbon":"ตาลสุม",
                                "postcode":"34330"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"34330"
                            },
                            {
                                "tumbon":"จิกเทิง",
                                "postcode":"34330"
                            },
                            {
                                "tumbon":"หนองกุง",
                                "postcode":"34330"
                            },
                            {
                                "tumbon":"นาคาย",
                                "postcode":"34330"
                            },
                            {
                                "tumbon":"คำหว้า",
                                "postcode":"34330"
                            }
                            ]
                        },
                        {
                            "amphur":"โพธิ์ไทร",
                            "listTumbon":[
                            {
                                "tumbon":"โพธิ์ไทร",
                                "postcode":"34340"
                            },
                            {
                                "tumbon":"ม่วงใหญ่",
                                "postcode":"34340"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"34340"
                            },
                            {
                                "tumbon":"สองคอน",
                                "postcode":"34340"
                            },
                            {
                                "tumbon":"สารภี",
                                "postcode":"34340"
                            },
                            {
                                "tumbon":"เหล่างาม",
                                "postcode":"34340"
                            }
                            ]
                        },
                        {
                            "amphur":"สำโรง",
                            "listTumbon":[
                            {
                                "tumbon":"โคกก่อง",
                                "postcode":"34360"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"34360"
                            },
                            {
                                "tumbon":"หนองไฮ",
                                "postcode":"34360"
                            },
                            {
                                "tumbon":"ค้อน้อย",
                                "postcode":"34360"
                            },
                            {
                                "tumbon":"โนนกาเล็น",
                                "postcode":"34360"
                            },
                            {
                                "tumbon":"โคกสว่าง",
                                "postcode":"34360"
                            },
                            {
                                "tumbon":"โนนกลาง",
                                "postcode":"34360"
                            },
                            {
                                "tumbon":"บอน",
                                "postcode":"34360"
                            },
                            {
                                "tumbon":"ขามป้อม",
                                "postcode":"34360"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอนมดแดง",
                            "listTumbon":[
                            {
                                "tumbon":"ดอนมดแดง",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"เหล่าแดง",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"ท่าเมือง",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"คำไฮใหญ่",
                                "postcode":"34000"
                            }
                            ]
                        },
                        {
                            "amphur":"สิรินธร",
                            "listTumbon":[
                            {
                                "tumbon":"คันไร่",
                                "postcode":"34350"
                            },
                            {
                                "tumbon":"ช่องเม็ก",
                                "postcode":"34350"
                            },
                            {
                                "tumbon":"โนนก่อ",
                                "postcode":"34350"
                            },
                            {
                                "tumbon":"นิคมสร้างตนเองลำโดมน้อย",
                                "postcode":"34350"
                            },
                            {
                                "tumbon":"ฝางคำ",
                                "postcode":"34350"
                            },
                            {
                                "tumbon":"คำเขื่อนแก้ว",
                                "postcode":"34350"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งศรีอุดม",
                            "listTumbon":[
                            {
                                "tumbon":"หนองอ้ม",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"นาเกษม",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"กุดเรือ",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"โคกชำแระ",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"นาห่อม",
                                "postcode":"34160"
                            }
                            ]
                        },
                        {
                            "amphur":"นาเยีย",
                            "listTumbon":[
                            {
                                "tumbon":"นาเยีย",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"นาดี",
                                "postcode":"34160"
                            },
                            {
                                "tumbon":"นาเรือง",
                                "postcode":"34160"
                            }
                            ]
                        },
                        {
                            "amphur":"นาตาล",
                            "listTumbon":[
                            {
                                "tumbon":"นาตาล",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"พะลาน",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"กองโพน",
                                "postcode":"34170"
                            },
                            {
                                "tumbon":"พังเคน",
                                "postcode":"34170"
                            }
                            ]
                        },
                        {
                            "amphur":"เหล่าเสือโก้ก",
                            "listTumbon":[
                            {
                                "tumbon":"เหล่าเสือโก้ก",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"โพนเมือง",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"แพงใหญ่",
                                "postcode":"34000"
                            },
                            {
                                "tumbon":"หนองบก",
                                "postcode":"34000"
                            }
                            ]
                        },
                        {
                            "amphur":"สว่างวีระวงศ์",
                            "listTumbon":[
                            {
                                "tumbon":"แก่งโดม",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"ท่าช้าง",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"บุ่งมะแลง",
                                "postcode":"34190"
                            },
                            {
                                "tumbon":"สว่าง",
                                "postcode":"34190"
                            }
                            ]
                        },
                        {
                            "amphur":"น้ำขุ่น",
                            "listTumbon":[
                            {
                                "tumbon":"ตาเกา",
                                "postcode":"34260"
                            },
                            {
                                "tumbon":"ไพบูลย์",
                                "postcode":"34260"
                            },
                            {
                                "tumbon":"ขี้เหล็ก",
                                "postcode":"34260"
                            },
                            {
                                "tumbon":"โคกสะอาด",
                                "postcode":"34260"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ยโสธร",
                    "listAmphur":[
                        {
                            "amphur":"เมืองยโสธร",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"น้ำคำใหญ่",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"ตาดทอง",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"สำราญ",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"ค้อเหนือ",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"ดู่ทุ่ง",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"เดิด",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"ขั้นไดใหญ่",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"ทุ่งแต้",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"สิงห์",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"นาสะไมย์",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"เขื่องคำ",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"หนองหิน",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"หนองคู",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"ขุมเงิน",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"ทุ่งนางโอก",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"หนองเรือ",
                                "postcode":"35000"
                            },
                            {
                                "tumbon":"หนองเป็ด",
                                "postcode":"35000"
                            }
                            ]
                        },
                        {
                            "amphur":"ทรายมูล",
                            "listTumbon":[
                            {
                                "tumbon":"ทรายมูล",
                                "postcode":"35170"
                            },
                            {
                                "tumbon":"ดู่ลาด",
                                "postcode":"35170"
                            },
                            {
                                "tumbon":"ดงมะไฟ",
                                "postcode":"35170"
                            },
                            {
                                "tumbon":"นาเวียง",
                                "postcode":"35170"
                            },
                            {
                                "tumbon":"ไผ่",
                                "postcode":"35170"
                            }
                            ]
                        },
                        {
                            "amphur":"กุดชุม",
                            "listTumbon":[
                            {
                                "tumbon":"กุดชุม",
                                "postcode":"35140"
                            },
                            {
                                "tumbon":"โนนเปือย",
                                "postcode":"35140"
                            },
                            {
                                "tumbon":"กำแมด",
                                "postcode":"35140"
                            },
                            {
                                "tumbon":"นาโส่",
                                "postcode":"35140"
                            },
                            {
                                "tumbon":"ห้วยแก้ง",
                                "postcode":"35140"
                            },
                            {
                                "tumbon":"หนองหมี",
                                "postcode":"35140"
                            },
                            {
                                "tumbon":"โพนงาม",
                                "postcode":"35140"
                            },
                            {
                                "tumbon":"คำน้ำสร้าง",
                                "postcode":"35140"
                            },
                            {
                                "tumbon":"หนองแหน",
                                "postcode":"35140"
                            }
                            ]
                        },
                        {
                            "amphur":"คำเขื่อนแก้ว",
                            "listTumbon":[
                            {
                                "tumbon":"ลุมพุก",
                                "postcode":"35110"
                            },
                            {
                                "tumbon":"ย่อ",
                                "postcode":"35110"
                            },
                            {
                                "tumbon":"สงเปือย",
                                "postcode":"35110"
                            },
                            {
                                "tumbon":"โพนทัน",
                                "postcode":"35110"
                            },
                            {
                                "tumbon":"ทุ่งมน",
                                "postcode":"35110"
                            },
                            {
                                "tumbon":"นาคำ",
                                "postcode":"35180"
                            },
                            {
                                "tumbon":"ดงแคนใหญ่",
                                "postcode":"35180"
                            },
                            {
                                "tumbon":"กู่จาน",
                                "postcode":"35110"
                            },
                            {
                                "tumbon":"นาแก",
                                "postcode":"35180"
                            },
                            {
                                "tumbon":"กุดกุง",
                                "postcode":"35110"
                            },
                            {
                                "tumbon":"เหล่าไฮ",
                                "postcode":"35110"
                            },
                            {
                                "tumbon":"แคนน้อย",
                                "postcode":"35180"
                            },
                            {
                                "tumbon":"ดงเจริญ",
                                "postcode":"35110"
                            }
                            ]
                        },
                        {
                            "amphur":"ป่าติ้ว",
                            "listTumbon":[
                            {
                                "tumbon":"โพธิ์ไทร",
                                "postcode":"35150"
                            },
                            {
                                "tumbon":"กระจาย",
                                "postcode":"35150"
                            },
                            {
                                "tumbon":"โคกนาโก",
                                "postcode":"35150"
                            },
                            {
                                "tumbon":"เชียงเพ็ง",
                                "postcode":"35150"
                            },
                            {
                                "tumbon":"ศรีฐาน",
                                "postcode":"35150"
                            }
                            ]
                        },
                        {
                            "amphur":"มหาชนะชัย",
                            "listTumbon":[
                            {
                                "tumbon":"ฟ้าหยาด",
                                "postcode":"35130"
                            },
                            {
                                "tumbon":"หัวเมือง",
                                "postcode":"35130"
                            },
                            {
                                "tumbon":"คูเมือง",
                                "postcode":"35130"
                            },
                            {
                                "tumbon":"ผือฮี",
                                "postcode":"35130"
                            },
                            {
                                "tumbon":"บากเรือ",
                                "postcode":"35130"
                            },
                            {
                                "tumbon":"ม่วง",
                                "postcode":"35130"
                            },
                            {
                                "tumbon":"โนนทราย",
                                "postcode":"35130"
                            },
                            {
                                "tumbon":"บึงแก",
                                "postcode":"35130"
                            },
                            {
                                "tumbon":"พระเสาร์",
                                "postcode":"35130"
                            },
                            {
                                "tumbon":"สงยาง",
                                "postcode":"35130"
                            }
                            ]
                        },
                        {
                            "amphur":"ค้อวัง",
                            "listTumbon":[
                            {
                                "tumbon":"ฟ้าห่วน",
                                "postcode":"35160"
                            },
                            {
                                "tumbon":"กุดน้ำใส",
                                "postcode":"35160"
                            },
                            {
                                "tumbon":"น้ำอ้อม",
                                "postcode":"35160"
                            },
                            {
                                "tumbon":"ค้อวัง",
                                "postcode":"35160"
                            }
                            ]
                        },
                        {
                            "amphur":"เลิงนกทา",
                            "listTumbon":[
                            {
                                "tumbon":"บุ่งค้า",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"สวาท",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"ห้องแซง",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"สามัคคี",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"กุดเชียงหมี",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"สามแยก",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"กุดแห่",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"โคกสำราญ",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"สร้างมิ่ง",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"ศรีแก้ว",
                                "postcode":"35120"
                            }
                            ]
                        },
                        {
                            "amphur":"ไทยเจริญ",
                            "listTumbon":[
                            {
                                "tumbon":"ไทยเจริญ",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"น้ำคำ",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"ส้มผ่อ",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"คำเตย",
                                "postcode":"35120"
                            },
                            {
                                "tumbon":"คำไผ่",
                                "postcode":"35120"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"นครพนม",
                    "listAmphur":[
                        {
                            "amphur":"เมืองนครพนม",
                            "listTumbon":[
                            {
                                "tumbon":"นาทราย",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"นาราชควาย",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"กุรุคุ",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"บ้านผึ้ง",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"อาจสามารถ",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"ขามเฒ่า",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"บ้านกลาง",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"ท่าค้อ",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"คำเตย",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"หนองญาติ",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"ดงขวาง",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"วังตามัว",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"หนองแสง",
                                "postcode":"48000"
                            },
                            {
                                "tumbon":"โพธิ์ตาก",
                                "postcode":"48000"
                            }
                            ]
                        },
                        {
                            "amphur":"ปลาปาก",
                            "listTumbon":[
                            {
                                "tumbon":"ปลาปาก",
                                "postcode":"48160"
                            },
                            {
                                "tumbon":"หนองฮี",
                                "postcode":"48160"
                            },
                            {
                                "tumbon":"กุตาไก้",
                                "postcode":"48160"
                            },
                            {
                                "tumbon":"โคกสว่าง",
                                "postcode":"48160"
                            },
                            {
                                "tumbon":"โคกสูง",
                                "postcode":"48160"
                            },
                            {
                                "tumbon":"มหาชัย",
                                "postcode":"48160"
                            },
                            {
                                "tumbon":"นามะเขือ",
                                "postcode":"48160"
                            },
                            {
                                "tumbon":"หนองเทาใหญ่",
                                "postcode":"48160"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าอุเทน",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าอุเทน",
                                "postcode":"48120"
                            },
                            {
                                "tumbon":"โนนตาล",
                                "postcode":"48120"
                            },
                            {
                                "tumbon":"ท่าจำปา",
                                "postcode":"48120"
                            },
                            {
                                "tumbon":"ไชยบุรี",
                                "postcode":"48120"
                            },
                            {
                                "tumbon":"พนอม",
                                "postcode":"48120"
                            },
                            {
                                "tumbon":"พะทาย",
                                "postcode":"48120"
                            },
                            {
                                "tumbon":"เวินพระบาท",
                                "postcode":"48120"
                            },
                            {
                                "tumbon":"รามราช",
                                "postcode":"48120"
                            },
                            {
                                "tumbon":"หนองเทา",
                                "postcode":"48120"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านแพง",
                            "listTumbon":[
                            {
                                "tumbon":"ไผ่ล้อม",
                                "postcode":"48140"
                            },
                            {
                                "tumbon":"โพนทอง",
                                "postcode":"48140"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"48140"
                            },
                            {
                                "tumbon":"นางัว",
                                "postcode":"48140"
                            },
                            {
                                "tumbon":"นาเข",
                                "postcode":"48140"
                            },
                            {
                                "tumbon":"บ้านแพง",
                                "postcode":"48140"
                            }
                            ]
                        },
                        {
                            "amphur":"ธาตุพนม",
                            "listTumbon":[
                            {
                                "tumbon":"ธาตุพนม",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"ฝั่งแดง",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"โพนแพง",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"พระกลางทุ่ง",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"นาถ่อน",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"แสนพัน",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"ดอนนางหงส์",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"น้ำก่ำ",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"อุ่มเหม้า",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"นาหนาด",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"กุดฉิม",
                                "postcode":"48110"
                            },
                            {
                                "tumbon":"ธาตุพนมเหนือ",
                                "postcode":"48110"
                            }
                            ]
                        },
                        {
                            "amphur":"เรณูนคร",
                            "listTumbon":[
                            {
                                "tumbon":"นาขาม",
                                "postcode":"48170"
                            },
                            {
                                "tumbon":"เรณู",
                                "postcode":"48170"
                            },
                            {
                                "tumbon":"ท่าลาด",
                                "postcode":"48170"
                            },
                            {
                                "tumbon":"นางาม",
                                "postcode":"48170"
                            },
                            {
                                "tumbon":"โคกหินแฮ่",
                                "postcode":"48170"
                            },
                            {
                                "tumbon":"หนองย่างชิ้น",
                                "postcode":"48170"
                            },
                            {
                                "tumbon":"เรณูใต้",
                                "postcode":"48170"
                            },
                            {
                                "tumbon":"โพนทอง",
                                "postcode":"48170"
                            }
                            ]
                        },
                        {
                            "amphur":"นาแก",
                            "listTumbon":[
                            {
                                "tumbon":"นาแก",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"พระซอง",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"หนองสังข์",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"นาคู่",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"พิมาน",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"พุ่มแก",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"ก้านเหลือง",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"หนองบ่อ",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"นาเลียง",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"บ้านแก้ง",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"คำพี้",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"สีชมพู",
                                "postcode":"48130"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีสงคราม",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีสงคราม",
                                "postcode":"48150"
                            },
                            {
                                "tumbon":"นาเดื่อ",
                                "postcode":"48150"
                            },
                            {
                                "tumbon":"บ้านเอื้อง",
                                "postcode":"48150"
                            },
                            {
                                "tumbon":"สามผง",
                                "postcode":"48150"
                            },
                            {
                                "tumbon":"ท่าบ่อสงคราม",
                                "postcode":"48150"
                            },
                            {
                                "tumbon":"บ้านข่า",
                                "postcode":"48150"
                            },
                            {
                                "tumbon":"นาคำ",
                                "postcode":"48150"
                            },
                            {
                                "tumbon":"โพนสว่าง",
                                "postcode":"48150"
                            },
                            {
                                "tumbon":"หาดแพง",
                                "postcode":"48150"
                            }
                            ]
                        },
                        {
                            "amphur":"นาหว้า",
                            "listTumbon":[
                            {
                                "tumbon":"นาหว้า",
                                "postcode":"48180"
                            },
                            {
                                "tumbon":"นางัว",
                                "postcode":"48180"
                            },
                            {
                                "tumbon":"บ้านเสียว",
                                "postcode":"48180"
                            },
                            {
                                "tumbon":"นาคูณใหญ่",
                                "postcode":"48180"
                            },
                            {
                                "tumbon":"เหล่าพัฒนา",
                                "postcode":"48180"
                            },
                            {
                                "tumbon":"ท่าเรือ",
                                "postcode":"48180"
                            }
                            ]
                        },
                        {
                            "amphur":"โพนสวรรค์",
                            "listTumbon":[
                            {
                                "tumbon":"โพนสวรรค์",
                                "postcode":"48190"
                            },
                            {
                                "tumbon":"นาหัวบ่อ",
                                "postcode":"48190"
                            },
                            {
                                "tumbon":"นาขมิ้น",
                                "postcode":"48190"
                            },
                            {
                                "tumbon":"โพนบก",
                                "postcode":"48190"
                            },
                            {
                                "tumbon":"บ้านค้อ",
                                "postcode":"48190"
                            },
                            {
                                "tumbon":"โพนจาน",
                                "postcode":"48190"
                            },
                            {
                                "tumbon":"นาใน",
                                "postcode":"48190"
                            }
                            ]
                        },
                        {
                            "amphur":"นาทม",
                            "listTumbon":[
                            {
                                "tumbon":"นาทม",
                                "postcode":"48140"
                            },
                            {
                                "tumbon":"หนองซน",
                                "postcode":"48140"
                            },
                            {
                                "tumbon":"ดอนเตย",
                                "postcode":"48140"
                            }
                            ]
                        },
                        {
                            "amphur":"วังยาง",
                            "listTumbon":[
                            {
                                "tumbon":"วังยาง",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"โคกสี",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"ยอดชาด",
                                "postcode":"48130"
                            },
                            {
                                "tumbon":"หนองโพธิ์",
                                "postcode":"48130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"มุกดาหาร",
                    "listAmphur":[
                        {
                            "amphur":"เมืองมุกดาหาร",
                            "listTumbon":[
                            {
                                "tumbon":"มุกดาหาร",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"ศรีบุญเรือง",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"บ้านโคก",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"บางทรายใหญ่",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"โพนทราย",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"ผึ่งแดด",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"นาโสก",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"นาสีนวน",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"คำป่าหลาย",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"คำอาฮวน",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"ดงเย็น",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"ดงมอน",
                                "postcode":"49000"
                            },
                            {
                                "tumbon":"กุดแข้",
                                "postcode":"49000"
                            }
                            ]
                        },
                        {
                            "amphur":"นิคมคำสร้อย",
                            "listTumbon":[
                            {
                                "tumbon":"นิคมคำสร้อย",
                                "postcode":"49130"
                            },
                            {
                                "tumbon":"นากอก",
                                "postcode":"49130"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"49130"
                            },
                            {
                                "tumbon":"กกแดง",
                                "postcode":"49130"
                            },
                            {
                                "tumbon":"นาอุดม",
                                "postcode":"49130"
                            },
                            {
                                "tumbon":"โชคชัย",
                                "postcode":"49130"
                            },
                            {
                                "tumbon":"ร่มเกล้า",
                                "postcode":"49130"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอนตาล",
                            "listTumbon":[
                            {
                                "tumbon":"ดอนตาล",
                                "postcode":"49120"
                            },
                            {
                                "tumbon":"โพธิ์ไทร",
                                "postcode":"49120"
                            },
                            {
                                "tumbon":"ป่าไร่",
                                "postcode":"49120"
                            },
                            {
                                "tumbon":"เหล่าหมี",
                                "postcode":"49120"
                            },
                            {
                                "tumbon":"บ้านบาก",
                                "postcode":"49120"
                            },
                            {
                                "tumbon":"นาสะเม็ง",
                                "postcode":"49120"
                            },
                            {
                                "tumbon":"บ้านแก้ง",
                                "postcode":"49120"
                            }
                            ]
                        },
                        {
                            "amphur":"ดงหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"ดงหลวง",
                                "postcode":"49140"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"49140"
                            },
                            {
                                "tumbon":"กกตูม",
                                "postcode":"49140"
                            },
                            {
                                "tumbon":"หนองแคน",
                                "postcode":"49140"
                            },
                            {
                                "tumbon":"ชะโนดน้อย",
                                "postcode":"49140"
                            },
                            {
                                "tumbon":"พังแดง",
                                "postcode":"49140"
                            }
                            ]
                        },
                        {
                            "amphur":"คำชะอี",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านซ่ง",
                                "postcode":"49110"
                            },
                            {
                                "tumbon":"คำชะอี",
                                "postcode":"49110"
                            },
                            {
                                "tumbon":"หนองเอี่ยน",
                                "postcode":"49110"
                            },
                            {
                                "tumbon":"บ้านค้อ",
                                "postcode":"49110"
                            },
                            {
                                "tumbon":"บ้านเหล่า",
                                "postcode":"49110"
                            },
                            {
                                "tumbon":"โพนงาม",
                                "postcode":"49110"
                            },
                            {
                                "tumbon":"เหล่าสร้างถ่อ",
                                "postcode":"49110"
                            },
                            {
                                "tumbon":"คำบก",
                                "postcode":"49110"
                            },
                            {
                                "tumbon":"น้ำเที่ยง",
                                "postcode":"49110"
                            }
                            ]
                        },
                        {
                            "amphur":"หว้านใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"หว้านใหญ่",
                                "postcode":"49150"
                            },
                            {
                                "tumbon":"ป่งขาม",
                                "postcode":"49150"
                            },
                            {
                                "tumbon":"บางทรายน้อย",
                                "postcode":"49150"
                            },
                            {
                                "tumbon":"ชะโนด",
                                "postcode":"49150"
                            },
                            {
                                "tumbon":"ดงหมู",
                                "postcode":"49150"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองสูง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองสูง",
                                "postcode":"49160"
                            },
                            {
                                "tumbon":"โนนยาง",
                                "postcode":"49160"
                            },
                            {
                                "tumbon":"ภูวง",
                                "postcode":"49160"
                            },
                            {
                                "tumbon":"บ้านเป้า",
                                "postcode":"49160"
                            },
                            {
                                "tumbon":"หนองสูงใต้",
                                "postcode":"49160"
                            },
                            {
                                "tumbon":"หนองสูงเหนือ",
                                "postcode":"49160"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ร้อยเอ็ด",
                    "listAmphur":[
                        {
                            "amphur":"เมืองร้อยเอ็ด",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"รอบเมือง",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"เหนือเมือง",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"ขอนแก่น",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"นาโพธิ์",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"สะอาดสมบูรณ์",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"สีแก้ว",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"ปอภาร",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"โนนรัง",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"หนองแก้ว",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"ดงลาน",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"แคนใหญ่",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"โนนตาล",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"เมืองทอง",
                                "postcode":"45000"
                            }
                            ]
                        },
                        {
                            "amphur":"เกษตรวิสัย",
                            "listTumbon":[
                            {
                                "tumbon":"เกษตรวิสัย",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"เมืองบัว",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"เหล่าหลวง",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"สิงห์โคก",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"ดงครั่งใหญ่",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"บ้านฝาง",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"กำแพง",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"กู่กาสิงห์",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"น้ำอ้อม",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"โนนสว่าง",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"ทุ่งทอง",
                                "postcode":"45150"
                            },
                            {
                                "tumbon":"ดงครั่งน้อย",
                                "postcode":"45150"
                            }
                            ]
                        },
                        {
                            "amphur":"ปทุมรัตต์",
                            "listTumbon":[
                            {
                                "tumbon":"บัวแดง",
                                "postcode":"45190"
                            },
                            {
                                "tumbon":"ดอกล้ำ",
                                "postcode":"45190"
                            },
                            {
                                "tumbon":"หนองแคน",
                                "postcode":"45190"
                            },
                            {
                                "tumbon":"โพนสูง",
                                "postcode":"45190"
                            },
                            {
                                "tumbon":"โนนสวรรค์",
                                "postcode":"45190"
                            },
                            {
                                "tumbon":"สระบัว",
                                "postcode":"45190"
                            },
                            {
                                "tumbon":"โนนสง่า",
                                "postcode":"45190"
                            },
                            {
                                "tumbon":"ขี้เหล็ก",
                                "postcode":"45190"
                            }
                            ]
                        },
                        {
                            "amphur":"จตุรพักตร์พิมาน",
                            "listTumbon":[
                            {
                                "tumbon":"หัวช้าง",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"หนองผือ",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"เมืองหงส์",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"โคกล่าม",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"น้ำใส",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"ดงแดง",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"ดงกลาง",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"ป่าสังข์",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"อีง่อง",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"ลิ้นฟ้า",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"ดู่น้อย",
                                "postcode":"45180"
                            },
                            {
                                "tumbon":"ศรีโคตร",
                                "postcode":"45180"
                            }
                            ]
                        },
                        {
                            "amphur":"ธวัชบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"นิเวศน์",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"ธงธานี",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"ธวัชบุรี",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"อุ่มเม้า",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"มะอึ",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"เขวาทุ่ง",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"ไพศาล",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"เมืองน้อย",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"บึงนคร",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"ราชธานี",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"หนองพอก",
                                "postcode":"45170"
                            }
                            ]
                        },
                        {
                            "amphur":"พนมไพร",
                            "listTumbon":[
                            {
                                "tumbon":"พนมไพร",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"แสนสุข",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"กุดน้ำใส",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"หนองทัพไทย",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"โพธิ์ใหญ่",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"วารีสวัสดิ์",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"โคกสว่าง",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"โพธิ์ชัย",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"นานวล",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"คำไฮ",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"สระแก้ว",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"ค้อใหญ่",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"ชานุวรรณ",
                                "postcode":"45140"
                            }
                            ]
                        },
                        {
                            "amphur":"โพนทอง",
                            "listTumbon":[
                            {
                                "tumbon":"แวง",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"โคกกกม่วง",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"นาอุดม",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"สว่าง",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"หนองใหญ่",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"โพธิ์ทอง",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"โนนชัยศรี",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"โพธิ์ศรีสว่าง",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"อุ่มเม่า",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"คำนาดี",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"พรมสวรรค์",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"สระนกแก้ว",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"วังสามัคคี",
                                "postcode":"45110"
                            },
                            {
                                "tumbon":"โคกสูง",
                                "postcode":"45110"
                            }
                            ]
                        },
                        {
                            "amphur":"โพธิ์ชัย",
                            "listTumbon":[
                            {
                                "tumbon":"ขามเปี้ย",
                                "postcode":"45230"
                            },
                            {
                                "tumbon":"เชียงใหม่",
                                "postcode":"45230"
                            },
                            {
                                "tumbon":"บัวคำ",
                                "postcode":"45230"
                            },
                            {
                                "tumbon":"อัคคะคำ",
                                "postcode":"45230"
                            },
                            {
                                "tumbon":"สะอาด",
                                "postcode":"45230"
                            },
                            {
                                "tumbon":"คำพอุง",
                                "postcode":"45230"
                            },
                            {
                                "tumbon":"หนองตาไก้",
                                "postcode":"45230"
                            },
                            {
                                "tumbon":"ดอนโอง",
                                "postcode":"45230"
                            },
                            {
                                "tumbon":"โพธิ์ศรี",
                                "postcode":"45230"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองพอก",
                            "listTumbon":[
                            {
                                "tumbon":"หนองพอก",
                                "postcode":"45210"
                            },
                            {
                                "tumbon":"บึงงาม",
                                "postcode":"45210"
                            },
                            {
                                "tumbon":"ภูเขาทอง",
                                "postcode":"45210"
                            },
                            {
                                "tumbon":"กกโพธิ์",
                                "postcode":"45210"
                            },
                            {
                                "tumbon":"โคกสว่าง",
                                "postcode":"45210"
                            },
                            {
                                "tumbon":"หนองขุ่นใหญ่",
                                "postcode":"45210"
                            },
                            {
                                "tumbon":"รอบเมือง",
                                "postcode":"45210"
                            },
                            {
                                "tumbon":"ผาน้ำย้อย",
                                "postcode":"45210"
                            },
                            {
                                "tumbon":"ท่าสีดา",
                                "postcode":"45210"
                            }
                            ]
                        },
                        {
                            "amphur":"เสลภูมิ",
                            "listTumbon":[
                            {
                                "tumbon":"กลาง",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"นางาม",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"เมืองไพร",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"นาแซง",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"นาเมือง",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"วังหลวง",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"ท่าม่วง",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"ขวาว",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"โพธิ์ทอง",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"ภูเงิน",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"เกาะแก้ว",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"นาเลิง",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"เหล่าน้อย",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"ศรีวิลัย",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"หนองหลวง",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"พรสวรรค์",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"ขวัญเมือง",
                                "postcode":"45120"
                            },
                            {
                                "tumbon":"บึงเกลือ",
                                "postcode":"45120"
                            }
                            ]
                        },
                        {
                            "amphur":"สุวรรณภูมิ",
                            "listTumbon":[
                            {
                                "tumbon":"สระคู",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"ดอกไม้",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"นาใหญ่",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"หินกอง",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"เมืองทุ่ง",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"หัวโทน",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"บ่อพันขัน",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"ทุ่งหลวง",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"หัวช้าง",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"น้ำคำ",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"ห้วยหินลาด",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"ช้างเผือก",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"ทุ่งกุลา",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"ทุ่งศรีเมือง",
                                "postcode":"45130"
                            },
                            {
                                "tumbon":"จำปาขัน",
                                "postcode":"45130"
                            }
                            ]
                        },
                        {
                            "amphur":"เมืองสรวง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองผือ",
                                "postcode":"45220"
                            },
                            {
                                "tumbon":"หนองหิน",
                                "postcode":"45220"
                            },
                            {
                                "tumbon":"คูเมือง",
                                "postcode":"45220"
                            },
                            {
                                "tumbon":"กกกุง",
                                "postcode":"45220"
                            },
                            {
                                "tumbon":"เมืองสรวง",
                                "postcode":"45220"
                            }
                            ]
                        },
                        {
                            "amphur":"โพนทราย",
                            "listTumbon":[
                            {
                                "tumbon":"โพนทราย",
                                "postcode":"45240"
                            },
                            {
                                "tumbon":"สามขา",
                                "postcode":"45240"
                            },
                            {
                                "tumbon":"ศรีสว่าง",
                                "postcode":"45240"
                            },
                            {
                                "tumbon":"ยางคำ",
                                "postcode":"45240"
                            },
                            {
                                "tumbon":"ท่าหาดยาว",
                                "postcode":"45240"
                            }
                            ]
                        },
                        {
                            "amphur":"อาจสามารถ",
                            "listTumbon":[
                            {
                                "tumbon":"อาจสามารถ",
                                "postcode":"45160"
                            },
                            {
                                "tumbon":"โพนเมือง",
                                "postcode":"45160"
                            },
                            {
                                "tumbon":"บ้านแจ้ง",
                                "postcode":"45160"
                            },
                            {
                                "tumbon":"หน่อม",
                                "postcode":"45160"
                            },
                            {
                                "tumbon":"หนองหมื่นถ่าน",
                                "postcode":"45160"
                            },
                            {
                                "tumbon":"หนองขาม",
                                "postcode":"45160"
                            },
                            {
                                "tumbon":"โหรา",
                                "postcode":"45160"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"45160"
                            },
                            {
                                "tumbon":"ขี้เหล็ก",
                                "postcode":"45160"
                            },
                            {
                                "tumbon":"บ้านดู่",
                                "postcode":"45160"
                            }
                            ]
                        },
                        {
                            "amphur":"เมยวดี",
                            "listTumbon":[
                            {
                                "tumbon":"เมยวดี",
                                "postcode":"45250"
                            },
                            {
                                "tumbon":"ชุมพร",
                                "postcode":"45250"
                            },
                            {
                                "tumbon":"บุ่งเลิศ",
                                "postcode":"45250"
                            },
                            {
                                "tumbon":"ชมสะอาด",
                                "postcode":"45250"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีสมเด็จ",
                            "listTumbon":[
                            {
                                "tumbon":"โพธิ์ทอง",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"ศรีสมเด็จ",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"เมืองเปลือย",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"หนองใหญ่",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"สวนจิก",
                                "postcode":"45280"
                            },
                            {
                                "tumbon":"โพธิ์สัย",
                                "postcode":"45280"
                            },
                            {
                                "tumbon":"หนองแวงควง",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"บ้านบาก",
                                "postcode":"45000"
                            }
                            ]
                        },
                        {
                            "amphur":"จังหาร",
                            "listTumbon":[
                            {
                                "tumbon":"ดินดำ",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"ปาฝา",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"ม่วงลาด",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"จังหาร",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"ดงสิงห์",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"ยางใหญ่",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"ผักแว่น",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"แสนชาติ",
                                "postcode":"45000"
                            }
                            ]
                        },
                        {
                            "amphur":"เชียงขวัญ",
                            "listTumbon":[
                            {
                                "tumbon":"เชียงขวัญ",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"พลับพลา",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"พระธาตุ",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"พระเจ้า",
                                "postcode":"45000"
                            },
                            {
                                "tumbon":"หมูม้น",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"บ้านเขือง",
                                "postcode":"45000"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองฮี",
                            "listTumbon":[
                            {
                                "tumbon":"หนองฮี",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"สาวแห",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"ดูกอึ่ง",
                                "postcode":"45140"
                            },
                            {
                                "tumbon":"เด่นราษฎร์",
                                "postcode":"45140"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งเขาหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งเขาหลวง",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"เทอดไทย",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"บึงงาม",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"มะบ้า",
                                "postcode":"45170"
                            },
                            {
                                "tumbon":"เหล่า",
                                "postcode":"45170"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ศรีสะเกษ",
                    "listAmphur":[
                        {
                            "amphur":"เมืองศรีสะเกษ",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองเหนือ",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"คูซอด",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"ซำ",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"จาน",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"ตะดอบ",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"หนองครก",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"โพนข่า",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"โพนค้อ",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"โพนเขวา",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"หญ้าปล้อง",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"ทุ่ม",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"หนองไฮ",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"หนองแก้ว",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"น้ำคำ",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"โพธิ์",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"หมากเขียบ",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"33000"
                            },
                            {
                                "tumbon":"เมืองใต้",
                                "postcode":"33000"
                            }
                            ]
                        },
                        {
                            "amphur":"ยางชุมน้อย",
                            "listTumbon":[
                            {
                                "tumbon":"ยางชุมน้อย",
                                "postcode":"33190"
                            },
                            {
                                "tumbon":"ลิ้นฟ้า",
                                "postcode":"33190"
                            },
                            {
                                "tumbon":"คอนกาม",
                                "postcode":"33190"
                            },
                            {
                                "tumbon":"โนนคูณ",
                                "postcode":"33190"
                            },
                            {
                                "tumbon":"กุดเมืองฮาม",
                                "postcode":"33190"
                            },
                            {
                                "tumbon":"บึงบอน",
                                "postcode":"33190"
                            },
                            {
                                "tumbon":"ยางชุมใหญ่",
                                "postcode":"33190"
                            }
                            ]
                        },
                        {
                            "amphur":"กันทรารมย์",
                            "listTumbon":[
                            {
                                "tumbon":"ดูน",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"โนนสัง",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"หนองหัวช้าง",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"ยาง",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"หนองแวง",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"หนองแก้ว",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"ทาม",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"ละทาย",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"เมืองน้อย",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"อีปาด",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"บัวน้อย",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"ดู่",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"ผักแพว",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"จาน",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"คำเนียม",
                                "postcode":"33130"
                            }
                            ]
                        },
                        {
                            "amphur":"กันทรลักษ์",
                            "listTumbon":[
                            {
                                "tumbon":"บึงมะลู",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"กุดเสลา",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"เมือง",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"สังเม็ก",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"น้ำอ้อม",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"ละลาย",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"รุง",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"ตระกาจ",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"จานใหญ่",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"ภูเงิน",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"ชำ",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"กระแชง",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"โนนสำราญ",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"หนองหญ้าลาด",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"เสาธงชัย",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"ขนุน",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"สวนกล้วย",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"เวียงเหนือ",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"ทุ่งใหญ่",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"ภูผาหมอก",
                                "postcode":"33110"
                            }
                            ]
                        },
                        {
                            "amphur":"ขุขันธ์",
                            "listTumbon":[
                            {
                                "tumbon":"กันทรารมย์",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"จะกง",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ใจดี",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ดองกำเม็ด",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"โสน",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ปรือใหญ่",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"สะเดาใหญ่",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ตาอุด",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ห้วยเหนือ",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ห้วยใต้",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"หัวเสือ",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ตะเคียน",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"นิคมพัฒนา",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"โคกเพชร",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ปราสาท",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"สำโรงตาเจ็น",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ห้วยสำราญ",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"กฤษณา",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ลมศักดิ์",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"หนองฉลอง",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ศรีตระกูล",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ศรีสะอาด",
                                "postcode":"33140"
                            }
                            ]
                        },
                        {
                            "amphur":"ไพรบึง",
                            "listTumbon":[
                            {
                                "tumbon":"ไพรบึง",
                                "postcode":"33180"
                            },
                            {
                                "tumbon":"ดินแดง",
                                "postcode":"33180"
                            },
                            {
                                "tumbon":"ปราสาทเยอ",
                                "postcode":"33180"
                            },
                            {
                                "tumbon":"สำโรงพลัน",
                                "postcode":"33180"
                            },
                            {
                                "tumbon":"สุขสวัสดิ์",
                                "postcode":"33180"
                            },
                            {
                                "tumbon":"โนนปูน",
                                "postcode":"33180"
                            }
                            ]
                        },
                        {
                            "amphur":"ปรางค์กู่",
                            "listTumbon":[
                            {
                                "tumbon":"พิมาย",
                                "postcode":"33170"
                            },
                            {
                                "tumbon":"กู่",
                                "postcode":"33170"
                            },
                            {
                                "tumbon":"หนองเชียงทูน",
                                "postcode":"33170"
                            },
                            {
                                "tumbon":"ตูม",
                                "postcode":"33170"
                            },
                            {
                                "tumbon":"สมอ",
                                "postcode":"33170"
                            },
                            {
                                "tumbon":"โพธิ์ศรี",
                                "postcode":"33170"
                            },
                            {
                                "tumbon":"สำโรงปราสาท",
                                "postcode":"33170"
                            },
                            {
                                "tumbon":"ดู่",
                                "postcode":"33170"
                            },
                            {
                                "tumbon":"สวาย",
                                "postcode":"33170"
                            },
                            {
                                "tumbon":"พิมายเหนือ",
                                "postcode":"33170"
                            }
                            ]
                        },
                        {
                            "amphur":"ขุนหาญ",
                            "listTumbon":[
                            {
                                "tumbon":"สิ",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"บักดอง",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"พราน",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"โพธิ์วงศ์",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"ไพร",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"กระหวัน",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"ขุนหาญ",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"โนนสูง",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"กันทรอม",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"ภูฝ้าย",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"โพธิ์กระสังข์",
                                "postcode":"33150"
                            },
                            {
                                "tumbon":"ห้วยจันทร์",
                                "postcode":"33150"
                            }
                            ]
                        },
                        {
                            "amphur":"ราษีไศล",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองคง",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"เมืองแคน",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"หนองแค",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"จิกสังข์ทอง",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"ด่าน",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"ดู่",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"หนองอึ่ง",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"บัวหุ่ง",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"ไผ่",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"ส้มป่อย",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"หนองหมี",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"หว้านคำ",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"สร้างปี่",
                                "postcode":"33160"
                            }
                            ]
                        },
                        {
                            "amphur":"อุทุมพรพิสัย",
                            "listTumbon":[
                            {
                                "tumbon":"กำแพง",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"อี่หล่ำ",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"ก้านเหลือง",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"ทุ่งไชย",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"สำโรง",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"แขม",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"หนองไฮ",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"ขะยูง",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"ตาเกษ",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"หัวช้าง",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"รังแร้ง",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"แต้",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"แข้",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"โพธิ์ชัย",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"ปะอาว",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"หนองห้าง",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"สระกำแพงใหญ่",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"โคกหล่าม",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"โคกจาน",
                                "postcode":"33120"
                            }
                            ]
                        },
                        {
                            "amphur":"บึงบูรพ์",
                            "listTumbon":[
                            {
                                "tumbon":"เป๊าะ",
                                "postcode":"33220"
                            },
                            {
                                "tumbon":"บึงบูรพ์",
                                "postcode":"33220"
                            }
                            ]
                        },
                        {
                            "amphur":"ห้วยทับทัน",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยทับทัน",
                                "postcode":"33210"
                            },
                            {
                                "tumbon":"เมืองหลวง",
                                "postcode":"33210"
                            },
                            {
                                "tumbon":"กล้วยกว้าง",
                                "postcode":"33210"
                            },
                            {
                                "tumbon":"ผักไหม",
                                "postcode":"33210"
                            },
                            {
                                "tumbon":"จานแสนไชย",
                                "postcode":"33210"
                            },
                            {
                                "tumbon":"ปราสาท",
                                "postcode":"33210"
                            }
                            ]
                        },
                        {
                            "amphur":"โนนคูณ",
                            "listTumbon":[
                            {
                                "tumbon":"โนนค้อ",
                                "postcode":"33250"
                            },
                            {
                                "tumbon":"บก",
                                "postcode":"33250"
                            },
                            {
                                "tumbon":"โพธิ์",
                                "postcode":"33250"
                            },
                            {
                                "tumbon":"หนองกุง",
                                "postcode":"33250"
                            },
                            {
                                "tumbon":"เหล่ากวาง",
                                "postcode":"33250"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีรัตนะ",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีแก้ว",
                                "postcode":"33240"
                            },
                            {
                                "tumbon":"พิงพวย",
                                "postcode":"33240"
                            },
                            {
                                "tumbon":"สระเยาว์",
                                "postcode":"33240"
                            },
                            {
                                "tumbon":"เสื่องข้าว",
                                "postcode":"33240"
                            },
                            {
                                "tumbon":"ศรีโนนงาม",
                                "postcode":"33240"
                            },
                            {
                                "tumbon":"สะพุง",
                                "postcode":"33240"
                            },
                            {
                                "tumbon":"ตูม",
                                "postcode":"33240"
                            }
                            ]
                        },
                        {
                            "amphur":"น้ำเกลี้ยง",
                            "listTumbon":[
                            {
                                "tumbon":"น้ำเกลี้ยง",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"ละเอาะ",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"ตองปิด",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"เขิน",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"รุ่งระวี",
                                "postcode":"33130"
                            },
                            {
                                "tumbon":"คูบ",
                                "postcode":"33130"
                            }
                            ]
                        },
                        {
                            "amphur":"วังหิน",
                            "listTumbon":[
                            {
                                "tumbon":"บุสูง",
                                "postcode":"33270"
                            },
                            {
                                "tumbon":"ธาตุ",
                                "postcode":"33270"
                            },
                            {
                                "tumbon":"ดวนใหญ่",
                                "postcode":"33270"
                            },
                            {
                                "tumbon":"บ่อแก้ว",
                                "postcode":"33270"
                            },
                            {
                                "tumbon":"ศรีสำราญ",
                                "postcode":"33270"
                            },
                            {
                                "tumbon":"ทุ่งสว่าง",
                                "postcode":"33270"
                            },
                            {
                                "tumbon":"วังหิน",
                                "postcode":"33270"
                            },
                            {
                                "tumbon":"โพนยาง",
                                "postcode":"33270"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูสิงห์",
                            "listTumbon":[
                            {
                                "tumbon":"โคกตาล",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ห้วยตามอญ",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ห้วยตึ๊กชู",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ละลม",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ตะเคียนราม",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ดงรัก",
                                "postcode":"33140"
                            },
                            {
                                "tumbon":"ไพรพัฒนา",
                                "postcode":"33140"
                            }
                            ]
                        },
                        {
                            "amphur":"เมืองจันทร์",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองจันทร์",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"ตาโกน",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"หนองใหญ่",
                                "postcode":"33120"
                            }
                            ]
                        },
                        {
                            "amphur":"เบญจลักษ์",
                            "listTumbon":[
                            {
                                "tumbon":"เสียว",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"หนองหว้า",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"หนองงูเหลือม",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"หนองฮาง",
                                "postcode":"33110"
                            },
                            {
                                "tumbon":"ท่าคล้อ",
                                "postcode":"33110"
                            }
                            ]
                        },
                        {
                            "amphur":"พยุห์",
                            "listTumbon":[
                            {
                                "tumbon":"พยุห์",
                                "postcode":"33230"
                            },
                            {
                                "tumbon":"พรหมสวัสดิ์",
                                "postcode":"33230"
                            },
                            {
                                "tumbon":"ตำแย",
                                "postcode":"33230"
                            },
                            {
                                "tumbon":"โนนเพ็ก",
                                "postcode":"33230"
                            },
                            {
                                "tumbon":"หนองค้า",
                                "postcode":"33230"
                            }
                            ]
                        },
                        {
                            "amphur":"โพธิ์ศรีสุวรรณ",
                            "listTumbon":[
                            {
                                "tumbon":"โดด",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"เสียว",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"หนองม้า",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"ผือใหญ่",
                                "postcode":"33120"
                            },
                            {
                                "tumbon":"อีเซ",
                                "postcode":"33120"
                            }
                            ]
                        },
                        {
                            "amphur":"ศิลาลาด",
                            "listTumbon":[
                            {
                                "tumbon":"กุง",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"คลีกลิ้ง",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"หนองบัวดง",
                                "postcode":"33160"
                            },
                            {
                                "tumbon":"โจดม่วง",
                                "postcode":"33160"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"อำนาจเจริญ",
                    "listAmphur":[
                        {
                            "amphur":"เมืองอำนาจเจริญ",
                            "listTumbon":[
                            {
                                "tumbon":"บุ่ง",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"ไก่คำ",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"นาจิก",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"ปลาค้าว",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"เหล่าพรวน",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"สร้างนกทา",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"คึมใหญ่",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"นาผือ",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"น้ำปลีก",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"นาวัง",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"นาหมอม้า",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"โนนโพธิ์",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"โนนหนามแท่ง",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"ห้วยไร่",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"หนองมะแซว",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"กุดปลาดุก",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"ดอนเมย",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"นายม",
                                "postcode":"37000"
                            },
                            {
                                "tumbon":"นาแต้",
                                "postcode":"37000"
                            }
                            ]
                        },
                        {
                            "amphur":"ชานุมาน",
                            "listTumbon":[
                            {
                                "tumbon":"ชานุมาน",
                                "postcode":"37210"
                            },
                            {
                                "tumbon":"โคกสาร",
                                "postcode":"37210"
                            },
                            {
                                "tumbon":"คำเขื่อนแก้ว",
                                "postcode":"37210"
                            },
                            {
                                "tumbon":"โคกก่ง",
                                "postcode":"37210"
                            },
                            {
                                "tumbon":"ป่าก่อ",
                                "postcode":"37210"
                            }
                            ]
                        },
                        {
                            "amphur":"ปทุมราชวงศา",
                            "listTumbon":[
                            {
                                "tumbon":"หนองข่า",
                                "postcode":"37110"
                            },
                            {
                                "tumbon":"คำโพน",
                                "postcode":"37110"
                            },
                            {
                                "tumbon":"นาหว้า",
                                "postcode":"37110"
                            },
                            {
                                "tumbon":"ลือ",
                                "postcode":"37110"
                            },
                            {
                                "tumbon":"ห้วย",
                                "postcode":"37110"
                            },
                            {
                                "tumbon":"โนนงาม",
                                "postcode":"37110"
                            },
                            {
                                "tumbon":"นาป่าแซง",
                                "postcode":"37110"
                            }
                            ]
                        },
                        {
                            "amphur":"พนา",
                            "listTumbon":[
                            {
                                "tumbon":"พนา",
                                "postcode":"37180"
                            },
                            {
                                "tumbon":"จานลาน",
                                "postcode":"37180"
                            },
                            {
                                "tumbon":"ไม้กลอน",
                                "postcode":"37180"
                            },
                            {
                                "tumbon":"พระเหลา",
                                "postcode":"37180"
                            }
                            ]
                        },
                        {
                            "amphur":"เสนางคนิคม",
                            "listTumbon":[
                            {
                                "tumbon":"เสนางคนิคม",
                                "postcode":"37290"
                            },
                            {
                                "tumbon":"โพนทอง",
                                "postcode":"37290"
                            },
                            {
                                "tumbon":"ไร่สีสุก",
                                "postcode":"37290"
                            },
                            {
                                "tumbon":"นาเวียง",
                                "postcode":"37290"
                            },
                            {
                                "tumbon":"หนองไฮ",
                                "postcode":"37290"
                            },
                            {
                                "tumbon":"หนองสามสี",
                                "postcode":"37290"
                            }
                            ]
                        },
                        {
                            "amphur":"หัวตะพาน",
                            "listTumbon":[
                            {
                                "tumbon":"หัวตะพาน",
                                "postcode":"37240"
                            },
                            {
                                "tumbon":"คำพระ",
                                "postcode":"37240"
                            },
                            {
                                "tumbon":"เค็งใหญ่",
                                "postcode":"37240"
                            },
                            {
                                "tumbon":"หนองแก้ว",
                                "postcode":"37240"
                            },
                            {
                                "tumbon":"โพนเมืองน้อย",
                                "postcode":"37240"
                            },
                            {
                                "tumbon":"สร้างถ่อน้อย",
                                "postcode":"37240"
                            },
                            {
                                "tumbon":"จิกดู่",
                                "postcode":"37240"
                            },
                            {
                                "tumbon":"รัตนวารี",
                                "postcode":"37240"
                            }
                            ]
                        },
                        {
                            "amphur":"ลืออำนาจ",
                            "listTumbon":[
                            {
                                "tumbon":"อำนาจ",
                                "postcode":"37120"
                            },
                            {
                                "tumbon":"ดงมะยาง",
                                "postcode":"37120"
                            },
                            {
                                "tumbon":"เปือย",
                                "postcode":"37120"
                            },
                            {
                                "tumbon":"ดงบัง",
                                "postcode":"37120"
                            },
                            {
                                "tumbon":"ไร่ขี",
                                "postcode":"37120"
                            },
                            {
                                "tumbon":"แมด",
                                "postcode":"37120"
                            },
                            {
                                "tumbon":"โคกกลาง",
                                "postcode":"37120"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"นครสวรรค์",
                    "listAmphur":[
                        {
                            "amphur":"เมืองนครสวรรค์",
                            "listTumbon":[
                            {
                                "tumbon":"ปากน้ำโพ",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"กลางแดด",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"เกรียงไกร",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"แควใหญ่",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"ตะเคียนเลื่อน",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"นครสวรรค์ตก",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"นครสวรรค์ออก",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"บางพระหลวง",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"บางม่วง",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"บ้านมะเกลือ",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"บ้านแก่ง",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"พระนอน",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"วัดไทรย์",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"หนองกรด",
                                "postcode":"60240"
                            },
                            {
                                "tumbon":"หนองกระโดน",
                                "postcode":"60240"
                            },
                            {
                                "tumbon":"หนองปลิง",
                                "postcode":"60000"
                            },
                            {
                                "tumbon":"บึงเสนาท",
                                "postcode":"60000"
                            }
                            ]
                        },
                        {
                            "amphur":"โกรกพระ",
                            "listTumbon":[
                            {
                                "tumbon":"โกรกพระ",
                                "postcode":"60170"
                            },
                            {
                                "tumbon":"ยางตาล",
                                "postcode":"60170"
                            },
                            {
                                "tumbon":"บางมะฝ่อ",
                                "postcode":"60170"
                            },
                            {
                                "tumbon":"บางประมุง",
                                "postcode":"60170"
                            },
                            {
                                "tumbon":"นากลาง",
                                "postcode":"60170"
                            },
                            {
                                "tumbon":"ศาลาแดง",
                                "postcode":"60170"
                            },
                            {
                                "tumbon":"เนินกว้าว",
                                "postcode":"60170"
                            },
                            {
                                "tumbon":"เนินศาลา",
                                "postcode":"60170"
                            },
                            {
                                "tumbon":"หาดสูง",
                                "postcode":"60170"
                            }
                            ]
                        },
                        {
                            "amphur":"ชุมแสง",
                            "listTumbon":[
                            {
                                "tumbon":"ชุมแสง",
                                "postcode":"60120"
                            },
                            {
                                "tumbon":"ทับกฤช",
                                "postcode":"60250"
                            },
                            {
                                "tumbon":"พิกุล",
                                "postcode":"60120"
                            },
                            {
                                "tumbon":"เกยไชย",
                                "postcode":"60120"
                            },
                            {
                                "tumbon":"ท่าไม้",
                                "postcode":"60120"
                            },
                            {
                                "tumbon":"บางเคียน",
                                "postcode":"60120"
                            },
                            {
                                "tumbon":"หนองกระเจา",
                                "postcode":"60120"
                            },
                            {
                                "tumbon":"พันลาน",
                                "postcode":"60250"
                            },
                            {
                                "tumbon":"โคกหม้อ",
                                "postcode":"60120"
                            },
                            {
                                "tumbon":"ไผ่สิงห์",
                                "postcode":"60120"
                            },
                            {
                                "tumbon":"ฆะมัง",
                                "postcode":"60120"
                            },
                            {
                                "tumbon":"ทับกฤชใต้",
                                "postcode":"60250"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองบัว",
                            "listTumbon":[
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"60110"
                            },
                            {
                                "tumbon":"หนองกลับ",
                                "postcode":"60110"
                            },
                            {
                                "tumbon":"ธารทหาร",
                                "postcode":"60110"
                            },
                            {
                                "tumbon":"ห้วยร่วม",
                                "postcode":"60110"
                            },
                            {
                                "tumbon":"ห้วยถั่วใต้",
                                "postcode":"60110"
                            },
                            {
                                "tumbon":"ห้วยถั่วเหนือ",
                                "postcode":"60110"
                            },
                            {
                                "tumbon":"ห้วยใหญ่",
                                "postcode":"60110"
                            },
                            {
                                "tumbon":"ทุ่งทอง",
                                "postcode":"60110"
                            },
                            {
                                "tumbon":"วังบ่อ",
                                "postcode":"60110"
                            }
                            ]
                        },
                        {
                            "amphur":"บรรพตพิสัย",
                            "listTumbon":[
                            {
                                "tumbon":"ท่างิ้ว",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"บางตาหงาย",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"หูกวาง",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"อ่างทอง",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"บ้านแดน",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"บางแก้ว",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"ตาขีด",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"ตาสัง",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"ด่านช้าง",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"หนองกรด",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"หนองตางู",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"บึงปลาทู",
                                "postcode":"60180"
                            },
                            {
                                "tumbon":"เจริญผล",
                                "postcode":"60180"
                            }
                            ]
                        },
                        {
                            "amphur":"เก้าเลี้ยว",
                            "listTumbon":[
                            {
                                "tumbon":"มหาโพธิ",
                                "postcode":"60230"
                            },
                            {
                                "tumbon":"หนองเต่า",
                                "postcode":"60230"
                            },
                            {
                                "tumbon":"เขาดิน",
                                "postcode":"60230"
                            },
                            {
                                "tumbon":"หัวดง",
                                "postcode":"60230"
                            },
                            {
                                "tumbon":"เก้าเลี้ยว",
                                "postcode":"60230"
                            }
                            ]
                        },
                        {
                            "amphur":"ตาคลี",
                            "listTumbon":[
                            {
                                "tumbon":"ตาคลี",
                                "postcode":"60140"
                            },
                            {
                                "tumbon":"ช่องแค",
                                "postcode":"60210"
                            },
                            {
                                "tumbon":"จันเสน",
                                "postcode":"60260"
                            },
                            {
                                "tumbon":"ห้วยหอม",
                                "postcode":"60210"
                            },
                            {
                                "tumbon":"หัวหวาย",
                                "postcode":"60140"
                            },
                            {
                                "tumbon":"หนองโพ",
                                "postcode":"60140"
                            },
                            {
                                "tumbon":"หนองหม้อ",
                                "postcode":"60140"
                            },
                            {
                                "tumbon":"สร้อยทอง",
                                "postcode":"60210"
                            },
                            {
                                "tumbon":"ลาดทิพรส",
                                "postcode":"60260"
                            },
                            {
                                "tumbon":"พรหมนิมิต",
                                "postcode":"60210"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าตะโก",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าตะโก",
                                "postcode":"60160"
                            },
                            {
                                "tumbon":"พนมรอก",
                                "postcode":"60160"
                            },
                            {
                                "tumbon":"หัวถนน",
                                "postcode":"60160"
                            },
                            {
                                "tumbon":"สายลำโพง",
                                "postcode":"60160"
                            },
                            {
                                "tumbon":"วังมหากร",
                                "postcode":"60160"
                            },
                            {
                                "tumbon":"ดอนคา",
                                "postcode":"60160"
                            },
                            {
                                "tumbon":"ทำนบ",
                                "postcode":"60160"
                            },
                            {
                                "tumbon":"วังใหญ่",
                                "postcode":"60160"
                            },
                            {
                                "tumbon":"พนมเศษ",
                                "postcode":"60160"
                            },
                            {
                                "tumbon":"หนองหลวง",
                                "postcode":"60160"
                            }
                            ]
                        },
                        {
                            "amphur":"ไพศาลี",
                            "listTumbon":[
                            {
                                "tumbon":"โคกเดื่อ",
                                "postcode":"60220"
                            },
                            {
                                "tumbon":"สำโรงชัย",
                                "postcode":"60220"
                            },
                            {
                                "tumbon":"วังน้ำลัด",
                                "postcode":"60220"
                            },
                            {
                                "tumbon":"ตะคร้อ",
                                "postcode":"60220"
                            },
                            {
                                "tumbon":"โพธิ์ประสาท",
                                "postcode":"60220"
                            },
                            {
                                "tumbon":"วังข่อย",
                                "postcode":"60220"
                            },
                            {
                                "tumbon":"นาขอม",
                                "postcode":"60220"
                            },
                            {
                                "tumbon":"ไพศาลี",
                                "postcode":"60220"
                            }
                            ]
                        },
                        {
                            "amphur":"พยุหะคีรี",
                            "listTumbon":[
                            {
                                "tumbon":"พยุหะ",
                                "postcode":"60130"
                            },
                            {
                                "tumbon":"เนินมะกอก",
                                "postcode":"60130"
                            },
                            {
                                "tumbon":"นิคมเขาบ่อแก้ว",
                                "postcode":"60130"
                            },
                            {
                                "tumbon":"ม่วงหัก",
                                "postcode":"60130"
                            },
                            {
                                "tumbon":"ยางขาว",
                                "postcode":"60130"
                            },
                            {
                                "tumbon":"ย่านมัทรี",
                                "postcode":"60130"
                            },
                            {
                                "tumbon":"เขาทอง",
                                "postcode":"60130"
                            },
                            {
                                "tumbon":"ท่าน้ำอ้อย",
                                "postcode":"60130"
                            },
                            {
                                "tumbon":"น้ำทรง",
                                "postcode":"60130"
                            },
                            {
                                "tumbon":"เขากะลา",
                                "postcode":"60130"
                            },
                            {
                                "tumbon":"สระทะเล",
                                "postcode":"60130"
                            }
                            ]
                        },
                        {
                            "amphur":"ลาดยาว",
                            "listTumbon":[
                            {
                                "tumbon":"ลาดยาว",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"ห้วยน้ำหอม",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"วังม้า",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"วังเมือง",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"สร้อยละคร",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"มาบแก",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"หนองยาว",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"หนองนมวัว",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"บ้านไร่",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"เนินขี้เหล็ก",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"ศาลเจ้าไก่ต่อ",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"สระแก้ว",
                                "postcode":"60150"
                            }
                            ]
                        },
                        {
                            "amphur":"ตากฟ้า",
                            "listTumbon":[
                            {
                                "tumbon":"ตากฟ้า",
                                "postcode":"60190"
                            },
                            {
                                "tumbon":"ลำพยนต์",
                                "postcode":"60190"
                            },
                            {
                                "tumbon":"สุขสำราญ",
                                "postcode":"60190"
                            },
                            {
                                "tumbon":"หนองพิกุล",
                                "postcode":"60190"
                            },
                            {
                                "tumbon":"พุนกยูง",
                                "postcode":"60190"
                            },
                            {
                                "tumbon":"อุดมธัญญา",
                                "postcode":"60190"
                            },
                            {
                                "tumbon":"เขาชายธง",
                                "postcode":"60190"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่วงก์",
                            "listTumbon":[
                            {
                                "tumbon":"แม่วงก์",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"แม่เล่ย์",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"วังซ่าน",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"เขาชนกัน",
                                "postcode":"60150"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่เปิน",
                            "listTumbon":[
                            {
                                "tumbon":"แม่เปิน",
                                "postcode":"60150"
                            }
                            ]
                        },
                        {
                            "amphur":"ชุมตาบง",
                            "listTumbon":[
                            {
                                "tumbon":"ชุมตาบง",
                                "postcode":"60150"
                            },
                            {
                                "tumbon":"ปางสวรรค์",
                                "postcode":"60150"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"อุทัยธานี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองอุทัยธานี",
                            "listTumbon":[
                            {
                                "tumbon":"อุทัยใหม่",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"น้ำซึม",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"สะแกกรัง",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"ดอนขวาง",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"หาดทนง",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"เกาะเทโพ",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"ท่าซุง",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"หนองแก",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"โนนเหล็ก",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"หนองเต่า",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"หนองไผ่แบน",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"หนองพังค่า",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"ทุ่งใหญ่",
                                "postcode":"61000"
                            },
                            {
                                "tumbon":"เนินแจง",
                                "postcode":"61000"
                            }
                            ]
                        },
                        {
                            "amphur":"ทัพทัน",
                            "listTumbon":[
                            {
                                "tumbon":"ทัพทัน",
                                "postcode":"61120"
                            },
                            {
                                "tumbon":"ทุ่งนาไทย",
                                "postcode":"61120"
                            },
                            {
                                "tumbon":"เขาขี้ฝอย",
                                "postcode":"61120"
                            },
                            {
                                "tumbon":"หนองหญ้าปล้อง",
                                "postcode":"61120"
                            },
                            {
                                "tumbon":"โคกหม้อ",
                                "postcode":"61120"
                            },
                            {
                                "tumbon":"หนองยายดา",
                                "postcode":"61120"
                            },
                            {
                                "tumbon":"หนองกลางดง",
                                "postcode":"61120"
                            },
                            {
                                "tumbon":"หนองกระทุ่ม",
                                "postcode":"61120"
                            },
                            {
                                "tumbon":"หนองสระ",
                                "postcode":"61120"
                            },
                            {
                                "tumbon":"ตลุกดู่",
                                "postcode":"61120"
                            }
                            ]
                        },
                        {
                            "amphur":"สว่างอารมณ์",
                            "listTumbon":[
                            {
                                "tumbon":"สว่างอารมณ์",
                                "postcode":"61150"
                            },
                            {
                                "tumbon":"หนองหลวง",
                                "postcode":"61150"
                            },
                            {
                                "tumbon":"พลวงสองนาง",
                                "postcode":"61150"
                            },
                            {
                                "tumbon":"ไผ่เขียว",
                                "postcode":"61150"
                            },
                            {
                                "tumbon":"บ่อยาง",
                                "postcode":"61150"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองฉาง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองฉาง",
                                "postcode":"61110"
                            },
                            {
                                "tumbon":"หนองยาง",
                                "postcode":"61110"
                            },
                            {
                                "tumbon":"หนองนางนวล",
                                "postcode":"61110"
                            },
                            {
                                "tumbon":"หนองสรวง",
                                "postcode":"61110"
                            },
                            {
                                "tumbon":"บ้านเก่า",
                                "postcode":"61110"
                            },
                            {
                                "tumbon":"อุทัยเก่า",
                                "postcode":"61110"
                            },
                            {
                                "tumbon":"ทุ่งโพ",
                                "postcode":"61110"
                            },
                            {
                                "tumbon":"ทุ่งพง",
                                "postcode":"61110"
                            },
                            {
                                "tumbon":"เขาบางแกรก",
                                "postcode":"61170"
                            },
                            {
                                "tumbon":"เขากวางทอง",
                                "postcode":"61110"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองขาหย่าง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองขาหย่าง",
                                "postcode":"61130"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"61130"
                            },
                            {
                                "tumbon":"ดอนกลอย",
                                "postcode":"61130"
                            },
                            {
                                "tumbon":"ห้วยรอบ",
                                "postcode":"61130"
                            },
                            {
                                "tumbon":"ทุ่งพึ่ง",
                                "postcode":"61130"
                            },
                            {
                                "tumbon":"ท่าโพ",
                                "postcode":"61130"
                            },
                            {
                                "tumbon":"หมกแถว",
                                "postcode":"61130"
                            },
                            {
                                "tumbon":"หลุมเข้า",
                                "postcode":"61130"
                            },
                            {
                                "tumbon":"ดงขวาง",
                                "postcode":"61130"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านไร่",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านไร่",
                                "postcode":"61140"
                            },
                            {
                                "tumbon":"ทัพหลวง",
                                "postcode":"61140"
                            },
                            {
                                "tumbon":"ห้วยแห้ง",
                                "postcode":"61140"
                            },
                            {
                                "tumbon":"คอกควาย",
                                "postcode":"61140"
                            },
                            {
                                "tumbon":"วังหิน",
                                "postcode":"61180"
                            },
                            {
                                "tumbon":"เมืองการุ้ง",
                                "postcode":"61180"
                            },
                            {
                                "tumbon":"แก่นมะกรูด",
                                "postcode":"61140"
                            },
                            {
                                "tumbon":"หนองจอก",
                                "postcode":"61180"
                            },
                            {
                                "tumbon":"หูช้าง",
                                "postcode":"61180"
                            },
                            {
                                "tumbon":"บ้านบึง",
                                "postcode":"61140"
                            },
                            {
                                "tumbon":"บ้านใหม่คลองเคียน",
                                "postcode":"61180"
                            },
                            {
                                "tumbon":"หนองบ่มกล้วย",
                                "postcode":"61180"
                            },
                            {
                                "tumbon":"เจ้าวัด",
                                "postcode":"61150"
                            }
                            ]
                        },
                        {
                            "amphur":"ลานสัก",
                            "listTumbon":[
                            {
                                "tumbon":"ลานสัก",
                                "postcode":"61160"
                            },
                            {
                                "tumbon":"ประดู่ยืน",
                                "postcode":"61160"
                            },
                            {
                                "tumbon":"ป่าอ้อ",
                                "postcode":"61160"
                            },
                            {
                                "tumbon":"ระบำ",
                                "postcode":"61160"
                            },
                            {
                                "tumbon":"น้ำรอบ",
                                "postcode":"61160"
                            },
                            {
                                "tumbon":"ทุ่งนางาม",
                                "postcode":"61160"
                            }
                            ]
                        },
                        {
                            "amphur":"ห้วยคต",
                            "listTumbon":[
                            {
                                "tumbon":"สุขฤทัย",
                                "postcode":"61170"
                            },
                            {
                                "tumbon":"ทองหลาง",
                                "postcode":"61170"
                            },
                            {
                                "tumbon":"ห้วยคต",
                                "postcode":"61170"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ตาก",
                    "listAmphur":[
                        {
                            "amphur":"เมืองตาก",
                            "listTumbon":[
                            {
                                "tumbon":"ระแหง",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"หนองหลวง",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"เชียงเงิน",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"หัวเดียด",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"หนองบัวเหนือ",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"ไม้งาม",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"โป่งแดง",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"น้ำรึม",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"วังหิน",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"แม่ท้อ",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"ป่ามะม่วง",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"หนองบัวใต้",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"วังประจบ",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"ตลุกกลางทุ่ง",
                                "postcode":"63000"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านตาก",
                            "listTumbon":[
                            {
                                "tumbon":"ตากออก",
                                "postcode":"63120"
                            },
                            {
                                "tumbon":"สมอโคน",
                                "postcode":"63120"
                            },
                            {
                                "tumbon":"แม่สลิด",
                                "postcode":"63120"
                            },
                            {
                                "tumbon":"ตากตก",
                                "postcode":"63120"
                            },
                            {
                                "tumbon":"เกาะตะเภา",
                                "postcode":"63120"
                            },
                            {
                                "tumbon":"ทุ่งกระเชาะ",
                                "postcode":"63120"
                            },
                            {
                                "tumbon":"ท้องฟ้า",
                                "postcode":"63120"
                            }
                            ]
                        },
                        {
                            "amphur":"สามเงา",
                            "listTumbon":[
                            {
                                "tumbon":"สามเงา",
                                "postcode":"63130"
                            },
                            {
                                "tumbon":"วังหมัน",
                                "postcode":"63130"
                            },
                            {
                                "tumbon":"ยกกระบัตร",
                                "postcode":"63130"
                            },
                            {
                                "tumbon":"ย่านรี",
                                "postcode":"63130"
                            },
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"63130"
                            },
                            {
                                "tumbon":"วังจันทร์",
                                "postcode":"63130"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่ระมาด",
                            "listTumbon":[
                            {
                                "tumbon":"แม่ระมาด",
                                "postcode":"63140"
                            },
                            {
                                "tumbon":"แม่จะเรา",
                                "postcode":"63140"
                            },
                            {
                                "tumbon":"ขะเนจื้อ",
                                "postcode":"63140"
                            },
                            {
                                "tumbon":"แม่ตื่น",
                                "postcode":"63140"
                            },
                            {
                                "tumbon":"สามหมื่น",
                                "postcode":"63140"
                            },
                            {
                                "tumbon":"พระธาตุ",
                                "postcode":"63140"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าสองยาง",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าสองยาง",
                                "postcode":"63150"
                            },
                            {
                                "tumbon":"แม่ต้าน",
                                "postcode":"63150"
                            },
                            {
                                "tumbon":"แม่สอง",
                                "postcode":"63150"
                            },
                            {
                                "tumbon":"แม่หละ",
                                "postcode":"63150"
                            },
                            {
                                "tumbon":"แม่วะหลวง",
                                "postcode":"63150"
                            },
                            {
                                "tumbon":"แม่อุสุ",
                                "postcode":"63150"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่สอด",
                            "listTumbon":[
                            {
                                "tumbon":"แม่สอด",
                                "postcode":"63110"
                            },
                            {
                                "tumbon":"แม่กุ",
                                "postcode":"63110"
                            },
                            {
                                "tumbon":"พะวอ",
                                "postcode":"63110"
                            },
                            {
                                "tumbon":"แม่ตาว",
                                "postcode":"63110"
                            },
                            {
                                "tumbon":"แม่กาษา",
                                "postcode":"63110"
                            },
                            {
                                "tumbon":"ท่าสายลวด",
                                "postcode":"63110"
                            },
                            {
                                "tumbon":"แม่ปะ",
                                "postcode":"63110"
                            },
                            {
                                "tumbon":"มหาวัน",
                                "postcode":"63110"
                            },
                            {
                                "tumbon":"ด่านแม่ละเมา",
                                "postcode":"63110"
                            },
                            {
                                "tumbon":"พระธาตุผาแดง",
                                "postcode":"63110"
                            }
                            ]
                        },
                        {
                            "amphur":"พบพระ",
                            "listTumbon":[
                            {
                                "tumbon":"พบพระ",
                                "postcode":"63160"
                            },
                            {
                                "tumbon":"ช่องแคบ",
                                "postcode":"63160"
                            },
                            {
                                "tumbon":"คีรีราษฎร์",
                                "postcode":"63160"
                            },
                            {
                                "tumbon":"วาเล่ย์",
                                "postcode":"63160"
                            },
                            {
                                "tumbon":"รวมไทยพัฒนา",
                                "postcode":"63160"
                            }
                            ]
                        },
                        {
                            "amphur":"อุ้มผาง",
                            "listTumbon":[
                            {
                                "tumbon":"อุ้มผาง",
                                "postcode":"63170"
                            },
                            {
                                "tumbon":"หนองหลวง",
                                "postcode":"63170"
                            },
                            {
                                "tumbon":"โมโกร",
                                "postcode":"63170"
                            },
                            {
                                "tumbon":"แม่จัน",
                                "postcode":"63170"
                            },
                            {
                                "tumbon":"แม่ละมุ้ง",
                                "postcode":"63170"
                            },
                            {
                                "tumbon":"แม่กลอง",
                                "postcode":"63170"
                            }
                            ]
                        },
                        {
                            "amphur":"วังเจ้า",
                            "listTumbon":[
                            {
                                "tumbon":"เชียงทอง",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"นาโบสถ์",
                                "postcode":"63000"
                            },
                            {
                                "tumbon":"ประดาง",
                                "postcode":"63000"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"กำแพงเพชร",
                    "listAmphur":[
                        {
                            "amphur":"เมืองกำแพงเพชร",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"ไตรตรึงษ์",
                                "postcode":"62160"
                            },
                            {
                                "tumbon":"อ่างทอง",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"นาบ่อคำ",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"นครชุม",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"ทรงธรรม",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"ลานดอกไม้",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"หนองปลิง",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"คณฑี",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"นิคมทุ่งโพธิ์ทะเล",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"เทพนคร",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"วังทอง",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"ท่าขุนราม",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"คลองแม่ลาย",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"ธำมรงค์",
                                "postcode":"62160"
                            },
                            {
                                "tumbon":"สระแก้ว",
                                "postcode":"62000"
                            }
                            ]
                        },
                        {
                            "amphur":"ไทรงาม",
                            "listTumbon":[
                            {
                                "tumbon":"ไทรงาม",
                                "postcode":"62150"
                            },
                            {
                                "tumbon":"หนองคล้า",
                                "postcode":"62150"
                            },
                            {
                                "tumbon":"หนองทอง",
                                "postcode":"62150"
                            },
                            {
                                "tumbon":"หนองไม้กอง",
                                "postcode":"62150"
                            },
                            {
                                "tumbon":"มหาชัย",
                                "postcode":"62150"
                            },
                            {
                                "tumbon":"พานทอง",
                                "postcode":"62150"
                            },
                            {
                                "tumbon":"หนองแม่แตง",
                                "postcode":"62150"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองลาน",
                            "listTumbon":[
                            {
                                "tumbon":"คลองน้ำไหล",
                                "postcode":"62180"
                            },
                            {
                                "tumbon":"โป่งน้ำร้อน",
                                "postcode":"62180"
                            },
                            {
                                "tumbon":"คลองลานพัฒนา",
                                "postcode":"62180"
                            },
                            {
                                "tumbon":"สักงาม",
                                "postcode":"62180"
                            }
                            ]
                        },
                        {
                            "amphur":"ขาณุวรลักษบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ยางสูง",
                                "postcode":"62130"
                            },
                            {
                                "tumbon":"ป่าพุทรา",
                                "postcode":"62130"
                            },
                            {
                                "tumbon":"แสนตอ",
                                "postcode":"62130"
                            },
                            {
                                "tumbon":"สลกบาตร",
                                "postcode":"62140"
                            },
                            {
                                "tumbon":"บ่อถ้ำ",
                                "postcode":"62140"
                            },
                            {
                                "tumbon":"ดอนแตง",
                                "postcode":"62140"
                            },
                            {
                                "tumbon":"วังชะพลู",
                                "postcode":"62140"
                            },
                            {
                                "tumbon":"โค้งไผ่",
                                "postcode":"62140"
                            },
                            {
                                "tumbon":"ปางมะค่า",
                                "postcode":"62140"
                            },
                            {
                                "tumbon":"วังหามแห",
                                "postcode":"62140"
                            },
                            {
                                "tumbon":"เกาะตาล",
                                "postcode":"62130"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองขลุง",
                            "listTumbon":[
                            {
                                "tumbon":"คลองขลุง",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"ท่ามะเขือ",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"ท่าพุทรา",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"แม่ลาด",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"วังยาง",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"วังแขม",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"หัวถนน",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"วังไทร",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"วังบัว",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"คลองสมบูรณ์",
                                "postcode":"62120"
                            }
                            ]
                        },
                        {
                            "amphur":"พรานกระต่าย",
                            "listTumbon":[
                            {
                                "tumbon":"พรานกระต่าย",
                                "postcode":"62110"
                            },
                            {
                                "tumbon":"หนองหัววัว",
                                "postcode":"62110"
                            },
                            {
                                "tumbon":"ท่าไม้",
                                "postcode":"62110"
                            },
                            {
                                "tumbon":"วังควง",
                                "postcode":"62110"
                            },
                            {
                                "tumbon":"วังตะแบก",
                                "postcode":"62110"
                            },
                            {
                                "tumbon":"เขาคีริส",
                                "postcode":"62110"
                            },
                            {
                                "tumbon":"คุยบ้านโอง",
                                "postcode":"62110"
                            },
                            {
                                "tumbon":"ถ้ำกระต่ายทอง",
                                "postcode":"62110"
                            },
                            {
                                "tumbon":"คลองพิไกร",
                                "postcode":"62110"
                            },
                            {
                                "tumbon":"ห้วยยั้ง",
                                "postcode":"62110"
                            }
                            ]
                        },
                        {
                            "amphur":"ลานกระบือ",
                            "listTumbon":[
                            {
                                "tumbon":"ลานกระบือ",
                                "postcode":"62170"
                            },
                            {
                                "tumbon":"ช่องลม",
                                "postcode":"62170"
                            },
                            {
                                "tumbon":"หนองหลวง",
                                "postcode":"62170"
                            },
                            {
                                "tumbon":"โนนพลวง",
                                "postcode":"62170"
                            },
                            {
                                "tumbon":"ประชาสุขสันต์",
                                "postcode":"62170"
                            },
                            {
                                "tumbon":"บึงทับแรต",
                                "postcode":"62170"
                            },
                            {
                                "tumbon":"จันทิมา",
                                "postcode":"62170"
                            }
                            ]
                        },
                        {
                            "amphur":"ทรายทองวัฒนา",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งทราย",
                                "postcode":"62190"
                            },
                            {
                                "tumbon":"ทุ่งทอง",
                                "postcode":"62190"
                            },
                            {
                                "tumbon":"ถาวรวัฒนา",
                                "postcode":"62190"
                            }
                            ]
                        },
                        {
                            "amphur":"ปางศิลาทอง",
                            "listTumbon":[
                            {
                                "tumbon":"โพธิ์ทอง",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"หินดาต",
                                "postcode":"62120"
                            },
                            {
                                "tumbon":"ปางตาไว",
                                "postcode":"62120"
                            }
                            ]
                        },
                        {
                            "amphur":"บึงสามัคคี",
                            "listTumbon":[
                            {
                                "tumbon":"บึงสามัคคี",
                                "postcode":"62210"
                            },
                            {
                                "tumbon":"วังชะโอน",
                                "postcode":"62210"
                            },
                            {
                                "tumbon":"ระหาน",
                                "postcode":"62210"
                            },
                            {
                                "tumbon":"เทพนิมิต",
                                "postcode":"62210"
                            }
                            ]
                        },
                        {
                            "amphur":"โกสัมพีนคร",
                            "listTumbon":[
                            {
                                "tumbon":"โกสัมพี",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"เพชรชมภู",
                                "postcode":"62000"
                            },
                            {
                                "tumbon":"ลานดอกไม้ตก",
                                "postcode":"62000"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สุโขทัย",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสุโขทัย",
                            "listTumbon":[
                            {
                                "tumbon":"ธานี",
                                "postcode":"64000"
                            },
                            {
                                "tumbon":"บ้านสวน",
                                "postcode":"64220"
                            },
                            {
                                "tumbon":"เมืองเก่า",
                                "postcode":"64210"
                            },
                            {
                                "tumbon":"ปากแคว",
                                "postcode":"64000"
                            },
                            {
                                "tumbon":"ยางซ้าย",
                                "postcode":"64000"
                            },
                            {
                                "tumbon":"บ้านกล้วย",
                                "postcode":"64000"
                            },
                            {
                                "tumbon":"บ้านหลุม",
                                "postcode":"64000"
                            },
                            {
                                "tumbon":"ตาลเตี้ย",
                                "postcode":"64220"
                            },
                            {
                                "tumbon":"ปากพระ",
                                "postcode":"64000"
                            },
                            {
                                "tumbon":"วังทองแดง",
                                "postcode":"64210"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านด่านลานหอย",
                            "listTumbon":[
                            {
                                "tumbon":"ลานหอย",
                                "postcode":"64140"
                            },
                            {
                                "tumbon":"บ้านด่าน",
                                "postcode":"64140"
                            },
                            {
                                "tumbon":"วังตะคร้อ",
                                "postcode":"64140"
                            },
                            {
                                "tumbon":"วังน้ำขาว",
                                "postcode":"64140"
                            },
                            {
                                "tumbon":"ตลิ่งชัน",
                                "postcode":"64140"
                            },
                            {
                                "tumbon":"หนองหญ้าปล้อง",
                                "postcode":"64140"
                            },
                            {
                                "tumbon":"วังลึก",
                                "postcode":"64140"
                            }
                            ]
                        },
                        {
                            "amphur":"คีรีมาศ",
                            "listTumbon":[
                            {
                                "tumbon":"โตนด",
                                "postcode":"64160"
                            },
                            {
                                "tumbon":"ทุ่งหลวง",
                                "postcode":"64160"
                            },
                            {
                                "tumbon":"บ้านป้อม",
                                "postcode":"64160"
                            },
                            {
                                "tumbon":"สามพวง",
                                "postcode":"64160"
                            },
                            {
                                "tumbon":"ศรีคีรีมาศ",
                                "postcode":"64160"
                            },
                            {
                                "tumbon":"หนองจิก",
                                "postcode":"64160"
                            },
                            {
                                "tumbon":"นาเชิงคีรี",
                                "postcode":"64160"
                            },
                            {
                                "tumbon":"หนองกระดิ่ง",
                                "postcode":"64160"
                            },
                            {
                                "tumbon":"บ้านน้ำพุ",
                                "postcode":"64160"
                            },
                            {
                                "tumbon":"ทุ่งยางเมือง",
                                "postcode":"64160"
                            }
                            ]
                        },
                        {
                            "amphur":"กงไกรลาศ",
                            "listTumbon":[
                            {
                                "tumbon":"กง",
                                "postcode":"64170"
                            },
                            {
                                "tumbon":"บ้านกร่าง",
                                "postcode":"64170"
                            },
                            {
                                "tumbon":"ไกรนอก",
                                "postcode":"64170"
                            },
                            {
                                "tumbon":"ไกรกลาง",
                                "postcode":"64170"
                            },
                            {
                                "tumbon":"ไกรใน",
                                "postcode":"64170"
                            },
                            {
                                "tumbon":"ดงเดือย",
                                "postcode":"64170"
                            },
                            {
                                "tumbon":"ป่าแฝก",
                                "postcode":"64170"
                            },
                            {
                                "tumbon":"กกแรต",
                                "postcode":"64170"
                            },
                            {
                                "tumbon":"ท่าฉนวน",
                                "postcode":"64170"
                            },
                            {
                                "tumbon":"หนองตูม",
                                "postcode":"64170"
                            },
                            {
                                "tumbon":"บ้านใหม่สุขเกษม",
                                "postcode":"64170"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีสัชนาลัย",
                            "listTumbon":[
                            {
                                "tumbon":"หาดเสี้ยว",
                                "postcode":"64130"
                            },
                            {
                                "tumbon":"ป่างิ้ว",
                                "postcode":"64130"
                            },
                            {
                                "tumbon":"แม่สำ",
                                "postcode":"64130"
                            },
                            {
                                "tumbon":"แม่สิน",
                                "postcode":"64130"
                            },
                            {
                                "tumbon":"บ้านตึก",
                                "postcode":"64130"
                            },
                            {
                                "tumbon":"หนองอ้อ",
                                "postcode":"64130"
                            },
                            {
                                "tumbon":"ท่าชัย",
                                "postcode":"64190"
                            },
                            {
                                "tumbon":"ศรีสัชนาลัย",
                                "postcode":"64190"
                            },
                            {
                                "tumbon":"ดงคู่",
                                "postcode":"64130"
                            },
                            {
                                "tumbon":"บ้านแก่ง",
                                "postcode":"64130"
                            },
                            {
                                "tumbon":"สารจิตร",
                                "postcode":"64130"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีสำโรง",
                            "listTumbon":[
                            {
                                "tumbon":"คลองตาล",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"วังลึก",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"สามเรือน",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"วังทอง",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"นาขุนไกร",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"เกาะตาเลี้ยง",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"วัดเกาะ",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"บ้านไร่",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"ทับผึ้ง",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"บ้านซ่าน",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"วังใหญ่",
                                "postcode":"64120"
                            },
                            {
                                "tumbon":"ราวต้นจันทร์",
                                "postcode":"64120"
                            }
                            ]
                        },
                        {
                            "amphur":"สวรรคโลก",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"คลองกระจง",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"วังพิณพาทย์",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"วังไม้ขอน",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"ย่านยาว",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"นาทุ่ง",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"คลองยาง",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"เมืองบางยม",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"ท่าทอง",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"ปากน้ำ",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"ป่ากุมเกาะ",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"เมืองบางขลัง",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"หนองกลับ",
                                "postcode":"64110"
                            },
                            {
                                "tumbon":"เมืองสวรรคโลก",
                                "postcode":"64110"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีนคร",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีนคร",
                                "postcode":"64180"
                            },
                            {
                                "tumbon":"นครเดิฐ",
                                "postcode":"64180"
                            },
                            {
                                "tumbon":"น้ำขุม",
                                "postcode":"64180"
                            },
                            {
                                "tumbon":"คลองมะพลับ",
                                "postcode":"64180"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"64180"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งเสลี่ยม",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านใหม่ไชยมงคล",
                                "postcode":"64230"
                            },
                            {
                                "tumbon":"ไทยชนะศึก",
                                "postcode":"64150"
                            },
                            {
                                "tumbon":"ทุ่งเสลี่ยม",
                                "postcode":"64150"
                            },
                            {
                                "tumbon":"กลางดง",
                                "postcode":"64150"
                            },
                            {
                                "tumbon":"เขาแก้วศรีสมบูรณ์",
                                "postcode":"64230"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"พิษณุโลก",
                    "listAmphur":[
                        {
                            "amphur":"เมืองพิษณุโลก",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"วังน้ำคู้",
                                "postcode":"65230"
                            },
                            {
                                "tumbon":"วัดจันทร์",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"วัดพริก",
                                "postcode":"65230"
                            },
                            {
                                "tumbon":"ท่าทอง",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"ท่าโพธิ์",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"สมอแข",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"ดอนทอง",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"บ้านป่า",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"ปากโทก",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"หัวรอ",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"จอมทอง",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"บ้านกร่าง",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"บ้านคลอง",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"พลายชุมพล",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"มะขามสูง",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"อรัญญิก",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"บึงพระ",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"ไผ่ขอดอน",
                                "postcode":"65000"
                            },
                            {
                                "tumbon":"งิ้วงาม",
                                "postcode":"65230"
                            }
                            ]
                        },
                        {
                            "amphur":"นครไทย",
                            "listTumbon":[
                            {
                                "tumbon":"นครไทย",
                                "postcode":"65120"
                            },
                            {
                                "tumbon":"หนองกะท้าว",
                                "postcode":"65120"
                            },
                            {
                                "tumbon":"บ้านแยง",
                                "postcode":"65120"
                            },
                            {
                                "tumbon":"เนินเพิ่ม",
                                "postcode":"65120"
                            },
                            {
                                "tumbon":"นาบัว",
                                "postcode":"65120"
                            },
                            {
                                "tumbon":"นครชุม",
                                "postcode":"65120"
                            },
                            {
                                "tumbon":"น้ำกุ่ม",
                                "postcode":"65120"
                            },
                            {
                                "tumbon":"ยางโกลน",
                                "postcode":"65120"
                            },
                            {
                                "tumbon":"บ่อโพธิ์",
                                "postcode":"65120"
                            },
                            {
                                "tumbon":"บ้านพร้าว",
                                "postcode":"65120"
                            },
                            {
                                "tumbon":"ห้วยเฮี้ย",
                                "postcode":"65120"
                            }
                            ]
                        },
                        {
                            "amphur":"ชาติตระการ",
                            "listTumbon":[
                            {
                                "tumbon":"ป่าแดง",
                                "postcode":"65170"
                            },
                            {
                                "tumbon":"ชาติตระการ",
                                "postcode":"65170"
                            },
                            {
                                "tumbon":"สวนเมี่ยง",
                                "postcode":"65170"
                            },
                            {
                                "tumbon":"บ้านดง",
                                "postcode":"65170"
                            },
                            {
                                "tumbon":"บ่อภาค",
                                "postcode":"65170"
                            },
                            {
                                "tumbon":"ท่าสะแก",
                                "postcode":"65170"
                            }
                            ]
                        },
                        {
                            "amphur":"บางระกำ",
                            "listTumbon":[
                            {
                                "tumbon":"บางระกำ",
                                "postcode":"65140"
                            },
                            {
                                "tumbon":"ปลักแรด",
                                "postcode":"65140"
                            },
                            {
                                "tumbon":"พันเสา",
                                "postcode":"65140"
                            },
                            {
                                "tumbon":"วังอิทก",
                                "postcode":"65140"
                            },
                            {
                                "tumbon":"บึงกอก",
                                "postcode":"65140"
                            },
                            {
                                "tumbon":"หนองกุลา",
                                "postcode":"65140"
                            },
                            {
                                "tumbon":"ชุมแสงสงคราม",
                                "postcode":"65240"
                            },
                            {
                                "tumbon":"นิคมพัฒนา",
                                "postcode":"65140"
                            },
                            {
                                "tumbon":"บ่อทอง",
                                "postcode":"65140"
                            },
                            {
                                "tumbon":"ท่านางงาม",
                                "postcode":"65140"
                            },
                            {
                                "tumbon":"คุยม่วง",
                                "postcode":"65240"
                            }
                            ]
                        },
                        {
                            "amphur":"บางกระทุ่ม",
                            "listTumbon":[
                            {
                                "tumbon":"บางกระทุ่ม",
                                "postcode":"65110"
                            },
                            {
                                "tumbon":"บ้านไร่",
                                "postcode":"65110"
                            },
                            {
                                "tumbon":"โคกสลุด",
                                "postcode":"65110"
                            },
                            {
                                "tumbon":"สนามคลี",
                                "postcode":"65110"
                            },
                            {
                                "tumbon":"ท่าตาล",
                                "postcode":"65110"
                            },
                            {
                                "tumbon":"ไผ่ล้อม",
                                "postcode":"65110"
                            },
                            {
                                "tumbon":"นครป่าหมาก",
                                "postcode":"65110"
                            },
                            {
                                "tumbon":"เนินกุ่ม",
                                "postcode":"65210"
                            },
                            {
                                "tumbon":"วัดตายม",
                                "postcode":"65210"
                            }
                            ]
                        },
                        {
                            "amphur":"พรหมพิราม",
                            "listTumbon":[
                            {
                                "tumbon":"พรหมพิราม",
                                "postcode":"65150"
                            },
                            {
                                "tumbon":"ท่าช้าง",
                                "postcode":"65150"
                            },
                            {
                                "tumbon":"วงฆ้อง",
                                "postcode":"65180"
                            },
                            {
                                "tumbon":"มะตูม",
                                "postcode":"65150"
                            },
                            {
                                "tumbon":"หอกลอง",
                                "postcode":"65150"
                            },
                            {
                                "tumbon":"ศรีภิรมย์",
                                "postcode":"65180"
                            },
                            {
                                "tumbon":"ตลุกเทียม",
                                "postcode":"65180"
                            },
                            {
                                "tumbon":"วังวน",
                                "postcode":"65150"
                            },
                            {
                                "tumbon":"หนองแขม",
                                "postcode":"65150"
                            },
                            {
                                "tumbon":"มะต้อง",
                                "postcode":"65180"
                            },
                            {
                                "tumbon":"ทับยายเชียง",
                                "postcode":"65150"
                            },
                            {
                                "tumbon":"ดงประคำ",
                                "postcode":"65180"
                            }
                            ]
                        },
                        {
                            "amphur":"วัดโบสถ์",
                            "listTumbon":[
                            {
                                "tumbon":"วัดโบสถ์",
                                "postcode":"65160"
                            },
                            {
                                "tumbon":"ท่างาม",
                                "postcode":"65160"
                            },
                            {
                                "tumbon":"ท้อแท้",
                                "postcode":"65160"
                            },
                            {
                                "tumbon":"บ้านยาง",
                                "postcode":"65160"
                            },
                            {
                                "tumbon":"หินลาด",
                                "postcode":"65160"
                            },
                            {
                                "tumbon":"คันโช้ง",
                                "postcode":"65160"
                            }
                            ]
                        },
                        {
                            "amphur":"วังทอง",
                            "listTumbon":[
                            {
                                "tumbon":"วังทอง",
                                "postcode":"65130"
                            },
                            {
                                "tumbon":"พันชาลี",
                                "postcode":"65130"
                            },
                            {
                                "tumbon":"แม่ระกา",
                                "postcode":"65130"
                            },
                            {
                                "tumbon":"บ้านกลาง",
                                "postcode":"65220"
                            },
                            {
                                "tumbon":"วังพิกุล",
                                "postcode":"65130"
                            },
                            {
                                "tumbon":"แก่งโสภา",
                                "postcode":"65220"
                            },
                            {
                                "tumbon":"ท่าหมื่นราม",
                                "postcode":"65130"
                            },
                            {
                                "tumbon":"วังนกแอ่น",
                                "postcode":"65130"
                            },
                            {
                                "tumbon":"หนองพระ",
                                "postcode":"65130"
                            },
                            {
                                "tumbon":"ชัยนาม",
                                "postcode":"65130"
                            },
                            {
                                "tumbon":"ดินทอง",
                                "postcode":"65130"
                            }
                            ]
                        },
                        {
                            "amphur":"เนินมะปราง",
                            "listTumbon":[
                            {
                                "tumbon":"ชมพู",
                                "postcode":"65190"
                            },
                            {
                                "tumbon":"บ้านมุง",
                                "postcode":"65190"
                            },
                            {
                                "tumbon":"ไทรย้อย",
                                "postcode":"65190"
                            },
                            {
                                "tumbon":"วังโพรง",
                                "postcode":"65190"
                            },
                            {
                                "tumbon":"บ้านน้อยซุ้มขี้เหล็ก",
                                "postcode":"65190"
                            },
                            {
                                "tumbon":"เนินมะปราง",
                                "postcode":"65190"
                            },
                            {
                                "tumbon":"วังยาง",
                                "postcode":"65190"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"พิจิตร",
                    "listAmphur":[
                        {
                            "amphur":"เมืองพิจิตร",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"ไผ่ขวาง",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"ย่านยาว",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"ท่าฬ่อ",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"ปากทาง",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"คลองคะเชนทร์",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"โรงช้าง",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"เมืองเก่า",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"ท่าหลวง",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"บ้านบุ่ง",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"ฆะมัง",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"ดงป่าคำ",
                                "postcode":"66170"
                            },
                            {
                                "tumbon":"หัวดง",
                                "postcode":"66170"
                            },
                            {
                                "tumbon":"ป่ามะคาบ",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"สายคำโห้",
                                "postcode":"66000"
                            },
                            {
                                "tumbon":"ดงกลาง",
                                "postcode":"66170"
                            }
                            ]
                        },
                        {
                            "amphur":"วังทรายพูน",
                            "listTumbon":[
                            {
                                "tumbon":"วังทรายพูน",
                                "postcode":"66180"
                            },
                            {
                                "tumbon":"หนองปลาไหล",
                                "postcode":"66180"
                            },
                            {
                                "tumbon":"หนองพระ",
                                "postcode":"66180"
                            },
                            {
                                "tumbon":"หนองปล้อง",
                                "postcode":"66180"
                            }
                            ]
                        },
                        {
                            "amphur":"โพธิ์ประทับช้าง",
                            "listTumbon":[
                            {
                                "tumbon":"โพธิ์ประทับช้าง",
                                "postcode":"66190"
                            },
                            {
                                "tumbon":"ไผ่ท่าโพ",
                                "postcode":"66190"
                            },
                            {
                                "tumbon":"วังจิก",
                                "postcode":"66190"
                            },
                            {
                                "tumbon":"ไผ่รอบ",
                                "postcode":"66190"
                            },
                            {
                                "tumbon":"ดงเสือเหลือง",
                                "postcode":"66190"
                            },
                            {
                                "tumbon":"เนินสว่าง",
                                "postcode":"66190"
                            },
                            {
                                "tumbon":"ทุ่งใหญ่",
                                "postcode":"66190"
                            }
                            ]
                        },
                        {
                            "amphur":"ตะพานหิน",
                            "listTumbon":[
                            {
                                "tumbon":"ตะพานหิน",
                                "postcode":"66110"
                            },
                            {
                                "tumbon":"งิ้วราย",
                                "postcode":"66110"
                            },
                            {
                                "tumbon":"ห้วยเกตุ",
                                "postcode":"66110"
                            },
                            {
                                "tumbon":"ไทรโรงโขน",
                                "postcode":"66110"
                            },
                            {
                                "tumbon":"หนองพยอม",
                                "postcode":"66110"
                            },
                            {
                                "tumbon":"ทุ่งโพธิ์",
                                "postcode":"66150"
                            },
                            {
                                "tumbon":"ดงตะขบ",
                                "postcode":"66110"
                            },
                            {
                                "tumbon":"คลองคูณ",
                                "postcode":"66110"
                            },
                            {
                                "tumbon":"วังสำโรง",
                                "postcode":"66110"
                            },
                            {
                                "tumbon":"วังหว้า",
                                "postcode":"66110"
                            },
                            {
                                "tumbon":"วังหลุม",
                                "postcode":"66150"
                            },
                            {
                                "tumbon":"ทับหมัน",
                                "postcode":"66110"
                            },
                            {
                                "tumbon":"ไผ่หลวง",
                                "postcode":"66110"
                            }
                            ]
                        },
                        {
                            "amphur":"บางมูลนาก",
                            "listTumbon":[
                            {
                                "tumbon":"บางมูลนาก",
                                "postcode":"66120"
                            },
                            {
                                "tumbon":"บางไผ่",
                                "postcode":"66120"
                            },
                            {
                                "tumbon":"หอไกร",
                                "postcode":"66120"
                            },
                            {
                                "tumbon":"เนินมะกอก",
                                "postcode":"66120"
                            },
                            {
                                "tumbon":"วังสำโรง",
                                "postcode":"66120"
                            },
                            {
                                "tumbon":"ภูมิ",
                                "postcode":"66120"
                            },
                            {
                                "tumbon":"วังกรด",
                                "postcode":"66120"
                            },
                            {
                                "tumbon":"ห้วยเขน",
                                "postcode":"66120"
                            },
                            {
                                "tumbon":"วังตะกู",
                                "postcode":"66210"
                            },
                            {
                                "tumbon":"ลำประดา",
                                "postcode":"66120"
                            }
                            ]
                        },
                        {
                            "amphur":"โพทะเล",
                            "listTumbon":[
                            {
                                "tumbon":"โพทะเล",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"ท้ายน้ำ",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"ทะนง",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"ท่าบัว",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"ทุ่งน้อย",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"ท่าขมิ้น",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"ท่าเสา",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"บางคลาน",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"ท่านั่ง",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"บ้านน้อย",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"วัดขวาง",
                                "postcode":"66130"
                            }
                            ]
                        },
                        {
                            "amphur":"สามง่าม",
                            "listTumbon":[
                            {
                                "tumbon":"สามง่าม",
                                "postcode":"66140"
                            },
                            {
                                "tumbon":"กำแพงดิน",
                                "postcode":"66220"
                            },
                            {
                                "tumbon":"รังนก",
                                "postcode":"66140"
                            },
                            {
                                "tumbon":"เนินปอ",
                                "postcode":"66140"
                            },
                            {
                                "tumbon":"หนองโสน",
                                "postcode":"66140"
                            }
                            ]
                        },
                        {
                            "amphur":"ทับคล้อ",
                            "listTumbon":[
                            {
                                "tumbon":"ทับคล้อ",
                                "postcode":"66150"
                            },
                            {
                                "tumbon":"เขาทราย",
                                "postcode":"66230"
                            },
                            {
                                "tumbon":"เขาเจ็ดลูก",
                                "postcode":"66230"
                            },
                            {
                                "tumbon":"ท้ายทุ่ง",
                                "postcode":"66150"
                            }
                            ]
                        },
                        {
                            "amphur":"สากเหล็ก",
                            "listTumbon":[
                            {
                                "tumbon":"สากเหล็ก",
                                "postcode":"66160"
                            },
                            {
                                "tumbon":"ท่าเยี่ยม",
                                "postcode":"66160"
                            },
                            {
                                "tumbon":"คลองทราย",
                                "postcode":"66160"
                            },
                            {
                                "tumbon":"หนองหญ้าไทร",
                                "postcode":"66160"
                            },
                            {
                                "tumbon":"วังทับไทร",
                                "postcode":"66160"
                            }
                            ]
                        },
                        {
                            "amphur":"บึงนาราง",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยแก้ว",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"โพธิ์ไทรงาม",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"แหลมรัง",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"บางลาย",
                                "postcode":"66130"
                            },
                            {
                                "tumbon":"บึงนาราง",
                                "postcode":"66130"
                            }
                            ]
                        },
                        {
                            "amphur":"ดงเจริญ",
                            "listTumbon":[
                            {
                                "tumbon":"วังงิ้วใต้",
                                "postcode":"66210"
                            },
                            {
                                "tumbon":"วังงิ้ว",
                                "postcode":"66210"
                            },
                            {
                                "tumbon":"ห้วยร่วม",
                                "postcode":"66210"
                            },
                            {
                                "tumbon":"ห้วยพุก",
                                "postcode":"66210"
                            },
                            {
                                "tumbon":"สำนักขุนเณร",
                                "postcode":"66210"
                            }
                            ]
                        },
                        {
                            "amphur":"วชิรบารมี",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"66140"
                            },
                            {
                                "tumbon":"บึงบัว",
                                "postcode":"66140"
                            },
                            {
                                "tumbon":"วังโมกข์",
                                "postcode":"66140"
                            },
                            {
                                "tumbon":"หนองหลุม",
                                "postcode":"66220"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"เพชรบูรณ์",
                    "listAmphur":[
                        {
                            "amphur":"เมืองเพชรบูรณ์",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"ตะเบาะ",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"บ้านโตก",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"สะเดียง",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"ป่าเลา",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"นางั่ว",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"ท่าพล",
                                "postcode":"67250"
                            },
                            {
                                "tumbon":"ดงมูลเหล็ก",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"บ้านโคก",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"ชอนไพร",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"นาป่า",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"นายม",
                                "postcode":"67210"
                            },
                            {
                                "tumbon":"วังชมภู",
                                "postcode":"67210"
                            },
                            {
                                "tumbon":"น้ำร้อน",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"ห้วยสะแก",
                                "postcode":"67210"
                            },
                            {
                                "tumbon":"ห้วยใหญ่",
                                "postcode":"67000"
                            },
                            {
                                "tumbon":"ระวิง",
                                "postcode":"67210"
                            }
                            ]
                        },
                        {
                            "amphur":"ชนแดน",
                            "listTumbon":[
                            {
                                "tumbon":"ชนแดน",
                                "postcode":"67150"
                            },
                            {
                                "tumbon":"ดงขุย",
                                "postcode":"67190"
                            },
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"67150"
                            },
                            {
                                "tumbon":"พุทธบาท",
                                "postcode":"67150"
                            },
                            {
                                "tumbon":"ลาดแค",
                                "postcode":"67150"
                            },
                            {
                                "tumbon":"บ้านกล้วย",
                                "postcode":"67190"
                            },
                            {
                                "tumbon":"ซับพุทรา",
                                "postcode":"67150"
                            },
                            {
                                "tumbon":"ศาลาลาย",
                                "postcode":"67150"
                            },
                            {
                                "tumbon":"ตะกุดไร",
                                "postcode":"67190"
                            }
                            ]
                        },
                        {
                            "amphur":"หล่มสัก",
                            "listTumbon":[
                            {
                                "tumbon":"หล่มสัก",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"วัดป่า",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"ตาลเดี่ยว",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"ฝายนาแซง",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"หนองสว่าง",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"น้ำเฮี้ย",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"สักหลง",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"ท่าอิบุญ",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"บ้านโสก",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"บ้านติ้ว",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"ห้วยไร่",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"น้ำก้อ",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"ปากช่อง",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"น้ำชุน",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"หนองไขว่",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"ลานบ่า",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"บุ่งคล้า",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"บุ่งน้ำเต้า",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"บ้านกลาง",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"ช้างตะลูด",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"บ้านไร่",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"บ้านหวาย",
                                "postcode":"67110"
                            },
                            {
                                "tumbon":"ปากดุก",
                                "postcode":"67110"
                            }
                            ]
                        },
                        {
                            "amphur":"หล่มเก่า",
                            "listTumbon":[
                            {
                                "tumbon":"หล่มเก่า",
                                "postcode":"67120"
                            },
                            {
                                "tumbon":"นาซำ",
                                "postcode":"67120"
                            },
                            {
                                "tumbon":"หินฮาว",
                                "postcode":"67120"
                            },
                            {
                                "tumbon":"บ้านเนิน",
                                "postcode":"67120"
                            },
                            {
                                "tumbon":"ศิลา",
                                "postcode":"67120"
                            },
                            {
                                "tumbon":"นาแซง",
                                "postcode":"67120"
                            },
                            {
                                "tumbon":"วังบาล",
                                "postcode":"67120"
                            },
                            {
                                "tumbon":"นาเกาะ",
                                "postcode":"67120"
                            },
                            {
                                "tumbon":"ตาดกลอย",
                                "postcode":"67120"
                            }
                            ]
                        },
                        {
                            "amphur":"วิเชียรบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าโรง",
                                "postcode":"67130"
                            },
                            {
                                "tumbon":"สระประดู่",
                                "postcode":"67130"
                            },
                            {
                                "tumbon":"สามแยก",
                                "postcode":"67130"
                            },
                            {
                                "tumbon":"โคกปรง",
                                "postcode":"67130"
                            },
                            {
                                "tumbon":"น้ำร้อน",
                                "postcode":"67130"
                            },
                            {
                                "tumbon":"บ่อรัง",
                                "postcode":"67130"
                            },
                            {
                                "tumbon":"พุเตย",
                                "postcode":"67180"
                            },
                            {
                                "tumbon":"พุขาม",
                                "postcode":"67180"
                            },
                            {
                                "tumbon":"ภูน้ำหยด",
                                "postcode":"67180"
                            },
                            {
                                "tumbon":"ซับสมบูรณ์",
                                "postcode":"67180"
                            },
                            {
                                "tumbon":"บึงกระจับ",
                                "postcode":"67130"
                            },
                            {
                                "tumbon":"วังใหญ่",
                                "postcode":"67180"
                            },
                            {
                                "tumbon":"ยางสาว",
                                "postcode":"67130"
                            },
                            {
                                "tumbon":"ซับน้อย",
                                "postcode":"67180"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีเทพ",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีเทพ",
                                "postcode":"67170"
                            },
                            {
                                "tumbon":"สระกรวด",
                                "postcode":"67170"
                            },
                            {
                                "tumbon":"คลองกระจัง",
                                "postcode":"67170"
                            },
                            {
                                "tumbon":"นาสนุ่น",
                                "postcode":"67170"
                            },
                            {
                                "tumbon":"โคกสะอาด",
                                "postcode":"67170"
                            },
                            {
                                "tumbon":"หนองย่างทอย",
                                "postcode":"67170"
                            },
                            {
                                "tumbon":"ประดู่งาม",
                                "postcode":"67170"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองไผ่",
                            "listTumbon":[
                            {
                                "tumbon":"กองทูล",
                                "postcode":"67140"
                            },
                            {
                                "tumbon":"นาเฉลียง",
                                "postcode":"67220"
                            },
                            {
                                "tumbon":"บ้านโภชน์",
                                "postcode":"67140"
                            },
                            {
                                "tumbon":"ท่าแดง",
                                "postcode":"67140"
                            },
                            {
                                "tumbon":"เพชรละคร",
                                "postcode":"67140"
                            },
                            {
                                "tumbon":"บ่อไทย",
                                "postcode":"67140"
                            },
                            {
                                "tumbon":"ห้วยโป่ง",
                                "postcode":"67220"
                            },
                            {
                                "tumbon":"วังท่าดี",
                                "postcode":"67140"
                            },
                            {
                                "tumbon":"บัววัฒนา",
                                "postcode":"67140"
                            },
                            {
                                "tumbon":"หนองไผ่",
                                "postcode":"67140"
                            },
                            {
                                "tumbon":"วังโบสถ์",
                                "postcode":"67140"
                            },
                            {
                                "tumbon":"ท่าด้วง",
                                "postcode":"67140"
                            },
                            {
                                "tumbon":"ยางงาม",
                                "postcode":"67220"
                            }
                            ]
                        },
                        {
                            "amphur":"บึงสามพัน",
                            "listTumbon":[
                            {
                                "tumbon":"ซับสมอทอด",
                                "postcode":"67160"
                            },
                            {
                                "tumbon":"ซับไม้แดง",
                                "postcode":"67160"
                            },
                            {
                                "tumbon":"หนองแจง",
                                "postcode":"67160"
                            },
                            {
                                "tumbon":"กันจุ",
                                "postcode":"67160"
                            },
                            {
                                "tumbon":"วังพิกุล",
                                "postcode":"67230"
                            },
                            {
                                "tumbon":"พญาวัง",
                                "postcode":"67160"
                            },
                            {
                                "tumbon":"ศรีมงคล",
                                "postcode":"67160"
                            },
                            {
                                "tumbon":"บึงสามพัน",
                                "postcode":"67160"
                            },
                            {
                                "tumbon":"สระแก้ว",
                                "postcode":"67160"
                            }
                            ]
                        },
                        {
                            "amphur":"น้ำหนาว",
                            "listTumbon":[
                            {
                                "tumbon":"น้ำหนาว",
                                "postcode":"67260"
                            },
                            {
                                "tumbon":"หลักด่าน",
                                "postcode":"67260"
                            },
                            {
                                "tumbon":"วังกวาง",
                                "postcode":"67260"
                            },
                            {
                                "tumbon":"โคกมน",
                                "postcode":"67260"
                            }
                            ]
                        },
                        {
                            "amphur":"วังโป่ง",
                            "listTumbon":[
                            {
                                "tumbon":"วังโป่ง",
                                "postcode":"67240"
                            },
                            {
                                "tumbon":"ท้ายดง",
                                "postcode":"67240"
                            },
                            {
                                "tumbon":"ซับเปิบ",
                                "postcode":"67240"
                            },
                            {
                                "tumbon":"วังหิน",
                                "postcode":"67240"
                            },
                            {
                                "tumbon":"วังศาล",
                                "postcode":"67240"
                            }
                            ]
                        },
                        {
                            "amphur":"เขาค้อ",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งสมอ",
                                "postcode":"67270"
                            },
                            {
                                "tumbon":"แคมป์สน",
                                "postcode":"67280"
                            },
                            {
                                "tumbon":"เขาค้อ",
                                "postcode":"67270"
                            },
                            {
                                "tumbon":"ริมสีม่วง",
                                "postcode":"67270"
                            },
                            {
                                "tumbon":"สะเดาะพง",
                                "postcode":"67270"
                            },
                            {
                                "tumbon":"หนองแม่นา",
                                "postcode":"67270"
                            },
                            {
                                "tumbon":"เข็กน้อย",
                                "postcode":"67280"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"แพร่",
                    "listAmphur":[
                        {
                            "amphur":"เมืองแพร่",
                            "listTumbon":[
                            {
                                "tumbon":"ในเวียง",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"นาจักร",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"น้ำชำ",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"ป่าแดง",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"ทุ่งโฮ้ง",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"เหมืองหม้อ",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"วังธง",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"แม่หล่าย",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"ห้วยม้า",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"ป่าแมต",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"บ้านถิ่น",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"สวนเขื่อน",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"วังหงษ์",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"แม่คำมี",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"ทุ่งกวาว",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"แม่ยม",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"ช่อแฮ",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"ร่องฟอง",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"กาญจนา",
                                "postcode":"54000"
                            }
                            ]
                        },
                        {
                            "amphur":"ร้องกวาง",
                            "listTumbon":[
                            {
                                "tumbon":"ร้องกวาง",
                                "postcode":"54140"
                            },
                            {
                                "tumbon":"ร้องเข็ม",
                                "postcode":"54140"
                            },
                            {
                                "tumbon":"น้ำเลา",
                                "postcode":"54140"
                            },
                            {
                                "tumbon":"บ้านเวียง",
                                "postcode":"54140"
                            },
                            {
                                "tumbon":"ทุ่งศรี",
                                "postcode":"54140"
                            },
                            {
                                "tumbon":"แม่ยางตาล",
                                "postcode":"54140"
                            },
                            {
                                "tumbon":"แม่ยางฮ่อ",
                                "postcode":"54140"
                            },
                            {
                                "tumbon":"ไผ่โทน",
                                "postcode":"54140"
                            },
                            {
                                "tumbon":"ห้วยโรง",
                                "postcode":"54140"
                            },
                            {
                                "tumbon":"แม่ทราย",
                                "postcode":"54140"
                            },
                            {
                                "tumbon":"แม่ยางร้อง",
                                "postcode":"54140"
                            }
                            ]
                        },
                        {
                            "amphur":"ลอง",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยอ้อ",
                                "postcode":"54150"
                            },
                            {
                                "tumbon":"บ้านปิน",
                                "postcode":"54150"
                            },
                            {
                                "tumbon":"ต้าผามอก",
                                "postcode":"54150"
                            },
                            {
                                "tumbon":"เวียงต้า",
                                "postcode":"54150"
                            },
                            {
                                "tumbon":"ปากกาง",
                                "postcode":"54150"
                            },
                            {
                                "tumbon":"หัวทุ่ง",
                                "postcode":"54150"
                            },
                            {
                                "tumbon":"ทุ่งแล้ง",
                                "postcode":"54150"
                            },
                            {
                                "tumbon":"บ่อเหล็กลอง",
                                "postcode":"54150"
                            },
                            {
                                "tumbon":"แม่ปาน",
                                "postcode":"54150"
                            }
                            ]
                        },
                        {
                            "amphur":"สูงเม่น",
                            "listTumbon":[
                            {
                                "tumbon":"สูงเม่น",
                                "postcode":"54130"
                            },
                            {
                                "tumbon":"น้ำชำ",
                                "postcode":"54130"
                            },
                            {
                                "tumbon":"หัวฝาย",
                                "postcode":"54130"
                            },
                            {
                                "tumbon":"ดอนมูล",
                                "postcode":"54130"
                            },
                            {
                                "tumbon":"บ้านเหล่า",
                                "postcode":"54130"
                            },
                            {
                                "tumbon":"บ้านกวาง",
                                "postcode":"54130"
                            },
                            {
                                "tumbon":"บ้านปง",
                                "postcode":"54130"
                            },
                            {
                                "tumbon":"บ้านกาศ",
                                "postcode":"54130"
                            },
                            {
                                "tumbon":"ร่องกาศ",
                                "postcode":"54130"
                            },
                            {
                                "tumbon":"สบสาย",
                                "postcode":"54130"
                            },
                            {
                                "tumbon":"เวียงทอง",
                                "postcode":"54000"
                            },
                            {
                                "tumbon":"พระหลวง",
                                "postcode":"54130"
                            }
                            ]
                        },
                        {
                            "amphur":"เด่นชัย",
                            "listTumbon":[
                            {
                                "tumbon":"เด่นชัย",
                                "postcode":"54110"
                            },
                            {
                                "tumbon":"แม่จั๊วะ",
                                "postcode":"54110"
                            },
                            {
                                "tumbon":"ไทรย้อย",
                                "postcode":"54110"
                            },
                            {
                                "tumbon":"ห้วยไร่",
                                "postcode":"54110"
                            },
                            {
                                "tumbon":"ปงป่าหวาย",
                                "postcode":"54110"
                            }
                            ]
                        },
                        {
                            "amphur":"สอง",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านหนุน",
                                "postcode":"54120"
                            },
                            {
                                "tumbon":"บ้านกลาง",
                                "postcode":"54120"
                            },
                            {
                                "tumbon":"ห้วยหม้าย",
                                "postcode":"54120"
                            },
                            {
                                "tumbon":"เตาปูน",
                                "postcode":"54120"
                            },
                            {
                                "tumbon":"หัวเมือง",
                                "postcode":"54120"
                            },
                            {
                                "tumbon":"สะเอียบ",
                                "postcode":"54120"
                            },
                            {
                                "tumbon":"แดนชุมพล",
                                "postcode":"54120"
                            },
                            {
                                "tumbon":"ทุ่งน้าว",
                                "postcode":"54120"
                            }
                            ]
                        },
                        {
                            "amphur":"วังชิ้น",
                            "listTumbon":[
                            {
                                "tumbon":"วังชิ้น",
                                "postcode":"54160"
                            },
                            {
                                "tumbon":"สรอย",
                                "postcode":"54160"
                            },
                            {
                                "tumbon":"แม่ป้าก",
                                "postcode":"54160"
                            },
                            {
                                "tumbon":"นาพูน",
                                "postcode":"54160"
                            },
                            {
                                "tumbon":"แม่พุง",
                                "postcode":"54160"
                            },
                            {
                                "tumbon":"ป่าสัก",
                                "postcode":"54160"
                            },
                            {
                                "tumbon":"แม่เกิ๋ง",
                                "postcode":"54160"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองม่วงไข่",
                            "listTumbon":[
                            {
                                "tumbon":"แม่คำมี",
                                "postcode":"54170"
                            },
                            {
                                "tumbon":"หนองม่วงไข่",
                                "postcode":"54170"
                            },
                            {
                                "tumbon":"น้ำรัด",
                                "postcode":"54170"
                            },
                            {
                                "tumbon":"วังหลวง",
                                "postcode":"54170"
                            },
                            {
                                "tumbon":"ตำหนักธรรม",
                                "postcode":"54170"
                            },
                            {
                                "tumbon":"ทุ่งแค้ว",
                                "postcode":"54170"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"น่าน",
                    "listAmphur":[
                        {
                            "amphur":"เมืองน่าน",
                            "listTumbon":[
                            {
                                "tumbon":"ในเวียง",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"บ่อ",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"ผาสิงห์",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"ไชยสถาน",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"ถืมตอง",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"เรือง",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"นาซาว",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"ดู่ใต้",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"กองควาย",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"สวก",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"สะเนียน",
                                "postcode":"55000"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่จริม",
                            "listTumbon":[
                            {
                                "tumbon":"หนองแดง",
                                "postcode":"55170"
                            },
                            {
                                "tumbon":"หมอเมือง",
                                "postcode":"55170"
                            },
                            {
                                "tumbon":"น้ำพาง",
                                "postcode":"55170"
                            },
                            {
                                "tumbon":"น้ำปาย",
                                "postcode":"55170"
                            },
                            {
                                "tumbon":"แม่จริม",
                                "postcode":"55170"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านฟ้า",
                                "postcode":"55190"
                            },
                            {
                                "tumbon":"ป่าคาหลวง",
                                "postcode":"55190"
                            },
                            {
                                "tumbon":"สวด",
                                "postcode":"55190"
                            },
                            {
                                "tumbon":"บ้านพี้",
                                "postcode":"55190"
                            }
                            ]
                        },
                        {
                            "amphur":"นาน้อย",
                            "listTumbon":[
                            {
                                "tumbon":"นาน้อย",
                                "postcode":"55150"
                            },
                            {
                                "tumbon":"เชียงของ",
                                "postcode":"55150"
                            },
                            {
                                "tumbon":"ศรีษะเกษ",
                                "postcode":"55150"
                            },
                            {
                                "tumbon":"สถาน",
                                "postcode":"55150"
                            },
                            {
                                "tumbon":"สันทะ",
                                "postcode":"55150"
                            },
                            {
                                "tumbon":"บัวใหญ่",
                                "postcode":"55150"
                            },
                            {
                                "tumbon":"น้ำตก",
                                "postcode":"55150"
                            }
                            ]
                        },
                        {
                            "amphur":"ปัว",
                            "listTumbon":[
                            {
                                "tumbon":"ปัว",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"แงง",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"สถาน",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"ศิลาแลง",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"ศิลาเพชร",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"อวน",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"ไชยวัฒนา",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"เจดีย์ชัย",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"ภูคา",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"สกาด",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"ป่ากลาง",
                                "postcode":"55120"
                            },
                            {
                                "tumbon":"วรนคร",
                                "postcode":"55120"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าวังผา",
                            "listTumbon":[
                            {
                                "tumbon":"ริม",
                                "postcode":"55140"
                            },
                            {
                                "tumbon":"ป่าคา",
                                "postcode":"55140"
                            },
                            {
                                "tumbon":"ผาตอ",
                                "postcode":"55140"
                            },
                            {
                                "tumbon":"ยม",
                                "postcode":"55140"
                            },
                            {
                                "tumbon":"ตาลชุม",
                                "postcode":"55140"
                            },
                            {
                                "tumbon":"ศรีภูมิ",
                                "postcode":"55140"
                            },
                            {
                                "tumbon":"จอมพระ",
                                "postcode":"55140"
                            },
                            {
                                "tumbon":"แสนทอง",
                                "postcode":"55140"
                            },
                            {
                                "tumbon":"ท่าวังผา",
                                "postcode":"55140"
                            },
                            {
                                "tumbon":"ผาทอง",
                                "postcode":"55140"
                            }
                            ]
                        },
                        {
                            "amphur":"เวียงสา",
                            "listTumbon":[
                            {
                                "tumbon":"กลางเวียง",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"ขึ่ง",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"ไหล่น่าน",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"ตาลชุม",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"นาเหลือง",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"ส้าน",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"น้ำมวบ",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"น้ำปั้ว",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"ยาบหัวนา",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"ปงสนุก",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"อ่ายนาไลย",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"ส้านนาหนองใหม่",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"แม่ขะนิง",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"แม่สาคร",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"จอมจันทร์",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"แม่สา",
                                "postcode":"55110"
                            },
                            {
                                "tumbon":"ทุ่งศรีทอง",
                                "postcode":"55110"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งช้าง",
                            "listTumbon":[
                            {
                                "tumbon":"ปอน",
                                "postcode":"55130"
                            },
                            {
                                "tumbon":"งอบ",
                                "postcode":"55130"
                            },
                            {
                                "tumbon":"และ",
                                "postcode":"55130"
                            },
                            {
                                "tumbon":"ทุ่งช้าง",
                                "postcode":"55130"
                            }
                            ]
                        },
                        {
                            "amphur":"เชียงกลาง",
                            "listTumbon":[
                            {
                                "tumbon":"เชียงกลาง",
                                "postcode":"55160"
                            },
                            {
                                "tumbon":"เปือ",
                                "postcode":"55160"
                            },
                            {
                                "tumbon":"เชียงคาน",
                                "postcode":"55160"
                            },
                            {
                                "tumbon":"พระธาตุ",
                                "postcode":"55160"
                            },
                            {
                                "tumbon":"พญาแก้ว",
                                "postcode":"55160"
                            },
                            {
                                "tumbon":"พระพุทธบาท",
                                "postcode":"55160"
                            }
                            ]
                        },
                        {
                            "amphur":"นาหมื่น",
                            "listTumbon":[
                            {
                                "tumbon":"นาทะนุง",
                                "postcode":"55180"
                            },
                            {
                                "tumbon":"บ่อแก้ว",
                                "postcode":"55180"
                            },
                            {
                                "tumbon":"เมืองลี",
                                "postcode":"55180"
                            },
                            {
                                "tumbon":"ปิงหลวง",
                                "postcode":"55180"
                            }
                            ]
                        },
                        {
                            "amphur":"สันติสุข",
                            "listTumbon":[
                            {
                                "tumbon":"ดู่พงษ์",
                                "postcode":"55210"
                            },
                            {
                                "tumbon":"ป่าแลวหลวง",
                                "postcode":"55210"
                            },
                            {
                                "tumbon":"พงษ์",
                                "postcode":"55210"
                            }
                            ]
                        },
                        {
                            "amphur":"บ่อเกลือ",
                            "listTumbon":[
                            {
                                "tumbon":"บ่อเกลือเหนือ",
                                "postcode":"55220"
                            },
                            {
                                "tumbon":"บ่อเกลือใต้",
                                "postcode":"55220"
                            },
                            {
                                "tumbon":"ภูฟ้า",
                                "postcode":"55220"
                            },
                            {
                                "tumbon":"ดงพญา",
                                "postcode":"55220"
                            }
                            ]
                        },
                        {
                            "amphur":"สองแคว",
                            "listTumbon":[
                            {
                                "tumbon":"นาไร่หลวง",
                                "postcode":"55160"
                            },
                            {
                                "tumbon":"ชนแดน",
                                "postcode":"55160"
                            },
                            {
                                "tumbon":"ยอด",
                                "postcode":"55160"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูเพียง",
                            "listTumbon":[
                            {
                                "tumbon":"ม่วงตึ๊ด",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"นาปัง",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"น้ำแก่น",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"น้ำเกี๋ยน",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"เมืองจัง",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"ท่าน้าว",
                                "postcode":"55000"
                            },
                            {
                                "tumbon":"ฝายแก้ว",
                                "postcode":"55000"
                            }
                            ]
                        },
                        {
                            "amphur":"เฉลิมพระเกียรติ",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยโก๋น",
                                "postcode":"55130"
                            },
                            {
                                "tumbon":"ขุนน่าน",
                                "postcode":"55130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"อุตรดิตถ์",
                    "listAmphur":[
                        {
                            "amphur":"เมืองอุตรดิตถ์",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าอิฐ",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"ท่าเสา",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"บ้านเกาะ",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"ป่าเซ่า",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"คุ้งตะเภา",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"วังกะพี้",
                                "postcode":"53170"
                            },
                            {
                                "tumbon":"หาดกรวด",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"น้ำริด",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"งิ้วงาม",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"บ้านด่านนาขาม",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"บ้านด่าน",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"ผาจุก",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"วังดิน",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"แสนตอ",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"หาดงิ้ว",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"ขุนฝาง",
                                "postcode":"53000"
                            },
                            {
                                "tumbon":"ถ้ำฉลอง",
                                "postcode":"53000"
                            }
                            ]
                        },
                        {
                            "amphur":"ตรอน",
                            "listTumbon":[
                            {
                                "tumbon":"วังแดง",
                                "postcode":"53140"
                            },
                            {
                                "tumbon":"บ้านแก่ง",
                                "postcode":"53140"
                            },
                            {
                                "tumbon":"หาดสองแคว",
                                "postcode":"53140"
                            },
                            {
                                "tumbon":"น้ำอ่าง",
                                "postcode":"53140"
                            },
                            {
                                "tumbon":"ข่อยสูง",
                                "postcode":"53140"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าปลา",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าปลา",
                                "postcode":"53150"
                            },
                            {
                                "tumbon":"หาดล้า",
                                "postcode":"53190"
                            },
                            {
                                "tumbon":"ผาเลือด",
                                "postcode":"53190"
                            },
                            {
                                "tumbon":"จริม",
                                "postcode":"53150"
                            },
                            {
                                "tumbon":"น้ำหมัน",
                                "postcode":"53150"
                            },
                            {
                                "tumbon":"ท่าแฝก",
                                "postcode":"53110"
                            },
                            {
                                "tumbon":"นางพญา",
                                "postcode":"53150"
                            },
                            {
                                "tumbon":"ร่วมจิต",
                                "postcode":"53190"
                            }
                            ]
                        },
                        {
                            "amphur":"น้ำปาด",
                            "listTumbon":[
                            {
                                "tumbon":"แสนตอ",
                                "postcode":"53110"
                            },
                            {
                                "tumbon":"บ้านฝาย",
                                "postcode":"53110"
                            },
                            {
                                "tumbon":"เด่นเหล็ก",
                                "postcode":"53110"
                            },
                            {
                                "tumbon":"น้ำไคร้",
                                "postcode":"53110"
                            },
                            {
                                "tumbon":"น้ำไผ่",
                                "postcode":"53110"
                            },
                            {
                                "tumbon":"ห้วยมุ่น",
                                "postcode":"53110"
                            }
                            ]
                        },
                        {
                            "amphur":"ฟากท่า",
                            "listTumbon":[
                            {
                                "tumbon":"ฟากท่า",
                                "postcode":"53160"
                            },
                            {
                                "tumbon":"สองคอน",
                                "postcode":"53160"
                            },
                            {
                                "tumbon":"บ้านเสี้ยว",
                                "postcode":"53160"
                            },
                            {
                                "tumbon":"สองห้อง",
                                "postcode":"53160"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านโคก",
                            "listTumbon":[
                            {
                                "tumbon":"ม่วงเจ็ดต้น",
                                "postcode":"53180"
                            },
                            {
                                "tumbon":"บ้านโคก",
                                "postcode":"53180"
                            },
                            {
                                "tumbon":"นาขุม",
                                "postcode":"53180"
                            },
                            {
                                "tumbon":"บ่อเบี้ย",
                                "postcode":"53180"
                            }
                            ]
                        },
                        {
                            "amphur":"พิชัย",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"53120"
                            },
                            {
                                "tumbon":"บ้านดารา",
                                "postcode":"53220"
                            },
                            {
                                "tumbon":"ไร่อ้อย",
                                "postcode":"53120"
                            },
                            {
                                "tumbon":"ท่าสัก",
                                "postcode":"53220"
                            },
                            {
                                "tumbon":"คอรุม",
                                "postcode":"53120"
                            },
                            {
                                "tumbon":"บ้านหม้อ",
                                "postcode":"53120"
                            },
                            {
                                "tumbon":"ท่ามะเฟือง",
                                "postcode":"53120"
                            },
                            {
                                "tumbon":"บ้านโคน",
                                "postcode":"53120"
                            },
                            {
                                "tumbon":"พญาแมน",
                                "postcode":"53120"
                            },
                            {
                                "tumbon":"นาอิน",
                                "postcode":"53120"
                            },
                            {
                                "tumbon":"นายาง",
                                "postcode":"53120"
                            }
                            ]
                        },
                        {
                            "amphur":"ลับแล",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีพนมมาศ",
                                "postcode":"53130"
                            },
                            {
                                "tumbon":"แม่พูล",
                                "postcode":"53130"
                            },
                            {
                                "tumbon":"นานกกก",
                                "postcode":"53130"
                            },
                            {
                                "tumbon":"ฝายหลวง",
                                "postcode":"53130"
                            },
                            {
                                "tumbon":"ชัยจุมพล",
                                "postcode":"53130"
                            },
                            {
                                "tumbon":"ไผ่ล้อม",
                                "postcode":"53210"
                            },
                            {
                                "tumbon":"ทุ่งยั้ง",
                                "postcode":"53210"
                            },
                            {
                                "tumbon":"ด่านแม่คำมัน",
                                "postcode":"53210"
                            }
                            ]
                        },
                        {
                            "amphur":"ทองแสนขัน",
                            "listTumbon":[
                            {
                                "tumbon":"ผักขวง",
                                "postcode":"53230"
                            },
                            {
                                "tumbon":"บ่อทอง",
                                "postcode":"53230"
                            },
                            {
                                "tumbon":"ป่าคาย",
                                "postcode":"53230"
                            },
                            {
                                "tumbon":"น้ำพี้",
                                "postcode":"53230"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ลำปาง",
                    "listAmphur":[
                        {
                            "amphur":"เมืองลำปาง",
                            "listTumbon":[
                            {
                                "tumbon":"พระบาท",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"ชมพู",
                                "postcode":"52100"
                            },
                            {
                                "tumbon":"กล้วยแพะ",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"ปงแสนทอง",
                                "postcode":"52100"
                            },
                            {
                                "tumbon":"บ้านแลง",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"บ้านเสด็จ",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"พิชัย",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"ทุ่งฝาย",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"บ้านเอื้อม",
                                "postcode":"52100"
                            },
                            {
                                "tumbon":"บ้านเป้า",
                                "postcode":"52100"
                            },
                            {
                                "tumbon":"บ้านค่า",
                                "postcode":"52100"
                            },
                            {
                                "tumbon":"บ่อแฮ้ว",
                                "postcode":"52100"
                            },
                            {
                                "tumbon":"ต้นธงชัย",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"นิคมพัฒนา",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"บุญนาคพัฒนา",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"เวียงเหนือ",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"หัวเวียง",
                                "postcode":"52000"
                            },
                            {
                                "tumbon":"สบตุ๋ย",
                                "postcode":"52100"
                            },
                            {
                                "tumbon":"สวนดอก",
                                "postcode":"52100"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่เมาะ",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านดง",
                                "postcode":"52220"
                            },
                            {
                                "tumbon":"นาสัก",
                                "postcode":"52220"
                            },
                            {
                                "tumbon":"จางเหนือ",
                                "postcode":"52220"
                            },
                            {
                                "tumbon":"แม่เมาะ",
                                "postcode":"52220"
                            },
                            {
                                "tumbon":"สบป้าด",
                                "postcode":"52220"
                            }
                            ]
                        },
                        {
                            "amphur":"เกาะคา",
                            "listTumbon":[
                            {
                                "tumbon":"ลำปางหลวง",
                                "postcode":"52130"
                            },
                            {
                                "tumbon":"นาแก้ว",
                                "postcode":"52130"
                            },
                            {
                                "tumbon":"ไหล่หิน",
                                "postcode":"52130"
                            },
                            {
                                "tumbon":"วังพร้าว",
                                "postcode":"52130"
                            },
                            {
                                "tumbon":"ศาลา",
                                "postcode":"52130"
                            },
                            {
                                "tumbon":"เกาะคา",
                                "postcode":"52130"
                            },
                            {
                                "tumbon":"นาแส่ง",
                                "postcode":"52130"
                            },
                            {
                                "tumbon":"ท่าผา",
                                "postcode":"52130"
                            },
                            {
                                "tumbon":"ใหม่พัฒนา",
                                "postcode":"52130"
                            }
                            ]
                        },
                        {
                            "amphur":"เสริมงาม",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งงาม",
                                "postcode":"52210"
                            },
                            {
                                "tumbon":"เสริมขวา",
                                "postcode":"52210"
                            },
                            {
                                "tumbon":"เสริมซ้าย",
                                "postcode":"52210"
                            },
                            {
                                "tumbon":"เสริมกลาง",
                                "postcode":"52210"
                            }
                            ]
                        },
                        {
                            "amphur":"งาว",
                            "listTumbon":[
                            {
                                "tumbon":"หลวงเหนือ",
                                "postcode":"52110"
                            },
                            {
                                "tumbon":"หลวงใต้",
                                "postcode":"52110"
                            },
                            {
                                "tumbon":"บ้านโป่ง",
                                "postcode":"52110"
                            },
                            {
                                "tumbon":"บ้านร้อง",
                                "postcode":"52110"
                            },
                            {
                                "tumbon":"ปงเตา",
                                "postcode":"52110"
                            },
                            {
                                "tumbon":"นาแก",
                                "postcode":"52110"
                            },
                            {
                                "tumbon":"บ้านอ้อน",
                                "postcode":"52110"
                            },
                            {
                                "tumbon":"บ้านแหง",
                                "postcode":"52110"
                            },
                            {
                                "tumbon":"บ้านหวด",
                                "postcode":"52110"
                            },
                            {
                                "tumbon":"แม่ตีบ",
                                "postcode":"52110"
                            }
                            ]
                        },
                        {
                            "amphur":"แจ้ห่ม",
                            "listTumbon":[
                            {
                                "tumbon":"แจ้ห่ม",
                                "postcode":"52120"
                            },
                            {
                                "tumbon":"บ้านสา",
                                "postcode":"52120"
                            },
                            {
                                "tumbon":"ปงดอน",
                                "postcode":"52120"
                            },
                            {
                                "tumbon":"แม่สุก",
                                "postcode":"52120"
                            },
                            {
                                "tumbon":"เมืองมาย",
                                "postcode":"52120"
                            },
                            {
                                "tumbon":"ทุ่งผึ้ง",
                                "postcode":"52120"
                            },
                            {
                                "tumbon":"วิเชตนคร",
                                "postcode":"52120"
                            }
                            ]
                        },
                        {
                            "amphur":"วังเหนือ",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งฮั้ว",
                                "postcode":"52140"
                            },
                            {
                                "tumbon":"วังเหนือ",
                                "postcode":"52140"
                            },
                            {
                                "tumbon":"วังใต้",
                                "postcode":"52140"
                            },
                            {
                                "tumbon":"ร่องเคาะ",
                                "postcode":"52140"
                            },
                            {
                                "tumbon":"วังทอง",
                                "postcode":"52140"
                            },
                            {
                                "tumbon":"วังซ้าย",
                                "postcode":"52140"
                            },
                            {
                                "tumbon":"วังแก้ว",
                                "postcode":"52140"
                            },
                            {
                                "tumbon":"วังทรายคำ",
                                "postcode":"52140"
                            }
                            ]
                        },
                        {
                            "amphur":"เถิน",
                            "listTumbon":[
                            {
                                "tumbon":"ล้อมแรด",
                                "postcode":"52160"
                            },
                            {
                                "tumbon":"แม่วะ",
                                "postcode":"52230"
                            },
                            {
                                "tumbon":"แม่ปะ",
                                "postcode":"52160"
                            },
                            {
                                "tumbon":"แม่มอก",
                                "postcode":"52160"
                            },
                            {
                                "tumbon":"เวียงมอก",
                                "postcode":"52160"
                            },
                            {
                                "tumbon":"นาโป่ง",
                                "postcode":"52160"
                            },
                            {
                                "tumbon":"แม่ถอด",
                                "postcode":"52160"
                            },
                            {
                                "tumbon":"เถินบุรี",
                                "postcode":"52160"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่พริก",
                            "listTumbon":[
                            {
                                "tumbon":"แม่พริก",
                                "postcode":"52180"
                            },
                            {
                                "tumbon":"ผาปัง",
                                "postcode":"52180"
                            },
                            {
                                "tumbon":"แม่ปุ",
                                "postcode":"52180"
                            },
                            {
                                "tumbon":"พระบาทวังตวง",
                                "postcode":"52230"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่ทะ",
                            "listTumbon":[
                            {
                                "tumbon":"แม่ทะ",
                                "postcode":"52150"
                            },
                            {
                                "tumbon":"นาครัว",
                                "postcode":"52150"
                            },
                            {
                                "tumbon":"ป่าตัน",
                                "postcode":"52150"
                            },
                            {
                                "tumbon":"บ้านกิ่ว",
                                "postcode":"52150"
                            },
                            {
                                "tumbon":"บ้านบอม",
                                "postcode":"52150"
                            },
                            {
                                "tumbon":"น้ำโจ้",
                                "postcode":"52150"
                            },
                            {
                                "tumbon":"ดอนไฟ",
                                "postcode":"52150"
                            },
                            {
                                "tumbon":"หัวเสือ",
                                "postcode":"52150"
                            },
                            {
                                "tumbon":"วังเงิน",
                                "postcode":"52150"
                            },
                            {
                                "tumbon":"สันดอนแก้ว",
                                "postcode":"52150"
                            }
                            ]
                        },
                        {
                            "amphur":"สบปราบ",
                            "listTumbon":[
                            {
                                "tumbon":"สบปราบ",
                                "postcode":"52170"
                            },
                            {
                                "tumbon":"สมัย",
                                "postcode":"52170"
                            },
                            {
                                "tumbon":"แม่กัวะ",
                                "postcode":"52170"
                            },
                            {
                                "tumbon":"นายาง",
                                "postcode":"52170"
                            }
                            ]
                        },
                        {
                            "amphur":"ห้างฉัตร",
                            "listTumbon":[
                            {
                                "tumbon":"ห้างฉัตร",
                                "postcode":"52190"
                            },
                            {
                                "tumbon":"หนองหล่ม",
                                "postcode":"52190"
                            },
                            {
                                "tumbon":"เมืองยาว",
                                "postcode":"52190"
                            },
                            {
                                "tumbon":"ปงยางคก",
                                "postcode":"52190"
                            },
                            {
                                "tumbon":"เวียงตาล",
                                "postcode":"52190"
                            },
                            {
                                "tumbon":"แม่สัน",
                                "postcode":"52190"
                            },
                            {
                                "tumbon":"วอแก้ว",
                                "postcode":"52190"
                            }
                            ]
                        },
                        {
                            "amphur":"เมืองปาน",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองปาน",
                                "postcode":"52240"
                            },
                            {
                                "tumbon":"บ้านขอ",
                                "postcode":"52240"
                            },
                            {
                                "tumbon":"ทุ่งกว๋าว",
                                "postcode":"52240"
                            },
                            {
                                "tumbon":"แจ้ซ้อน",
                                "postcode":"52240"
                            },
                            {
                                "tumbon":"หัวเมือง",
                                "postcode":"52240"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"เชียงใหม่",
                    "listAmphur":[
                        {
                            "amphur":"เมืองเชียงใหม่",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีภูมิ",
                                "postcode":"50200"
                            },
                            {
                                "tumbon":"พระสิงห์",
                                "postcode":"50200"
                            },
                            {
                                "tumbon":"หายยา",
                                "postcode":"50100"
                            },
                            {
                                "tumbon":"ช้างม่อย",
                                "postcode":"50300"
                            },
                            {
                                "tumbon":"ช้างคลาน",
                                "postcode":"50100"
                            },
                            {
                                "tumbon":"วัดเกต",
                                "postcode":"50000"
                            },
                            {
                                "tumbon":"ช้างเผือก",
                                "postcode":"50300"
                            },
                            {
                                "tumbon":"สุเทพ",
                                "postcode":"50200"
                            },
                            {
                                "tumbon":"แม่เหียะ",
                                "postcode":"50100"
                            },
                            {
                                "tumbon":"ป่าแดด",
                                "postcode":"50100"
                            },
                            {
                                "tumbon":"หนองหอย",
                                "postcode":"50000"
                            },
                            {
                                "tumbon":"ท่าศาลา",
                                "postcode":"50000"
                            },
                            {
                                "tumbon":"หนองป่าครั่ง",
                                "postcode":"50000"
                            },
                            {
                                "tumbon":"ฟ้าฮ่าม",
                                "postcode":"50000"
                            },
                            {
                                "tumbon":"ป่าตัน",
                                "postcode":"50300"
                            },
                            {
                                "tumbon":"สันผีเสื้อ",
                                "postcode":"50300"
                            }
                            ]
                        },
                        {
                            "amphur":"จอมทอง",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านหลวง",
                                "postcode":"50160"
                            },
                            {
                                "tumbon":"ข่วงเปา",
                                "postcode":"50160"
                            },
                            {
                                "tumbon":"สบเตี๊ยะ",
                                "postcode":"50160"
                            },
                            {
                                "tumbon":"บ้านแปะ",
                                "postcode":"50240"
                            },
                            {
                                "tumbon":"ดอยแก้ว",
                                "postcode":"50160"
                            },
                            {
                                "tumbon":"แม่สอย",
                                "postcode":"50240"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่แจ่ม",
                            "listTumbon":[
                            {
                                "tumbon":"ช่างเคิ่ง",
                                "postcode":"50270"
                            },
                            {
                                "tumbon":"ท่าผา",
                                "postcode":"50270"
                            },
                            {
                                "tumbon":"บ้านทับ",
                                "postcode":"50270"
                            },
                            {
                                "tumbon":"แม่ศึก",
                                "postcode":"50270"
                            },
                            {
                                "tumbon":"แม่นาจร",
                                "postcode":"50270"
                            },
                            {
                                "tumbon":"ปางหินฝน",
                                "postcode":"50270"
                            },
                            {
                                "tumbon":"กองแขก",
                                "postcode":"50270"
                            }
                            ]
                        },
                        {
                            "amphur":"เชียงดาว",
                            "listTumbon":[
                            {
                                "tumbon":"เชียงดาว",
                                "postcode":"50170"
                            },
                            {
                                "tumbon":"เมืองนะ",
                                "postcode":"50170"
                            },
                            {
                                "tumbon":"เมืองงาย",
                                "postcode":"50170"
                            },
                            {
                                "tumbon":"แม่นะ",
                                "postcode":"50170"
                            },
                            {
                                "tumbon":"เมืองคอง",
                                "postcode":"50170"
                            },
                            {
                                "tumbon":"ปิงโค้ง",
                                "postcode":"50170"
                            },
                            {
                                "tumbon":"ทุ่งข้าวพวง",
                                "postcode":"50170"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอยสะเก็ด",
                            "listTumbon":[
                            {
                                "tumbon":"เชิงดอย",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"สันปูเลย",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"ลวงเหนือ",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"ป่าป้อง",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"สง่าบ้าน",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"ป่าลาน",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"ตลาดขวัญ",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"สำราญราษฎร์",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"แม่คือ",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"ตลาดใหญ่",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"แม่ฮ้อยเงิน",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"แม่โป่ง",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"ป่าเมี่ยง",
                                "postcode":"50220"
                            },
                            {
                                "tumbon":"เทพเสด็จ",
                                "postcode":"50220"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่แตง",
                            "listTumbon":[
                            {
                                "tumbon":"สันมหาพน",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"แม่แตง",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"ขี้เหล็ก",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"ช่อแล",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"แม่หอพระ",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"สบเปิง",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"บ้านเป้า",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"สันป่ายาง",
                                "postcode":"50330"
                            },
                            {
                                "tumbon":"ป่าแป๋",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"เมืองก๋าย",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"บ้านช้าง",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"กื้ดช้าง",
                                "postcode":"50150"
                            },
                            {
                                "tumbon":"อินทขิล",
                                "postcode":"50150"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่ริม",
                            "listTumbon":[
                            {
                                "tumbon":"ริมใต้",
                                "postcode":"50180"
                            },
                            {
                                "tumbon":"สันโป่ง",
                                "postcode":"50180"
                            },
                            {
                                "tumbon":"ขี้เหล็ก",
                                "postcode":"50180"
                            },
                            {
                                "tumbon":"สะลวง",
                                "postcode":"50330"
                            },
                            {
                                "tumbon":"แม่แรม",
                                "postcode":"50180"
                            },
                            {
                                "tumbon":"โป่งแยง",
                                "postcode":"50180"
                            },
                            {
                                "tumbon":"แม่สา",
                                "postcode":"50180"
                            },
                            {
                                "tumbon":"ดอนแก้ว",
                                "postcode":"50180"
                            },
                            {
                                "tumbon":"เหมืองแก้ว",
                                "postcode":"50180"
                            },
                            {
                                "tumbon":"ห้วยทราย",
                                "postcode":"50180"
                            },
                            {
                                "tumbon":"ริมเหนือ",
                                "postcode":"50180"
                            }
                            ]
                        },
                        {
                            "amphur":"สะเมิง",
                            "listTumbon":[
                            {
                                "tumbon":"สะเมิงใต้",
                                "postcode":"50250"
                            },
                            {
                                "tumbon":"สะเมิงเหนือ",
                                "postcode":"50250"
                            },
                            {
                                "tumbon":"แม่สาบ",
                                "postcode":"50250"
                            },
                            {
                                "tumbon":"บ่อแก้ว",
                                "postcode":"50250"
                            },
                            {
                                "tumbon":"ยั้งเมิน",
                                "postcode":"50250"
                            }
                            ]
                        },
                        {
                            "amphur":"ฝาง",
                            "listTumbon":[
                            {
                                "tumbon":"เวียง",
                                "postcode":"50110"
                            },
                            {
                                "tumbon":"ม่อนปิ่น",
                                "postcode":"50110"
                            },
                            {
                                "tumbon":"แม่งอน",
                                "postcode":"50320"
                            },
                            {
                                "tumbon":"แม่สูน",
                                "postcode":"50110"
                            },
                            {
                                "tumbon":"สันทราย",
                                "postcode":"50110"
                            },
                            {
                                "tumbon":"โป่งน้ำร้อน",
                                "postcode":"50110"
                            },
                            {
                                "tumbon":"แม่คะ",
                                "postcode":"50110"
                            },
                            {
                                "tumbon":"แม่ข่า",
                                "postcode":"50320"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่อาย",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านหลวง",
                                "postcode":"50280"
                            },
                            {
                                "tumbon":"แม่อาย",
                                "postcode":"50280"
                            },
                            {
                                "tumbon":"แม่สาว",
                                "postcode":"50280"
                            },
                            {
                                "tumbon":"สันต้นหมื้อ",
                                "postcode":"50280"
                            },
                            {
                                "tumbon":"แม่นาวาง",
                                "postcode":"50280"
                            },
                            {
                                "tumbon":"ท่าตอน",
                                "postcode":"50280"
                            },
                            {
                                "tumbon":"มะลิกา",
                                "postcode":"50280"
                            }
                            ]
                        },
                        {
                            "amphur":"พร้าว",
                            "listTumbon":[
                            {
                                "tumbon":"เวียง",
                                "postcode":"50190"
                            },
                            {
                                "tumbon":"สันทราย",
                                "postcode":"50190"
                            },
                            {
                                "tumbon":"ทุ่งหลวง",
                                "postcode":"50190"
                            },
                            {
                                "tumbon":"ป่าตุ้ม",
                                "postcode":"50190"
                            },
                            {
                                "tumbon":"ป่าไหน่",
                                "postcode":"50190"
                            },
                            {
                                "tumbon":"บ้านโป่ง",
                                "postcode":"50190"
                            },
                            {
                                "tumbon":"น้ำแพร่",
                                "postcode":"50190"
                            },
                            {
                                "tumbon":"เขื่อนผาก",
                                "postcode":"50190"
                            },
                            {
                                "tumbon":"แม่แวน",
                                "postcode":"50190"
                            },
                            {
                                "tumbon":"แม่ปั๋ง",
                                "postcode":"50190"
                            },
                            {
                                "tumbon":"โหล่งขอด",
                                "postcode":"50190"
                            }
                            ]
                        },
                        {
                            "amphur":"สันป่าตอง",
                            "listTumbon":[
                            {
                                "tumbon":"ยุหว่า",
                                "postcode":"50120"
                            },
                            {
                                "tumbon":"สันกลาง",
                                "postcode":"50120"
                            },
                            {
                                "tumbon":"ท่าวังพร้าว",
                                "postcode":"50120"
                            },
                            {
                                "tumbon":"มะขามหลวง",
                                "postcode":"50120"
                            },
                            {
                                "tumbon":"แม่ก๊า",
                                "postcode":"50120"
                            },
                            {
                                "tumbon":"บ้านแม",
                                "postcode":"50120"
                            },
                            {
                                "tumbon":"บ้านกลาง",
                                "postcode":"50120"
                            },
                            {
                                "tumbon":"ทุ่งสะโตก",
                                "postcode":"50120"
                            },
                            {
                                "tumbon":"ทุ่งต้อม",
                                "postcode":"50120"
                            },
                            {
                                "tumbon":"น้ำบ่อหลวง",
                                "postcode":"50120"
                            },
                            {
                                "tumbon":"มะขุนหวาน",
                                "postcode":"50120"
                            }
                            ]
                        },
                        {
                            "amphur":"สันกำแพง",
                            "listTumbon":[
                            {
                                "tumbon":"สันกลาง",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"สันกำแพง",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"ทรายมูล",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"ร้องวัวแดง",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"บวกค้าง",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"แช่ช้าง",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"ออนใต้",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"แม่ปูคา",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"ห้วยทราย",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"ต้นเปา",
                                "postcode":"50130"
                            }
                            ]
                        },
                        {
                            "amphur":"สันทราย",
                            "listTumbon":[
                            {
                                "tumbon":"สันทรายหลวง",
                                "postcode":"50210"
                            },
                            {
                                "tumbon":"สันทรายน้อย",
                                "postcode":"50210"
                            },
                            {
                                "tumbon":"สันพระเนตร",
                                "postcode":"50210"
                            },
                            {
                                "tumbon":"สันนาเม็ง",
                                "postcode":"50210"
                            },
                            {
                                "tumbon":"สันป่าเปา",
                                "postcode":"50210"
                            },
                            {
                                "tumbon":"หนองแหย่ง",
                                "postcode":"50210"
                            },
                            {
                                "tumbon":"หนองจ๊อม",
                                "postcode":"50210"
                            },
                            {
                                "tumbon":"หนองหาร",
                                "postcode":"50290"
                            },
                            {
                                "tumbon":"แม่แฝก",
                                "postcode":"50290"
                            },
                            {
                                "tumbon":"แม่แฝกใหม่",
                                "postcode":"50290"
                            },
                            {
                                "tumbon":"เมืองเล็น",
                                "postcode":"50210"
                            },
                            {
                                "tumbon":"ป่าไผ่",
                                "postcode":"50210"
                            }
                            ]
                        },
                        {
                            "amphur":"หางดง",
                            "listTumbon":[
                            {
                                "tumbon":"น้ำแพร่",
                                "postcode":"50230"
                            },
                            {
                                "tumbon":"หนองแก๋ว",
                                "postcode":"50230"
                            },
                            {
                                "tumbon":"หารแก้ว",
                                "postcode":"50230"
                            },
                            {
                                "tumbon":"หนองตอง",
                                "postcode":"50340"
                            },
                            {
                                "tumbon":"ขุนคง",
                                "postcode":"50230"
                            },
                            {
                                "tumbon":"สบแม่ข่า",
                                "postcode":"50230"
                            },
                            {
                                "tumbon":"บ้านแหวน",
                                "postcode":"50230"
                            },
                            {
                                "tumbon":"สันผักหวาน",
                                "postcode":"50230"
                            },
                            {
                                "tumbon":"หนองควาย",
                                "postcode":"50230"
                            },
                            {
                                "tumbon":"บ้านปง",
                                "postcode":"50230"
                            },
                            {
                                "tumbon":"หางดง",
                                "postcode":"50230"
                            }
                            ]
                        },
                        {
                            "amphur":"ฮอด",
                            "listTumbon":[
                            {
                                "tumbon":"หางดง",
                                "postcode":"50240"
                            },
                            {
                                "tumbon":"ฮอด",
                                "postcode":"50240"
                            },
                            {
                                "tumbon":"บ้านตาล",
                                "postcode":"50240"
                            },
                            {
                                "tumbon":"บ่อหลวง",
                                "postcode":"50240"
                            },
                            {
                                "tumbon":"บ่อสลี",
                                "postcode":"50240"
                            },
                            {
                                "tumbon":"นาคอเรือ",
                                "postcode":"50240"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอยเต่า",
                            "listTumbon":[
                            {
                                "tumbon":"ดอยเต่า",
                                "postcode":"50260"
                            },
                            {
                                "tumbon":"ท่าเดื่อ",
                                "postcode":"50260"
                            },
                            {
                                "tumbon":"มืดกา",
                                "postcode":"50260"
                            },
                            {
                                "tumbon":"บ้านแอ่น",
                                "postcode":"50260"
                            },
                            {
                                "tumbon":"บงตัน",
                                "postcode":"50260"
                            },
                            {
                                "tumbon":"โปงทุ่ง",
                                "postcode":"50260"
                            }
                            ]
                        },
                        {
                            "amphur":"อมก๋อย",
                            "listTumbon":[
                            {
                                "tumbon":"อมก๋อย",
                                "postcode":"50310"
                            },
                            {
                                "tumbon":"ยางเปียง",
                                "postcode":"50310"
                            },
                            {
                                "tumbon":"แม่ตื่น",
                                "postcode":"50310"
                            },
                            {
                                "tumbon":"ม่อนจอง",
                                "postcode":"50310"
                            },
                            {
                                "tumbon":"สบโขง",
                                "postcode":"50310"
                            },
                            {
                                "tumbon":"นาเกียน",
                                "postcode":"50310"
                            }
                            ]
                        },
                        {
                            "amphur":"สารภี",
                            "listTumbon":[
                            {
                                "tumbon":"ดอนแก้ว",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"สันทราย",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"ยางเนิ้ง",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"สารภี",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"ชมภู",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"ไชยสถาน",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"ขัวมุง",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"หนองแฝก",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"หนองผึ้ง",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"ท่ากว้าง",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"ท่าวังตาล",
                                "postcode":"50140"
                            },
                            {
                                "tumbon":"ป่าบง",
                                "postcode":"50140"
                            }
                            ]
                        },
                        {
                            "amphur":"เวียงแหง",
                            "listTumbon":[
                            {
                                "tumbon":"เมืองแหง",
                                "postcode":"50350"
                            },
                            {
                                "tumbon":"เปียงหลวง",
                                "postcode":"50350"
                            },
                            {
                                "tumbon":"แสนไห",
                                "postcode":"50350"
                            }
                            ]
                        },
                        {
                            "amphur":"ไชยปราการ",
                            "listTumbon":[
                            {
                                "tumbon":"ปงตำ",
                                "postcode":"50320"
                            },
                            {
                                "tumbon":"ศรีดงเย็น",
                                "postcode":"50320"
                            },
                            {
                                "tumbon":"แม่ทะลบ",
                                "postcode":"50320"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"50320"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่วาง",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านกาด",
                                "postcode":"50360"
                            },
                            {
                                "tumbon":"ทุ่งปี้",
                                "postcode":"50360"
                            },
                            {
                                "tumbon":"แม่วิน",
                                "postcode":"50360"
                            },
                            {
                                "tumbon":"ดอนเปา",
                                "postcode":"50360"
                            },
                            {
                                "tumbon":"ทุ่งรวงทอง",
                                "postcode":"50360"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่ออน",
                            "listTumbon":[
                            {
                                "tumbon":"ออนเหนือ",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"ออนกลาง",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"ห้วยแก้ว",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"แม่ทา",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"ทาเหนือ",
                                "postcode":"50130"
                            },
                            {
                                "tumbon":"บ้านสหกรณ์",
                                "postcode":"50130"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอยหล่อ",
                            "listTumbon":[
                            {
                                "tumbon":"ดอยหล่อ",
                                "postcode":"50160"
                            },
                            {
                                "tumbon":"สองแคว",
                                "postcode":"50160"
                            },
                            {
                                "tumbon":"ยางคราม",
                                "postcode":"50160"
                            },
                            {
                                "tumbon":"สันติสุข",
                                "postcode":"50160"
                            }
                            ]
                        },
                        {
                            "amphur":"กัลยาณิวัฒนา",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านจันทร์",
                                "postcode":"58130"
                            },
                            {
                                "tumbon":"แจ่มหลวง",
                                "postcode":"58130"
                            },
                            {
                                "tumbon":"แม่แดด",
                                "postcode":"58130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"เชียงราย",
                    "listAmphur":[
                        {
                            "amphur":"เมืองเชียงราย",
                            "listTumbon":[
                            {
                                "tumbon":"รอบเวียง",
                                "postcode":"57000"
                            },
                            {
                                "tumbon":"บ้านดู่",
                                "postcode":"57100"
                            },
                            {
                                "tumbon":"นางแล",
                                "postcode":"57100"
                            },
                            {
                                "tumbon":"แม่ข้าวต้ม",
                                "postcode":"57100"
                            },
                            {
                                "tumbon":"แม่ยาว",
                                "postcode":"57100"
                            },
                            {
                                "tumbon":"สันทราย",
                                "postcode":"57000"
                            },
                            {
                                "tumbon":"แม่กรณ์",
                                "postcode":"57000"
                            },
                            {
                                "tumbon":"ห้วยชมภู",
                                "postcode":"57000"
                            },
                            {
                                "tumbon":"ห้วยสัก",
                                "postcode":"57000"
                            },
                            {
                                "tumbon":"ริมกก",
                                "postcode":"57100"
                            },
                            {
                                "tumbon":"ดอยลาน",
                                "postcode":"57000"
                            },
                            {
                                "tumbon":"ป่าอ้อดอนชัย",
                                "postcode":"57000"
                            },
                            {
                                "tumbon":"ท่าสาย",
                                "postcode":"57000"
                            },
                            {
                                "tumbon":"ดอยฮาง",
                                "postcode":"57000"
                            },
                            {
                                "tumbon":"เวียง",
                                "postcode":"57000"
                            },
                            {
                                "tumbon":"ท่าสุด",
                                "postcode":"57100"
                            }
                            ]
                        },
                        {
                            "amphur":"เวียงชัย",
                            "listTumbon":[
                            {
                                "tumbon":"เวียงชัย",
                                "postcode":"57210"
                            },
                            {
                                "tumbon":"ผางาม",
                                "postcode":"57210"
                            },
                            {
                                "tumbon":"เวียงเหนือ",
                                "postcode":"57210"
                            },
                            {
                                "tumbon":"ดอนศิลา",
                                "postcode":"57210"
                            },
                            {
                                "tumbon":"เมืองชุม",
                                "postcode":"57210"
                            }
                            ]
                        },
                        {
                            "amphur":"เชียงของ",
                            "listTumbon":[
                            {
                                "tumbon":"เวียง",
                                "postcode":"57140"
                            },
                            {
                                "tumbon":"สถาน",
                                "postcode":"57140"
                            },
                            {
                                "tumbon":"ครึ่ง",
                                "postcode":"57140"
                            },
                            {
                                "tumbon":"บุญเรือง",
                                "postcode":"57140"
                            },
                            {
                                "tumbon":"ห้วยซ้อ",
                                "postcode":"57140"
                            },
                            {
                                "tumbon":"ศรีดอนชัย",
                                "postcode":"57140"
                            },
                            {
                                "tumbon":"ริมโขง",
                                "postcode":"57140"
                            }
                            ]
                        },
                        {
                            "amphur":"เทิง",
                            "listTumbon":[
                            {
                                "tumbon":"เวียง",
                                "postcode":"57160"
                            },
                            {
                                "tumbon":"งิ้ว",
                                "postcode":"57160"
                            },
                            {
                                "tumbon":"ปล้อง",
                                "postcode":"57230"
                            },
                            {
                                "tumbon":"แม่ลอย",
                                "postcode":"57230"
                            },
                            {
                                "tumbon":"เชียงเคี่ยน",
                                "postcode":"57230"
                            },
                            {
                                "tumbon":"ตับเต่า",
                                "postcode":"57160"
                            },
                            {
                                "tumbon":"หงาว",
                                "postcode":"57160"
                            },
                            {
                                "tumbon":"สันทรายงาม",
                                "postcode":"57160"
                            },
                            {
                                "tumbon":"ศรีดอนไชย",
                                "postcode":"57230"
                            },
                            {
                                "tumbon":"หนองแรด",
                                "postcode":"57230"
                            }
                            ]
                        },
                        {
                            "amphur":"พาน",
                            "listTumbon":[
                            {
                                "tumbon":"สันมะเค็ด",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"แม่อ้อ",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"ธารทอง",
                                "postcode":"57250"
                            },
                            {
                                "tumbon":"สันติสุข",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"ดอยงาม",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"หัวง้ม",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"เจริญเมือง",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"ป่าหุ่ง",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"ม่วงคำ",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"ทรายขาว",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"สันกลาง",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"แม่เย็น",
                                "postcode":"57280"
                            },
                            {
                                "tumbon":"เมืองพาน",
                                "postcode":"57120"
                            },
                            {
                                "tumbon":"ทานตะวัน",
                                "postcode":"57280"
                            },
                            {
                                "tumbon":"เวียงห้าว",
                                "postcode":"57120"
                            }
                            ]
                        },
                        {
                            "amphur":"ป่าแดด",
                            "listTumbon":[
                            {
                                "tumbon":"ป่าแงะ",
                                "postcode":"57190"
                            },
                            {
                                "tumbon":"สันมะค่า",
                                "postcode":"57190"
                            },
                            {
                                "tumbon":"โรงช้าง",
                                "postcode":"57190"
                            },
                            {
                                "tumbon":"ศรีโพธิ์เงิน",
                                "postcode":"57190"
                            },
                            {
                                "tumbon":"ป่าแดด",
                                "postcode":"57190"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่จัน",
                            "listTumbon":[
                            {
                                "tumbon":"แม่จัน",
                                "postcode":"57110"
                            },
                            {
                                "tumbon":"จันจว้า",
                                "postcode":"57270"
                            },
                            {
                                "tumbon":"แม่คำ",
                                "postcode":"57240"
                            },
                            {
                                "tumbon":"สันทราย",
                                "postcode":"57110"
                            },
                            {
                                "tumbon":"ท่าข้าวเปลือก",
                                "postcode":"57110"
                            },
                            {
                                "tumbon":"ป่าตึง",
                                "postcode":"57110"
                            },
                            {
                                "tumbon":"แม่ไร่",
                                "postcode":"57240"
                            },
                            {
                                "tumbon":"ศรีค้ำ",
                                "postcode":"57110"
                            },
                            {
                                "tumbon":"จันจว้าใต้",
                                "postcode":"57270"
                            },
                            {
                                "tumbon":"ป่าซาง",
                                "postcode":"57110"
                            },
                            {
                                "tumbon":"จอมสวรรค์",
                                "postcode":"57110"
                            }
                            ]
                        },
                        {
                            "amphur":"เชียงแสน",
                            "listTumbon":[
                            {
                                "tumbon":"เวียง",
                                "postcode":"57150"
                            },
                            {
                                "tumbon":"ป่าสัก",
                                "postcode":"57150"
                            },
                            {
                                "tumbon":"บ้านแซว",
                                "postcode":"57150"
                            },
                            {
                                "tumbon":"ศรีดอนมูล",
                                "postcode":"57150"
                            },
                            {
                                "tumbon":"แม่เงิน",
                                "postcode":"57150"
                            },
                            {
                                "tumbon":"โยนก",
                                "postcode":"57150"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่สาย",
                            "listTumbon":[
                            {
                                "tumbon":"แม่สาย",
                                "postcode":"57130"
                            },
                            {
                                "tumbon":"ห้วยไคร้",
                                "postcode":"57220"
                            },
                            {
                                "tumbon":"เกาะช้าง",
                                "postcode":"57130"
                            },
                            {
                                "tumbon":"โป่งผา",
                                "postcode":"57130"
                            },
                            {
                                "tumbon":"ศรีเมืองชุม",
                                "postcode":"57130"
                            },
                            {
                                "tumbon":"เวียงพางคำ",
                                "postcode":"57130"
                            },
                            {
                                "tumbon":"บ้านด้าย",
                                "postcode":"57220"
                            },
                            {
                                "tumbon":"โป่งงาม",
                                "postcode":"57130"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่สรวย",
                            "listTumbon":[
                            {
                                "tumbon":"แม่สรวย",
                                "postcode":"57180"
                            },
                            {
                                "tumbon":"ป่าแดด",
                                "postcode":"57180"
                            },
                            {
                                "tumbon":"แม่พริก",
                                "postcode":"57180"
                            },
                            {
                                "tumbon":"ศรีถ้อย",
                                "postcode":"57180"
                            },
                            {
                                "tumbon":"ท่าก๊อ",
                                "postcode":"57180"
                            },
                            {
                                "tumbon":"วาวี",
                                "postcode":"57180"
                            },
                            {
                                "tumbon":"เจดีย์หลวง",
                                "postcode":"57180"
                            }
                            ]
                        },
                        {
                            "amphur":"เวียงป่าเป้า",
                            "listTumbon":[
                            {
                                "tumbon":"สันสลี",
                                "postcode":"57170"
                            },
                            {
                                "tumbon":"เวียง",
                                "postcode":"57170"
                            },
                            {
                                "tumbon":"บ้านโป่ง",
                                "postcode":"57170"
                            },
                            {
                                "tumbon":"ป่างิ้ว",
                                "postcode":"57170"
                            },
                            {
                                "tumbon":"เวียงกาหลง",
                                "postcode":"57260"
                            },
                            {
                                "tumbon":"แม่เจดีย์",
                                "postcode":"57260"
                            },
                            {
                                "tumbon":"แม่เจดีย์ใหม่",
                                "postcode":"57260"
                            }
                            ]
                        },
                        {
                            "amphur":"พญาเม็งราย",
                            "listTumbon":[
                            {
                                "tumbon":"แม่เปา",
                                "postcode":"57290"
                            },
                            {
                                "tumbon":"แม่ต๋ำ",
                                "postcode":"57290"
                            },
                            {
                                "tumbon":"ไม้ยา",
                                "postcode":"57290"
                            },
                            {
                                "tumbon":"เม็งราย",
                                "postcode":"57290"
                            },
                            {
                                "tumbon":"ตาดควัน",
                                "postcode":"57290"
                            }
                            ]
                        },
                        {
                            "amphur":"เวียงแก่น",
                            "listTumbon":[
                            {
                                "tumbon":"ม่วงยาย",
                                "postcode":"57310"
                            },
                            {
                                "tumbon":"ปอ",
                                "postcode":"57310"
                            },
                            {
                                "tumbon":"หล่ายงาว",
                                "postcode":"57310"
                            },
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"57310"
                            }
                            ]
                        },
                        {
                            "amphur":"ขุนตาล",
                            "listTumbon":[
                            {
                                "tumbon":"ต้า",
                                "postcode":"57340"
                            },
                            {
                                "tumbon":"ป่าตาล",
                                "postcode":"57340"
                            },
                            {
                                "tumbon":"ยางฮอม",
                                "postcode":"57340"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่ฟ้าหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"เทอดไทย",
                                "postcode":"57240"
                            },
                            {
                                "tumbon":"แม่สลองใน",
                                "postcode":"57110"
                            },
                            {
                                "tumbon":"แม่สลองนอก",
                                "postcode":"57110"
                            },
                            {
                                "tumbon":"แม่ฟ้าหลวง",
                                "postcode":"57240"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่ลาว",
                            "listTumbon":[
                            {
                                "tumbon":"ดงมะดะ",
                                "postcode":"57250"
                            },
                            {
                                "tumbon":"จอมหมอกแก้ว",
                                "postcode":"57250"
                            },
                            {
                                "tumbon":"บัวสลี",
                                "postcode":"57250"
                            },
                            {
                                "tumbon":"ป่าก่อดำ",
                                "postcode":"57250"
                            },
                            {
                                "tumbon":"โป่งแพร่",
                                "postcode":"57000"
                            }
                            ]
                        },
                        {
                            "amphur":"เวียงเชียงรุ้ง",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งก่อ",
                                "postcode":"57210"
                            },
                            {
                                "tumbon":"ดงมหาวัน",
                                "postcode":"57210"
                            },
                            {
                                "tumbon":"ป่าซาง",
                                "postcode":"57210"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอยหลวง",
                            "listTumbon":[
                            {
                                "tumbon":"ปงน้อย",
                                "postcode":"57110"
                            },
                            {
                                "tumbon":"หนองป่าก่อ",
                                "postcode":"57110"
                            },
                            {
                                "tumbon":"โชคชัย",
                                "postcode":"57110"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ลำพูน",
                    "listAmphur":[
                        {
                            "amphur":"เมืองลำพูน",
                            "listTumbon":[
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"เหมืองง่า",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"อุโมงค์",
                                "postcode":"51150"
                            },
                            {
                                "tumbon":"หนองช้างคืน",
                                "postcode":"51150"
                            },
                            {
                                "tumbon":"ประตูป่า",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"ริมปิง",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"ต้นธง",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"บ้านแป้น",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"เหมืองจี้",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"ป่าสัก",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"เวียงยอง",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"บ้านกลาง",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"มะเขือแจ้",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"ศรีบัวบาน",
                                "postcode":"51000"
                            },
                            {
                                "tumbon":"หนองหนาม",
                                "postcode":"51000"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่ทา",
                            "listTumbon":[
                            {
                                "tumbon":"ทาปลาดุก",
                                "postcode":"51140"
                            },
                            {
                                "tumbon":"ทาสบเส้า",
                                "postcode":"51140"
                            },
                            {
                                "tumbon":"ทากาศ",
                                "postcode":"51170"
                            },
                            {
                                "tumbon":"ทาขุมเงิน",
                                "postcode":"51170"
                            },
                            {
                                "tumbon":"ทาทุ่งหลวง",
                                "postcode":"51170"
                            },
                            {
                                "tumbon":"ทาแม่ลอบ",
                                "postcode":"51170"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านโฮ่ง",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านโฮ่ง",
                                "postcode":"51130"
                            },
                            {
                                "tumbon":"ป่าพลู",
                                "postcode":"51130"
                            },
                            {
                                "tumbon":"เหล่ายาว",
                                "postcode":"51130"
                            },
                            {
                                "tumbon":"ศรีเตี้ย",
                                "postcode":"51130"
                            },
                            {
                                "tumbon":"หนองปลาสะวาย",
                                "postcode":"51130"
                            }
                            ]
                        },
                        {
                            "amphur":"ลี้",
                            "listTumbon":[
                            {
                                "tumbon":"ลี้",
                                "postcode":"51110"
                            },
                            {
                                "tumbon":"แม่ตืน",
                                "postcode":"51110"
                            },
                            {
                                "tumbon":"นาทราย",
                                "postcode":"51110"
                            },
                            {
                                "tumbon":"ดงดำ",
                                "postcode":"51110"
                            },
                            {
                                "tumbon":"ก้อ",
                                "postcode":"51110"
                            },
                            {
                                "tumbon":"แม่ลาน",
                                "postcode":"51110"
                            },
                            {
                                "tumbon":"ป่าไผ่",
                                "postcode":"51110"
                            },
                            {
                                "tumbon":"ศรีวิชัย",
                                "postcode":"51110"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งหัวช้าง",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งหัวช้าง",
                                "postcode":"51160"
                            },
                            {
                                "tumbon":"บ้านปวง",
                                "postcode":"51160"
                            },
                            {
                                "tumbon":"ตะเคียนปม",
                                "postcode":"51160"
                            }
                            ]
                        },
                        {
                            "amphur":"ป่าซาง",
                            "listTumbon":[
                            {
                                "tumbon":"ปากบ่อง",
                                "postcode":"51120"
                            },
                            {
                                "tumbon":"ป่าซาง",
                                "postcode":"51120"
                            },
                            {
                                "tumbon":"แม่แรง",
                                "postcode":"51120"
                            },
                            {
                                "tumbon":"ม่วงน้อย",
                                "postcode":"51120"
                            },
                            {
                                "tumbon":"บ้านเรือน",
                                "postcode":"51120"
                            },
                            {
                                "tumbon":"มะกอก",
                                "postcode":"51120"
                            },
                            {
                                "tumbon":"ท่าตุ้ม",
                                "postcode":"51120"
                            },
                            {
                                "tumbon":"น้ำดิบ",
                                "postcode":"51120"
                            },
                            {
                                "tumbon":"นครเจดีย์",
                                "postcode":"51120"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านธิ",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านธิ",
                                "postcode":"51180"
                            },
                            {
                                "tumbon":"ห้วยยาบ",
                                "postcode":"51180"
                            }
                            ]
                        },
                        {
                            "amphur":"เวียงหนองล่อง",
                            "listTumbon":[
                            {
                                "tumbon":"หนองล่อง",
                                "postcode":"51120"
                            },
                            {
                                "tumbon":"หนองยวง",
                                "postcode":"51120"
                            },
                            {
                                "tumbon":"วังผาง",
                                "postcode":"51120"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"พะเยา",
                    "listAmphur":[
                        {
                            "amphur":"เมืองพะเยา",
                            "listTumbon":[
                            {
                                "tumbon":"เวียง",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"แม่นาเรือ",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"บ้านตุ่น",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"บ้านต๊ำ",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"บ้านต๋อม",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"แม่ปืม",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"แม่กา",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"จำป่าหวาย",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"ท่าวังทอง",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"แม่ใส",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"บ้านสาง",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"ท่าจำปี",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"สันป่าม่วง",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"แม่ต๋ำ",
                                "postcode":"56000"
                            }
                            ]
                        },
                        {
                            "amphur":"จุน",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยข้าวก่ำ",
                                "postcode":"56150"
                            },
                            {
                                "tumbon":"จุน",
                                "postcode":"56150"
                            },
                            {
                                "tumbon":"ลอ",
                                "postcode":"56150"
                            },
                            {
                                "tumbon":"หงส์หิน",
                                "postcode":"56150"
                            },
                            {
                                "tumbon":"ทุ่งรวงทอง",
                                "postcode":"56150"
                            },
                            {
                                "tumbon":"ห้วยยางขาม",
                                "postcode":"56150"
                            },
                            {
                                "tumbon":"พระธาตุขิงแกง",
                                "postcode":"56150"
                            }
                            ]
                        },
                        {
                            "amphur":"เชียงคำ",
                            "listTumbon":[
                            {
                                "tumbon":"หย่วน",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"น้ำแวน",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"เวียง",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"ฝายกวาง",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"เจดีย์คำ",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"ร่มเย็น",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"เชียงบาน",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"แม่ลาว",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"อ่างทอง",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"ทุ่งผาสุข",
                                "postcode":"56110"
                            }
                            ]
                        },
                        {
                            "amphur":"เชียงม่วน",
                            "listTumbon":[
                            {
                                "tumbon":"เชียงม่วน",
                                "postcode":"56160"
                            },
                            {
                                "tumbon":"บ้านมาง",
                                "postcode":"56160"
                            },
                            {
                                "tumbon":"สระ",
                                "postcode":"56160"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอกคำใต้",
                            "listTumbon":[
                            {
                                "tumbon":"ดอกคำใต้",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"ดอนศรีชุม",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"บ้านถ้ำ",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"บ้านปิน",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"ห้วยลาน",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"สันโค้ง",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"ป่าซาง",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"หนองหล่ม",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"ดงสุวรรณ",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"บุญเกิด",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"สว่างอารมณ์",
                                "postcode":"56120"
                            },
                            {
                                "tumbon":"คือเวียง",
                                "postcode":"56120"
                            }
                            ]
                        },
                        {
                            "amphur":"ปง",
                            "listTumbon":[
                            {
                                "tumbon":"ปง",
                                "postcode":"56140"
                            },
                            {
                                "tumbon":"ควร",
                                "postcode":"56140"
                            },
                            {
                                "tumbon":"ออย",
                                "postcode":"56140"
                            },
                            {
                                "tumbon":"งิม",
                                "postcode":"56140"
                            },
                            {
                                "tumbon":"ผาช้างน้อย",
                                "postcode":"56140"
                            },
                            {
                                "tumbon":"นาปรัง",
                                "postcode":"56140"
                            },
                            {
                                "tumbon":"ขุนควร",
                                "postcode":"56140"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่ใจ",
                            "listTumbon":[
                            {
                                "tumbon":"แม่ใจ",
                                "postcode":"56130"
                            },
                            {
                                "tumbon":"ศรีถ้อย",
                                "postcode":"56130"
                            },
                            {
                                "tumbon":"แม่สุก",
                                "postcode":"56130"
                            },
                            {
                                "tumbon":"ป่าแฝก",
                                "postcode":"56130"
                            },
                            {
                                "tumbon":"บ้านเหล่า",
                                "postcode":"56130"
                            },
                            {
                                "tumbon":"เจริญราษฎร์",
                                "postcode":"56130"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูซาง",
                            "listTumbon":[
                            {
                                "tumbon":"ภูซาง",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"ทุ่งกล้วย",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"เชียงแรง",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"สบบง",
                                "postcode":"56110"
                            },
                            {
                                "tumbon":"ป่าสัก",
                                "postcode":"56110"
                            }
                            ]
                        },
                        {
                            "amphur":"ภูกามยาว",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยแก้ว",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"ดงเจน",
                                "postcode":"56000"
                            },
                            {
                                "tumbon":"แม่อิง",
                                "postcode":"56000"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"แม่ฮ่องสอน",
                    "listAmphur":[
                        {
                            "amphur":"เมืองแม่ฮ่องสอน",
                            "listTumbon":[
                            {
                                "tumbon":"จองคำ",
                                "postcode":"58000"
                            },
                            {
                                "tumbon":"ห้วยโป่ง",
                                "postcode":"58000"
                            },
                            {
                                "tumbon":"ผาบ่อง",
                                "postcode":"58000"
                            },
                            {
                                "tumbon":"ปางหมู",
                                "postcode":"58000"
                            },
                            {
                                "tumbon":"หมอกจำแป่",
                                "postcode":"58000"
                            },
                            {
                                "tumbon":"ห้วยผา",
                                "postcode":"58000"
                            },
                            {
                                "tumbon":"ห้วยปูลิง",
                                "postcode":"58000"
                            }
                            ]
                        },
                        {
                            "amphur":"ขุนยวม",
                            "listTumbon":[
                            {
                                "tumbon":"ขุนยวม",
                                "postcode":"58140"
                            },
                            {
                                "tumbon":"แม่เงา",
                                "postcode":"58140"
                            },
                            {
                                "tumbon":"เมืองปอน",
                                "postcode":"58140"
                            },
                            {
                                "tumbon":"แม่ยวมน้อย",
                                "postcode":"58140"
                            },
                            {
                                "tumbon":"แม่กิ๊",
                                "postcode":"58140"
                            },
                            {
                                "tumbon":"แม่อูคอ",
                                "postcode":"58140"
                            }
                            ]
                        },
                        {
                            "amphur":"ปาย",
                            "listTumbon":[
                            {
                                "tumbon":"เวียงใต้",
                                "postcode":"58130"
                            },
                            {
                                "tumbon":"เวียงเหนือ",
                                "postcode":"58130"
                            },
                            {
                                "tumbon":"แม่นาเติง",
                                "postcode":"58130"
                            },
                            {
                                "tumbon":"แม่ฮี้",
                                "postcode":"58130"
                            },
                            {
                                "tumbon":"ทุ่งยาว",
                                "postcode":"58130"
                            },
                            {
                                "tumbon":"เมืองแปง",
                                "postcode":"58130"
                            },
                            {
                                "tumbon":"โป่งสา",
                                "postcode":"58130"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่สะเรียง",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านกาศ",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"แม่สะเรียง",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"แม่คง",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"แม่เหาะ",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"แม่ยวม",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"เสาหิน",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"ป่าแป๋",
                                "postcode":"58110"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่ลาน้อย",
                            "listTumbon":[
                            {
                                "tumbon":"แม่ลาน้อย",
                                "postcode":"58120"
                            },
                            {
                                "tumbon":"แม่ลาหลวง",
                                "postcode":"58120"
                            },
                            {
                                "tumbon":"ท่าผาปุ้ม",
                                "postcode":"58120"
                            },
                            {
                                "tumbon":"แม่โถ",
                                "postcode":"58120"
                            },
                            {
                                "tumbon":"ห้วยห้อม",
                                "postcode":"58120"
                            },
                            {
                                "tumbon":"แม่นาจาง",
                                "postcode":"58120"
                            },
                            {
                                "tumbon":"สันติคีรี",
                                "postcode":"58120"
                            },
                            {
                                "tumbon":"ขุนแม่ลาน้อย",
                                "postcode":"58120"
                            }
                            ]
                        },
                        {
                            "amphur":"สบเมย",
                            "listTumbon":[
                            {
                                "tumbon":"สบเมย",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"แม่คะตวน",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"กองก๋อย",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"แม่สวด",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"ป่าโปง",
                                "postcode":"58110"
                            },
                            {
                                "tumbon":"แม่สามแลบ",
                                "postcode":"58110"
                            }
                            ]
                        },
                        {
                            "amphur":"ปางมะผ้า",
                            "listTumbon":[
                            {
                                "tumbon":"สบป่อง",
                                "postcode":"58150"
                            },
                            {
                                "tumbon":"ปางมะผ้า",
                                "postcode":"58150"
                            },
                            {
                                "tumbon":"ถ้ำลอด",
                                "postcode":"58150"
                            },
                            {
                                "tumbon":"นาปู่ป้อม",
                                "postcode":"58150"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"นครศรีธรรมราช",
                    "listAmphur":[
                        {
                            "amphur":"เมืองนครศรีธรรมราช",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าไร่",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"ปากนคร",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"นาทราย",
                                "postcode":"80280"
                            },
                            {
                                "tumbon":"กำแพงเซา",
                                "postcode":"80280"
                            },
                            {
                                "tumbon":"ไชยมนตรี",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"มะม่วงสองต้น",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"นาเคียน",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"ท่างิ้ว",
                                "postcode":"80280"
                            },
                            {
                                "tumbon":"โพธิ์เสด็จ",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"บางจาก",
                                "postcode":"80330"
                            },
                            {
                                "tumbon":"ปากพูน",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"ท่าซัก",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"ท่าเรือ",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"ในเมือง",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"คลัง",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"ท่าวัง",
                                "postcode":"80000"
                            }
                            ]
                        },
                        {
                            "amphur":"พรหมคีรี",
                            "listTumbon":[
                            {
                                "tumbon":"พรหมโลก",
                                "postcode":"80320"
                            },
                            {
                                "tumbon":"บ้านเกาะ",
                                "postcode":"80320"
                            },
                            {
                                "tumbon":"อินคีรี",
                                "postcode":"80320"
                            },
                            {
                                "tumbon":"ทอนหงส์",
                                "postcode":"80320"
                            },
                            {
                                "tumbon":"นาเรียง",
                                "postcode":"80320"
                            }
                            ]
                        },
                        {
                            "amphur":"ลานสกา",
                            "listTumbon":[
                            {
                                "tumbon":"เขาแก้ว",
                                "postcode":"80230"
                            },
                            {
                                "tumbon":"ลานสกา",
                                "postcode":"80230"
                            },
                            {
                                "tumbon":"ท่าดี",
                                "postcode":"80230"
                            },
                            {
                                "tumbon":"กำโลน",
                                "postcode":"80230"
                            },
                            {
                                "tumbon":"ขุนทะเล",
                                "postcode":"80230"
                            }
                            ]
                        },
                        {
                            "amphur":"ฉวาง",
                            "listTumbon":[
                            {
                                "tumbon":"ฉวาง",
                                "postcode":"80150"
                            },
                            {
                                "tumbon":"ละอาย",
                                "postcode":"80250"
                            },
                            {
                                "tumbon":"นาแว",
                                "postcode":"80260"
                            },
                            {
                                "tumbon":"ไม้เรียง",
                                "postcode":"80260"
                            },
                            {
                                "tumbon":"กะเปียด",
                                "postcode":"80260"
                            },
                            {
                                "tumbon":"นากะชะ",
                                "postcode":"80150"
                            },
                            {
                                "tumbon":"ห้วยปริก",
                                "postcode":"80260"
                            },
                            {
                                "tumbon":"ไสหร้า",
                                "postcode":"80150"
                            },
                            {
                                "tumbon":"นาเขลียง",
                                "postcode":"80260"
                            },
                            {
                                "tumbon":"จันดี",
                                "postcode":"80250"
                            }
                            ]
                        },
                        {
                            "amphur":"พิปูน",
                            "listTumbon":[
                            {
                                "tumbon":"พิปูน",
                                "postcode":"80270"
                            },
                            {
                                "tumbon":"กะทูน",
                                "postcode":"80270"
                            },
                            {
                                "tumbon":"เขาพระ",
                                "postcode":"80270"
                            },
                            {
                                "tumbon":"ยางค้อม",
                                "postcode":"80270"
                            },
                            {
                                "tumbon":"ควนกลาง",
                                "postcode":"80270"
                            }
                            ]
                        },
                        {
                            "amphur":"เชียรใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"เชียรใหญ่",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"ท่าขนาน",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"บ้านกลาง",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"บ้านเนิน",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"ไสหมาก",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"ท้องลำเจียก",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"เสือหึง",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"การะเกด",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"เขาพระบาท",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"แม่เจ้าอยู่หัว",
                                "postcode":"80190"
                            }
                            ]
                        },
                        {
                            "amphur":"ชะอวด",
                            "listTumbon":[
                            {
                                "tumbon":"ชะอวด",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"ท่าเสม็ด",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"ท่าประจะ",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"เคร็ง",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"วังอ่าง",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"บ้านตูล",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"ขอนหาด",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"เกาะขันธ์",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"เขาพระทอง",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"นางหลง",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"ควนหนองหงษ์",
                                "postcode":"80180"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าศาลา",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าศาลา",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"กลาย",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"ท่าขึ้น",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"หัวตะพาน",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"สระแก้ว",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"โมคลาน",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"ไทยบุรี",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"ดอนตะโก",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"ตลิ่งชัน",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"โพธิ์ทอง",
                                "postcode":"80160"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งสง",
                            "listTumbon":[
                            {
                                "tumbon":"ปากแพรก",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"ชะมาย",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"หนองหงส์",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"ควนกรด",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"นาไม้ไผ่",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"นาหลวงเสน",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"เขาโร",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"กะปาง",
                                "postcode":"80310"
                            },
                            {
                                "tumbon":"ที่วัง",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"น้ำตก",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"ถ้ำใหญ่",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"นาโพธิ์",
                                "postcode":"80110"
                            },
                            {
                                "tumbon":"เขาขาว",
                                "postcode":"80110"
                            }
                            ]
                        },
                        {
                            "amphur":"นาบอน",
                            "listTumbon":[
                            {
                                "tumbon":"นาบอน",
                                "postcode":"80220"
                            },
                            {
                                "tumbon":"ทุ่งสง",
                                "postcode":"80220"
                            },
                            {
                                "tumbon":"แก้วแสน",
                                "postcode":"80220"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"ท่ายาง",
                                "postcode":"80240"
                            },
                            {
                                "tumbon":"ทุ่งสัง",
                                "postcode":"80240"
                            },
                            {
                                "tumbon":"ทุ่งใหญ่",
                                "postcode":"80240"
                            },
                            {
                                "tumbon":"กุแหระ",
                                "postcode":"80240"
                            },
                            {
                                "tumbon":"ปริก",
                                "postcode":"80240"
                            },
                            {
                                "tumbon":"บางรูป",
                                "postcode":"80240"
                            },
                            {
                                "tumbon":"กรุงหยัน",
                                "postcode":"80240"
                            }
                            ]
                        },
                        {
                            "amphur":"ปากพนัง",
                            "listTumbon":[
                            {
                                "tumbon":"ปากพนัง",
                                "postcode":"80140"
                            },
                            {
                                "tumbon":"คลองน้อย",
                                "postcode":"80330"
                            },
                            {
                                "tumbon":"ป่าระกำ",
                                "postcode":"80370"
                            },
                            {
                                "tumbon":"ชะเมา",
                                "postcode":"80330"
                            },
                            {
                                "tumbon":"คลองกระบือ",
                                "postcode":"80370"
                            },
                            {
                                "tumbon":"เกาะทวด",
                                "postcode":"80330"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"80370"
                            },
                            {
                                "tumbon":"หูล่อง",
                                "postcode":"80370"
                            },
                            {
                                "tumbon":"แหลมตะลุมพุก",
                                "postcode":"80140"
                            },
                            {
                                "tumbon":"ปากพนังฝั่งตะวันตก",
                                "postcode":"80370"
                            },
                            {
                                "tumbon":"บางศาลา",
                                "postcode":"80370"
                            },
                            {
                                "tumbon":"บางพระ",
                                "postcode":"80140"
                            },
                            {
                                "tumbon":"บางตะพง",
                                "postcode":"80370"
                            },
                            {
                                "tumbon":"ปากพนังฝั่งตะวันออก",
                                "postcode":"80140"
                            },
                            {
                                "tumbon":"บ้านเพิง",
                                "postcode":"80140"
                            },
                            {
                                "tumbon":"ท่าพยา",
                                "postcode":"80140"
                            },
                            {
                                "tumbon":"ปากแพรก",
                                "postcode":"80140"
                            },
                            {
                                "tumbon":"ขนาบนาก",
                                "postcode":"80140"
                            }
                            ]
                        },
                        {
                            "amphur":"ร่อนพิบูลย์",
                            "listTumbon":[
                            {
                                "tumbon":"ร่อนพิบูลย์",
                                "postcode":"80130"
                            },
                            {
                                "tumbon":"หินตก",
                                "postcode":"80350"
                            },
                            {
                                "tumbon":"เสาธง",
                                "postcode":"80350"
                            },
                            {
                                "tumbon":"ควนพัง",
                                "postcode":"80130"
                            },
                            {
                                "tumbon":"ควนชุม",
                                "postcode":"80130"
                            },
                            {
                                "tumbon":"ควนเกย",
                                "postcode":"80130"
                            }
                            ]
                        },
                        {
                            "amphur":"สิชล",
                            "listTumbon":[
                            {
                                "tumbon":"สิชล",
                                "postcode":"80120"
                            },
                            {
                                "tumbon":"ทุ่งปรัง",
                                "postcode":"80120"
                            },
                            {
                                "tumbon":"ฉลอง",
                                "postcode":"80120"
                            },
                            {
                                "tumbon":"เสาเภา",
                                "postcode":"80340"
                            },
                            {
                                "tumbon":"เปลี่ยน",
                                "postcode":"80120"
                            },
                            {
                                "tumbon":"สี่ขีด",
                                "postcode":"80120"
                            },
                            {
                                "tumbon":"เทพราช",
                                "postcode":"80340"
                            },
                            {
                                "tumbon":"เขาน้อย",
                                "postcode":"80120"
                            },
                            {
                                "tumbon":"ทุ่งใส",
                                "postcode":"80120"
                            }
                            ]
                        },
                        {
                            "amphur":"ขนอม",
                            "listTumbon":[
                            {
                                "tumbon":"ขนอม",
                                "postcode":"80210"
                            },
                            {
                                "tumbon":"ควนทอง",
                                "postcode":"80210"
                            },
                            {
                                "tumbon":"ท้องเนียน",
                                "postcode":"80210"
                            }
                            ]
                        },
                        {
                            "amphur":"หัวไทร",
                            "listTumbon":[
                            {
                                "tumbon":"หัวไทร",
                                "postcode":"80170"
                            },
                            {
                                "tumbon":"หน้าสตน",
                                "postcode":"80170"
                            },
                            {
                                "tumbon":"ทรายขาว",
                                "postcode":"80170"
                            },
                            {
                                "tumbon":"แหลม",
                                "postcode":"80170"
                            },
                            {
                                "tumbon":"เขาพังไกร",
                                "postcode":"80170"
                            },
                            {
                                "tumbon":"บ้านราม",
                                "postcode":"80170"
                            },
                            {
                                "tumbon":"บางนบ",
                                "postcode":"80170"
                            },
                            {
                                "tumbon":"ท่าซอม",
                                "postcode":"80170"
                            },
                            {
                                "tumbon":"ควนชะลิก",
                                "postcode":"80170"
                            },
                            {
                                "tumbon":"รามแก้ว",
                                "postcode":"80170"
                            },
                            {
                                "tumbon":"เกาะเพชร",
                                "postcode":"80170"
                            }
                            ]
                        },
                        {
                            "amphur":"บางขัน",
                            "listTumbon":[
                            {
                                "tumbon":"บางขัน",
                                "postcode":"80360"
                            },
                            {
                                "tumbon":"บ้านลำนาว",
                                "postcode":"80360"
                            },
                            {
                                "tumbon":"วังหิน",
                                "postcode":"80360"
                            },
                            {
                                "tumbon":"บ้านนิคม",
                                "postcode":"80360"
                            }
                            ]
                        },
                        {
                            "amphur":"ถ้ำพรรณรา",
                            "listTumbon":[
                            {
                                "tumbon":"ถ้ำพรรณรา",
                                "postcode":"80260"
                            },
                            {
                                "tumbon":"คลองเส",
                                "postcode":"80260"
                            },
                            {
                                "tumbon":"ดุสิต",
                                "postcode":"80260"
                            }
                            ]
                        },
                        {
                            "amphur":"จุฬาภรณ์",
                            "listTumbon":[
                            {
                                "tumbon":"สามตำบล",
                                "postcode":"80130"
                            },
                            {
                                "tumbon":"ควนหนองคว้า",
                                "postcode":"80130"
                            },
                            {
                                "tumbon":"ทุ่งโพธิ์",
                                "postcode":"80130"
                            },
                            {
                                "tumbon":"นาหมอบุญ",
                                "postcode":"80130"
                            },
                            {
                                "tumbon":"บ้านควนมุด",
                                "postcode":"80180"
                            },
                            {
                                "tumbon":"บ้านชะอวด",
                                "postcode":"80180"
                            }
                            ]
                        },
                        {
                            "amphur":"พระพรหม",
                            "listTumbon":[
                            {
                                "tumbon":"นาพรุ",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"นาสาร",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"ท้ายสำเภา",
                                "postcode":"80000"
                            },
                            {
                                "tumbon":"ช้างซ้าย",
                                "postcode":"80000"
                            }
                            ]
                        },
                        {
                            "amphur":"นบพิตำ",
                            "listTumbon":[
                            {
                                "tumbon":"นบพิตำ",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"กะหรอ",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"นาเหรง",
                                "postcode":"80160"
                            },
                            {
                                "tumbon":"กรุงชิง",
                                "postcode":"80160"
                            }
                            ]
                        },
                        {
                            "amphur":"ช้างกลาง",
                            "listTumbon":[
                            {
                                "tumbon":"ช้างกลาง",
                                "postcode":"80250"
                            },
                            {
                                "tumbon":"หลักช้าง",
                                "postcode":"80250"
                            },
                            {
                                "tumbon":"สวนขัน",
                                "postcode":"80250"
                            }
                            ]
                        },
                        {
                            "amphur":"เฉลิมพระเกียรติ",
                            "listTumbon":[
                            {
                                "tumbon":"เชียรเขา",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"ดอนตรอ",
                                "postcode":"80290"
                            },
                            {
                                "tumbon":"สวนหลวง",
                                "postcode":"80190"
                            },
                            {
                                "tumbon":"ทางพูน",
                                "postcode":"80290"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สุราษฎร์ธานี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสุราษฎร์ธานี",
                            "listTumbon":[
                            {
                                "tumbon":"ตลาด",
                                "postcode":"84000"
                            },
                            {
                                "tumbon":"มะขามเตี้ย",
                                "postcode":"84000"
                            },
                            {
                                "tumbon":"วัดประดู่",
                                "postcode":"84000"
                            },
                            {
                                "tumbon":"ขุนทะเล",
                                "postcode":"84100"
                            },
                            {
                                "tumbon":"บางใบไม้",
                                "postcode":"84000"
                            },
                            {
                                "tumbon":"บางชนะ",
                                "postcode":"84000"
                            },
                            {
                                "tumbon":"คลองน้อย",
                                "postcode":"84000"
                            },
                            {
                                "tumbon":"บางไทร",
                                "postcode":"84000"
                            },
                            {
                                "tumbon":"บางโพธิ์",
                                "postcode":"84000"
                            },
                            {
                                "tumbon":"บางกุ้ง",
                                "postcode":"84000"
                            },
                            {
                                "tumbon":"คลองฉนาก",
                                "postcode":"84000"
                            }
                            ]
                        },
                        {
                            "amphur":"กาญจนดิษฐ์",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าทองใหม่",
                                "postcode":"84290"
                            },
                            {
                                "tumbon":"ท่าทอง",
                                "postcode":"84160"
                            },
                            {
                                "tumbon":"กะแดะ",
                                "postcode":"84160"
                            },
                            {
                                "tumbon":"ทุ่งกง",
                                "postcode":"84290"
                            },
                            {
                                "tumbon":"กรูด",
                                "postcode":"84160"
                            },
                            {
                                "tumbon":"ช้างซ้าย",
                                "postcode":"84160"
                            },
                            {
                                "tumbon":"พลายวาส",
                                "postcode":"84160"
                            },
                            {
                                "tumbon":"ป่าร่อน",
                                "postcode":"84160"
                            },
                            {
                                "tumbon":"ตะเคียนทอง",
                                "postcode":"84160"
                            },
                            {
                                "tumbon":"ช้างขวา",
                                "postcode":"84160"
                            },
                            {
                                "tumbon":"ท่าอุแท",
                                "postcode":"84160"
                            },
                            {
                                "tumbon":"ทุ่งรัง",
                                "postcode":"84290"
                            },
                            {
                                "tumbon":"คลองสระ",
                                "postcode":"84160"
                            }
                            ]
                        },
                        {
                            "amphur":"ดอนสัก",
                            "listTumbon":[
                            {
                                "tumbon":"ดอนสัก",
                                "postcode":"84220"
                            },
                            {
                                "tumbon":"ชลคราม",
                                "postcode":"84160"
                            },
                            {
                                "tumbon":"ไชยคราม",
                                "postcode":"84220"
                            },
                            {
                                "tumbon":"ปากแพรก",
                                "postcode":"84340"
                            }
                            ]
                        },
                        {
                            "amphur":"เกาะสมุย",
                            "listTumbon":[
                            {
                                "tumbon":"อ่างทอง",
                                "postcode":"84140"
                            },
                            {
                                "tumbon":"ลิปะน้อย",
                                "postcode":"84140"
                            },
                            {
                                "tumbon":"ตลิ่งงาม",
                                "postcode":"84140"
                            },
                            {
                                "tumbon":"หน้าเมือง",
                                "postcode":"84140"
                            },
                            {
                                "tumbon":"มะเร็ต",
                                "postcode":"84310"
                            },
                            {
                                "tumbon":"บ่อผุด",
                                "postcode":"84320"
                            },
                            {
                                "tumbon":"แม่น้ำ",
                                "postcode":"84330"
                            }
                            ]
                        },
                        {
                            "amphur":"เกาะพะงัน",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะพะงัน",
                                "postcode":"84280"
                            },
                            {
                                "tumbon":"บ้านใต้",
                                "postcode":"84280"
                            },
                            {
                                "tumbon":"เกาะเต่า",
                                "postcode":"84280"
                            }
                            ]
                        },
                        {
                            "amphur":"ไชยา",
                            "listTumbon":[
                            {
                                "tumbon":"ตลาดไชยา",
                                "postcode":"84110"
                            },
                            {
                                "tumbon":"พุมเรียง",
                                "postcode":"84110"
                            },
                            {
                                "tumbon":"เลม็ด",
                                "postcode":"84110"
                            },
                            {
                                "tumbon":"เวียง",
                                "postcode":"84110"
                            },
                            {
                                "tumbon":"ทุ่ง",
                                "postcode":"84110"
                            },
                            {
                                "tumbon":"ป่าเว",
                                "postcode":"84110"
                            },
                            {
                                "tumbon":"ตะกรบ",
                                "postcode":"84110"
                            },
                            {
                                "tumbon":"โมถ่าย",
                                "postcode":"84110"
                            },
                            {
                                "tumbon":"ปากหมาก",
                                "postcode":"84110"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าชนะ",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าชนะ",
                                "postcode":"84170"
                            },
                            {
                                "tumbon":"สมอทอง",
                                "postcode":"84170"
                            },
                            {
                                "tumbon":"ประสงค์",
                                "postcode":"84170"
                            },
                            {
                                "tumbon":"คันธุลี",
                                "postcode":"84170"
                            },
                            {
                                "tumbon":"วัง",
                                "postcode":"84170"
                            },
                            {
                                "tumbon":"คลองพา",
                                "postcode":"84170"
                            }
                            ]
                        },
                        {
                            "amphur":"คีรีรัฐนิคม",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าขนอน",
                                "postcode":"84180"
                            },
                            {
                                "tumbon":"บ้านยาง",
                                "postcode":"84180"
                            },
                            {
                                "tumbon":"น้ำหัก",
                                "postcode":"84180"
                            },
                            {
                                "tumbon":"กะเปา",
                                "postcode":"84180"
                            },
                            {
                                "tumbon":"ท่ากระดาน",
                                "postcode":"84180"
                            },
                            {
                                "tumbon":"ย่านยาว",
                                "postcode":"84180"
                            },
                            {
                                "tumbon":"ถ้ำสิงขร",
                                "postcode":"84180"
                            },
                            {
                                "tumbon":"บ้านทำเนียบ",
                                "postcode":"84180"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านตาขุน",
                            "listTumbon":[
                            {
                                "tumbon":"เขาวง",
                                "postcode":"84230"
                            },
                            {
                                "tumbon":"พะแสง",
                                "postcode":"84230"
                            },
                            {
                                "tumbon":"พรุไทย",
                                "postcode":"84230"
                            },
                            {
                                "tumbon":"เขาพัง",
                                "postcode":"84230"
                            }
                            ]
                        },
                        {
                            "amphur":"พนม",
                            "listTumbon":[
                            {
                                "tumbon":"พนม",
                                "postcode":"84250"
                            },
                            {
                                "tumbon":"ต้นยวน",
                                "postcode":"84250"
                            },
                            {
                                "tumbon":"คลองศก",
                                "postcode":"84250"
                            },
                            {
                                "tumbon":"พลูเถื่อน",
                                "postcode":"84250"
                            },
                            {
                                "tumbon":"พังกาญจน์",
                                "postcode":"84250"
                            },
                            {
                                "tumbon":"คลองชะอุ่น",
                                "postcode":"84250"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าฉาง",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าฉาง",
                                "postcode":"84150"
                            },
                            {
                                "tumbon":"ท่าเคย",
                                "postcode":"84150"
                            },
                            {
                                "tumbon":"คลองไทร",
                                "postcode":"84150"
                            },
                            {
                                "tumbon":"เขาถ่าน",
                                "postcode":"84150"
                            },
                            {
                                "tumbon":"เสวียด",
                                "postcode":"84150"
                            },
                            {
                                "tumbon":"ปากฉลุย",
                                "postcode":"84150"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านนาสาร",
                            "listTumbon":[
                            {
                                "tumbon":"นาสาร",
                                "postcode":"84120"
                            },
                            {
                                "tumbon":"พรุพี",
                                "postcode":"84270"
                            },
                            {
                                "tumbon":"ทุ่งเตา",
                                "postcode":"84120"
                            },
                            {
                                "tumbon":"ลำพูน",
                                "postcode":"84120"
                            },
                            {
                                "tumbon":"ท่าชี",
                                "postcode":"84120"
                            },
                            {
                                "tumbon":"ควนศรี",
                                "postcode":"84270"
                            },
                            {
                                "tumbon":"ควนสุบรรณ",
                                "postcode":"84120"
                            },
                            {
                                "tumbon":"คลองปราบ",
                                "postcode":"84120"
                            },
                            {
                                "tumbon":"น้ำพุ",
                                "postcode":"84120"
                            },
                            {
                                "tumbon":"ทุ่งเตาใหม่",
                                "postcode":"84120"
                            },
                            {
                                "tumbon":"เพิ่มพูนทรัพย์",
                                "postcode":"84120"
                            }
                            ]
                        },
                        {
                            "amphur":"บ้านนาเดิม",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"84240"
                            },
                            {
                                "tumbon":"ท่าเรือ",
                                "postcode":"84240"
                            },
                            {
                                "tumbon":"ทรัพย์ทวี",
                                "postcode":"84240"
                            },
                            {
                                "tumbon":"นาใต้",
                                "postcode":"84240"
                            }
                            ]
                        },
                        {
                            "amphur":"เคียนซา",
                            "listTumbon":[
                            {
                                "tumbon":"เคียนซา",
                                "postcode":"84260"
                            },
                            {
                                "tumbon":"พ่วงพรมคร",
                                "postcode":"84210"
                            },
                            {
                                "tumbon":"เขาตอก",
                                "postcode":"84260"
                            },
                            {
                                "tumbon":"อรัญคามวารี",
                                "postcode":"84260"
                            },
                            {
                                "tumbon":"บ้านเสด็จ",
                                "postcode":"84260"
                            }
                            ]
                        },
                        {
                            "amphur":"เวียงสระ",
                            "listTumbon":[
                            {
                                "tumbon":"เวียงสระ",
                                "postcode":"84190"
                            },
                            {
                                "tumbon":"บ้านส้อง",
                                "postcode":"84190"
                            },
                            {
                                "tumbon":"คลองฉนวน",
                                "postcode":"84190"
                            },
                            {
                                "tumbon":"ทุ่งหลวง",
                                "postcode":"84190"
                            },
                            {
                                "tumbon":"เขานิพันธ์",
                                "postcode":"84190"
                            }
                            ]
                        },
                        {
                            "amphur":"พระแสง",
                            "listTumbon":[
                            {
                                "tumbon":"อิปัน",
                                "postcode":"84210"
                            },
                            {
                                "tumbon":"สินปุน",
                                "postcode":"84210"
                            },
                            {
                                "tumbon":"บางสวรรค์",
                                "postcode":"84210"
                            },
                            {
                                "tumbon":"ไทรขึง",
                                "postcode":"84210"
                            },
                            {
                                "tumbon":"สินเจริญ",
                                "postcode":"84210"
                            },
                            {
                                "tumbon":"ไทรโสภา",
                                "postcode":"84210"
                            },
                            {
                                "tumbon":"สาคู",
                                "postcode":"84210"
                            }
                            ]
                        },
                        {
                            "amphur":"พุนพิน",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"ท่าสะท้อน",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"ลีเล็ด",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"บางมะเดื่อ",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"บางเดือน",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"ท่าโรงช้าง",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"กรูด",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"พุนพิน",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"บางงอน",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"ศรีวิชัย",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"น้ำรอบ",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"มะลวน",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"หัวเตย",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"หนองไทร",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"เขาหัวควาย",
                                "postcode":"84130"
                            },
                            {
                                "tumbon":"ตะปาน",
                                "postcode":"84130"
                            }
                            ]
                        },
                        {
                            "amphur":"ชัยบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"สองแพรก",
                                "postcode":"84350"
                            },
                            {
                                "tumbon":"ชัยบุรี",
                                "postcode":"84350"
                            },
                            {
                                "tumbon":"คลองน้อย",
                                "postcode":"84350"
                            },
                            {
                                "tumbon":"ไทรทอง",
                                "postcode":"84350"
                            }
                            ]
                        },
                        {
                            "amphur":"วิภาวดี",
                            "listTumbon":[
                            {
                                "tumbon":"ตะกุกใต้",
                                "postcode":"84180"
                            },
                            {
                                "tumbon":"ตะกุกเหนือ",
                                "postcode":"84180"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ชุมพร",
                    "listAmphur":[
                        {
                            "amphur":"เมืองชุมพร",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าตะเภา",
                                "postcode":"86000"
                            },
                            {
                                "tumbon":"ท่ายาง",
                                "postcode":"86000"
                            },
                            {
                                "tumbon":"เกาะทะลุ",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะงามเล็ก",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะงามใหญ่",
                                "postcode":""
                            },
                            {
                                "tumbon":"บางหมาก",
                                "postcode":"86000"
                            },
                            {
                                "tumbon":"นาทุ่ง",
                                "postcode":"86000"
                            },
                            {
                                "tumbon":"นาชะอัง",
                                "postcode":"86000"
                            },
                            {
                                "tumbon":"เกาะกินหลักง้ำ",
                                "postcode":""
                            },
                            {
                                "tumbon":"ตากแดด",
                                "postcode":"86000"
                            },
                            {
                                "tumbon":"บางลึก",
                                "postcode":"86000"
                            },
                            {
                                "tumbon":"หาดพันไกร",
                                "postcode":"86000"
                            },
                            {
                                "tumbon":"วังไผ่",
                                "postcode":"86000"
                            },
                            {
                                "tumbon":"วังใหม่",
                                "postcode":"86190"
                            },
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"86190"
                            },
                            {
                                "tumbon":"ขุนกระทิง",
                                "postcode":"86190"
                            },
                            {
                                "tumbon":"ทุ่งคา",
                                "postcode":"86100"
                            },
                            {
                                "tumbon":"วิสัยเหนือ",
                                "postcode":"86100"
                            },
                            {
                                "tumbon":"เกาะกา",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะรังกาจิว",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะมะพร้าว",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะหลักแรด",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะทองหลาง",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะละวะ",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะอีแรด",
                                "postcode":""
                            },
                            {
                                "tumbon":"หาดทรายรี",
                                "postcode":"86120"
                            },
                            {
                                "tumbon":"เกาะสาก",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะมาตรา",
                                "postcode":""
                            },
                            {
                                "tumbon":"ถ้ำสิงห์",
                                "postcode":"86100"
                            },
                            {
                                "tumbon":"เกาะมัตโพน",
                                "postcode":""
                            },
                            {
                                "tumbon":"ปากน้ำ",
                                "postcode":"86120"
                            },
                            {
                                "tumbon":"เกาะเสม็ด",
                                "postcode":""
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าแซะ",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าแซะ",
                                "postcode":"86140"
                            },
                            {
                                "tumbon":"คุริง",
                                "postcode":"86140"
                            },
                            {
                                "tumbon":"สลุย",
                                "postcode":"86140"
                            },
                            {
                                "tumbon":"รับร่อ",
                                "postcode":"86190"
                            },
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"86140"
                            },
                            {
                                "tumbon":"หงษ์เจริญ",
                                "postcode":"86140"
                            },
                            {
                                "tumbon":"หินแก้ว",
                                "postcode":"86190"
                            },
                            {
                                "tumbon":"สองพี่น้อง",
                                "postcode":"86140"
                            },
                            {
                                "tumbon":"ทรัพย์อนันต์",
                                "postcode":"86140"
                            },
                            {
                                "tumbon":"นากระตาม",
                                "postcode":"86140"
                            }
                            ]
                        },
                        {
                            "amphur":"ปะทิว",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะร้านไก่",
                                "postcode":""
                            },
                            {
                                "tumbon":"บางสน",
                                "postcode":"86160"
                            },
                            {
                                "tumbon":"ทะเลทรัพย์",
                                "postcode":"86160"
                            },
                            {
                                "tumbon":"สะพลี",
                                "postcode":"86230"
                            },
                            {
                                "tumbon":"เกาะไข่",
                                "postcode":""
                            },
                            {
                                "tumbon":"ชุมโค",
                                "postcode":"86160"
                            },
                            {
                                "tumbon":"ดอนยาง",
                                "postcode":"86210"
                            },
                            {
                                "tumbon":"เกาะยอ",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะซีกง",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะพระ",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะรัง",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะร้านเป็ด",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะเอียง",
                                "postcode":""
                            },
                            {
                                "tumbon":"ปากคลอง",
                                "postcode":"86210"
                            },
                            {
                                "tumbon":"เขาไชยราช",
                                "postcode":"86210"
                            }
                            ]
                        },
                        {
                            "amphur":"หลังสวน",
                            "listTumbon":[
                            {
                                "tumbon":"หลังสวน",
                                "postcode":"86110"
                            },
                            {
                                "tumbon":"ขันเงิน",
                                "postcode":"86110"
                            },
                            {
                                "tumbon":"ท่ามะพลา",
                                "postcode":"86110"
                            },
                            {
                                "tumbon":"นาขา",
                                "postcode":"86110"
                            },
                            {
                                "tumbon":"นาพญา",
                                "postcode":"86110"
                            },
                            {
                                "tumbon":"บ้านควน",
                                "postcode":"86110"
                            },
                            {
                                "tumbon":"บางมะพร้าว",
                                "postcode":"86110"
                            },
                            {
                                "tumbon":"บางน้ำจืด",
                                "postcode":"86150"
                            },
                            {
                                "tumbon":"เกาะพิทักษ์",
                                "postcode":""
                            },
                            {
                                "tumbon":"ปากน้ำ",
                                "postcode":"86150"
                            },
                            {
                                "tumbon":"พ้อแดง",
                                "postcode":"86110"
                            },
                            {
                                "tumbon":"แหลมทราย",
                                "postcode":"86110"
                            },
                            {
                                "tumbon":"วังตะกอ",
                                "postcode":"86110"
                            },
                            {
                                "tumbon":"หาดยาย",
                                "postcode":"86110"
                            }
                            ]
                        },
                        {
                            "amphur":"ละแม",
                            "listTumbon":[
                            {
                                "tumbon":"ละแม",
                                "postcode":"86170"
                            },
                            {
                                "tumbon":"ทุ่งหลวง",
                                "postcode":"86170"
                            },
                            {
                                "tumbon":"สวนแตง",
                                "postcode":"86170"
                            },
                            {
                                "tumbon":"ทุ่งคาวัด",
                                "postcode":"86170"
                            }
                            ]
                        },
                        {
                            "amphur":"พะโต๊ะ",
                            "listTumbon":[
                            {
                                "tumbon":"พะโต๊ะ",
                                "postcode":"86180"
                            },
                            {
                                "tumbon":"ปากทรง",
                                "postcode":"86180"
                            },
                            {
                                "tumbon":"ปังหวาน",
                                "postcode":"86180"
                            },
                            {
                                "tumbon":"พระรักษ์",
                                "postcode":"86180"
                            }
                            ]
                        },
                        {
                            "amphur":"สวี",
                            "listTumbon":[
                            {
                                "tumbon":"นาโพธิ์",
                                "postcode":"86130"
                            },
                            {
                                "tumbon":"สวี",
                                "postcode":"86130"
                            },
                            {
                                "tumbon":"ทุ่งระยะ",
                                "postcode":"86130"
                            },
                            {
                                "tumbon":"ท่าหิน",
                                "postcode":"86130"
                            },
                            {
                                "tumbon":"ปากแพรก",
                                "postcode":"86130"
                            },
                            {
                                "tumbon":"เกาะพัดหวายใหญ่",
                                "postcode":""
                            },
                            {
                                "tumbon":"ด่านสวี",
                                "postcode":"86130"
                            },
                            {
                                "tumbon":"เกาะแมว",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะพัดหวายเล็ก",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะบาตร์",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะทองแก้ว",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะกุลา",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะแรด",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะหนู",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะกระ",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะยูง",
                                "postcode":""
                            },
                            {
                                "tumbon":"ครน",
                                "postcode":"86130"
                            },
                            {
                                "tumbon":"วิสัยใต้",
                                "postcode":"86130"
                            },
                            {
                                "tumbon":"นาสัก",
                                "postcode":"86130"
                            },
                            {
                                "tumbon":"เขาทะลุ",
                                "postcode":"86130"
                            },
                            {
                                "tumbon":"เขาค่าย",
                                "postcode":"86130"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งตะโก",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะคราม",
                                "postcode":""
                            },
                            {
                                "tumbon":"ปากตะโก",
                                "postcode":"86220"
                            },
                            {
                                "tumbon":"เกาะรางบรรทัด",
                                "postcode":""
                            },
                            {
                                "tumbon":"หมู่เกาะศรีอบยา",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะสูบ",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะขี้นก",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะคางสือ",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะมะพร้าว",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะมุก",
                                "postcode":""
                            },
                            {
                                "tumbon":"เกาะยอ",
                                "postcode":""
                            },
                            {
                                "tumbon":"ทุ่งตะไคร",
                                "postcode":"86220"
                            },
                            {
                                "tumbon":"ตะโก",
                                "postcode":"86220"
                            },
                            {
                                "tumbon":"ช่องไม้แก้ว",
                                "postcode":"86220"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ระนอง",
                    "listAmphur":[
                        {
                            "amphur":"เมืองระนอง",
                            "listTumbon":[
                            {
                                "tumbon":"เขานิเวศน์",
                                "postcode":"85000"
                            },
                            {
                                "tumbon":"ราชกรูด",
                                "postcode":"85000"
                            },
                            {
                                "tumbon":"หงาว",
                                "postcode":"85000"
                            },
                            {
                                "tumbon":"บางริ้น",
                                "postcode":"85000"
                            },
                            {
                                "tumbon":"ปากน้ำ",
                                "postcode":"85000"
                            },
                            {
                                "tumbon":"บางนอน",
                                "postcode":"85000"
                            },
                            {
                                "tumbon":"หาดส้มแป้น",
                                "postcode":"85000"
                            },
                            {
                                "tumbon":"ทรายแดง",
                                "postcode":"85130"
                            },
                            {
                                "tumbon":"เกาะพยาม",
                                "postcode":"85000"
                            }
                            ]
                        },
                        {
                            "amphur":"ละอุ่น",
                            "listTumbon":[
                            {
                                "tumbon":"ละอุ่นใต้",
                                "postcode":"85130"
                            },
                            {
                                "tumbon":"ละอุ่นเหนือ",
                                "postcode":"85130"
                            },
                            {
                                "tumbon":"บางพระใต้",
                                "postcode":"85130"
                            },
                            {
                                "tumbon":"บางพระเหนือ",
                                "postcode":"85130"
                            },
                            {
                                "tumbon":"บางแก้ว",
                                "postcode":"85130"
                            },
                            {
                                "tumbon":"ในวงเหนือ",
                                "postcode":"85130"
                            },
                            {
                                "tumbon":"ในวงใต้",
                                "postcode":"85130"
                            }
                            ]
                        },
                        {
                            "amphur":"กะเปอร์",
                            "listTumbon":[
                            {
                                "tumbon":"ม่วงกลวง",
                                "postcode":"85120"
                            },
                            {
                                "tumbon":"กะเปอร์",
                                "postcode":"85120"
                            },
                            {
                                "tumbon":"เชี่ยวเหลียง",
                                "postcode":"85120"
                            },
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"85120"
                            },
                            {
                                "tumbon":"บางหิน",
                                "postcode":"85120"
                            }
                            ]
                        },
                        {
                            "amphur":"กระบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"น้ำจืด",
                                "postcode":"85110"
                            },
                            {
                                "tumbon":"น้ำจืดน้อย",
                                "postcode":"85110"
                            },
                            {
                                "tumbon":"มะมุ",
                                "postcode":"85110"
                            },
                            {
                                "tumbon":"ปากจั่น",
                                "postcode":"85110"
                            },
                            {
                                "tumbon":"ลำเลียง",
                                "postcode":"85110"
                            },
                            {
                                "tumbon":"จ.ป.ร.",
                                "postcode":"85110"
                            },
                            {
                                "tumbon":"บางใหญ่",
                                "postcode":"85110"
                            }
                            ]
                        },
                        {
                            "amphur":"สุขสำราญ",
                            "listTumbon":[
                            {
                                "tumbon":"นาคา",
                                "postcode":"85120"
                            },
                            {
                                "tumbon":"กำพวน",
                                "postcode":"85120"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"พังงา",
                    "listAmphur":[
                        {
                            "amphur":"เมืองพังงา",
                            "listTumbon":[
                            {
                                "tumbon":"นบปริง",
                                "postcode":"82000"
                            },
                            {
                                "tumbon":"ถ้ำน้ำผุด",
                                "postcode":"82000"
                            },
                            {
                                "tumbon":"บางเตย",
                                "postcode":"82000"
                            },
                            {
                                "tumbon":"ตากแดด",
                                "postcode":"82000"
                            },
                            {
                                "tumbon":"สองแพรก",
                                "postcode":"82000"
                            },
                            {
                                "tumbon":"ทุ่งคาโงก",
                                "postcode":"82000"
                            },
                            {
                                "tumbon":"เกาะปันหยี",
                                "postcode":"82000"
                            },
                            {
                                "tumbon":"ป่ากอ",
                                "postcode":"82000"
                            },
                            {
                                "tumbon":"ท้ายช้าง",
                                "postcode":"82000"
                            }
                            ]
                        },
                        {
                            "amphur":"เกาะยาว",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะยาวน้อย",
                                "postcode":"82160"
                            },
                            {
                                "tumbon":"เกาะยาวใหญ่",
                                "postcode":"82160"
                            },
                            {
                                "tumbon":"พรุใน",
                                "postcode":"83000"
                            }
                            ]
                        },
                        {
                            "amphur":"กะปง",
                            "listTumbon":[
                            {
                                "tumbon":"กะปง",
                                "postcode":"82170"
                            },
                            {
                                "tumbon":"ท่านา",
                                "postcode":"82170"
                            },
                            {
                                "tumbon":"เหมาะ",
                                "postcode":"82170"
                            },
                            {
                                "tumbon":"เหล",
                                "postcode":"82170"
                            },
                            {
                                "tumbon":"รมณีย์",
                                "postcode":"82170"
                            }
                            ]
                        },
                        {
                            "amphur":"ตะกั่วทุ่ง",
                            "listTumbon":[
                            {
                                "tumbon":"ถ้ำ",
                                "postcode":"82130"
                            },
                            {
                                "tumbon":"กระโสม",
                                "postcode":"82130"
                            },
                            {
                                "tumbon":"กะไหล",
                                "postcode":"82130"
                            },
                            {
                                "tumbon":"ท่าอยู่",
                                "postcode":"82130"
                            },
                            {
                                "tumbon":"หล่อยูง",
                                "postcode":"82140"
                            },
                            {
                                "tumbon":"โคกกลอย",
                                "postcode":"82140"
                            },
                            {
                                "tumbon":"คลองเคียน",
                                "postcode":"82130"
                            }
                            ]
                        },
                        {
                            "amphur":"ตะกั่วป่า",
                            "listTumbon":[
                            {
                                "tumbon":"ตะกั่วป่า",
                                "postcode":"82110"
                            },
                            {
                                "tumbon":"บางนายสี",
                                "postcode":"82110"
                            },
                            {
                                "tumbon":"บางไทร",
                                "postcode":"82110"
                            },
                            {
                                "tumbon":"บางม่วง",
                                "postcode":"82190"
                            },
                            {
                                "tumbon":"ตำตัว",
                                "postcode":"82110"
                            },
                            {
                                "tumbon":"โคกเคียน",
                                "postcode":"82110"
                            },
                            {
                                "tumbon":"คึกคัก",
                                "postcode":"82220"
                            },
                            {
                                "tumbon":"เกาะคอเขา",
                                "postcode":"82190"
                            }
                            ]
                        },
                        {
                            "amphur":"คุระบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"คุระ",
                                "postcode":"82150"
                            },
                            {
                                "tumbon":"บางวัน",
                                "postcode":"82150"
                            },
                            {
                                "tumbon":"เกาะพระทอง",
                                "postcode":"82150"
                            },
                            {
                                "tumbon":"แม่นางขาว",
                                "postcode":"82150"
                            }
                            ]
                        },
                        {
                            "amphur":"ทับปุด",
                            "listTumbon":[
                            {
                                "tumbon":"ทับปุด",
                                "postcode":"82180"
                            },
                            {
                                "tumbon":"มะรุ่ย",
                                "postcode":"82180"
                            },
                            {
                                "tumbon":"บ่อแสน",
                                "postcode":"82180"
                            },
                            {
                                "tumbon":"ถ้ำทองหลาง",
                                "postcode":"82180"
                            },
                            {
                                "tumbon":"โคกเจริญ",
                                "postcode":"82180"
                            },
                            {
                                "tumbon":"บางเหรียง",
                                "postcode":"82180"
                            }
                            ]
                        },
                        {
                            "amphur":"ท้ายเหมือง",
                            "listTumbon":[
                            {
                                "tumbon":"ท้ายเหมือง",
                                "postcode":"82120"
                            },
                            {
                                "tumbon":"นาเตย",
                                "postcode":"82120"
                            },
                            {
                                "tumbon":"บางทอง",
                                "postcode":"82120"
                            },
                            {
                                "tumbon":"ทุ่งมะพร้าว",
                                "postcode":"82120"
                            },
                            {
                                "tumbon":"ลำภี",
                                "postcode":"82120"
                            },
                            {
                                "tumbon":"ลำแก่น",
                                "postcode":"82210"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ภูเก็ต",
                    "listAmphur":[
                        {
                            "amphur":"เมืองภูเก็ต",
                            "listTumbon":[
                            {
                                "tumbon":"ตลาดใหญ่",
                                "postcode":"83000"
                            },
                            {
                                "tumbon":"ตลาดเหนือ",
                                "postcode":"83000"
                            },
                            {
                                "tumbon":"เกาะแก้ว",
                                "postcode":"83000"
                            },
                            {
                                "tumbon":"รัษฎา",
                                "postcode":"83000"
                            },
                            {
                                "tumbon":"วิชิต",
                                "postcode":"83000"
                            },
                            {
                                "tumbon":"ฉลอง",
                                "postcode":"83000"
                            },
                            {
                                "tumbon":"ราไวย์",
                                "postcode":"83100"
                            },
                            {
                                "tumbon":"กะรน",
                                "postcode":"83100"
                            }
                            ]
                        },
                        {
                            "amphur":"กะทู้",
                            "listTumbon":[
                            {
                                "tumbon":"กะทู้",
                                "postcode":"83120"
                            },
                            {
                                "tumbon":"ป่าตอง",
                                "postcode":"83150"
                            },
                            {
                                "tumbon":"กมลา",
                                "postcode":"83120"
                            }
                            ]
                        },
                        {
                            "amphur":"ถลาง",
                            "listTumbon":[
                            {
                                "tumbon":"เทพกระษัตรี",
                                "postcode":"83110"
                            },
                            {
                                "tumbon":"ศรีสุนทร",
                                "postcode":"83110"
                            },
                            {
                                "tumbon":"เชิงทะเล",
                                "postcode":"83110"
                            },
                            {
                                "tumbon":"ป่าคลอก",
                                "postcode":"83110"
                            },
                            {
                                "tumbon":"ไม้ขาว",
                                "postcode":"83110"
                            },
                            {
                                "tumbon":"สาคู",
                                "postcode":"83110"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"กระบี่",
                    "listAmphur":[
                        {
                            "amphur":"เมืองกระบี่",
                            "listTumbon":[
                            {
                                "tumbon":"กระบี่น้อย",
                                "postcode":"81000"
                            },
                            {
                                "tumbon":"เขาคราม",
                                "postcode":"81000"
                            },
                            {
                                "tumbon":"เขาทอง",
                                "postcode":"81000"
                            },
                            {
                                "tumbon":"ทับปริก",
                                "postcode":"81000"
                            },
                            {
                                "tumbon":"ไสไทย",
                                "postcode":"81000"
                            },
                            {
                                "tumbon":"อ่าวนาง",
                                "postcode":"81180"
                            },
                            {
                                "tumbon":"หนองทะเล",
                                "postcode":"81180"
                            },
                            {
                                "tumbon":"คลองประสงค์",
                                "postcode":"81000"
                            },
                            {
                                "tumbon":"กระบี่ใหญ่",
                                "postcode":"81000"
                            },
                            {
                                "tumbon":"ปากน้ำ",
                                "postcode":"81000"
                            }
                            ]
                        },
                        {
                            "amphur":"เขาพนม",
                            "listTumbon":[
                            {
                                "tumbon":"เขาพนม",
                                "postcode":"81140"
                            },
                            {
                                "tumbon":"เขาดิน",
                                "postcode":"81140"
                            },
                            {
                                "tumbon":"สินปุน",
                                "postcode":"80240"
                            },
                            {
                                "tumbon":"พรุเตียว",
                                "postcode":"81140"
                            },
                            {
                                "tumbon":"หน้าเขา",
                                "postcode":"81140"
                            },
                            {
                                "tumbon":"โคกหาร",
                                "postcode":"80240"
                            }
                            ]
                        },
                        {
                            "amphur":"เกาะลันตา",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะลันตาใหญ่",
                                "postcode":"81150"
                            },
                            {
                                "tumbon":"เกาะลันตาน้อย",
                                "postcode":"81150"
                            },
                            {
                                "tumbon":"เกาะกลาง",
                                "postcode":"81120"
                            },
                            {
                                "tumbon":"คลองยาง",
                                "postcode":"81120"
                            },
                            {
                                "tumbon":"ศาลาด่าน",
                                "postcode":"81150"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองท่อม",
                            "listTumbon":[
                            {
                                "tumbon":"คลองท่อมใต้",
                                "postcode":"81120"
                            },
                            {
                                "tumbon":"คลองท่อมเหนือ",
                                "postcode":"81120"
                            },
                            {
                                "tumbon":"คลองพน",
                                "postcode":"81170"
                            },
                            {
                                "tumbon":"ทรายขาว",
                                "postcode":"81170"
                            },
                            {
                                "tumbon":"ห้วยน้ำขาว",
                                "postcode":"81120"
                            },
                            {
                                "tumbon":"พรุดินนา",
                                "postcode":"81120"
                            },
                            {
                                "tumbon":"เพหลา",
                                "postcode":"81120"
                            }
                            ]
                        },
                        {
                            "amphur":"อ่าวลึก",
                            "listTumbon":[
                            {
                                "tumbon":"อ่าวลึกใต้",
                                "postcode":"81110"
                            },
                            {
                                "tumbon":"แหลมสัก",
                                "postcode":"81110"
                            },
                            {
                                "tumbon":"นาเหนือ",
                                "postcode":"81110"
                            },
                            {
                                "tumbon":"คลองหิน",
                                "postcode":"81110"
                            },
                            {
                                "tumbon":"อ่าวลึกน้อย",
                                "postcode":"81110"
                            },
                            {
                                "tumbon":"อ่าวลึกเหนือ",
                                "postcode":"81110"
                            },
                            {
                                "tumbon":"เขาใหญ่",
                                "postcode":"81110"
                            },
                            {
                                "tumbon":"คลองยา",
                                "postcode":"81110"
                            },
                            {
                                "tumbon":"บ้านกลาง",
                                "postcode":"81110"
                            }
                            ]
                        },
                        {
                            "amphur":"ปลายพระยา",
                            "listTumbon":[
                            {
                                "tumbon":"ปลายพระยา",
                                "postcode":"81160"
                            },
                            {
                                "tumbon":"เขาเขน",
                                "postcode":"81160"
                            },
                            {
                                "tumbon":"เขาต่อ",
                                "postcode":"81160"
                            },
                            {
                                "tumbon":"คีรีวง",
                                "postcode":"81160"
                            }
                            ]
                        },
                        {
                            "amphur":"ลำทับ",
                            "listTumbon":[
                            {
                                "tumbon":"ลำทับ",
                                "postcode":"81190"
                            },
                            {
                                "tumbon":"ดินอุดม",
                                "postcode":"81190"
                            },
                            {
                                "tumbon":"ทุ่งไทรทอง",
                                "postcode":"81190"
                            },
                            {
                                "tumbon":"ดินแดง",
                                "postcode":"81190"
                            }
                            ]
                        },
                        {
                            "amphur":"เหนือคลอง",
                            "listTumbon":[
                            {
                                "tumbon":"เหนือคลอง",
                                "postcode":"81130"
                            },
                            {
                                "tumbon":"เกาะศรีบอยา",
                                "postcode":"81130"
                            },
                            {
                                "tumbon":"คลองขนาน",
                                "postcode":"81130"
                            },
                            {
                                "tumbon":"คลองเขม้า",
                                "postcode":"81130"
                            },
                            {
                                "tumbon":"โคกยาง",
                                "postcode":"81130"
                            },
                            {
                                "tumbon":"ตลิ่งชัน",
                                "postcode":"81130"
                            },
                            {
                                "tumbon":"ปกาสัย",
                                "postcode":"81130"
                            },
                            {
                                "tumbon":"ห้วยยูง",
                                "postcode":"81130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สงขลา",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสงขลา",
                            "listTumbon":[
                            {
                                "tumbon":"บ่อยาง",
                                "postcode":"90000"
                            },
                            {
                                "tumbon":"เขารูปช้าง",
                                "postcode":"90000"
                            },
                            {
                                "tumbon":"เกาะแต้ว",
                                "postcode":"90000"
                            },
                            {
                                "tumbon":"พะวง",
                                "postcode":"90100"
                            },
                            {
                                "tumbon":"ทุ่งหวัง",
                                "postcode":"90000"
                            },
                            {
                                "tumbon":"เกาะยอ",
                                "postcode":"90100"
                            }
                            ]
                        },
                        {
                            "amphur":"สทิงพระ",
                            "listTumbon":[
                            {
                                "tumbon":"จะทิ้งพระ",
                                "postcode":"90190"
                            },
                            {
                                "tumbon":"กระดังงา",
                                "postcode":"90190"
                            },
                            {
                                "tumbon":"สนามชัย",
                                "postcode":"90190"
                            },
                            {
                                "tumbon":"ดีหลวง",
                                "postcode":"90190"
                            },
                            {
                                "tumbon":"ชุมพล",
                                "postcode":"90190"
                            },
                            {
                                "tumbon":"คลองรี",
                                "postcode":"90190"
                            },
                            {
                                "tumbon":"คูขุด",
                                "postcode":"90190"
                            },
                            {
                                "tumbon":"ท่าหิน",
                                "postcode":"90190"
                            },
                            {
                                "tumbon":"วัดจันทร์",
                                "postcode":"90190"
                            },
                            {
                                "tumbon":"บ่อแดง",
                                "postcode":"90190"
                            },
                            {
                                "tumbon":"บ่อดาน",
                                "postcode":"90190"
                            }
                            ]
                        },
                        {
                            "amphur":"จะนะ",
                            "listTumbon":[
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"ป่าชิง",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"สะพานไม้แก่น",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"สะกอม",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"นาหว้า",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"นาทับ",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"น้ำขาว",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"ขุนตัดหวาย",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"ท่าหมอไทร",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"จะโหนง",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"คู",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"แค",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"คลองเปียะ",
                                "postcode":"90130"
                            },
                            {
                                "tumbon":"ตลิ่งชัน",
                                "postcode":"90130"
                            }
                            ]
                        },
                        {
                            "amphur":"นาทวี",
                            "listTumbon":[
                            {
                                "tumbon":"นาทวี",
                                "postcode":"90160"
                            },
                            {
                                "tumbon":"ฉาง",
                                "postcode":"90160"
                            },
                            {
                                "tumbon":"นาหมอศรี",
                                "postcode":"90160"
                            },
                            {
                                "tumbon":"คลองทราย",
                                "postcode":"90160"
                            },
                            {
                                "tumbon":"ปลักหนู",
                                "postcode":"90160"
                            },
                            {
                                "tumbon":"ท่าประดู่",
                                "postcode":"90160"
                            },
                            {
                                "tumbon":"สะท้อน",
                                "postcode":"90160"
                            },
                            {
                                "tumbon":"ทับช้าง",
                                "postcode":"90160"
                            },
                            {
                                "tumbon":"ประกอบ",
                                "postcode":"90160"
                            },
                            {
                                "tumbon":"คลองกวาง",
                                "postcode":"90160"
                            }
                            ]
                        },
                        {
                            "amphur":"เทพา",
                            "listTumbon":[
                            {
                                "tumbon":"เทพา",
                                "postcode":"90150"
                            },
                            {
                                "tumbon":"ปากบาง",
                                "postcode":"90150"
                            },
                            {
                                "tumbon":"เกาะสะบ้า",
                                "postcode":"90150"
                            },
                            {
                                "tumbon":"ลำไพล",
                                "postcode":"90260"
                            },
                            {
                                "tumbon":"ท่าม่วง",
                                "postcode":"90150"
                            },
                            {
                                "tumbon":"วังใหญ่",
                                "postcode":"90260"
                            },
                            {
                                "tumbon":"สะกอม",
                                "postcode":"90150"
                            }
                            ]
                        },
                        {
                            "amphur":"สะบ้าย้อย",
                            "listTumbon":[
                            {
                                "tumbon":"สะบ้าย้อย",
                                "postcode":"90210"
                            },
                            {
                                "tumbon":"ทุ่งพอ",
                                "postcode":"90210"
                            },
                            {
                                "tumbon":"เปียน",
                                "postcode":"90210"
                            },
                            {
                                "tumbon":"บ้านโหนด",
                                "postcode":"90210"
                            },
                            {
                                "tumbon":"จะแหน",
                                "postcode":"90210"
                            },
                            {
                                "tumbon":"คูหา",
                                "postcode":"90210"
                            },
                            {
                                "tumbon":"เขาแดง",
                                "postcode":"90210"
                            },
                            {
                                "tumbon":"บาโหย",
                                "postcode":"90210"
                            },
                            {
                                "tumbon":"ธารคีรี",
                                "postcode":"90210"
                            }
                            ]
                        },
                        {
                            "amphur":"ระโนด",
                            "listTumbon":[
                            {
                                "tumbon":"ระโนด",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"คลองแดน",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"ตะเครียะ",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"ท่าบอน",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"บ้านใหม่",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"บ่อตรุ",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"ปากแตระ",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"พังยาง",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"ระวะ",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"วัดสน",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"บ้านขาว",
                                "postcode":"90140"
                            },
                            {
                                "tumbon":"แดนสงวน",
                                "postcode":"90140"
                            }
                            ]
                        },
                        {
                            "amphur":"กระแสสินธุ์",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะใหญ่",
                                "postcode":"90270"
                            },
                            {
                                "tumbon":"โรง",
                                "postcode":"90270"
                            },
                            {
                                "tumbon":"เชิงแส",
                                "postcode":"90270"
                            },
                            {
                                "tumbon":"กระแสสินธุ์",
                                "postcode":"90270"
                            }
                            ]
                        },
                        {
                            "amphur":"รัตภูมิ",
                            "listTumbon":[
                            {
                                "tumbon":"กำแพงเพชร",
                                "postcode":"90180"
                            },
                            {
                                "tumbon":"ท่าชะมวง",
                                "postcode":"90180"
                            },
                            {
                                "tumbon":"คูหาใต้",
                                "postcode":"90180"
                            },
                            {
                                "tumbon":"ควนรู",
                                "postcode":"90220"
                            },
                            {
                                "tumbon":"เขาพระ",
                                "postcode":"90180"
                            }
                            ]
                        },
                        {
                            "amphur":"สะเดา",
                            "listTumbon":[
                            {
                                "tumbon":"สะเดา",
                                "postcode":"90120"
                            },
                            {
                                "tumbon":"ปริก",
                                "postcode":"90120"
                            },
                            {
                                "tumbon":"พังลา",
                                "postcode":"90170"
                            },
                            {
                                "tumbon":"สำนักแต้ว",
                                "postcode":"90120"
                            },
                            {
                                "tumbon":"ทุ่งหมอ",
                                "postcode":"90240"
                            },
                            {
                                "tumbon":"ท่าโพธิ์",
                                "postcode":"90170"
                            },
                            {
                                "tumbon":"ปาดังเบซาร์",
                                "postcode":"90240"
                            },
                            {
                                "tumbon":"สำนักขาม",
                                "postcode":"90320"
                            },
                            {
                                "tumbon":"เขามีเกียรติ",
                                "postcode":"90170"
                            }
                            ]
                        },
                        {
                            "amphur":"หาดใหญ่",
                            "listTumbon":[
                            {
                                "tumbon":"หาดใหญ่",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"ควนลัง",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"คูเต่า",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"คอหงส์",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"คลองแห",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"คลองอู่ตะเภา",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"ฉลุง",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"ทุ่งใหญ่",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"ทุ่งตำเสา",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"น้ำน้อย",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"บ้านพรุ",
                                "postcode":"90250"
                            },
                            {
                                "tumbon":"พะตง",
                                "postcode":"90230"
                            }
                            ]
                        },
                        {
                            "amphur":"นาหม่อม",
                            "listTumbon":[
                            {
                                "tumbon":"นาหม่อม",
                                "postcode":"90310"
                            },
                            {
                                "tumbon":"พิจิตร",
                                "postcode":"90310"
                            },
                            {
                                "tumbon":"ทุ่งขมิ้น",
                                "postcode":"90310"
                            },
                            {
                                "tumbon":"คลองหรัง",
                                "postcode":"90310"
                            }
                            ]
                        },
                        {
                            "amphur":"ควนเนียง",
                            "listTumbon":[
                            {
                                "tumbon":"รัตภูมิ",
                                "postcode":"90220"
                            },
                            {
                                "tumbon":"ควนโส",
                                "postcode":"90220"
                            },
                            {
                                "tumbon":"ห้วยลึก",
                                "postcode":"90220"
                            },
                            {
                                "tumbon":"บางเหรียง",
                                "postcode":"90220"
                            }
                            ]
                        },
                        {
                            "amphur":"บางกล่ำ",
                            "listTumbon":[
                            {
                                "tumbon":"บางกล่ำ",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"ท่าช้าง",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"แม่ทอม",
                                "postcode":"90110"
                            },
                            {
                                "tumbon":"บ้านหาร",
                                "postcode":"90110"
                            }
                            ]
                        },
                        {
                            "amphur":"สิงหนคร",
                            "listTumbon":[
                            {
                                "tumbon":"ชิงโค",
                                "postcode":"90280"
                            },
                            {
                                "tumbon":"สทิงหม้อ",
                                "postcode":"90280"
                            },
                            {
                                "tumbon":"ทำนบ",
                                "postcode":"90280"
                            },
                            {
                                "tumbon":"รำแดง",
                                "postcode":"90330"
                            },
                            {
                                "tumbon":"วัดขนุน",
                                "postcode":"90330"
                            },
                            {
                                "tumbon":"ชะแล้",
                                "postcode":"90330"
                            },
                            {
                                "tumbon":"ปากรอ",
                                "postcode":"90330"
                            },
                            {
                                "tumbon":"ป่าขาด",
                                "postcode":"90330"
                            },
                            {
                                "tumbon":"หัวเขา",
                                "postcode":"90280"
                            },
                            {
                                "tumbon":"บางเขียด",
                                "postcode":"90330"
                            },
                            {
                                "tumbon":"ม่วงงาม",
                                "postcode":"90330"
                            }
                            ]
                        },
                        {
                            "amphur":"คลองหอยโข่ง",
                            "listTumbon":[
                            {
                                "tumbon":"คลองหอยโข่ง",
                                "postcode":"90230"
                            },
                            {
                                "tumbon":"ทุ่งลาน",
                                "postcode":"90230"
                            },
                            {
                                "tumbon":"โคกม่วง",
                                "postcode":"90230"
                            },
                            {
                                "tumbon":"คลองหลา",
                                "postcode":"90115"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"พัทลุง",
                    "listAmphur":[
                        {
                            "amphur":"เมืองพัทลุง",
                            "listTumbon":[
                            {
                                "tumbon":"คูหาสวรรค์",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"เขาเจียก",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"ท่ามิหรำ",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"โคกชะงาย",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"นาท่อม",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"ปรางหมู่",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"ท่าแค",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"ลำปำ",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"ตำนาน",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"ควนมะพร้าว",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"ร่มเมือง",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"ชัยบุรี",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"นาโหนด",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"พญาขัน",
                                "postcode":"93000"
                            }
                            ]
                        },
                        {
                            "amphur":"กงหรา",
                            "listTumbon":[
                            {
                                "tumbon":"กงหรา",
                                "postcode":"93180"
                            },
                            {
                                "tumbon":"ชะรัด",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"คลองเฉลิม",
                                "postcode":"93180"
                            },
                            {
                                "tumbon":"คลองทรายขาว",
                                "postcode":"93180"
                            },
                            {
                                "tumbon":"สมหวัง",
                                "postcode":"93000"
                            }
                            ]
                        },
                        {
                            "amphur":"เขาชัยสน",
                            "listTumbon":[
                            {
                                "tumbon":"เขาชัยสน",
                                "postcode":"93130"
                            },
                            {
                                "tumbon":"ควนขนุน",
                                "postcode":"93130"
                            },
                            {
                                "tumbon":"จองถนน",
                                "postcode":"93130"
                            },
                            {
                                "tumbon":"หานโพธิ์",
                                "postcode":"93130"
                            },
                            {
                                "tumbon":"โคกม่วง",
                                "postcode":"93130"
                            }
                            ]
                        },
                        {
                            "amphur":"ตะโหมด",
                            "listTumbon":[
                            {
                                "tumbon":"แม่ขรี",
                                "postcode":"93160"
                            },
                            {
                                "tumbon":"ตะโหมด",
                                "postcode":"93160"
                            },
                            {
                                "tumbon":"คลองใหญ่",
                                "postcode":"93160"
                            }
                            ]
                        },
                        {
                            "amphur":"ควนขนุน",
                            "listTumbon":[
                            {
                                "tumbon":"ควนขนุน",
                                "postcode":"93110"
                            },
                            {
                                "tumbon":"ทะเลน้อย",
                                "postcode":"93150"
                            },
                            {
                                "tumbon":"นาขยาด",
                                "postcode":"93110"
                            },
                            {
                                "tumbon":"พนมวังก์",
                                "postcode":"93110"
                            },
                            {
                                "tumbon":"แหลมโตนด",
                                "postcode":"93110"
                            },
                            {
                                "tumbon":"ปันแต",
                                "postcode":"93110"
                            },
                            {
                                "tumbon":"โตนดด้วน",
                                "postcode":"93110"
                            },
                            {
                                "tumbon":"ดอนทราย",
                                "postcode":"93110"
                            },
                            {
                                "tumbon":"มะกอกเหนือ",
                                "postcode":"93150"
                            },
                            {
                                "tumbon":"พนางตุง",
                                "postcode":"93150"
                            },
                            {
                                "tumbon":"ชะมวง",
                                "postcode":"93110"
                            },
                            {
                                "tumbon":"แพรกหา",
                                "postcode":"93110"
                            }
                            ]
                        },
                        {
                            "amphur":"ปากพะยูน",
                            "listTumbon":[
                            {
                                "tumbon":"ปากพะยูน",
                                "postcode":"93120"
                            },
                            {
                                "tumbon":"ดอนประดู่",
                                "postcode":"93120"
                            },
                            {
                                "tumbon":"เกาะนางคำ",
                                "postcode":"93120"
                            },
                            {
                                "tumbon":"เกาะหมาก",
                                "postcode":"93120"
                            },
                            {
                                "tumbon":"ฝาละมี",
                                "postcode":"93120"
                            },
                            {
                                "tumbon":"หารเทา",
                                "postcode":"93120"
                            },
                            {
                                "tumbon":"ดอนทราย",
                                "postcode":"93120"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีบรรพต",
                            "listTumbon":[
                            {
                                "tumbon":"เขาย่า",
                                "postcode":"93190"
                            },
                            {
                                "tumbon":"เขาปู่",
                                "postcode":"93190"
                            },
                            {
                                "tumbon":"ตะแพน",
                                "postcode":"93190"
                            }
                            ]
                        },
                        {
                            "amphur":"ป่าบอน",
                            "listTumbon":[
                            {
                                "tumbon":"ป่าบอน",
                                "postcode":"93170"
                            },
                            {
                                "tumbon":"โคกทราย",
                                "postcode":"93170"
                            },
                            {
                                "tumbon":"หนองธง",
                                "postcode":"93170"
                            },
                            {
                                "tumbon":"ทุ่งนารี",
                                "postcode":"93170"
                            },
                            {
                                "tumbon":"วังใหม่",
                                "postcode":"93170"
                            }
                            ]
                        },
                        {
                            "amphur":"บางแก้ว",
                            "listTumbon":[
                            {
                                "tumbon":"ท่ามะเดื่อ",
                                "postcode":"93140"
                            },
                            {
                                "tumbon":"นาปะขอ",
                                "postcode":"93140"
                            },
                            {
                                "tumbon":"โคกสัก",
                                "postcode":"93140"
                            }
                            ]
                        },
                        {
                            "amphur":"ป่าพะยอม",
                            "listTumbon":[
                            {
                                "tumbon":"ป่าพะยอม",
                                "postcode":"93210"
                            },
                            {
                                "tumbon":"ลานข่อย",
                                "postcode":"93210"
                            },
                            {
                                "tumbon":"เกาะเต่า",
                                "postcode":"93210"
                            },
                            {
                                "tumbon":"บ้านพร้าว",
                                "postcode":"93210"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีนครินทร์",
                            "listTumbon":[
                            {
                                "tumbon":"ชุมพล",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"อ่างทอง",
                                "postcode":"93000"
                            },
                            {
                                "tumbon":"ลำสินธุ์",
                                "postcode":"93000"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ตรัง",
                    "listAmphur":[
                        {
                            "amphur":"เมืองตรัง",
                            "listTumbon":[
                            {
                                "tumbon":"ทับเที่ยง",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"นาพละ",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"บ้านควน",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"นาบินหลา",
                                "postcode":"92170"
                            },
                            {
                                "tumbon":"ควนปริง",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"นาโยงใต้",
                                "postcode":"92170"
                            },
                            {
                                "tumbon":"บางรัก",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"โคกหล่อ",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"นาโต๊ะหมิง",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"หนองตรุด",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"น้ำผุด",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"นาตาล่วง",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"บ้านโพธิ์",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"นาท่ามเหนือ",
                                "postcode":"92190"
                            },
                            {
                                "tumbon":"นาท่ามใต้",
                                "postcode":"92190"
                            }
                            ]
                        },
                        {
                            "amphur":"กันตัง",
                            "listTumbon":[
                            {
                                "tumbon":"กันตัง",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"ควนธานี",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"บางหมาก",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"บางเป้า",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"วังวน",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"กันตังใต้",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"โคกยาง",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"คลองลุ",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"ย่านซื่อ",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"บ่อน้ำร้อน",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"บางสัก",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"นาเกลือ",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"เกาะลิบง",
                                "postcode":"92110"
                            },
                            {
                                "tumbon":"คลองชีล้อม",
                                "postcode":"92110"
                            }
                            ]
                        },
                        {
                            "amphur":"ย่านตาขาว",
                            "listTumbon":[
                            {
                                "tumbon":"ย่านตาขาว",
                                "postcode":"92140"
                            },
                            {
                                "tumbon":"หนองบ่อ",
                                "postcode":"92140"
                            },
                            {
                                "tumbon":"นาชุมเห็ด",
                                "postcode":"92140"
                            },
                            {
                                "tumbon":"ในควน",
                                "postcode":"92140"
                            },
                            {
                                "tumbon":"โพรงจระเข้",
                                "postcode":"92140"
                            },
                            {
                                "tumbon":"ทุ่งกระบือ",
                                "postcode":"92140"
                            },
                            {
                                "tumbon":"ทุ่งค่าย",
                                "postcode":"92140"
                            },
                            {
                                "tumbon":"เกาะเปียะ",
                                "postcode":"92140"
                            }
                            ]
                        },
                        {
                            "amphur":"ปะเหลียน",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"92120"
                            },
                            {
                                "tumbon":"ทุ่งยาว",
                                "postcode":"92180"
                            },
                            {
                                "tumbon":"ปะเหลียน",
                                "postcode":"92180"
                            },
                            {
                                "tumbon":"บางด้วน",
                                "postcode":"92140"
                            },
                            {
                                "tumbon":"บ้านนา",
                                "postcode":"92140"
                            },
                            {
                                "tumbon":"สุโสะ",
                                "postcode":"92120"
                            },
                            {
                                "tumbon":"ลิพัง",
                                "postcode":"92180"
                            },
                            {
                                "tumbon":"เกาะสุกร",
                                "postcode":"92120"
                            },
                            {
                                "tumbon":"ท่าพญา",
                                "postcode":"92140"
                            },
                            {
                                "tumbon":"แหลมสอม",
                                "postcode":"92180"
                            }
                            ]
                        },
                        {
                            "amphur":"สิเกา",
                            "listTumbon":[
                            {
                                "tumbon":"บ่อหิน",
                                "postcode":"92150"
                            },
                            {
                                "tumbon":"เขาไม้แก้ว",
                                "postcode":"92150"
                            },
                            {
                                "tumbon":"กะลาเส",
                                "postcode":"92150"
                            },
                            {
                                "tumbon":"ไม้ฝาด",
                                "postcode":"92150"
                            },
                            {
                                "tumbon":"นาเมืองเพชร",
                                "postcode":"92000"
                            }
                            ]
                        },
                        {
                            "amphur":"ห้วยยอด",
                            "listTumbon":[
                            {
                                "tumbon":"ห้วยยอด",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"หนองช้างแล่น",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"บางดี",
                                "postcode":"92210"
                            },
                            {
                                "tumbon":"บางกุ้ง",
                                "postcode":"92210"
                            },
                            {
                                "tumbon":"เขากอบ",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"เขาขาว",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"เขาปูน",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"ปากแจ่ม",
                                "postcode":"92190"
                            },
                            {
                                "tumbon":"ปากคม",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"ท่างิ้ว",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"ลำภูรา",
                                "postcode":"92190"
                            },
                            {
                                "tumbon":"นาวง",
                                "postcode":"92210"
                            },
                            {
                                "tumbon":"ห้วยนาง",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"ในเตา",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"ทุ่งต่อ",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"วังคีรี",
                                "postcode":"92210"
                            }
                            ]
                        },
                        {
                            "amphur":"วังวิเศษ",
                            "listTumbon":[
                            {
                                "tumbon":"เขาวิเศษ",
                                "postcode":"92220"
                            },
                            {
                                "tumbon":"วังมะปราง",
                                "postcode":"92220"
                            },
                            {
                                "tumbon":"อ่าวตง",
                                "postcode":"92220"
                            },
                            {
                                "tumbon":"ท่าสะบ้า",
                                "postcode":"92000"
                            },
                            {
                                "tumbon":"วังมะปรางเหนือ",
                                "postcode":"92220"
                            }
                            ]
                        },
                        {
                            "amphur":"นาโยง",
                            "listTumbon":[
                            {
                                "tumbon":"นาโยงเหนือ",
                                "postcode":"92170"
                            },
                            {
                                "tumbon":"ช่อง",
                                "postcode":"92170"
                            },
                            {
                                "tumbon":"ละมอ",
                                "postcode":"92170"
                            },
                            {
                                "tumbon":"โคกสะบ้า",
                                "postcode":"92170"
                            },
                            {
                                "tumbon":"นาหมื่นศรี",
                                "postcode":"92170"
                            },
                            {
                                "tumbon":"นาข้าวเสีย",
                                "postcode":"92170"
                            }
                            ]
                        },
                        {
                            "amphur":"รัษฎา",
                            "listTumbon":[
                            {
                                "tumbon":"ควนเมา",
                                "postcode":"92160"
                            },
                            {
                                "tumbon":"คลองปาง",
                                "postcode":"92160"
                            },
                            {
                                "tumbon":"หนองบัว",
                                "postcode":"92160"
                            },
                            {
                                "tumbon":"หนองปรือ",
                                "postcode":"92130"
                            },
                            {
                                "tumbon":"เขาไพร",
                                "postcode":"92160"
                            }
                            ]
                        },
                        {
                            "amphur":"หาดสำราญ",
                            "listTumbon":[
                            {
                                "tumbon":"หาดสำราญ",
                                "postcode":"92120"
                            },
                            {
                                "tumbon":"บ้าหวี",
                                "postcode":"92120"
                            },
                            {
                                "tumbon":"ตะเสะ",
                                "postcode":"92120"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"สตูล",
                    "listAmphur":[
                        {
                            "amphur":"เมืองสตูล",
                            "listTumbon":[
                            {
                                "tumbon":"พิมาน",
                                "postcode":"91000"
                            },
                            {
                                "tumbon":"คลองขุด",
                                "postcode":"91000"
                            },
                            {
                                "tumbon":"ควนขัน",
                                "postcode":"91000"
                            },
                            {
                                "tumbon":"บ้านควน",
                                "postcode":"91140"
                            },
                            {
                                "tumbon":"ฉลุง",
                                "postcode":"91140"
                            },
                            {
                                "tumbon":"เกาะสาหร่าย",
                                "postcode":"91000"
                            },
                            {
                                "tumbon":"ตันหยงโป",
                                "postcode":"91000"
                            },
                            {
                                "tumbon":"เจ๊ะบิลัง",
                                "postcode":"91000"
                            },
                            {
                                "tumbon":"ตำมะลัง",
                                "postcode":"91000"
                            },
                            {
                                "tumbon":"ปูยู",
                                "postcode":"91000"
                            },
                            {
                                "tumbon":"ควนโพธิ์",
                                "postcode":"91140"
                            },
                            {
                                "tumbon":"เกตรี",
                                "postcode":"91140"
                            }
                            ]
                        },
                        {
                            "amphur":"ควนโดน",
                            "listTumbon":[
                            {
                                "tumbon":"ควนโดน",
                                "postcode":"91160"
                            },
                            {
                                "tumbon":"ควนสตอ",
                                "postcode":"91160"
                            },
                            {
                                "tumbon":"ย่านซื่อ",
                                "postcode":"91160"
                            },
                            {
                                "tumbon":"วังประจัน",
                                "postcode":"91160"
                            }
                            ]
                        },
                        {
                            "amphur":"ควนกาหลง",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งนุ้ย",
                                "postcode":"91130"
                            },
                            {
                                "tumbon":"ควนกาหลง",
                                "postcode":"91130"
                            },
                            {
                                "tumbon":"อุไดเจริญ",
                                "postcode":"91130"
                            }
                            ]
                        },
                        {
                            "amphur":"ท่าแพ",
                            "listTumbon":[
                            {
                                "tumbon":"ท่าแพ",
                                "postcode":"91150"
                            },
                            {
                                "tumbon":"แป-ระ",
                                "postcode":"91150"
                            },
                            {
                                "tumbon":"สาคร",
                                "postcode":"91150"
                            },
                            {
                                "tumbon":"ท่าเรือ",
                                "postcode":"91150"
                            }
                            ]
                        },
                        {
                            "amphur":"ละงู",
                            "listTumbon":[
                            {
                                "tumbon":"กำแพง",
                                "postcode":"91110"
                            },
                            {
                                "tumbon":"ละงู",
                                "postcode":"91110"
                            },
                            {
                                "tumbon":"เขาขาว",
                                "postcode":"91110"
                            },
                            {
                                "tumbon":"ปากน้ำ",
                                "postcode":"91110"
                            },
                            {
                                "tumbon":"น้ำผุด",
                                "postcode":"91110"
                            },
                            {
                                "tumbon":"แหลมสน",
                                "postcode":"91110"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งหว้า",
                            "listTumbon":[
                            {
                                "tumbon":"ทุ่งหว้า",
                                "postcode":"91120"
                            },
                            {
                                "tumbon":"นาทอน",
                                "postcode":"91120"
                            },
                            {
                                "tumbon":"ขอนคลาน",
                                "postcode":"91120"
                            },
                            {
                                "tumbon":"ทุ่งบุหลัง",
                                "postcode":"91120"
                            },
                            {
                                "tumbon":"ป่าแก่บ่อหิน",
                                "postcode":"91120"
                            }
                            ]
                        },
                        {
                            "amphur":"มะนัง",
                            "listTumbon":[
                            {
                                "tumbon":"ปาล์มพัฒนา",
                                "postcode":"91130"
                            },
                            {
                                "tumbon":"นิคมพัฒนา",
                                "postcode":"91130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ยะลา",
                    "listAmphur":[
                        {
                            "amphur":"เมืองยะลา",
                            "listTumbon":[
                            {
                                "tumbon":"สะเตง",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"บุดี",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"ยุโป",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"ลิดล",
                                "postcode":"95160"
                            },
                            {
                                "tumbon":"ยะลา",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"ท่าสาป",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"ลำใหม่",
                                "postcode":"95160"
                            },
                            {
                                "tumbon":"หน้าถ้ำ",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"ลำพะยา",
                                "postcode":"95160"
                            },
                            {
                                "tumbon":"เปาะเส้ง",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"พร่อน",
                                "postcode":"95160"
                            },
                            {
                                "tumbon":"บันนังสาเรง",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"สะเตงนอก",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"ตาเซะ",
                                "postcode":"95000"
                            }
                            ]
                        },
                        {
                            "amphur":"เบตง",
                            "listTumbon":[
                            {
                                "tumbon":"เบตง",
                                "postcode":"95110"
                            },
                            {
                                "tumbon":"ยะรม",
                                "postcode":"95110"
                            },
                            {
                                "tumbon":"ตาเนาะแมเราะ",
                                "postcode":"95110"
                            },
                            {
                                "tumbon":"อัยเยอร์เวง",
                                "postcode":"95110"
                            },
                            {
                                "tumbon":"ธารน้ำทิพย์",
                                "postcode":"95110"
                            }
                            ]
                        },
                        {
                            "amphur":"บันนังสตา",
                            "listTumbon":[
                            {
                                "tumbon":"บันนังสตา",
                                "postcode":"95130"
                            },
                            {
                                "tumbon":"บาเจาะ",
                                "postcode":"95130"
                            },
                            {
                                "tumbon":"ตาเนาะปูเต๊ะ",
                                "postcode":"95130"
                            },
                            {
                                "tumbon":"ถ้ำทะลุ",
                                "postcode":"95130"
                            },
                            {
                                "tumbon":"ตลิ่งชัน",
                                "postcode":"95130"
                            },
                            {
                                "tumbon":"เขื่อนบางลาง",
                                "postcode":"95130"
                            }
                            ]
                        },
                        {
                            "amphur":"ธารโต",
                            "listTumbon":[
                            {
                                "tumbon":"ธารโต",
                                "postcode":"95150"
                            },
                            {
                                "tumbon":"บ้านแหร",
                                "postcode":"95150"
                            },
                            {
                                "tumbon":"แม่หวาด",
                                "postcode":"95170"
                            },
                            {
                                "tumbon":"คีรีเขต",
                                "postcode":"95150"
                            }
                            ]
                        },
                        {
                            "amphur":"ยะหา",
                            "listTumbon":[
                            {
                                "tumbon":"ยะหา",
                                "postcode":"95120"
                            },
                            {
                                "tumbon":"ละแอ",
                                "postcode":"95120"
                            },
                            {
                                "tumbon":"ปะแต",
                                "postcode":"95120"
                            },
                            {
                                "tumbon":"บาโร๊ะ",
                                "postcode":"95120"
                            },
                            {
                                "tumbon":"ตาชี",
                                "postcode":"95120"
                            },
                            {
                                "tumbon":"บาโงยซิแน",
                                "postcode":"95120"
                            },
                            {
                                "tumbon":"กาตอง",
                                "postcode":"95120"
                            }
                            ]
                        },
                        {
                            "amphur":"รามัน",
                            "listTumbon":[
                            {
                                "tumbon":"กายูบอเกาะ",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"กาลูปัง",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"กาลอ",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"กอตอตือร๊ะ",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"โกตาบารู",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"เกะรอ",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"จะกว๊ะ",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"ท่าธง",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"เนินงาม",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"บาลอ",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"บาโงย",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"บือมัง",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"ยะต๊ะ",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"วังพญา",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"อาซ่อง",
                                "postcode":"95140"
                            },
                            {
                                "tumbon":"ตะโล๊ะหะลอ",
                                "postcode":"95140"
                            }
                            ]
                        },
                        {
                            "amphur":"กาบัง",
                            "listTumbon":[
                            {
                                "tumbon":"กาบัง",
                                "postcode":"95120"
                            },
                            {
                                "tumbon":"บาละ",
                                "postcode":"95120"
                            }
                            ]
                        },
                        {
                            "amphur":"กรงปินัง",
                            "listTumbon":[
                            {
                                "tumbon":"กรงปินัง",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"สะเอะ",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"ห้วยกระทิง",
                                "postcode":"95000"
                            },
                            {
                                "tumbon":"ปุโรง",
                                "postcode":"95000"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"ปัตตานี",
                    "listAmphur":[
                        {
                            "amphur":"เมืองปัตตานี",
                            "listTumbon":[
                            {
                                "tumbon":"สะบารัง",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"บานา",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"ตันหยงลุโละ",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"คลองมานิง",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"กะมิยอ",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"บาราโหม",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"ปะกาฮะรัง",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"รูสะมิแล",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"ตะลุโบะ",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"บาราเฮาะ",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"ปุยุด",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"จะบังติกอ",
                                "postcode":"94000"
                            },
                            {
                                "tumbon":"อาเนาะรู",
                                "postcode":"94000"
                            }
                            ]
                        },
                        {
                            "amphur":"โคกโพธิ์",
                            "listTumbon":[
                            {
                                "tumbon":"โคกโพธิ์",
                                "postcode":"94120"
                            },
                            {
                                "tumbon":"มะกรูด",
                                "postcode":"94120"
                            },
                            {
                                "tumbon":"บางโกระ",
                                "postcode":"94120"
                            },
                            {
                                "tumbon":"ป่าบอน",
                                "postcode":"94120"
                            },
                            {
                                "tumbon":"ทรายขาว",
                                "postcode":"94120"
                            },
                            {
                                "tumbon":"นาประดู่",
                                "postcode":"94180"
                            },
                            {
                                "tumbon":"ปากล่อ",
                                "postcode":"94180"
                            },
                            {
                                "tumbon":"ทุ่งพลา",
                                "postcode":"94180"
                            },
                            {
                                "tumbon":"ท่าเรือ",
                                "postcode":"94120"
                            },
                            {
                                "tumbon":"นาเกตุ",
                                "postcode":"94120"
                            },
                            {
                                "tumbon":"ควนโนรี",
                                "postcode":"94180"
                            },
                            {
                                "tumbon":"ช้างให้ตก",
                                "postcode":"94120"
                            }
                            ]
                        },
                        {
                            "amphur":"หนองจิก",
                            "listTumbon":[
                            {
                                "tumbon":"เกาะเปาะ",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"คอลอตันหยง",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"ดอนรัก",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"ดาโต๊ะ",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"ตุยง",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"ท่ากำชำ",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"บ่อทอง",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"บางเขา",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"บางตาวา",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"ปุโละปุโย",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"ยาบี",
                                "postcode":"94170"
                            },
                            {
                                "tumbon":"ลิปะสะโง",
                                "postcode":"94170"
                            }
                            ]
                        },
                        {
                            "amphur":"ปะนาเระ",
                            "listTumbon":[
                            {
                                "tumbon":"ปะนาเระ",
                                "postcode":"94130"
                            },
                            {
                                "tumbon":"ท่าข้าม",
                                "postcode":"94130"
                            },
                            {
                                "tumbon":"บ้านนอก",
                                "postcode":"94130"
                            },
                            {
                                "tumbon":"ดอน",
                                "postcode":"94190"
                            },
                            {
                                "tumbon":"ควน",
                                "postcode":"94190"
                            },
                            {
                                "tumbon":"ท่าน้ำ",
                                "postcode":"94130"
                            },
                            {
                                "tumbon":"คอกกระบือ",
                                "postcode":"94130"
                            },
                            {
                                "tumbon":"พ่อมิ่ง",
                                "postcode":"94130"
                            },
                            {
                                "tumbon":"บ้านกลาง",
                                "postcode":"94130"
                            },
                            {
                                "tumbon":"บ้านน้ำบ่อ",
                                "postcode":"94130"
                            }
                            ]
                        },
                        {
                            "amphur":"มายอ",
                            "listTumbon":[
                            {
                                "tumbon":"มายอ",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"ถนน",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"ตรัง",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"กระหวะ",
                                "postcode":"94190"
                            },
                            {
                                "tumbon":"ลุโบะยิไร",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"ลางา",
                                "postcode":"94190"
                            },
                            {
                                "tumbon":"กระเสาะ",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"เกาะจัน",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"ปะโด",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"สาคอบน",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"สาคอใต้",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"สะกำ",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"ปานัน",
                                "postcode":"94140"
                            }
                            ]
                        },
                        {
                            "amphur":"ทุ่งยางแดง",
                            "listTumbon":[
                            {
                                "tumbon":"ตะโละแมะนา",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"พิเทน",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"น้ำดำ",
                                "postcode":"94140"
                            },
                            {
                                "tumbon":"ปากู",
                                "postcode":"94140"
                            }
                            ]
                        },
                        {
                            "amphur":"สายบุรี",
                            "listTumbon":[
                            {
                                "tumbon":"ตะลุบัน",
                                "postcode":"94110"
                            },
                            {
                                "tumbon":"ตะบิ้ง",
                                "postcode":"94110"
                            },
                            {
                                "tumbon":"ปะเสยะวอ",
                                "postcode":"94110"
                            },
                            {
                                "tumbon":"บางเก่า",
                                "postcode":"94110"
                            },
                            {
                                "tumbon":"บือเระ",
                                "postcode":"94110"
                            },
                            {
                                "tumbon":"เตราะบอน",
                                "postcode":"94110"
                            },
                            {
                                "tumbon":"กะดุนง",
                                "postcode":"94110"
                            },
                            {
                                "tumbon":"ละหาร",
                                "postcode":"94110"
                            },
                            {
                                "tumbon":"มะนังดาลำ",
                                "postcode":"94110"
                            },
                            {
                                "tumbon":"แป้น",
                                "postcode":"94110"
                            },
                            {
                                "tumbon":"ทุ่งคล้า",
                                "postcode":"94190"
                            }
                            ]
                        },
                        {
                            "amphur":"ไม้แก่น",
                            "listTumbon":[
                            {
                                "tumbon":"ไทรทอง",
                                "postcode":"94220"
                            },
                            {
                                "tumbon":"ไม้แก่น",
                                "postcode":"94220"
                            },
                            {
                                "tumbon":"ตะโละไกรทอง",
                                "postcode":"94220"
                            },
                            {
                                "tumbon":"ดอนทราย",
                                "postcode":"94220"
                            }
                            ]
                        },
                        {
                            "amphur":"ยะหริ่ง",
                            "listTumbon":[
                            {
                                "tumbon":"ตะโละ",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"ตะโละกาโปร์",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"ตันหยงดาลอ",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"ตันหยงจึงงา",
                                "postcode":"94190"
                            },
                            {
                                "tumbon":"ตอหลัง",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"ตาแกะ",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"ตาลีอายร์",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"ยามู",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"บางปู",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"หนองแรต",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"ปิยามุมัง",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"ปุลากง",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"บาโลย",
                                "postcode":"94190"
                            },
                            {
                                "tumbon":"สาบัน",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"มะนังยง",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"ราตาปันยัง",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"จะรัง",
                                "postcode":"94150"
                            },
                            {
                                "tumbon":"แหลมโพธิ์",
                                "postcode":"94150"
                            }
                            ]
                        },
                        {
                            "amphur":"ยะรัง",
                            "listTumbon":[
                            {
                                "tumbon":"ยะรัง",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"สะดาวา",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"ประจัน",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"สะนอ",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"ระแว้ง",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"ปิตูมุดี",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"วัด",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"กระโด",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"คลองใหม่",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"เมาะมาวี",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"กอลำ",
                                "postcode":"94160"
                            },
                            {
                                "tumbon":"เขาตูม",
                                "postcode":"94160"
                            }
                            ]
                        },
                        {
                            "amphur":"กะพ้อ",
                            "listTumbon":[
                            {
                                "tumbon":"กะรุบี",
                                "postcode":"94230"
                            },
                            {
                                "tumbon":"ตะโละดือรามัน",
                                "postcode":"94230"
                            },
                            {
                                "tumbon":"ปล่องหอย",
                                "postcode":"94230"
                            }
                            ]
                        },
                        {
                            "amphur":"แม่ลาน",
                            "listTumbon":[
                            {
                                "tumbon":"แม่ลาน",
                                "postcode":"94180"
                            },
                            {
                                "tumbon":"ม่วงเตี้ย",
                                "postcode":"94180"
                            },
                            {
                                "tumbon":"ป่าไร่",
                                "postcode":"94180"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"นราธิวาส",
                    "listAmphur":[
                        {
                            "amphur":"เมืองนราธิวาส",
                            "listTumbon":[
                            {
                                "tumbon":"บางนาค",
                                "postcode":"96000"
                            },
                            {
                                "tumbon":"ลำภู",
                                "postcode":"96000"
                            },
                            {
                                "tumbon":"มะนังตายอ",
                                "postcode":"96000"
                            },
                            {
                                "tumbon":"บางปอ",
                                "postcode":"96000"
                            },
                            {
                                "tumbon":"กะลุวอ",
                                "postcode":"96000"
                            },
                            {
                                "tumbon":"กะลุวอเหนือ",
                                "postcode":"96000"
                            },
                            {
                                "tumbon":"โคกเคียน",
                                "postcode":"96000"
                            }
                            ]
                        },
                        {
                            "amphur":"ตากใบ",
                            "listTumbon":[
                            {
                                "tumbon":"เจ๊ะเห",
                                "postcode":"96110"
                            },
                            {
                                "tumbon":"ไพรวัน",
                                "postcode":"96110"
                            },
                            {
                                "tumbon":"พร่อน",
                                "postcode":"96110"
                            },
                            {
                                "tumbon":"ศาลาใหม่",
                                "postcode":"96110"
                            },
                            {
                                "tumbon":"บางขุนทอง",
                                "postcode":"96110"
                            },
                            {
                                "tumbon":"เกาะสะท้อน",
                                "postcode":"96110"
                            },
                            {
                                "tumbon":"นานาค",
                                "postcode":"96110"
                            },
                            {
                                "tumbon":"โฆษิต",
                                "postcode":"96110"
                            }
                            ]
                        },
                        {
                            "amphur":"บาเจาะ",
                            "listTumbon":[
                            {
                                "tumbon":"บาเจาะ",
                                "postcode":"96170"
                            },
                            {
                                "tumbon":"ลุโบะสาวอ",
                                "postcode":"96170"
                            },
                            {
                                "tumbon":"กาเยาะมาตี",
                                "postcode":"96170"
                            },
                            {
                                "tumbon":"ปะลุกาสาเมาะ",
                                "postcode":"96170"
                            },
                            {
                                "tumbon":"บาเระเหนือ",
                                "postcode":"96170"
                            },
                            {
                                "tumbon":"บาเระใต้",
                                "postcode":"96170"
                            }
                            ]
                        },
                        {
                            "amphur":"ยี่งอ",
                            "listTumbon":[
                            {
                                "tumbon":"ยี่งอ",
                                "postcode":"96180"
                            },
                            {
                                "tumbon":"ละหาร",
                                "postcode":"96180"
                            },
                            {
                                "tumbon":"จอเบาะ",
                                "postcode":"96180"
                            },
                            {
                                "tumbon":"ลุโบะบายะ",
                                "postcode":"96180"
                            },
                            {
                                "tumbon":"ลุโบะบือซา",
                                "postcode":"96180"
                            },
                            {
                                "tumbon":"ตะปอเยาะ",
                                "postcode":"96180"
                            }
                            ]
                        },
                        {
                            "amphur":"ระแงะ",
                            "listTumbon":[
                            {
                                "tumbon":"ตันหยงมัส",
                                "postcode":"96130"
                            },
                            {
                                "tumbon":"ตันหยงลิมอ",
                                "postcode":"96130"
                            },
                            {
                                "tumbon":"บองอ",
                                "postcode":"96220"
                            },
                            {
                                "tumbon":"กาลิซา",
                                "postcode":"96130"
                            },
                            {
                                "tumbon":"บาโงสะโต",
                                "postcode":"96130"
                            },
                            {
                                "tumbon":"เฉลิม",
                                "postcode":"96130"
                            },
                            {
                                "tumbon":"มะรือโบตก",
                                "postcode":"96130"
                            }
                            ]
                        },
                        {
                            "amphur":"รือเสาะ",
                            "listTumbon":[
                            {
                                "tumbon":"รือเสาะ",
                                "postcode":"96150"
                            },
                            {
                                "tumbon":"สาวอ",
                                "postcode":"96150"
                            },
                            {
                                "tumbon":"เรียง",
                                "postcode":"96150"
                            },
                            {
                                "tumbon":"สามัคคี",
                                "postcode":"96150"
                            },
                            {
                                "tumbon":"บาตง",
                                "postcode":"96150"
                            },
                            {
                                "tumbon":"ลาโละ",
                                "postcode":"96150"
                            },
                            {
                                "tumbon":"รือเสาะออก",
                                "postcode":"96150"
                            },
                            {
                                "tumbon":"โคกสะตอ",
                                "postcode":"96150"
                            },
                            {
                                "tumbon":"สุวารี",
                                "postcode":"96150"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีสาคร",
                            "listTumbon":[
                            {
                                "tumbon":"ซากอ",
                                "postcode":"96210"
                            },
                            {
                                "tumbon":"ตะมะยูง",
                                "postcode":"96210"
                            },
                            {
                                "tumbon":"ศรีสาคร",
                                "postcode":"96210"
                            },
                            {
                                "tumbon":"เชิงคีรี",
                                "postcode":"96210"
                            },
                            {
                                "tumbon":"กาหลง",
                                "postcode":"96210"
                            },
                            {
                                "tumbon":"ศรีบรรพต",
                                "postcode":"96210"
                            }
                            ]
                        },
                        {
                            "amphur":"แว้ง",
                            "listTumbon":[
                            {
                                "tumbon":"แว้ง",
                                "postcode":"96160"
                            },
                            {
                                "tumbon":"กายูคละ",
                                "postcode":"96160"
                            },
                            {
                                "tumbon":"ฆอเลาะ",
                                "postcode":"96160"
                            },
                            {
                                "tumbon":"โละจูด",
                                "postcode":"96160"
                            },
                            {
                                "tumbon":"แม่ดง",
                                "postcode":"96160"
                            },
                            {
                                "tumbon":"เอราวัณ",
                                "postcode":"96160"
                            }
                            ]
                        },
                        {
                            "amphur":"สุคิริน",
                            "listTumbon":[
                            {
                                "tumbon":"มาโมง",
                                "postcode":"96190"
                            },
                            {
                                "tumbon":"สุคิริน",
                                "postcode":"96190"
                            },
                            {
                                "tumbon":"เกียร์",
                                "postcode":"96190"
                            },
                            {
                                "tumbon":"ภูเขาทอง",
                                "postcode":"96190"
                            },
                            {
                                "tumbon":"ร่มไทร",
                                "postcode":"96190"
                            }
                            ]
                        },
                        {
                            "amphur":"สุไหงโก-ลก",
                            "listTumbon":[
                            {
                                "tumbon":"สุไหงโก-ลก",
                                "postcode":"96120"
                            },
                            {
                                "tumbon":"ปาเสมัส",
                                "postcode":"96120"
                            },
                            {
                                "tumbon":"มูโนะ",
                                "postcode":"96120"
                            },
                            {
                                "tumbon":"ปูโยะ",
                                "postcode":"96120"
                            }
                            ]
                        },
                        {
                            "amphur":"สุไหงปาดี",
                            "listTumbon":[
                            {
                                "tumbon":"ปะลุรู",
                                "postcode":"96140"
                            },
                            {
                                "tumbon":"สุไหงปาดี",
                                "postcode":"96140"
                            },
                            {
                                "tumbon":"โต๊ะเด็ง",
                                "postcode":"96140"
                            },
                            {
                                "tumbon":"สากอ",
                                "postcode":"96140"
                            },
                            {
                                "tumbon":"ริโก๋",
                                "postcode":"96140"
                            },
                            {
                                "tumbon":"กาวะ",
                                "postcode":"96140"
                            }
                            ]
                        },
                        {
                            "amphur":"จะแนะ",
                            "listTumbon":[
                            {
                                "tumbon":"จะแนะ",
                                "postcode":"96220"
                            },
                            {
                                "tumbon":"ดุซงญอ",
                                "postcode":"96220"
                            },
                            {
                                "tumbon":"ผดุงมาตร",
                                "postcode":"96220"
                            },
                            {
                                "tumbon":"ช้างเผือก",
                                "postcode":"96220"
                            }
                            ]
                        },
                        {
                            "amphur":"เจาะไอร้อง",
                            "listTumbon":[
                            {
                                "tumbon":"จวบ",
                                "postcode":"96130"
                            },
                            {
                                "tumbon":"บูกิต",
                                "postcode":"96130"
                            },
                            {
                                "tumbon":"มะรือโบออก",
                                "postcode":"96130"
                            }
                            ]
                        }
                    ]
                },
                {
                    "province":"บึงกาฬ",
                    "listAmphur":[
                        {
                            "amphur":"เมืองบึงกาฬ",
                            "listTumbon":[
                            {
                                "tumbon":"บึงกาฬ",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"โนนสมบูรณ์",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"หนองเข็ง",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"หอคำ",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"หนองเลิง",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"โคกก่อง",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"นาสวรรค์",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"ไคสี",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"ชัยพร",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"วิศิษฐ์",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"คำนาดี",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"โป่งเปือย",
                                "postcode":"38000"
                            }
                            ]
                        },
                        {
                            "amphur":"พรเจริญ",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีชมภู",
                                "postcode":"38180"
                            },
                            {
                                "tumbon":"ดอนหญ้านาง",
                                "postcode":"38180"
                            },
                            {
                                "tumbon":"พรเจริญ",
                                "postcode":"38180"
                            },
                            {
                                "tumbon":"หนองหัวช้าง",
                                "postcode":"38180"
                            },
                            {
                                "tumbon":"วังชมภู",
                                "postcode":"38180"
                            },
                            {
                                "tumbon":"ป่าแฝก",
                                "postcode":"38180"
                            },
                            {
                                "tumbon":"ศรีสำราญ",
                                "postcode":"38180"
                            }
                            ]
                        },
                        {
                            "amphur":"โซ่พิสัย",
                            "listTumbon":[
                            {
                                "tumbon":"โซ่",
                                "postcode":"38170"
                            },
                            {
                                "tumbon":"หนองพันทา",
                                "postcode":"38170"
                            },
                            {
                                "tumbon":"ศรีชมภู",
                                "postcode":"38170"
                            },
                            {
                                "tumbon":"คำแก้ว",
                                "postcode":"38170"
                            },
                            {
                                "tumbon":"บัวตูม",
                                "postcode":"38170"
                            },
                            {
                                "tumbon":"ถ้ำเจริญ",
                                "postcode":"38170"
                            },
                            {
                                "tumbon":"เหล่าทอง",
                                "postcode":"38170"
                            }
                            ]
                        },
                        {
                            "amphur":"เซกา",
                            "listTumbon":[
                            {
                                "tumbon":"เซกา",
                                "postcode":"38150"
                            },
                            {
                                "tumbon":"ซาง",
                                "postcode":"38150"
                            },
                            {
                                "tumbon":"ท่ากกแดง",
                                "postcode":"38150"
                            },
                            {
                                "tumbon":"บ้านต้อง",
                                "postcode":"38150"
                            },
                            {
                                "tumbon":"ป่งไฮ",
                                "postcode":"38150"
                            },
                            {
                                "tumbon":"น้ำจั้น",
                                "postcode":"38150"
                            },
                            {
                                "tumbon":"ท่าสะอาด",
                                "postcode":"38150"
                            },
                            {
                                "tumbon":"หนองทุ่ม",
                                "postcode":"38150"
                            },
                            {
                                "tumbon":"โสกก่าม",
                                "postcode":"38150"
                            }
                            ]
                        },
                        {
                            "amphur":"ปากคาด",
                            "listTumbon":[
                            {
                                "tumbon":"ปากคาด",
                                "postcode":"38190"
                            },
                            {
                                "tumbon":"หนองยอง",
                                "postcode":"38190"
                            },
                            {
                                "tumbon":"นากั้ง",
                                "postcode":"38190"
                            },
                            {
                                "tumbon":"โนนศิลา",
                                "postcode":"38190"
                            },
                            {
                                "tumbon":"สมสนุก",
                                "postcode":"38190"
                            },
                            {
                                "tumbon":"นาดง",
                                "postcode":"38190"
                            }
                            ]
                        },
                        {
                            "amphur":"บึงโขงหลง",
                            "listTumbon":[
                            {
                                "tumbon":"บึงโขงหลง",
                                "postcode":"38220"
                            },
                            {
                                "tumbon":"โพธิ์หมากแข้ง",
                                "postcode":"38220"
                            },
                            {
                                "tumbon":"ดงบัง",
                                "postcode":"38220"
                            },
                            {
                                "tumbon":"ท่าดอกคำ",
                                "postcode":"38220"
                            }
                            ]
                        },
                        {
                            "amphur":"ศรีวิไล",
                            "listTumbon":[
                            {
                                "tumbon":"ศรีวิไล",
                                "postcode":"38210"
                            },
                            {
                                "tumbon":"ชุมภูพร",
                                "postcode":"38210"
                            },
                            {
                                "tumbon":"นาแสง",
                                "postcode":"38210"
                            },
                            {
                                "tumbon":"นาสะแบง",
                                "postcode":"38210"
                            },
                            {
                                "tumbon":"นาสิงห์",
                                "postcode":"38210"
                            }
                            ]
                        },
                        {
                            "amphur":"บุ่งคล้า",
                            "listTumbon":[
                            {
                                "tumbon":"บุ่งคล้า",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"หนองเดิ่น",
                                "postcode":"38000"
                            },
                            {
                                "tumbon":"โคกกว้าง",
                                "postcode":"38000"
                            }
                            ]
                        }
                    ]
                }
            ]
        } 
    }
}